/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import {
  FieldPolicy,
  FieldReadFunction,
  TypePolicies,
  TypePolicy,
} from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

/** Defines the bundle products to add to the cart. */
export type AddBundleProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String'];
  /** An array of bundle products to add. */
  cart_items: Array<InputMaybe<BundleProductCartItemInput>>;
};

/** Contains details about the cart after adding bundle products. */
export type AddBundleProductsToCartOutput = {
  __typename?: 'AddBundleProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

/** Defines the configurable products to add to the cart. */
export type AddConfigurableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String'];
  /** An array of configurable products to add. */
  cart_items: Array<InputMaybe<ConfigurableProductCartItemInput>>;
};

/** Contains details about the cart after adding configurable products. */
export type AddConfigurableProductsToCartOutput = {
  __typename?: 'AddConfigurableProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

export type AddPaperToCartInput = {
  cart_id: Scalars['String'];
};

export type AddPaperToCartOutput = {
  __typename?: 'AddPaperToCartOutput';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Contains details about the cart after adding products to it. */
export type AddProductsToCartOutput = {
  __typename?: 'AddProductsToCartOutput';
  /** The cart after products have been added. */
  cart: Cart;
  /** Contains errors encountered while adding an item to the cart. */
  user_errors: Array<Maybe<CartUserInputError>>;
};

/** Contains the customer's wish list and any errors encountered. */
export type AddProductsToWishlistOutput = {
  __typename?: 'AddProductsToWishlistOutput';
  /** An array of errors encountered while adding products to a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with all items that were successfully added. */
  wishlist: Wishlist;
};

/** Defines the simple and group products to add to the cart. */
export type AddSimpleProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of simple and group items to add. */
  cart_items: Array<InputMaybe<SimpleProductCartItemInput>>;
};

/** Contains details about the cart after adding simple or group products. */
export type AddSimpleProductsToCartOutput = {
  __typename?: 'AddSimpleProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

/** Defines the virtual products to add to the cart. */
export type AddVirtualProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of virtual products to add. */
  cart_items: Array<InputMaybe<VirtualProductCartItemInput>>;
};

/** Contains details about the cart after adding virtual products. */
export type AddVirtualProductsToCartOutput = {
  __typename?: 'AddVirtualProductsToCartOutput';
  /** The cart after adding products. */
  cart: Cart;
};

/** Contains the resultant wish list and any error information. */
export type AddWishlistItemsToCartOutput = {
  __typename?: 'AddWishlistItemsToCartOutput';
  /** An array of errors encountered while adding products to the customer's cart. */
  add_wishlist_items_to_cart_user_errors: Array<
    Maybe<WishlistCartUserInputError>
  >;
  /** Indicates whether the attempt to add items to the customer's cart was successful. */
  status: Scalars['Boolean'];
  /** Contains the wish list with all items that were successfully added. */
  wishlist: Wishlist;
};

/** Contains information for each filterable option (such as price, category `UID`, and custom attributes). */
export type Aggregation = {
  __typename?: 'Aggregation';
  /** Attribute code of the aggregation group. */
  attribute_code: Scalars['String'];
  /** The number of options in the aggregation group. */
  count?: Maybe<Scalars['Int']>;
  /** The aggregation display name. */
  label?: Maybe<Scalars['String']>;
  /** Array of options for the aggregation. */
  options?: Maybe<Array<Maybe<AggregationOption>>>;
  /** The relative position of the attribute in a layered navigation block. */
  position?: Maybe<Scalars['Int']>;
};

/** An implementation of `AggregationOptionInterface`. */
export type AggregationOption = AggregationOptionInterface & {
  __typename?: 'AggregationOption';
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']>;
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars['String']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String'];
};

/** Defines aggregation option fields. */
export type AggregationOptionInterface = {
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']>;
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars['String']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String'];
};

/** Filter category aggregations in layered navigation. */
export type AggregationsCategoryFilterInput = {
  /** Indicates whether to include only direct subcategories or all children categories at all levels. */
  includeDirectChildrenOnly?: InputMaybe<Scalars['Boolean']>;
};

/** An input object that specifies the filters used in product aggregations. */
export type AggregationsFilterInput = {
  /** Filter category aggregations in layered navigation. */
  category?: InputMaybe<AggregationsCategoryFilterInput>;
};

export type Amount = {
  __typename?: 'Amount';
  value?: Maybe<Scalars['Float']>;
};

/** Contains the applied coupon code. */
export type AppliedCoupon = {
  __typename?: 'AppliedCoupon';
  /** The coupon code the shopper applied to the card. */
  code: Scalars['String'];
};

/** Specifies the coupon code to apply to the cart. */
export type ApplyCouponToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** A valid coupon code. */
  coupon_code: Scalars['String'];
};

/** Contains details about the cart after applying a coupon. */
export type ApplyCouponToCartOutput = {
  __typename?: 'ApplyCouponToCartOutput';
  /** The cart after applying a coupon. */
  cart: Cart;
};

/** The strategy to apply coupons to the cart. */
export type ApplyCouponsStrategy =
  /** Append new coupons keeping the coupons that have been applied before. */
  | 'APPEND'
  /** Remove all the coupons from the cart and apply only new provided coupons. */
  | 'REPLACE';

/** Apply coupons to the cart. */
export type ApplyCouponsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of valid coupon codes. */
  coupon_codes: Array<InputMaybe<Scalars['String']>>;
  /** `replace` to replace the existing coupon(s) or `append` to add the coupon to the coupon(s) list. */
  type?: InputMaybe<ApplyCouponsStrategy>;
};

/** AreaInput defines the parameters which will be used for filter by specified location. */
export type AreaInput = {
  /** The radius for the search in KM. */
  radius: Scalars['Int'];
  /** The country code where search must be performed. Required parameter together with region, city or postcode. */
  search_term: Scalars['String'];
};

/** Contains details about the attribute, including the code and type. */
export type Attribute = {
  __typename?: 'Attribute';
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: Maybe<Scalars['String']>;
  /** Attribute options list. */
  attribute_options?: Maybe<Array<Maybe<AttributeOption>>>;
  /** The data type of the attribute. */
  attribute_type?: Maybe<Scalars['String']>;
  /** The type of entity that defines the attribute. */
  entity_type?: Maybe<Scalars['String']>;
  /** The frontend input type of the attribute. */
  input_type?: Maybe<Scalars['String']>;
  /** Details about the storefront properties configured for the attribute. */
  storefront_properties?: Maybe<StorefrontProperties>;
};

/** List of all entity types. Populated by the modules introducing EAV entities. */
export type AttributeEntityTypeEnum =
  | 'CATALOG_CATEGORY'
  | 'CATALOG_PRODUCT'
  | 'CUSTOMER'
  | 'CUSTOMER_ADDRESS';

/** An input object that specifies the filters used for attributes. */
export type AttributeFilterInput = {
  /** Whether a product or category attribute can be compared against another or not. */
  is_comparable?: InputMaybe<Scalars['Boolean']>;
  /** Whether a product or category attribute can be filtered or not. */
  is_filterable?: InputMaybe<Scalars['Boolean']>;
  /** Whether a product or category attribute can be filtered in search or not. */
  is_filterable_in_search?: InputMaybe<Scalars['Boolean']>;
  /** Whether a product or category attribute can use HTML on front or not. */
  is_html_allowed_on_front?: InputMaybe<Scalars['Boolean']>;
  /** Whether a product or category attribute can be searched or not. */
  is_searchable?: InputMaybe<Scalars['Boolean']>;
  /** Whether a customer or customer address attribute is used for customer segment or not. */
  is_used_for_customer_segment?: InputMaybe<Scalars['Boolean']>;
  /** Whether a product or category attribute can be used for price rules or not. */
  is_used_for_price_rules?: InputMaybe<Scalars['Boolean']>;
  /** Whether a product or category attribute is used for promo rules or not. */
  is_used_for_promo_rules?: InputMaybe<Scalars['Boolean']>;
  /** Whether a product or category attribute is visible in advanced search or not. */
  is_visible_in_advanced_search?: InputMaybe<Scalars['Boolean']>;
  /** Whether a product or category attribute is visible on front or not. */
  is_visible_on_front?: InputMaybe<Scalars['Boolean']>;
  /** Whether a product or category attribute has WYSIWYG enabled or not. */
  is_wysiwyg_enabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether a product or category attribute is used in product listing or not. */
  used_in_product_listing?: InputMaybe<Scalars['Boolean']>;
};

/** EAV attribute frontend input types. */
export type AttributeFrontendInputEnum =
  | 'BOOLEAN'
  | 'DATE'
  | 'DATETIME'
  | 'FILE'
  | 'GALLERY'
  | 'HIDDEN'
  | 'IMAGE'
  | 'MEDIA_IMAGE'
  | 'MULTILINE'
  | 'MULTISELECT'
  | 'PRICE'
  | 'SELECT'
  | 'TEXT'
  | 'TEXTAREA'
  | 'UNDEFINED'
  | 'WEIGHT';

/** Defines the attribute characteristics to search for the `attribute_code` and `entity_type` to search. */
export type AttributeInput = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: InputMaybe<Scalars['String']>;
  /** The type of entity that defines the attribute. */
  entity_type?: InputMaybe<Scalars['String']>;
};

/** Specifies selected option for a select or multiselect attribute value. */
export type AttributeInputSelectedOption = {
  /** The attribute option value. */
  value: Scalars['String'];
};

/** Base EAV implementation of CustomAttributeMetadataInterface. */
export type AttributeMetadata = CustomAttributeMetadataInterface & {
  __typename?: 'AttributeMetadata';
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars['ID'];
  /** Default attribute value. */
  default_value?: Maybe<Scalars['String']>;
  /** The type of entity that defines the attribute. */
  entity_type: AttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class?: Maybe<Scalars['String']>;
  /** The frontend input type of the attribute. */
  frontend_input?: Maybe<AttributeFrontendInputEnum>;
  /** Whether the attribute value is required. */
  is_required: Scalars['Boolean'];
  /** Whether the attribute value must be unique. */
  is_unique: Scalars['Boolean'];
  /** The label assigned to the attribute. */
  label?: Maybe<Scalars['String']>;
  /** Attribute options. */
  options: Array<Maybe<CustomAttributeOptionInterface>>;
};

/** Attribute metadata retrieval error. */
export type AttributeMetadataError = {
  __typename?: 'AttributeMetadataError';
  /** Attribute metadata retrieval error message. */
  message: Scalars['String'];
  /** Attribute metadata retrieval error type. */
  type: AttributeMetadataErrorType;
};

/** Attribute metadata retrieval error types. */
export type AttributeMetadataErrorType =
  /** The requested attribute was not found. */
  | 'ATTRIBUTE_NOT_FOUND'
  /** The requested entity was not found. */
  | 'ENTITY_NOT_FOUND'
  /** The filter cannot be applied as it does not belong to the entity */
  | 'FILTER_NOT_FOUND'
  /** Not categorized error, see the error message. */
  | 'UNDEFINED';

/** Defines an attribute option. */
export type AttributeOption = {
  __typename?: 'AttributeOption';
  /** The label assigned to the attribute option. */
  label?: Maybe<Scalars['String']>;
  /** The attribute option value. */
  value?: Maybe<Scalars['String']>;
};

/** Base EAV implementation of CustomAttributeOptionInterface. */
export type AttributeOptionMetadata = CustomAttributeOptionInterface & {
  __typename?: 'AttributeOptionMetadata';
  /** Is the option value default. */
  is_default: Scalars['Boolean'];
  /** The label assigned to the attribute option. */
  label: Scalars['String'];
  /** The attribute option value. */
  value: Scalars['String'];
};

export type AttributeSelectedOption = AttributeSelectedOptionInterface & {
  __typename?: 'AttributeSelectedOption';
  /** The attribute selected option label. */
  label: Scalars['String'];
  /** The attribute selected option value. */
  value: Scalars['String'];
};

export type AttributeSelectedOptionInterface = {
  /** The attribute selected option label. */
  label: Scalars['String'];
  /** The attribute selected option value. */
  value: Scalars['String'];
};

export type AttributeSelectedOptions = AttributeValueInterface & {
  __typename?: 'AttributeSelectedOptions';
  /** The attribute code. */
  code: Scalars['ID'];
  selected_options: Array<Maybe<AttributeSelectedOptionInterface>>;
};

export type AttributeValue = AttributeValueInterface & {
  __typename?: 'AttributeValue';
  /** The attribute code. */
  code: Scalars['ID'];
  /** The attribute value. */
  value: Scalars['String'];
};

/** Specifies the value for attribute. */
export type AttributeValueInput = {
  /** The code of the attribute. */
  attribute_code: Scalars['String'];
  /** An array containing selected options for a select or multiselect attribute. */
  selected_options?: InputMaybe<
    Array<InputMaybe<AttributeInputSelectedOption>>
  >;
  /** The value assigned to the attribute. */
  value?: InputMaybe<Scalars['String']>;
};

export type AttributeValueInterface = {
  /** The attribute code. */
  code: Scalars['ID'];
};

/** Metadata of EAV attributes associated to form */
export type AttributesFormOutput = {
  __typename?: 'AttributesFormOutput';
  /** Errors of retrieving certain attributes metadata. */
  errors: Array<Maybe<AttributeMetadataError>>;
  /** Requested attributes metadata. */
  items: Array<Maybe<CustomAttributeMetadataInterface>>;
};

/** Metadata of EAV attributes. */
export type AttributesMetadataOutput = {
  __typename?: 'AttributesMetadataOutput';
  /** Errors of retrieving certain attributes metadata. */
  errors: Array<Maybe<AttributeMetadataError>>;
  /** Requested attributes metadata. */
  items: Array<Maybe<CustomAttributeMetadataInterface>>;
};

/** Describes a payment method that the shopper can use to pay for the order. */
export type AvailablePaymentMethod = {
  __typename?: 'AvailablePaymentMethod';
  /** The payment method code. */
  code: Scalars['String'];
  /** If the payment method is an online integration */
  is_deferred: Scalars['Boolean'];
  /** The payment method title. */
  title: Scalars['String'];
};

/** Contains details about the possible shipping methods and carriers. */
export type AvailableShippingMethod = {
  __typename?: 'AvailableShippingMethod';
  /** The cost of shipping using this shipping method. */
  amount: Money;
  /** Indicates whether this shipping method can be applied to the cart. */
  available: Scalars['Boolean'];
  /** @deprecated The field should not be used on the storefront. */
  base_amount?: Maybe<Money>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars['String'];
  /** The label for the carrier code. */
  carrier_title: Scalars['String'];
  /** Describes an error condition. */
  error_message?: Maybe<Scalars['String']>;
  /** A shipping method code associated with a carrier. The value could be null if no method is available. */
  method_code?: Maybe<Scalars['String']>;
  /** The label for the shipping method code. The value could be null if no method is available. */
  method_title?: Maybe<Scalars['String']>;
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: Money;
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: Money;
};

export type BatchMutationStatus = 'FAILURE' | 'MIXED_RESULTS' | 'SUCCESS';

/** Defines the billing address. */
export type BillingAddressInput = {
  /** Defines a billing address. */
  address?: InputMaybe<CartAddressInput>;
  /** An ID from the customer's address book that uniquely identifies the address to be used for billing. */
  customer_address_id?: InputMaybe<Scalars['Int']>;
  /** Indicates whether to set the billing address to be the same as the existing shipping address on the cart. */
  same_as_shipping?: InputMaybe<Scalars['Boolean']>;
  /** Indicates whether to set the shipping address to be the same as this billing address. */
  use_for_shipping?: InputMaybe<Scalars['Boolean']>;
};

/** Contains details about the billing address. */
export type BillingCartAddress = CartAddressInterface & {
  __typename?: 'BillingCartAddress';
  /** The city specified for the billing or shipping address. */
  city: Scalars['String'];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']>;
  /** An object containing the country label and code. */
  country: CartAddressCountry;
  /** The custom attribute values of the billing or shipping address. */
  custom_attributes: Array<Maybe<AttributeValueInterface>>;
  /** @deprecated The field is used only in shipping address. */
  customer_notes?: Maybe<Scalars['String']>;
  /** The customer's fax number. */
  fax?: Maybe<Scalars['String']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String'];
  /** hp address id */
  hp_address_id?: Maybe<Scalars['String']>;
  /** The last name of the customer or guest. */
  lastname: Scalars['String'];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: Maybe<Scalars['String']>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>;
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']>;
  /** The unique id of the customer address. */
  uid: Scalars['String'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']>;
};

/** Contains details about an individual category that comprises a breadcrumb. */
export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  /**
   * The ID of the category.
   * @deprecated Use `category_uid` instead.
   */
  category_id?: Maybe<Scalars['Int']>;
  /** The category level. */
  category_level?: Maybe<Scalars['Int']>;
  /** The display name of the category. */
  category_name?: Maybe<Scalars['String']>;
  /** The unique ID for a `Breadcrumb` object. */
  category_uid: Scalars['ID'];
  /** The URL key of the category. */
  category_url_key?: Maybe<Scalars['String']>;
  /** The URL path of the category. */
  category_url_path?: Maybe<Scalars['String']>;
};

/** An implementation for bundle product cart items. */
export type BundleCartItem = CartItemInterface & {
  __typename?: 'BundleCartItem';
  /** An array containing the bundle options the shopper selected. */
  bundle_options: Array<Maybe<SelectedBundleOption>>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** To provide cancellation json over bundle cart item */
  hp_cancellation_json?: Maybe<Scalars['String']>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars['Boolean'];
  lineItems?: Maybe<Array<Maybe<LineItem>>>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Defines bundle product options for `CreditMemoItemInterface`. */
export type BundleCreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'BundleCreditMemoItem';
  /** A list of bundle options that are assigned to a bundle product that is part of a credit memo. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
};

/** Defines bundle product options for `InvoiceItemInterface`. */
export type BundleInvoiceItem = InvoiceItemInterface & {
  __typename?: 'BundleInvoiceItem';
  /** A list of bundle options that are assigned to an invoiced bundle product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
};

/** Defines an individual item within a bundle product. */
export type BundleItem = {
  __typename?: 'BundleItem';
  /** Bundle product custom option to hide bundle option. */
  hidden?: Maybe<Scalars['Int']>;
  /** Bundle product custom option for JSON SCHEMA. */
  json_option?: Maybe<Scalars['String']>;
  /**
   * An ID assigned to each type of item in a bundle product.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** An array of additional options for this bundle item. */
  options?: Maybe<Array<Maybe<BundleItemOption>>>;
  /** A number indicating the sequence order of this item compared to the other bundle items. */
  position?: Maybe<Scalars['Int']>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** Indicates whether the item must be included in the bundle. */
  required?: Maybe<Scalars['Boolean']>;
  /** Bundle product custom option for Required SKU. */
  required_sku?: Maybe<Scalars['String']>;
  /** The SKU of the bundle product. */
  sku?: Maybe<Scalars['String']>;
  /** The display name of the item. */
  title?: Maybe<Scalars['String']>;
  /** The input type that the customer uses to select the item. Examples include radio button and checkbox. */
  type?: Maybe<Scalars['String']>;
  /** The unique ID for a `BundleItem` object. */
  uid?: Maybe<Scalars['ID']>;
};

/** Defines the characteristics that comprise a specific bundle item and its options. */
export type BundleItemOption = {
  __typename?: 'BundleItemOption';
  /** Indicates whether the customer can change the number of items for this option. */
  can_change_quantity?: Maybe<Scalars['Boolean']>;
  /** Bundle product custom item option for is popular. */
  hp_is_popular?: Maybe<Scalars['String']>;
  /** Bundle product custom item option for hp plan. */
  hp_plan_option?: Maybe<Scalars['String']>;
  /**
   * The ID assigned to the bundled item option.
   * @deprecated Use `uid` instead
   */
  id?: Maybe<Scalars['Int']>;
  /** Indicates whether this option is the default option. */
  is_default?: Maybe<Scalars['Boolean']>;
  /** The text that identifies the bundled item option. */
  label?: Maybe<Scalars['String']>;
  lowest_price?: Maybe<Scalars['Float']>;
  /** When a bundle item contains multiple options, the relative position of this option compared to the other options. */
  position?: Maybe<Scalars['Int']>;
  /** The price of the selected option. */
  price?: Maybe<Scalars['Float']>;
  /** One of FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** Contains details about this product option. */
  product?: Maybe<ProductInterface>;
  /**
   * Indicates the quantity of this specific bundle item.
   * @deprecated Use `quantity` instead.
   */
  qty?: Maybe<Scalars['Float']>;
  /** The quantity of this specific bundle item. */
  quantity?: Maybe<Scalars['Float']>;
  /** Bundle product custom item option for Required SKU. */
  required_sku?: Maybe<Scalars['String']>;
  /** The unique ID for a `BundleItemOption` object. */
  uid: Scalars['ID'];
};

/** Defines the input for a bundle option. */
export type BundleOptionInput = {
  /** The ID of the option. */
  id: Scalars['Int'];
  /** The number of the selected item to add to the cart. */
  quantity: Scalars['Float'];
  /** An array with the chosen value of the option. */
  value: Array<InputMaybe<Scalars['String']>>;
};

/** Defines bundle product options for `OrderItemInterface`. */
export type BundleOrderItem = OrderItemInterface & {
  __typename?: 'BundleOrderItem';
  /** A list of bundle options that are assigned to the bundle product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** Product number of the product. */
  hp_product_number?: Maybe<Scalars['String']>;
  /** Product type of the product. */
  hp_product_type_label?: Maybe<Scalars['String']>;
  /** Product hp_short_config_name of the product. */
  hp_short_config_name?: Maybe<Scalars['String']>;
  /** HP Storage Amount of the product. */
  hp_storage_amount?: Maybe<Scalars['Float']>;
  /** HP Storage Uom of the product. */
  hp_storage_uom_label?: Maybe<Scalars['String']>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID'];
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<ProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>;
};

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProduct = CustomizableProductInterface &
  PhysicalProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'BundleProduct';
    a12345?: Maybe<Scalars['String']>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars['Int']>;
    /** Base Accessories Image for Catalog Product Image */
    base_accessories?: Maybe<ProductImage>;
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars['String']>;
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>;
    color?: Maybe<Scalars['Int']>;
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars['String']>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars['String']>;
    /** An array of cross-sell products. */
    crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2?: Maybe<ProductCustomAttributes>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>;
    /** Indicates whether the bundle product has a dynamic price. */
    dynamic_price?: Maybe<Scalars['Boolean']>;
    /** Indicates whether the bundle product has a dynamic SKU. */
    dynamic_sku?: Maybe<Scalars['Boolean']>;
    /** Indicates whether the bundle product has a dynamically calculated weight. */
    dynamic_weight?: Maybe<Scalars['Boolean']>;
    /** Indicates whether a gift message is available. */
    gift_message_available?: Maybe<Scalars['String']>;
    hp_allowed_payment_type?: Maybe<Scalars['String']>;
    /** Allowed Payment Type. */
    hp_allowed_payment_type_label?: Maybe<Scalars['String']>;
    hp_as_low_as_price?: Maybe<Scalars['Float']>;
    hp_auto_renewal?: Maybe<Scalars['Int']>;
    hp_billing_cycle?: Maybe<Scalars['Int']>;
    hp_billing_cycle_uom?: Maybe<Scalars['Int']>;
    /** Billing cycle UOM of the product. */
    hp_billing_cycle_uom_label?: Maybe<Scalars['String']>;
    hp_billing_period?: Maybe<Scalars['Int']>;
    /** Billing Period label */
    hp_billing_period_label?: Maybe<Scalars['String']>;
    hp_bundle_lease_type?: Maybe<Scalars['String']>;
    hp_bundle_type?: Maybe<Scalars['Int']>;
    /** Bundle type of the product, like On Books or Hp One. */
    hp_bundle_type_label?: Maybe<Scalars['String']>;
    hp_can_be_ordered_individually?: Maybe<Scalars['Int']>;
    hp_cancellation_json?: Maybe<Scalars['String']>;
    hp_charge_type?: Maybe<Scalars['Int']>;
    /** Charge Type label */
    hp_charge_type_label?: Maybe<Scalars['String']>;
    hp_contract_duration?: Maybe<Scalars['Int']>;
    hp_contract_duration_uom?: Maybe<Scalars['Int']>;
    /** Contract duration UOM of the product. */
    hp_contract_duration_uom_label?: Maybe<Scalars['String']>;
    /** Delivery method value */
    hp_delivery_method?: Maybe<Scalars['Int']>;
    /** Delivery method label */
    hp_delivery_method_label?: Maybe<Scalars['String']>;
    hp_disclaimer?: Maybe<Scalars['String']>;
    hp_downgrade_cost_change?: Maybe<Scalars['Float']>;
    hp_early_accessibility?: Maybe<Scalars['Int']>;
    hp_eligibility_ruleset_id?: Maybe<Scalars['String']>;
    hp_external_product_id?: Maybe<Scalars['String']>;
    hp_fair_market_value?: Maybe<Scalars['Float']>;
    hp_initial_hpone_subscription_cost?: Maybe<Scalars['Float']>;
    hp_is_popular?: Maybe<Scalars['Int']>;
    hp_lease_fmv?: Maybe<Scalars['Float']>;
    hp_lease_type?: Maybe<Scalars['String']>;
    hp_limit_per_org?: Maybe<Scalars['Int']>;
    hp_marketing_name?: Maybe<Scalars['String']>;
    hp_max_days_to_return?: Maybe<Scalars['Int']>;
    hp_max_rollover_pages?: Maybe<Scalars['Int']>;
    hp_model_name?: Maybe<Scalars['String']>;
    /** Model Purpose of the Bundle Product */
    hp_model_purpose?: Maybe<Scalars['String']>;
    hp_offer_type?: Maybe<Scalars['Int']>;
    /** Offer Type label */
    hp_offer_type_label?: Maybe<Scalars['String']>;
    hp_order_type?: Maybe<Scalars['String']>;
    hp_overage_block_price?: Maybe<Scalars['Float']>;
    hp_overage_block_size?: Maybe<Scalars['Int']>;
    hp_overage_block_uom?: Maybe<Scalars['String']>;
    hp_pages_per_month?: Maybe<Scalars['Int']>;
    hp_partner_fmvs?: Maybe<Array<Maybe<PartnerFmv>>>;
    hp_plan_change_freeze_period?: Maybe<Scalars['Int']>;
    hp_plan_change_freeze_period_uom?: Maybe<Scalars['Int']>;
    /** Plan Change Freeze Period UOM. */
    hp_plan_change_freeze_period_uom_label?: Maybe<Scalars['String']>;
    hp_price_type?: Maybe<Scalars['Int']>;
    /** Price type of the product. */
    hp_price_type_label?: Maybe<Scalars['String']>;
    hp_product_full_specification?: Maybe<Scalars['String']>;
    /** Product number of the product. */
    hp_product_number?: Maybe<Scalars['String']>;
    hp_product_type?: Maybe<Scalars['Int']>;
    /** Product type of the product. */
    hp_product_type_label?: Maybe<Scalars['String']>;
    hp_return_json?: Maybe<Scalars['String']>;
    hp_return_shipping_fee_sku?: Maybe<Scalars['String']>;
    hp_rollover_pages?: Maybe<Scalars['Int']>;
    hp_short_config_name?: Maybe<Scalars['String']>;
    hp_solution_id?: Maybe<Scalars['String']>;
    hp_source_system?: Maybe<Scalars['String']>;
    hp_specifications_json?: Maybe<Scalars['String']>;
    hp_storage_amount?: Maybe<Scalars['Int']>;
    hp_storage_uom?: Maybe<Scalars['Int']>;
    /** HP Storage Uom of the product. */
    hp_storage_uom_label?: Maybe<Scalars['String']>;
    hp_storefront_group?: Maybe<Scalars['Int']>;
    /** Storefront group of the product. */
    hp_storefront_group_label?: Maybe<Scalars['String']>;
    hp_supply_type?: Maybe<Scalars['Int']>;
    /** Supply type of the product on printers. */
    hp_supply_type_label?: Maybe<Scalars['String']>;
    hp_support_coverage_included_with_hw?: Maybe<Scalars['Int']>;
    /** support coverage of the product. */
    hp_support_coverage_included_with_hw_label?: Maybe<Scalars['String']>;
    hp_tokens_count?: Maybe<Scalars['Int']>;
    hp_trial_duration?: Maybe<Scalars['Int']>;
    hp_trial_duration_unit?: Maybe<Scalars['Int']>;
    /** Trial duration unit of the product. */
    hp_trial_duration_unit_label?: Maybe<Scalars['String']>;
    hp_trial_pages_per_month?: Maybe<Scalars['Int']>;
    hp_trial_price?: Maybe<Scalars['Float']>;
    hp_unit_of_measure?: Maybe<Scalars['Int']>;
    /** Unit of Measure label */
    hp_unit_of_measure_label?: Maybe<Scalars['String']>;
    hp_updated_hpone_subscription_cost?: Maybe<Scalars['Float']>;
    hp_upgrade_cost_change?: Maybe<Scalars['Float']>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars['Int']>;
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>;
    /** An array containing information about individual bundle items. */
    items?: Maybe<Array<Maybe<BundleItem>>>;
    lowest_price?: Maybe<Scalars['Float']>;
    /** A number representing the product's manufacturer. */
    manufacturer?: Maybe<Scalars['Int']>;
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars['String']>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars['String']>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars['String']>;
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars['String']>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars['String']>;
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars['String']>;
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars['Float']>;
    operational_system?: Maybe<Scalars['String']>;
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars['String']>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>;
    /** The price details of the main product */
    price_details?: Maybe<PriceDetails>;
    /** The range of prices for the product */
    price_range: PriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
    /** One of PRICE_RANGE or AS_LOW_AS. */
    price_view?: Maybe<PriceViewEnum>;
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars['Int'];
    /** An array of related products. */
    related_products?: Maybe<Array<Maybe<ProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars['String']>;
    /** Indicates whether to ship bundle items together or individually. */
    ship_bundle_items?: Maybe<ShipBundleItemsEnum>;
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<ComplexTextValue>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars['String']>;
    /** Small Accessories Image for Catalog Product Image */
    small_accessories?: Maybe<ProductImage>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<ProductImage>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars['String']>;
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars['Float']>;
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars['String']>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars['Boolean'];
    /** Stock status of the product */
    stock_status?: Maybe<ProductStockStatus>;
    storage?: Maybe<Scalars['String']>;
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars['String']>;
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>;
    /** Thumbnail Accessories Image for Catalog Product Image */
    thumbnail_accessories?: Maybe<ProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars['Float']>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars['String']>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID'];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars['String']>;
    /** An array of up-sell products. */
    upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars['String']>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars['String']>;
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars['String']>;
    usage?: Maybe<Scalars['String']>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>;
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars['Float']>;
  };

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProductCustom_AttributesV2Args = {
  filters?: InputMaybe<AttributeFilterInput>;
};

/** Defines a single bundle product. */
export type BundleProductCartItemInput = {
  /** A mandatory array of options for the bundle product, including each chosen option and specified quantity. */
  bundle_options: Array<InputMaybe<BundleOptionInput>>;
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The quantity and SKU of the bundle product. */
  data: CartItemInput;
};

/** Defines bundle product options for `ShipmentItemInterface`. */
export type BundleShipmentItem = ShipmentItemInterface & {
  __typename?: 'BundleShipmentItem';
  /** A list of bundle options that are assigned to a shipped product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float'];
};

/** Defines bundle product options for `WishlistItemInterface`. */
export type BundleWishlistItem = WishlistItemInterface & {
  __typename?: 'BundleWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** An array containing information about the selected bundle items. */
  bundle_options?: Maybe<Array<Maybe<SelectedBundleOption>>>;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

/** Defines the order to cancel. */
export type CancelOrderInput = {
  /** Order ID. */
  order_id: Scalars['ID'];
  /** Cancellation reason. */
  reason: Scalars['String'];
};

/** Contains the updated customer order and error message if any. */
export type CancelOrderOutput = {
  __typename?: 'CancelOrderOutput';
  /** Error encountered while cancelling the order. */
  error?: Maybe<Scalars['String']>;
  /** Updated customer order. */
  order?: Maybe<CustomerOrder>;
};

export type CancellationReason = {
  __typename?: 'CancellationReason';
  description: Scalars['String'];
};

/** Contains the contents and other details about a guest or customer cart. */
export type Cart = {
  __typename?: 'Cart';
  /** @deprecated Use `applied_coupons` instead. */
  applied_coupon?: Maybe<AppliedCoupon>;
  /** An array of `AppliedCoupon` objects. Each object contains the `code` text attribute, which specifies the coupon code. */
  applied_coupons?: Maybe<Array<Maybe<AppliedCoupon>>>;
  /** An array of available payment methods. */
  available_payment_methods?: Maybe<Array<Maybe<AvailablePaymentMethod>>>;
  /** The billing address assigned to the cart. */
  billing_address?: Maybe<BillingCartAddress>;
  /** Hardware cost applied to the quote. */
  device_total_with_tax: Money;
  /** The email address of the guest or customer. */
  email?: Maybe<Scalars['String']>;
  /** Indicates whether the cart contains only virtual products */
  hp_paper_eligible?: Maybe<Scalars['Boolean']>;
  /** Total Subscription applied to the quote. */
  hp_total_subscription_price: Money;
  /** The unique ID for a `Cart` object. */
  id: Scalars['ID'];
  /** Indicates whether the cart contains only virtual products. */
  is_virtual: Scalars['Boolean'];
  /**
   * An array of products that have been added to the cart.
   * @deprecated Use `itemsV2` instead.
   */
  items?: Maybe<Array<Maybe<CartItemInterface>>>;
  itemsV2?: Maybe<CartItems>;
  /** Pricing details for the quote. */
  prices?: Maybe<CartPrices>;
  /** Indicates which payment method was applied to the cart. */
  selected_payment_method?: Maybe<SelectedPaymentMethod>;
  /** Service Cost applied to the quote. */
  services_total_with_tax: Money;
  /** An array of shipping addresses assigned to the cart. */
  shipping_addresses: Array<Maybe<ShippingCartAddress>>;
  /** The total number of items in the cart. */
  total_quantity: Scalars['Float'];
};

/** Contains the contents and other details about a guest or customer cart. */
export type CartItemsV2Args = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuoteItemsSortInput>;
};

/** Contains details the country in a billing or shipping address. */
export type CartAddressCountry = {
  __typename?: 'CartAddressCountry';
  /** The country code. */
  code: Scalars['String'];
  /** The display label for the country. */
  label: Scalars['String'];
};

/** Defines the billing or shipping address to be applied to the cart. */
export type CartAddressInput = {
  /** The city specified for the billing or shipping address. */
  city: Scalars['String'];
  /** The company specified for the billing or shipping address. */
  company?: InputMaybe<Scalars['String']>;
  /** The country code and label for the billing or shipping address. */
  country_code: Scalars['String'];
  /** The custom attribute values of the billing or shipping address. */
  custom_attributes?: InputMaybe<Array<InputMaybe<AttributeValueInput>>>;
  /** The customer's fax number. */
  fax?: InputMaybe<Scalars['String']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String'];
  /** hp address id */
  hp_address_id: Scalars['String'];
  /** The last name of the customer or guest. */
  lastname: Scalars['String'];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: InputMaybe<Scalars['String']>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: InputMaybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>;
  /** A string that defines the state or province of the billing or shipping address. */
  region?: InputMaybe<Scalars['String']>;
  /** An integer that defines the state or province of the billing or shipping address. */
  region_id?: InputMaybe<Scalars['Int']>;
  /** Determines whether to save the address in the customer's address book. The default value is true. */
  save_in_address_book?: InputMaybe<Scalars['Boolean']>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<InputMaybe<Scalars['String']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>;
  /** The telephone number for the billing or shipping address. */
  telephone?: InputMaybe<Scalars['String']>;
  /** The VAT company number for billing or shipping address. */
  vat_id?: InputMaybe<Scalars['String']>;
};

export type CartAddressInterface = {
  /** The city specified for the billing or shipping address. */
  city: Scalars['String'];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']>;
  /** An object containing the country label and code. */
  country: CartAddressCountry;
  /** The custom attribute values of the billing or shipping address. */
  custom_attributes: Array<Maybe<AttributeValueInterface>>;
  /** The customer's fax number. */
  fax?: Maybe<Scalars['String']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String'];
  /** hp address id */
  hp_address_id?: Maybe<Scalars['String']>;
  /** The last name of the customer or guest. */
  lastname: Scalars['String'];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: Maybe<Scalars['String']>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>;
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']>;
  /** The unique id of the customer address. */
  uid: Scalars['String'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']>;
};

/** Contains details about the region in a billing or shipping address. */
export type CartAddressRegion = {
  __typename?: 'CartAddressRegion';
  /** The state or province code. */
  code?: Maybe<Scalars['String']>;
  /** The display label for the region. */
  label?: Maybe<Scalars['String']>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']>;
};

/** Contains information about discounts applied to the cart. */
export type CartDiscount = {
  __typename?: 'CartDiscount';
  /** The amount of the discount applied to the item. */
  amount: Money;
  /** The description of the discount. */
  label: Array<Maybe<Scalars['String']>>;
};

export type CartDiscountType = 'ITEM' | 'SHIPPING';

export type CartItemError = {
  __typename?: 'CartItemError';
  /** An error code that describes the error encountered */
  code: CartItemErrorType;
  /** A localized error message */
  message: Scalars['String'];
};

export type CartItemErrorType = 'ITEM_INCREMENTS' | 'ITEM_QTY' | 'UNDEFINED';

/** Defines an item to be added to the cart. */
export type CartItemInput = {
  /** An array of entered options for the base product, such as personalization text. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** For a child product, the SKU of its parent product. */
  parent_sku?: InputMaybe<Scalars['String']>;
  /** The amount or number of an item to add. */
  quantity: Scalars['Float'];
  /** The selected options for the base product, such as color or size, using the unique ID for an object such as `CustomizableRadioOption`, `CustomizableDropDownOption`, or `ConfigurableProductOptionsValues`. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The SKU of the product. */
  sku: Scalars['String'];
};

/** An interface for products in a cart. */
export type CartItemInterface = {
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars['Boolean'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Contains details about the price of the item, including taxes and discounts. */
export type CartItemPrices = {
  __typename?: 'CartItemPrices';
  /** An array of discounts to be applied to the cart item. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** An array of FPTs applied to the cart item. */
  fixed_product_taxes?: Maybe<Array<Maybe<FixedProductTax>>>;
  /** Later months including tax for cart item. */
  hp_upcoming_price_including_tax?: Maybe<Money>;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price: Money;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price_including_tax: Money;
  /** The value of the price multiplied by the quantity of the item. */
  row_total: Money;
  /** The value of `row_total` plus the tax applied to the item. */
  row_total_including_tax: Money;
  /** The total of all discounts applied to the item. */
  total_item_discount?: Maybe<Money>;
};

/** Deprecated: The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
export type CartItemQuantity = {
  __typename?: 'CartItemQuantity';
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  cart_item_id: Scalars['Int'];
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  quantity: Scalars['Float'];
};

/** Contains details about the price of a selected customizable value. */
export type CartItemSelectedOptionValuePrice = {
  __typename?: 'CartItemSelectedOptionValuePrice';
  /** Indicates whether the price type is fixed, percent, or dynamic. */
  type: PriceTypeEnum;
  /** A string that describes the unit of the value. */
  units: Scalars['String'];
  /** A price value. */
  value: Scalars['Float'];
};

/** A single item to be updated. */
export type CartItemUpdateInput = {
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars['Int']>;
  /** The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars['ID']>;
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The new quantity of the item. */
  quantity?: InputMaybe<Scalars['Float']>;
};

export type CartItems = {
  __typename?: 'CartItems';
  /** An array of products that have been added to the cart. */
  items: Array<Maybe<CartItemInterface>>;
  /** Metadata for pagination rendering. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of returned cart items. */
  total_count: Scalars['Int'];
};

/** Contains details about the final price of items in the cart, including discount and tax information. */
export type CartPrices = {
  __typename?: 'CartPrices';
  /** An array containing the names and amounts of taxes applied to each item in the cart. */
  applied_taxes?: Maybe<Array<Maybe<CartTaxItem>>>;
  /** Total device price related to the cart. */
  device_total?: Maybe<Money>;
  /** @deprecated Use discounts instead. */
  discount?: Maybe<CartDiscount>;
  /** An array containing cart rule discounts, store credit and gift cards applied to the cart. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The total, including discounts, taxes, shipping, and other fees. */
  grand_total?: Maybe<Money>;
  /** An array containing device and subscription based monthly total with and without tax related to the cart. */
  monthly_total: MonthlyTotal;
  /** The subtotal without any applied taxes. */
  subtotal_excluding_tax?: Maybe<Money>;
  /** The subtotal including any applied taxes. */
  subtotal_including_tax?: Maybe<Money>;
  /** The subtotal with any discounts applied, but not taxes. */
  subtotal_with_discount_excluding_tax?: Maybe<Money>;
  /** Total WsReg Fee for all the products in cart. */
  total_wsreg_fee?: Maybe<Money>;
  /** An array containing different ws_reg fees. */
  wsreg_fees: WsRegFees;
};

/** Contains tax information about an item in the cart. */
export type CartTaxItem = {
  __typename?: 'CartTaxItem';
  /** The amount of tax applied to the item. */
  amount: Money;
  /** The description of the tax. */
  label: Scalars['String'];
};

/** An error encountered while adding an item to the the cart. */
export type CartUserInputError = {
  __typename?: 'CartUserInputError';
  /** A cart-specific error code. */
  code: CartUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String'];
};

export type CartUserInputErrorType =
  | 'INSUFFICIENT_STOCK'
  | 'NOT_SALABLE'
  | 'PERMISSION_DENIED'
  | 'PRODUCT_NOT_FOUND'
  | 'UNDEFINED';

export type CatalogAttributeApplyToEnum =
  | 'BUNDLE'
  | 'CATEGORY'
  | 'CONFIGURABLE'
  | 'DOWNLOADABLE'
  | 'GROUPED'
  | 'SIMPLE'
  | 'VIRTUAL';

/** Swatch attribute metadata. */
export type CatalogAttributeMetadata = CustomAttributeMetadataInterface & {
  __typename?: 'CatalogAttributeMetadata';
  /** To which catalog types an attribute can be applied. */
  apply_to?: Maybe<Array<Maybe<CatalogAttributeApplyToEnum>>>;
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars['ID'];
  /** Default attribute value. */
  default_value?: Maybe<Scalars['String']>;
  /** The type of entity that defines the attribute. */
  entity_type: AttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class?: Maybe<Scalars['String']>;
  /** The frontend input type of the attribute. */
  frontend_input?: Maybe<AttributeFrontendInputEnum>;
  /** Whether a product or category attribute can be compared against another or not. */
  is_comparable?: Maybe<Scalars['Boolean']>;
  /** Whether a product or category attribute can be filtered or not. */
  is_filterable?: Maybe<Scalars['Boolean']>;
  /** Whether a product or category attribute can be filtered in search or not. */
  is_filterable_in_search?: Maybe<Scalars['Boolean']>;
  /** Whether a product or category attribute can use HTML on front or not. */
  is_html_allowed_on_front?: Maybe<Scalars['Boolean']>;
  /** Whether the attribute value is required. */
  is_required: Scalars['Boolean'];
  /** Whether a product or category attribute can be searched or not. */
  is_searchable?: Maybe<Scalars['Boolean']>;
  /** Whether the attribute value must be unique. */
  is_unique: Scalars['Boolean'];
  /** Whether a product or category attribute can be used for price rules or not. */
  is_used_for_price_rules?: Maybe<Scalars['Boolean']>;
  /** Whether a product or category attribute is used for promo rules or not. */
  is_used_for_promo_rules?: Maybe<Scalars['Boolean']>;
  /** Whether a product or category attribute is visible in advanced search or not. */
  is_visible_in_advanced_search?: Maybe<Scalars['Boolean']>;
  /** Whether a product or category attribute is visible on front or not. */
  is_visible_on_front?: Maybe<Scalars['Boolean']>;
  /** Whether a product or category attribute has WYSIWYG enabled or not. */
  is_wysiwyg_enabled?: Maybe<Scalars['Boolean']>;
  /** The label assigned to the attribute. */
  label?: Maybe<Scalars['String']>;
  /** Attribute options. */
  options: Array<Maybe<CustomAttributeOptionInterface>>;
  /** Input type of the swatch attribute option. */
  swatch_input_type?: Maybe<SwatchInputTypeEnum>;
  /** Whether update product preview image or not. */
  update_product_preview_image?: Maybe<Scalars['Boolean']>;
  /** Whether use product image for swatch or not. */
  use_product_image_for_swatch?: Maybe<Scalars['Boolean']>;
  /** Whether a product or category attribute is used in product listing or not. */
  used_in_product_listing?: Maybe<Scalars['Boolean']>;
};

/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type CategoryFilterInput = {
  /** Filter by the unique category ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Deprecated: use 'category_uid' to filter uniquely identifiers of categories. */
  ids?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the display name of the category. */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the part of the URL that identifies the category. */
  url_key?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the URL path for the category. */
  url_path?: InputMaybe<FilterEqualTypeInput>;
};

/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterface = {
  automatic_sorting?: Maybe<Scalars['String']>;
  available_sort_by?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** An array of breadcrumb items. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  children_count?: Maybe<Scalars['String']>;
  /** Contains a category CMS block. */
  cms_block?: Maybe<CmsBlock>;
  /**
   * The timestamp indicating when the category was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  custom_layout_update_file?: Maybe<Scalars['String']>;
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars['String']>;
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']>;
  display_mode?: Maybe<Scalars['String']>;
  filter_price_range?: Maybe<Scalars['Float']>;
  /**
   * An ID that uniquely identifies the category.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  include_in_menu?: Maybe<Scalars['Int']>;
  is_anchor?: Maybe<Scalars['Int']>;
  landing_page?: Maybe<Scalars['Int']>;
  /** The depth of the category within the tree. */
  level?: Maybe<Scalars['Int']>;
  meta_description?: Maybe<Scalars['String']>;
  meta_keywords?: Maybe<Scalars['String']>;
  meta_title?: Maybe<Scalars['String']>;
  /** The display name of the category. */
  name?: Maybe<Scalars['String']>;
  /** The full category path. */
  path?: Maybe<Scalars['String']>;
  /** The category path within the store. */
  path_in_store?: Maybe<Scalars['String']>;
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  product_count?: Maybe<Scalars['Int']>;
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>;
  /** Indicates whether the category is staged for a future campaign. */
  staged: Scalars['Boolean'];
  /** The unique ID for a `CategoryInterface` object. */
  uid: Scalars['ID'];
  /**
   * The timestamp indicating when the category was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** The URL key assigned to the category. */
  url_key?: Maybe<Scalars['String']>;
  /** The URL path assigned to the category. */
  url_path?: Maybe<Scalars['String']>;
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
};

/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterfaceProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

/** Contains details about the products assigned to a category. */
export type CategoryProducts = {
  __typename?: 'CategoryProducts';
  /** An array of products that are assigned to the category. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Contains a collection of `CategoryTree` objects and pagination information. */
export type CategoryResult = {
  __typename?: 'CategoryResult';
  /** A list of categories that match the filter criteria. */
  items?: Maybe<Array<Maybe<CategoryTree>>>;
  /** An object that includes the `page_info` and `currentPage` values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total number of categories that match the criteria. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Contains the hierarchy of categories. */
export type CategoryTree = CategoryInterface &
  RoutableInterface & {
    __typename?: 'CategoryTree';
    automatic_sorting?: Maybe<Scalars['String']>;
    available_sort_by?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** An array of breadcrumb items. */
    breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
    canonical_url?: Maybe<Scalars['String']>;
    /** A tree of child categories. */
    children?: Maybe<Array<Maybe<CategoryTree>>>;
    children_count?: Maybe<Scalars['String']>;
    /** Contains a category CMS block. */
    cms_block?: Maybe<CmsBlock>;
    /**
     * The timestamp indicating when the category was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars['String']>;
    custom_layout_update_file?: Maybe<Scalars['String']>;
    /** The attribute to use for sorting. */
    default_sort_by?: Maybe<Scalars['String']>;
    /** An optional description of the category. */
    description?: Maybe<Scalars['String']>;
    display_mode?: Maybe<Scalars['String']>;
    filter_price_range?: Maybe<Scalars['Float']>;
    /**
     * An ID that uniquely identifies the category.
     * @deprecated Use `uid` instead.
     */
    id?: Maybe<Scalars['Int']>;
    image?: Maybe<Scalars['String']>;
    include_in_menu?: Maybe<Scalars['Int']>;
    is_anchor?: Maybe<Scalars['Int']>;
    landing_page?: Maybe<Scalars['Int']>;
    /** The depth of the category within the tree. */
    level?: Maybe<Scalars['Int']>;
    meta_description?: Maybe<Scalars['String']>;
    meta_keywords?: Maybe<Scalars['String']>;
    meta_title?: Maybe<Scalars['String']>;
    /** The display name of the category. */
    name?: Maybe<Scalars['String']>;
    /** The full category path. */
    path?: Maybe<Scalars['String']>;
    /** The category path within the store. */
    path_in_store?: Maybe<Scalars['String']>;
    /** The position of the category relative to other categories at the same level in tree. */
    position?: Maybe<Scalars['Int']>;
    /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
    product_count?: Maybe<Scalars['Int']>;
    /** The list of products assigned to the category. */
    products?: Maybe<CategoryProducts>;
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars['Int'];
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars['String']>;
    /** Indicates whether the category is staged for a future campaign. */
    staged: Scalars['Boolean'];
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>;
    /** The unique ID for a `CategoryInterface` object. */
    uid: Scalars['ID'];
    /**
     * The timestamp indicating when the category was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars['String']>;
    /** The URL key assigned to the category. */
    url_key?: Maybe<Scalars['String']>;
    /** The URL path assigned to the category. */
    url_path?: Maybe<Scalars['String']>;
    /** The part of the category URL that is appended after the url key */
    url_suffix?: Maybe<Scalars['String']>;
  };

/** Contains the hierarchy of categories. */
export type CategoryTreeProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

/** Defines details about an individual checkout agreement. */
export type CheckoutAgreement = {
  __typename?: 'CheckoutAgreement';
  /** The ID for a checkout agreement. */
  agreement_id: Scalars['Int'];
  /** The checkbox text for the checkout agreement. */
  checkbox_text: Scalars['String'];
  /** Required. The text of the agreement. */
  content: Scalars['String'];
  /** The height of the text box where the Terms and Conditions statement appears during checkout. */
  content_height?: Maybe<Scalars['String']>;
  /** Indicates whether the `content` text is in HTML format. */
  is_html: Scalars['Boolean'];
  /** Indicates whether agreements are accepted automatically or manually. */
  mode: CheckoutAgreementMode;
  /** The name given to the condition. */
  name: Scalars['String'];
  /** The type given to the condition */
  type: Scalars['String'];
};

/** Indicates how agreements are accepted. */
export type CheckoutAgreementMode =
  /** Conditions are automatically accepted upon checkout. */
  | 'AUTO'
  /** Shoppers must manually accept the conditions to place an order. */
  | 'MANUAL';

/** An error encountered while adding an item to the cart. */
export type CheckoutUserInputError = {
  __typename?: 'CheckoutUserInputError';
  /** An error code that is specific to Checkout. */
  code: CheckoutUserInputErrorCodes;
  /** A localized error message. */
  message: Scalars['String'];
  /** The path to the input field that caused an error. See the GraphQL specification about path errors for details: http://spec.graphql.org/draft/#sec-Errors */
  path: Array<Maybe<Scalars['String']>>;
};

export type CheckoutUserInputErrorCodes =
  | 'INSUFFICIENT_STOCK'
  | 'NOT_SALABLE'
  | 'PRODUCT_NOT_FOUND'
  | 'REORDER_NOT_AVAILABLE'
  | 'UNDEFINED';

/** Contains details about errors encountered when a customer clear cart. */
export type ClearCartError = {
  __typename?: 'ClearCartError';
  /** A localized error message */
  message: Scalars['String'];
  /** A cart-specific error type. */
  type: ClearCartErrorType;
};

export type ClearCartErrorType =
  | 'INACTIVE'
  | 'NOT_FOUND'
  | 'UNAUTHORISED'
  | 'UNDEFINED';

/** Assigns a specific `cart_id` to the empty cart. */
export type ClearCartInput = {
  /** The unique ID of a `Cart` object. */
  uid: Scalars['ID'];
};

/** Output of the request to clear the customer cart. */
export type ClearCartOutput = {
  __typename?: 'ClearCartOutput';
  /** The cart after clear cart items. */
  cart?: Maybe<Cart>;
  /** An array of errors encountered while clearing the cart item */
  errors?: Maybe<Array<Maybe<ClearCartError>>>;
};

/** Output of the request to clear the customer cart. */
export type ClearCustomerCartOutput = {
  __typename?: 'ClearCustomerCartOutput';
  /** The cart after clearing items. */
  cart?: Maybe<Cart>;
  /** Indicates whether cart was cleared. */
  status: Scalars['Boolean'];
};

/** Contains details about a specific CMS block. */
export type CmsBlock = {
  __typename?: 'CmsBlock';
  /** The content of the CMS block in raw HTML. */
  content?: Maybe<Scalars['String']>;
  /** The filtered content of the CMS block in JSON format for Magento Storefront */
  data?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The CMS block identifier. */
  identifier?: Maybe<Scalars['String']>;
  /** The title assigned to the CMS block. */
  title?: Maybe<Scalars['String']>;
};

/** Contains an array CMS block items. */
export type CmsBlocks = {
  __typename?: 'CmsBlocks';
  /** An array of CMS blocks. */
  items?: Maybe<Array<Maybe<CmsBlock>>>;
};

/** Contains details about a CMS page. */
export type CmsPage = RoutableInterface & {
  __typename?: 'CmsPage';
  /** The content of the CMS page in raw HTML. */
  content?: Maybe<Scalars['String']>;
  /** The heading that displays at the top of the CMS page. */
  content_heading?: Maybe<Scalars['String']>;
  /** The ID of a CMS page. */
  identifier?: Maybe<Scalars['String']>;
  /** A brief description of the page for search results listings. */
  meta_description?: Maybe<Scalars['String']>;
  /** A brief description of the page for search results listings. */
  meta_keywords?: Maybe<Scalars['String']>;
  /** A page title that is indexed by search engines and appears in search results listings. */
  meta_title?: Maybe<Scalars['String']>;
  /** The design layout of the page, indicating the number of columns and navigation features used on the page. */
  page_layout?: Maybe<Scalars['String']>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** The name that appears in the breadcrumb trail navigation and in the browser title bar and tab. */
  title?: Maybe<Scalars['String']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /** The URL key of the CMS page, which is often based on the `content_heading`. */
  url_key?: Maybe<Scalars['String']>;
};

export type ColorSwatchData = SwatchDataInterface & {
  __typename?: 'ColorSwatchData';
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>;
};

export type ComplexTextValue = {
  __typename?: 'ComplexTextValue';
  /** Text that can contain HTML tags. */
  html: Scalars['String'];
};

/** Contains details about a configurable product attribute option. */
export type ConfigurableAttributeOption = {
  __typename?: 'ConfigurableAttributeOption';
  /** The ID assigned to the attribute. */
  code?: Maybe<Scalars['String']>;
  /** A string that describes the configurable attribute option. */
  label?: Maybe<Scalars['String']>;
  /** The unique ID for a `ConfigurableAttributeOption` object. */
  uid: Scalars['ID'];
  /** A unique index number assigned to the configurable product option. */
  value_index?: Maybe<Scalars['Int']>;
};

/** An implementation for configurable product cart items. */
export type ConfigurableCartItem = CartItemInterface & {
  __typename?: 'ConfigurableCartItem';
  /** An array containing the configuranle options the shopper selected. */
  configurable_options: Array<Maybe<SelectedConfigurableOption>>;
  /** Product details of the cart item. */
  configured_variant: ProductInterface;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars['Boolean'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Describes configurable options that have been selected and can be selected as a result of the previous selections. */
export type ConfigurableOptionAvailableForSelection = {
  __typename?: 'ConfigurableOptionAvailableForSelection';
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars['String'];
  /** An array of selectable option value IDs. */
  option_value_uids: Array<Maybe<Scalars['ID']>>;
};

/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProduct = CustomizableProductInterface &
  PhysicalProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'ConfigurableProduct';
    a12345?: Maybe<Scalars['String']>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars['Int']>;
    /** Base Accessories Image for Catalog Product Image */
    base_accessories?: Maybe<ProductImage>;
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars['String']>;
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>;
    color?: Maybe<Scalars['Int']>;
    /** An array of options for the configurable product. */
    configurable_options?: Maybe<Array<Maybe<ConfigurableProductOptions>>>;
    /** An array of media gallery items and other details about selected configurable product options as well as details about remaining selectable options. */
    configurable_product_options_selection?: Maybe<ConfigurableProductOptionsSelection>;
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars['String']>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars['String']>;
    /** An array of cross-sell products. */
    crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2?: Maybe<ProductCustomAttributes>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>;
    /** Indicates whether a gift message is available. */
    gift_message_available?: Maybe<Scalars['String']>;
    hp_allowed_payment_type?: Maybe<Scalars['String']>;
    /** Allowed Payment Type. */
    hp_allowed_payment_type_label?: Maybe<Scalars['String']>;
    hp_as_low_as_price?: Maybe<Scalars['Float']>;
    hp_auto_renewal?: Maybe<Scalars['Int']>;
    hp_billing_cycle?: Maybe<Scalars['Int']>;
    hp_billing_cycle_uom?: Maybe<Scalars['Int']>;
    /** Billing cycle UOM of the product. */
    hp_billing_cycle_uom_label?: Maybe<Scalars['String']>;
    hp_billing_period?: Maybe<Scalars['Int']>;
    /** Billing Period label */
    hp_billing_period_label?: Maybe<Scalars['String']>;
    hp_bundle_lease_type?: Maybe<Scalars['String']>;
    hp_bundle_type?: Maybe<Scalars['Int']>;
    /** Bundle type of the product, like On Books or Hp One. */
    hp_bundle_type_label?: Maybe<Scalars['String']>;
    hp_can_be_ordered_individually?: Maybe<Scalars['Int']>;
    hp_cancellation_json?: Maybe<Scalars['String']>;
    hp_charge_type?: Maybe<Scalars['Int']>;
    /** Charge Type label */
    hp_charge_type_label?: Maybe<Scalars['String']>;
    hp_contract_duration?: Maybe<Scalars['Int']>;
    hp_contract_duration_uom?: Maybe<Scalars['Int']>;
    /** Contract duration UOM of the product. */
    hp_contract_duration_uom_label?: Maybe<Scalars['String']>;
    /** Delivery method value */
    hp_delivery_method?: Maybe<Scalars['Int']>;
    /** Delivery method label */
    hp_delivery_method_label?: Maybe<Scalars['String']>;
    hp_disclaimer?: Maybe<Scalars['String']>;
    hp_downgrade_cost_change?: Maybe<Scalars['Float']>;
    hp_early_accessibility?: Maybe<Scalars['Int']>;
    hp_eligibility_ruleset_id?: Maybe<Scalars['String']>;
    hp_external_product_id?: Maybe<Scalars['String']>;
    hp_fair_market_value?: Maybe<Scalars['Float']>;
    hp_initial_hpone_subscription_cost?: Maybe<Scalars['Float']>;
    hp_is_popular?: Maybe<Scalars['Int']>;
    hp_lease_fmv?: Maybe<Scalars['Float']>;
    hp_lease_type?: Maybe<Scalars['String']>;
    hp_limit_per_org?: Maybe<Scalars['Int']>;
    hp_marketing_name?: Maybe<Scalars['String']>;
    hp_max_days_to_return?: Maybe<Scalars['Int']>;
    hp_max_rollover_pages?: Maybe<Scalars['Int']>;
    hp_model_name?: Maybe<Scalars['String']>;
    /** Model Purpose of the Bundle Product */
    hp_model_purpose?: Maybe<Scalars['String']>;
    hp_offer_type?: Maybe<Scalars['Int']>;
    /** Offer Type label */
    hp_offer_type_label?: Maybe<Scalars['String']>;
    hp_order_type?: Maybe<Scalars['String']>;
    hp_overage_block_price?: Maybe<Scalars['Float']>;
    hp_overage_block_size?: Maybe<Scalars['Int']>;
    hp_overage_block_uom?: Maybe<Scalars['String']>;
    hp_pages_per_month?: Maybe<Scalars['Int']>;
    hp_partner_fmvs?: Maybe<Array<Maybe<PartnerFmv>>>;
    hp_plan_change_freeze_period?: Maybe<Scalars['Int']>;
    hp_plan_change_freeze_period_uom?: Maybe<Scalars['Int']>;
    /** Plan Change Freeze Period UOM. */
    hp_plan_change_freeze_period_uom_label?: Maybe<Scalars['String']>;
    hp_price_type?: Maybe<Scalars['Int']>;
    /** Price type of the product. */
    hp_price_type_label?: Maybe<Scalars['String']>;
    hp_product_full_specification?: Maybe<Scalars['String']>;
    /** Product number of the product. */
    hp_product_number?: Maybe<Scalars['String']>;
    hp_product_type?: Maybe<Scalars['Int']>;
    /** Product type of the product. */
    hp_product_type_label?: Maybe<Scalars['String']>;
    hp_return_json?: Maybe<Scalars['String']>;
    hp_return_shipping_fee_sku?: Maybe<Scalars['String']>;
    hp_rollover_pages?: Maybe<Scalars['Int']>;
    hp_short_config_name?: Maybe<Scalars['String']>;
    hp_solution_id?: Maybe<Scalars['String']>;
    hp_source_system?: Maybe<Scalars['String']>;
    hp_specifications_json?: Maybe<Scalars['String']>;
    hp_storage_amount?: Maybe<Scalars['Int']>;
    hp_storage_uom?: Maybe<Scalars['Int']>;
    /** HP Storage Uom of the product. */
    hp_storage_uom_label?: Maybe<Scalars['String']>;
    hp_storefront_group?: Maybe<Scalars['Int']>;
    /** Storefront group of the product. */
    hp_storefront_group_label?: Maybe<Scalars['String']>;
    hp_supply_type?: Maybe<Scalars['Int']>;
    /** Supply type of the product on printers. */
    hp_supply_type_label?: Maybe<Scalars['String']>;
    hp_support_coverage_included_with_hw?: Maybe<Scalars['Int']>;
    /** support coverage of the product. */
    hp_support_coverage_included_with_hw_label?: Maybe<Scalars['String']>;
    hp_tokens_count?: Maybe<Scalars['Int']>;
    hp_trial_duration?: Maybe<Scalars['Int']>;
    hp_trial_duration_unit?: Maybe<Scalars['Int']>;
    /** Trial duration unit of the product. */
    hp_trial_duration_unit_label?: Maybe<Scalars['String']>;
    hp_trial_pages_per_month?: Maybe<Scalars['Int']>;
    hp_trial_price?: Maybe<Scalars['Float']>;
    hp_unit_of_measure?: Maybe<Scalars['Int']>;
    /** Unit of Measure label */
    hp_unit_of_measure_label?: Maybe<Scalars['String']>;
    hp_updated_hpone_subscription_cost?: Maybe<Scalars['Float']>;
    hp_upgrade_cost_change?: Maybe<Scalars['Float']>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars['Int']>;
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>;
    /** A number representing the product's manufacturer. */
    manufacturer?: Maybe<Scalars['Int']>;
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars['String']>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars['String']>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars['String']>;
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars['String']>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars['String']>;
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars['String']>;
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars['Float']>;
    operational_system?: Maybe<Scalars['String']>;
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars['String']>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>;
    /** The range of prices for the product */
    price_range: PriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars['Int'];
    /** An array of related products. */
    related_products?: Maybe<Array<Maybe<ProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars['String']>;
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<ComplexTextValue>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars['String']>;
    /** Small Accessories Image for Catalog Product Image */
    small_accessories?: Maybe<ProductImage>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<ProductImage>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars['String']>;
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars['Float']>;
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars['String']>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars['Boolean'];
    /** Stock status of the product */
    stock_status?: Maybe<ProductStockStatus>;
    storage?: Maybe<Scalars['String']>;
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars['String']>;
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>;
    /** Thumbnail Accessories Image for Catalog Product Image */
    thumbnail_accessories?: Maybe<ProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars['Float']>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars['String']>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID'];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars['String']>;
    /** An array of up-sell products. */
    upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars['String']>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars['String']>;
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars['String']>;
    usage?: Maybe<Scalars['String']>;
    /** An array of simple product variants. */
    variants?: Maybe<Array<Maybe<ConfigurableVariant>>>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>;
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars['Float']>;
  };

/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductConfigurable_Product_Options_SelectionArgs = {
  configurableOptionValueUids?: InputMaybe<Array<Scalars['ID']>>;
};

/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductCustom_AttributesV2Args = {
  filters?: InputMaybe<AttributeFilterInput>;
};

export type ConfigurableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The quantity and SKU of the configurable product. */
  data: CartItemInput;
  /** The SKU of the parent configurable product. */
  parent_sku?: InputMaybe<Scalars['String']>;
  /** Deprecated. Use `CartItemInput.sku` instead. */
  variant_sku?: InputMaybe<Scalars['String']>;
};

/** Contains details about configurable product options. */
export type ConfigurableProductOption = {
  __typename?: 'ConfigurableProductOption';
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars['String'];
  /** The display name of the option. */
  label: Scalars['String'];
  /** The unique ID of the configurable option. */
  uid: Scalars['ID'];
  /** An array of values that are applicable for this option. */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionValue>>>;
};

/** Defines a value for a configurable product option. */
export type ConfigurableProductOptionValue = {
  __typename?: 'ConfigurableProductOptionValue';
  /** Indicates whether the product is available with this selected option. */
  is_available: Scalars['Boolean'];
  /** Indicates whether the value is the default. */
  is_use_default: Scalars['Boolean'];
  /** The display name of the value. */
  label: Scalars['String'];
  /** The URL assigned to the thumbnail of the swatch image. */
  swatch?: Maybe<SwatchDataInterface>;
  /** The unique ID of the value. */
  uid: Scalars['ID'];
};

/** Defines configurable attributes for the specified product. */
export type ConfigurableProductOptions = {
  __typename?: 'ConfigurableProductOptions';
  /** A string that identifies the attribute. */
  attribute_code?: Maybe<Scalars['String']>;
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id?: Maybe<Scalars['String']>;
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id_v2?: Maybe<Scalars['Int']>;
  /** The unique ID for an `Attribute` object. */
  attribute_uid: Scalars['ID'];
  /**
   * The configurable option ID number assigned by the system.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** A displayed string that describes the configurable product option. */
  label?: Maybe<Scalars['String']>;
  /** A number that indicates the order in which the attribute is displayed. */
  position?: Maybe<Scalars['Int']>;
  /**
   * This is the same as a product's `id` field.
   * @deprecated `product_id` is not needed and can be obtained from its parent.
   */
  product_id?: Maybe<Scalars['Int']>;
  /** The unique ID for a `ConfigurableProductOptions` object. */
  uid: Scalars['ID'];
  /** Indicates whether the option is the default. */
  use_default?: Maybe<Scalars['Boolean']>;
  /** An array that defines the `value_index` codes assigned to the configurable product. */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionsValues>>>;
};

/** Contains metadata corresponding to the selected configurable options. */
export type ConfigurableProductOptionsSelection = {
  __typename?: 'ConfigurableProductOptionsSelection';
  /** An array of all possible configurable options. */
  configurable_options?: Maybe<Array<Maybe<ConfigurableProductOption>>>;
  /** Product images and videos corresponding to the specified configurable options selection. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /** The configurable options available for further selection based on the current selection. */
  options_available_for_selection?: Maybe<
    Array<Maybe<ConfigurableOptionAvailableForSelection>>
  >;
  /** A variant represented by the specified configurable options selection. The value is expected to be null until selections are made for each configurable option. */
  variant?: Maybe<SimpleProduct>;
};

/** Contains the index number assigned to a configurable product option. */
export type ConfigurableProductOptionsValues = {
  __typename?: 'ConfigurableProductOptionsValues';
  /** The label of the product on the default store. */
  default_label?: Maybe<Scalars['String']>;
  /** The label of the product. */
  label?: Maybe<Scalars['String']>;
  /** The label of the product on the current store. */
  store_label?: Maybe<Scalars['String']>;
  /** Swatch data for a configurable product option. */
  swatch_data?: Maybe<SwatchDataInterface>;
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  uid?: Maybe<Scalars['ID']>;
  /** Indicates whether to use the default_label. */
  use_default_value?: Maybe<Scalars['Boolean']>;
  /**
   * A unique index number assigned to the configurable product option.
   * @deprecated Use `uid` instead.
   */
  value_index?: Maybe<Scalars['Int']>;
};

/** Contains all the simple product variants of a configurable product. */
export type ConfigurableVariant = {
  __typename?: 'ConfigurableVariant';
  /** An array of configurable attribute options. */
  attributes?: Maybe<Array<Maybe<ConfigurableAttributeOption>>>;
  /** An array of linked simple products. */
  product?: Maybe<SimpleProduct>;
};

/** A configurable product wish list item. */
export type ConfigurableWishlistItem = WishlistItemInterface & {
  __typename?: 'ConfigurableWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /**
   * The SKU of the simple product corresponding to a set of selected configurable options.
   * @deprecated Use `ConfigurableWishlistItem.configured_variant.sku` instead.
   */
  child_sku: Scalars['String'];
  /** An array of selected configurable options. */
  configurable_options?: Maybe<Array<Maybe<SelectedConfigurableOption>>>;
  /** Product details of the selected variant. The value is null if some options are not configured. */
  configured_variant?: Maybe<ProductInterface>;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

/** Contains details about a customer email address to confirm. */
export type ConfirmEmailInput = {
  /** The key to confirm the email address. */
  confirmation_key: Scalars['String'];
  /** The email address to be confirmed. */
  email: Scalars['String'];
};

/** List of account confirmation statuses. */
export type ConfirmationStatusEnum =
  /** Account confirmation not required */
  | 'ACCOUNT_CONFIRMATION_NOT_REQUIRED'
  /** Account confirmed */
  | 'ACCOUNT_CONFIRMED';

export type ContactUsInput = {
  /** The shopper's comment to the merchant. */
  comment: Scalars['String'];
  /** The email address of the shopper. */
  email: Scalars['String'];
  /** The full name of the shopper. */
  name: Scalars['String'];
  /** The shopper's telephone number. */
  telephone?: InputMaybe<Scalars['String']>;
};

/** Contains the status of the request. */
export type ContactUsOutput = {
  __typename?: 'ContactUsOutput';
  /** Indicates whether the request was successful. */
  status: Scalars['Boolean'];
};

export type Country = {
  __typename?: 'Country';
  /** An array of regions within a particular country. */
  available_regions?: Maybe<Array<Maybe<Region>>>;
  /** The name of the country in English. */
  full_name_english?: Maybe<Scalars['String']>;
  /** The name of the country in the current locale. */
  full_name_locale?: Maybe<Scalars['String']>;
  /** The unique ID for a `Country` object. */
  id?: Maybe<Scalars['String']>;
  /** The three-letter abbreviation of the country, such as USA. */
  three_letter_abbreviation?: Maybe<Scalars['String']>;
  /** The two-letter abbreviation of the country, such as US. */
  two_letter_abbreviation?: Maybe<Scalars['String']>;
};

/** The list of country codes. */
export type CountryCodeEnum =
  /** Andorra */
  | 'AD'
  /** United Arab Emirates */
  | 'AE'
  /** Afghanistan */
  | 'AF'
  /** Antigua & Barbuda */
  | 'AG'
  /** Anguilla */
  | 'AI'
  /** Albania */
  | 'AL'
  /** Armenia */
  | 'AM'
  /** Netherlands Antilles */
  | 'AN'
  /** Angola */
  | 'AO'
  /** Antarctica */
  | 'AQ'
  /** Argentina */
  | 'AR'
  /** American Samoa */
  | 'AS'
  /** Austria */
  | 'AT'
  /** Australia */
  | 'AU'
  /** Aruba */
  | 'AW'
  /** Åland Islands */
  | 'AX'
  /** Azerbaijan */
  | 'AZ'
  /** Bosnia & Herzegovina */
  | 'BA'
  /** Barbados */
  | 'BB'
  /** Bangladesh */
  | 'BD'
  /** Belgium */
  | 'BE'
  /** Burkina Faso */
  | 'BF'
  /** Bulgaria */
  | 'BG'
  /** Bahrain */
  | 'BH'
  /** Burundi */
  | 'BI'
  /** Benin */
  | 'BJ'
  /** St. Barthélemy */
  | 'BL'
  /** Bermuda */
  | 'BM'
  /** Brunei */
  | 'BN'
  /** Bolivia */
  | 'BO'
  /** Brazil */
  | 'BR'
  /** Bahamas */
  | 'BS'
  /** Bhutan */
  | 'BT'
  /** Bouvet Island */
  | 'BV'
  /** Botswana */
  | 'BW'
  /** Belarus */
  | 'BY'
  /** Belize */
  | 'BZ'
  /** Canada */
  | 'CA'
  /** Cocos (Keeling) Islands */
  | 'CC'
  /** Congo-Kinshasa */
  | 'CD'
  /** Central African Republic */
  | 'CF'
  /** Congo-Brazzaville */
  | 'CG'
  /** Switzerland */
  | 'CH'
  /** Côte d’Ivoire */
  | 'CI'
  /** Cook Islands */
  | 'CK'
  /** Chile */
  | 'CL'
  /** Cameroon */
  | 'CM'
  /** China */
  | 'CN'
  /** Colombia */
  | 'CO'
  /** Costa Rica */
  | 'CR'
  /** Cuba */
  | 'CU'
  /** Cape Verde */
  | 'CV'
  /** Christmas Island */
  | 'CX'
  /** Cyprus */
  | 'CY'
  /** Czech Republic */
  | 'CZ'
  /** Germany */
  | 'DE'
  /** Djibouti */
  | 'DJ'
  /** Denmark */
  | 'DK'
  /** Dominica */
  | 'DM'
  /** Dominican Republic */
  | 'DO'
  /** Algeria */
  | 'DZ'
  /** Ecuador */
  | 'EC'
  /** Estonia */
  | 'EE'
  /** Egypt */
  | 'EG'
  /** Western Sahara */
  | 'EH'
  /** Eritrea */
  | 'ER'
  /** Spain */
  | 'ES'
  /** Ethiopia */
  | 'ET'
  /** Finland */
  | 'FI'
  /** Fiji */
  | 'FJ'
  /** Falkland Islands */
  | 'FK'
  /** Micronesia */
  | 'FM'
  /** Faroe Islands */
  | 'FO'
  /** France */
  | 'FR'
  /** Gabon */
  | 'GA'
  /** United Kingdom */
  | 'GB'
  /** Grenada */
  | 'GD'
  /** Georgia */
  | 'GE'
  /** French Guiana */
  | 'GF'
  /** Guernsey */
  | 'GG'
  /** Ghana */
  | 'GH'
  /** Gibraltar */
  | 'GI'
  /** Greenland */
  | 'GL'
  /** Gambia */
  | 'GM'
  /** Guinea */
  | 'GN'
  /** Guadeloupe */
  | 'GP'
  /** Equatorial Guinea */
  | 'GQ'
  /** Greece */
  | 'GR'
  /** South Georgia & South Sandwich Islands */
  | 'GS'
  /** Guatemala */
  | 'GT'
  /** Guam */
  | 'GU'
  /** Guinea-Bissau */
  | 'GW'
  /** Guyana */
  | 'GY'
  /** Hong Kong SAR China */
  | 'HK'
  /** Heard &amp; McDonald Islands */
  | 'HM'
  /** Honduras */
  | 'HN'
  /** Croatia */
  | 'HR'
  /** Haiti */
  | 'HT'
  /** Hungary */
  | 'HU'
  /** Indonesia */
  | 'ID'
  /** Ireland */
  | 'IE'
  /** Israel */
  | 'IL'
  /** Isle of Man */
  | 'IM'
  /** India */
  | 'IN'
  /** British Indian Ocean Territory */
  | 'IO'
  /** Iraq */
  | 'IQ'
  /** Iran */
  | 'IR'
  /** Iceland */
  | 'IS'
  /** Italy */
  | 'IT'
  /** Jersey */
  | 'JE'
  /** Jamaica */
  | 'JM'
  /** Jordan */
  | 'JO'
  /** Japan */
  | 'JP'
  /** Kenya */
  | 'KE'
  /** Kyrgyzstan */
  | 'KG'
  /** Cambodia */
  | 'KH'
  /** Kiribati */
  | 'KI'
  /** Comoros */
  | 'KM'
  /** St. Kitts & Nevis */
  | 'KN'
  /** North Korea */
  | 'KP'
  /** South Korea */
  | 'KR'
  /** Kuwait */
  | 'KW'
  /** Cayman Islands */
  | 'KY'
  /** Kazakhstan */
  | 'KZ'
  /** Laos */
  | 'LA'
  /** Lebanon */
  | 'LB'
  /** St. Lucia */
  | 'LC'
  /** Liechtenstein */
  | 'LI'
  /** Sri Lanka */
  | 'LK'
  /** Liberia */
  | 'LR'
  /** Lesotho */
  | 'LS'
  /** Lithuania */
  | 'LT'
  /** Luxembourg */
  | 'LU'
  /** Latvia */
  | 'LV'
  /** Libya */
  | 'LY'
  /** Morocco */
  | 'MA'
  /** Monaco */
  | 'MC'
  /** Moldova */
  | 'MD'
  /** Montenegro */
  | 'ME'
  /** St. Martin */
  | 'MF'
  /** Madagascar */
  | 'MG'
  /** Marshall Islands */
  | 'MH'
  /** Macedonia */
  | 'MK'
  /** Mali */
  | 'ML'
  /** Myanmar (Burma) */
  | 'MM'
  /** Mongolia */
  | 'MN'
  /** Macau SAR China */
  | 'MO'
  /** Northern Mariana Islands */
  | 'MP'
  /** Martinique */
  | 'MQ'
  /** Mauritania */
  | 'MR'
  /** Montserrat */
  | 'MS'
  /** Malta */
  | 'MT'
  /** Mauritius */
  | 'MU'
  /** Maldives */
  | 'MV'
  /** Malawi */
  | 'MW'
  /** Mexico */
  | 'MX'
  /** Malaysia */
  | 'MY'
  /** Mozambique */
  | 'MZ'
  /** Namibia */
  | 'NA'
  /** New Caledonia */
  | 'NC'
  /** Niger */
  | 'NE'
  /** Norfolk Island */
  | 'NF'
  /** Nigeria */
  | 'NG'
  /** Nicaragua */
  | 'NI'
  /** Netherlands */
  | 'NL'
  /** Norway */
  | 'NO'
  /** Nepal */
  | 'NP'
  /** Nauru */
  | 'NR'
  /** Niue */
  | 'NU'
  /** New Zealand */
  | 'NZ'
  /** Oman */
  | 'OM'
  /** Panama */
  | 'PA'
  /** Peru */
  | 'PE'
  /** French Polynesia */
  | 'PF'
  /** Papua New Guinea */
  | 'PG'
  /** Philippines */
  | 'PH'
  /** Pakistan */
  | 'PK'
  /** Poland */
  | 'PL'
  /** St. Pierre & Miquelon */
  | 'PM'
  /** Pitcairn Islands */
  | 'PN'
  /** Palestinian Territories */
  | 'PS'
  /** Portugal */
  | 'PT'
  /** Palau */
  | 'PW'
  /** Paraguay */
  | 'PY'
  /** Qatar */
  | 'QA'
  /** Réunion */
  | 'RE'
  /** Romania */
  | 'RO'
  /** Serbia */
  | 'RS'
  /** Russia */
  | 'RU'
  /** Rwanda */
  | 'RW'
  /** Saudi Arabia */
  | 'SA'
  /** Solomon Islands */
  | 'SB'
  /** Seychelles */
  | 'SC'
  /** Sudan */
  | 'SD'
  /** Sweden */
  | 'SE'
  /** Singapore */
  | 'SG'
  /** St. Helena */
  | 'SH'
  /** Slovenia */
  | 'SI'
  /** Svalbard & Jan Mayen */
  | 'SJ'
  /** Slovakia */
  | 'SK'
  /** Sierra Leone */
  | 'SL'
  /** San Marino */
  | 'SM'
  /** Senegal */
  | 'SN'
  /** Somalia */
  | 'SO'
  /** Suriname */
  | 'SR'
  /** São Tomé & Príncipe */
  | 'ST'
  /** El Salvador */
  | 'SV'
  /** Syria */
  | 'SY'
  /** Eswatini */
  | 'SZ'
  /** Turks & Caicos Islands */
  | 'TC'
  /** Chad */
  | 'TD'
  /** French Southern Territories */
  | 'TF'
  /** Togo */
  | 'TG'
  /** Thailand */
  | 'TH'
  /** Tajikistan */
  | 'TJ'
  /** Tokelau */
  | 'TK'
  /** Timor-Leste */
  | 'TL'
  /** Turkmenistan */
  | 'TM'
  /** Tunisia */
  | 'TN'
  /** Tonga */
  | 'TO'
  /** Turkey */
  | 'TR'
  /** Trinidad & Tobago */
  | 'TT'
  /** Tuvalu */
  | 'TV'
  /** Taiwan */
  | 'TW'
  /** Tanzania */
  | 'TZ'
  /** Ukraine */
  | 'UA'
  /** Uganda */
  | 'UG'
  /** U.S. Outlying Islands */
  | 'UM'
  /** United States */
  | 'US'
  /** Uruguay */
  | 'UY'
  /** Uzbekistan */
  | 'UZ'
  /** Vatican City */
  | 'VA'
  /** St. Vincent & Grenadines */
  | 'VC'
  /** Venezuela */
  | 'VE'
  /** British Virgin Islands */
  | 'VG'
  /** U.S. Virgin Islands */
  | 'VI'
  /** Vietnam */
  | 'VN'
  /** Vanuatu */
  | 'VU'
  /** Wallis & Futuna */
  | 'WF'
  /** Samoa */
  | 'WS'
  /** Yemen */
  | 'YE'
  /** Mayotte */
  | 'YT'
  /** South Africa */
  | 'ZA'
  /** Zambia */
  | 'ZM'
  /** Zimbabwe */
  | 'ZW';

export type CreateGuestCartInput = {
  /** Optional client-generated ID */
  cart_uid?: InputMaybe<Scalars['ID']>;
};

export type CreateGuestCartOutput = {
  __typename?: 'CreateGuestCartOutput';
  /** The newly created cart. */
  cart?: Maybe<Cart>;
};

/** Output of the request to Create payment method. */
export type CreatePaymentMethodOnCartOutput = {
  __typename?: 'CreatePaymentMethodOnCartOutput';
  /** Payment method ID */
  payment_method_id?: Maybe<Scalars['String']>;
};

/** Contains credit memo details. */
export type CreditMemo = {
  __typename?: 'CreditMemo';
  /** Comments on the credit memo. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `CreditMemo` object. */
  id: Scalars['ID'];
  /** An array containing details about refunded items. */
  items?: Maybe<Array<Maybe<CreditMemoItemInterface>>>;
  /** The sequential credit memo number. */
  number: Scalars['String'];
  /** Details about the total refunded amount. */
  total?: Maybe<CreditMemoTotal>;
};

export type CreditMemoItem = CreditMemoItemInterface & {
  __typename?: 'CreditMemoItem';
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
};

/** Credit memo item details. */
export type CreditMemoItemInterface = {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
};

/** Contains credit memo price details. */
export type CreditMemoTotal = {
  __typename?: 'CreditMemoTotal';
  /** An adjustment manually applied to the order. */
  adjustment: Money;
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the credit memo. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the credit memo. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The credit memo tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the credit memo. */
  total_shipping: Money;
  /** The amount of tax applied to the credit memo. */
  total_tax: Money;
};

export type Currency = {
  __typename?: 'Currency';
  /** An array of three-letter currency codes accepted by the store, such as USD and EUR. */
  available_currency_codes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The base currency set for the store, such as USD. */
  base_currency_code?: Maybe<Scalars['String']>;
  /** The symbol for the specified base currency, such as $. */
  base_currency_symbol?: Maybe<Scalars['String']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_code?: Maybe<Scalars['String']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_symbol?: Maybe<Scalars['String']>;
  /** The currency that is displayed by default, such as USD. */
  default_display_currency_code?: Maybe<Scalars['String']>;
  /** The currency symbol that is displayed by default, such as $. */
  default_display_currency_symbol?: Maybe<Scalars['String']>;
  /** An array of exchange rates for currencies defined in the store. */
  exchange_rates?: Maybe<Array<Maybe<ExchangeRate>>>;
};

/** The list of available currency codes. */
export type CurrencyEnum =
  | 'AED'
  | 'AFN'
  | 'ALL'
  | 'AMD'
  | 'ANG'
  | 'AOA'
  | 'ARS'
  | 'AUD'
  | 'AWG'
  | 'AZM'
  | 'AZN'
  | 'BAM'
  | 'BBD'
  | 'BDT'
  | 'BGN'
  | 'BHD'
  | 'BIF'
  | 'BMD'
  | 'BND'
  | 'BOB'
  | 'BRL'
  | 'BSD'
  | 'BTN'
  | 'BUK'
  | 'BWP'
  | 'BYN'
  | 'BZD'
  | 'CAD'
  | 'CDF'
  | 'CHE'
  | 'CHF'
  | 'CHW'
  | 'CLP'
  | 'CNY'
  | 'COP'
  | 'CRC'
  | 'CUP'
  | 'CVE'
  | 'CZK'
  | 'DJF'
  | 'DKK'
  | 'DOP'
  | 'DZD'
  | 'EEK'
  | 'EGP'
  | 'ERN'
  | 'ETB'
  | 'EUR'
  | 'FJD'
  | 'FKP'
  | 'GBP'
  | 'GEK'
  | 'GEL'
  | 'GHS'
  | 'GIP'
  | 'GMD'
  | 'GNF'
  | 'GQE'
  | 'GTQ'
  | 'GYD'
  | 'HKD'
  | 'HNL'
  | 'HRK'
  | 'HTG'
  | 'HUF'
  | 'IDR'
  | 'ILS'
  | 'INR'
  | 'IQD'
  | 'IRR'
  | 'ISK'
  | 'JMD'
  | 'JOD'
  | 'JPY'
  | 'KES'
  | 'KGS'
  | 'KHR'
  | 'KMF'
  | 'KPW'
  | 'KRW'
  | 'KWD'
  | 'KYD'
  | 'KZT'
  | 'LAK'
  | 'LBP'
  | 'LKR'
  | 'LRD'
  | 'LSL'
  | 'LSM'
  | 'LTL'
  | 'LVL'
  | 'LYD'
  | 'MAD'
  | 'MDL'
  | 'MGA'
  | 'MKD'
  | 'MMK'
  | 'MNT'
  | 'MOP'
  | 'MRO'
  | 'MUR'
  | 'MVR'
  | 'MWK'
  | 'MXN'
  | 'MYR'
  | 'MZN'
  | 'NAD'
  | 'NGN'
  | 'NIC'
  | 'NOK'
  | 'NPR'
  | 'NZD'
  | 'OMR'
  | 'PAB'
  | 'PEN'
  | 'PGK'
  | 'PHP'
  | 'PKR'
  | 'PLN'
  | 'PYG'
  | 'QAR'
  | 'RHD'
  | 'ROL'
  | 'RON'
  | 'RSD'
  | 'RUB'
  | 'RWF'
  | 'SAR'
  | 'SBD'
  | 'SCR'
  | 'SDG'
  | 'SEK'
  | 'SGD'
  | 'SHP'
  | 'SKK'
  | 'SLL'
  | 'SOS'
  | 'SRD'
  | 'STD'
  | 'SVC'
  | 'SYP'
  | 'SZL'
  | 'THB'
  | 'TJS'
  | 'TMM'
  | 'TND'
  | 'TOP'
  | 'TRL'
  | 'TRY'
  | 'TTD'
  | 'TWD'
  | 'TZS'
  | 'UAH'
  | 'UGX'
  | 'USD'
  | 'UYU'
  | 'UZS'
  | 'VEB'
  | 'VEF'
  | 'VND'
  | 'VUV'
  | 'WST'
  | 'XCD'
  | 'XOF'
  | 'XPF'
  | 'YER'
  | 'YTL'
  | 'ZAR'
  | 'ZMK'
  | 'ZWD';

/** Defines an array of custom attributes. */
export type CustomAttributeMetadata = {
  __typename?: 'CustomAttributeMetadata';
  /** An array of attributes. */
  items?: Maybe<Array<Maybe<Attribute>>>;
};

/** An interface containing fields that define the EAV attribute. */
export type CustomAttributeMetadataInterface = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars['ID'];
  /** Default attribute value. */
  default_value?: Maybe<Scalars['String']>;
  /** The type of entity that defines the attribute. */
  entity_type: AttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class?: Maybe<Scalars['String']>;
  /** The frontend input type of the attribute. */
  frontend_input?: Maybe<AttributeFrontendInputEnum>;
  /** Whether the attribute value is required. */
  is_required: Scalars['Boolean'];
  /** Whether the attribute value must be unique. */
  is_unique: Scalars['Boolean'];
  /** The label assigned to the attribute. */
  label?: Maybe<Scalars['String']>;
  /** Attribute options. */
  options: Array<Maybe<CustomAttributeOptionInterface>>;
};

export type CustomAttributeOptionInterface = {
  /** Is the option value default. */
  is_default: Scalars['Boolean'];
  /** The label assigned to the attribute option. */
  label: Scalars['String'];
  /** The attribute option value. */
  value: Scalars['String'];
};

/** Defines the customer name, addresses, and other details. */
export type Customer = {
  __typename?: 'Customer';
  /** An array containing the customer's shipping and billing addresses. */
  addresses?: Maybe<Array<Maybe<CustomerAddress>>>;
  /** The customer's confirmation status. */
  confirmation_status: ConfirmationStatusEnum;
  /** Timestamp indicating when the account was created. */
  created_at?: Maybe<Scalars['String']>;
  /** Customer's custom attributes. */
  custom_attributes?: Maybe<Array<Maybe<AttributeValueInterface>>>;
  /** The customer's date of birth. */
  date_of_birth?: Maybe<Scalars['String']>;
  /** The ID assigned to the billing address. */
  default_billing?: Maybe<Scalars['String']>;
  /** The ID assigned to the shipping address. */
  default_shipping?: Maybe<Scalars['String']>;
  /**
   * The customer's date of birth.
   * @deprecated Use `date_of_birth` instead.
   */
  dob?: Maybe<Scalars['String']>;
  /** The customer's email address. Required. */
  email?: Maybe<Scalars['String']>;
  /** The customer's first name. */
  firstname?: Maybe<Scalars['String']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: Maybe<Scalars['Int']>;
  /** @deprecated Customer group should not be exposed in the storefront scenarios. */
  group_id?: Maybe<Scalars['Int']>;
  /**
   * The ID assigned to the customer.
   * @deprecated `id` is not needed as part of `Customer`, because on the server side, it can be identified based on the customer token used for authentication. There is no need to know customer ID on the client side.
   */
  id?: Maybe<Scalars['Int']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: Maybe<Scalars['Boolean']>;
  /** The customer's family name. */
  lastname?: Maybe<Scalars['String']>;
  /** The customer's middle name. */
  middlename?: Maybe<Scalars['String']>;
  orders?: Maybe<CustomerOrders>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  taxvat?: Maybe<Scalars['String']>;
  /**
   * Return a customer's wish lists.
   * @deprecated Use `Customer.wishlists` or `Customer.wishlist_v2` instead.
   */
  wishlist: Wishlist;
  /** Retrieve the wish list identified by the unique ID for a `Wishlist` object. */
  wishlist_v2?: Maybe<Wishlist>;
  /** An array of wishlists. In Magento Open Source, customers are limited to one wish list. The number of wish lists is configurable for Adobe Commerce. */
  wishlists: Array<Maybe<Wishlist>>;
};

/** Defines the customer name, addresses, and other details. */
export type CustomerCustom_AttributesArgs = {
  attributeCodes?: InputMaybe<Array<Scalars['ID']>>;
};

/** Defines the customer name, addresses, and other details. */
export type CustomerOrdersArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CustomerOrdersFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  scope?: InputMaybe<ScopeTypeEnum>;
  sort?: InputMaybe<CustomerOrderSortInput>;
};

/** Defines the customer name, addresses, and other details. */
export type CustomerWishlist_V2Args = {
  id: Scalars['ID'];
};

/** Defines the customer name, addresses, and other details. */
export type CustomerWishlistsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Contains detailed information about a customer's billing or shipping address. */
export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  /** The customer's city or town. */
  city?: Maybe<Scalars['String']>;
  /** The customer's company. */
  company?: Maybe<Scalars['String']>;
  /** The customer's country. */
  country_code?: Maybe<CountryCodeEnum>;
  /**
   * The customer's country.
   * @deprecated Use `country_code` instead.
   */
  country_id?: Maybe<Scalars['String']>;
  /** @deprecated Use custom_attributesV2 instead. */
  custom_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>;
  /** Custom attributes assigned to the customer address. */
  custom_attributesV2: Array<Maybe<AttributeValueInterface>>;
  /**
   * The customer ID
   * @deprecated `customer_id` is not needed as part of `CustomerAddress`. The `id` is a unique identifier for the addresses.
   */
  customer_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the address is the customer's default billing address. */
  default_billing?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the address is the customer's default shipping address. */
  default_shipping?: Maybe<Scalars['Boolean']>;
  /** Contains any extension attributes for the address. */
  extension_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>;
  /** The customer's fax number. */
  fax?: Maybe<Scalars['String']>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname?: Maybe<Scalars['String']>;
  /** The ID of a `CustomerAddress` object. */
  id?: Maybe<Scalars['Int']>;
  /** The family name of the person associated with the shipping/billing address. */
  lastname?: Maybe<Scalars['String']>;
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']>;
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>;
  /** An object containing the region name, region code, and region ID. */
  region?: Maybe<CustomerAddressRegion>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']>;
  /** An array of strings that define the street number and name. */
  street?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>;
  /** The customer's telephone number. */
  telephone?: Maybe<Scalars['String']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars['String']>;
};

/** Contains detailed information about a customer's billing or shipping address. */
export type CustomerAddressCustom_AttributesV2Args = {
  attributeCodes?: InputMaybe<Array<Scalars['ID']>>;
};

/** Specifies the attribute code and value of a customer address attribute. */
export type CustomerAddressAttribute = {
  __typename?: 'CustomerAddressAttribute';
  /** The name assigned to the customer address attribute. */
  attribute_code?: Maybe<Scalars['String']>;
  /** The value assigned to the customer address attribute. */
  value?: Maybe<Scalars['String']>;
};

/** Specifies the attribute code and value of a customer attribute. */
export type CustomerAddressAttributeInput = {
  /** The name assigned to the attribute. */
  attribute_code: Scalars['String'];
  /** The value assigned to the attribute. */
  value: Scalars['String'];
};

/** Contains details about a billing or shipping address. */
export type CustomerAddressInput = {
  /** The customer's city or town. */
  city?: InputMaybe<Scalars['String']>;
  /** The customer's company. */
  company?: InputMaybe<Scalars['String']>;
  /** The two-letter code representing the customer's country. */
  country_code?: InputMaybe<CountryCodeEnum>;
  /** Deprecated: use `country_code` instead. */
  country_id?: InputMaybe<CountryCodeEnum>;
  /** Deprecated. Use custom_attributesV2 instead. */
  custom_attributes?: InputMaybe<
    Array<InputMaybe<CustomerAddressAttributeInput>>
  >;
  /** Custom attributes assigned to the customer address. */
  custom_attributesV2?: InputMaybe<Array<InputMaybe<AttributeValueInput>>>;
  /** Indicates whether the address is the default billing address. */
  default_billing?: InputMaybe<Scalars['Boolean']>;
  /** Indicates whether the address is the default shipping address. */
  default_shipping?: InputMaybe<Scalars['Boolean']>;
  /** The customer's fax number. */
  fax?: InputMaybe<Scalars['String']>;
  /** The first name of the person associated with the billing/shipping address. */
  firstname?: InputMaybe<Scalars['String']>;
  /** The family name of the person associated with the billing/shipping address. */
  lastname?: InputMaybe<Scalars['String']>;
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: InputMaybe<Scalars['String']>;
  /** The customer's ZIP or postal code. */
  postcode?: InputMaybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>;
  /** An object containing the region name, region code, and region ID. */
  region?: InputMaybe<CustomerAddressRegionInput>;
  /** An array of strings that define the street number and name. */
  street?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>;
  /** The customer's telephone number. */
  telephone?: InputMaybe<Scalars['String']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  vat_id?: InputMaybe<Scalars['String']>;
};

/** Defines the customer's state or province. */
export type CustomerAddressRegion = {
  __typename?: 'CustomerAddressRegion';
  /** The state or province name. */
  region?: Maybe<Scalars['String']>;
  /** The address region code. */
  region_code?: Maybe<Scalars['String']>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']>;
};

/** Defines the customer's state or province. */
export type CustomerAddressRegionInput = {
  /** The state or province name. */
  region?: InputMaybe<Scalars['String']>;
  /** The address region code. */
  region_code?: InputMaybe<Scalars['String']>;
  /** The unique ID for a pre-defined region. */
  region_id?: InputMaybe<Scalars['Int']>;
};

/** Customer attribute metadata. */
export type CustomerAttributeMetadata = CustomAttributeMetadataInterface & {
  __typename?: 'CustomerAttributeMetadata';
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  code: Scalars['ID'];
  /** Default attribute value. */
  default_value?: Maybe<Scalars['String']>;
  /** The type of entity that defines the attribute. */
  entity_type: AttributeEntityTypeEnum;
  /** The frontend class of the attribute. */
  frontend_class?: Maybe<Scalars['String']>;
  /** The frontend input type of the attribute. */
  frontend_input?: Maybe<AttributeFrontendInputEnum>;
  /** The template used for the input of the attribute (e.g., 'date'). */
  input_filter?: Maybe<InputFilterEnum>;
  /** Whether the attribute value is required. */
  is_required: Scalars['Boolean'];
  /** Whether the attribute value must be unique. */
  is_unique: Scalars['Boolean'];
  /** The label assigned to the attribute. */
  label?: Maybe<Scalars['String']>;
  /** The number of lines of the attribute value. */
  multiline_count?: Maybe<Scalars['Int']>;
  /** Attribute options. */
  options: Array<Maybe<CustomAttributeOptionInterface>>;
  /** The position of the attribute in the form. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The validation rules of the attribute value. */
  validate_rules?: Maybe<Array<Maybe<ValidationRule>>>;
};

/** An input object for creating a customer. */
export type CustomerCreateInput = {
  /** The customer's custom attributes. */
  custom_attributes?: InputMaybe<Array<InputMaybe<AttributeValueInput>>>;
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']>;
  /** The customer's email address. */
  email: Scalars['String'];
  /** The customer's first name. */
  firstname: Scalars['String'];
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']>;
  /** The customer's family name. */
  lastname: Scalars['String'];
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']>;
  /** The customer's password. */
  password?: InputMaybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']>;
};

/** An input object that assigns or updates customer attributes. */
export type CustomerInput = {
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']>;
  /** The customer's email address. Required when creating a customer. */
  email?: InputMaybe<Scalars['String']>;
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars['String']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']>;
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']>;
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']>;
  /** The customer's password. */
  password?: InputMaybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']>;
};

/** Contains details about each of the customer's orders. */
export type CustomerOrder = {
  __typename?: 'CustomerOrder';
  /** Coupons applied to the order. */
  applied_coupons: Array<Maybe<AppliedCoupon>>;
  /** The billing address for the order. */
  billing_address?: Maybe<OrderAddress>;
  /** The shipping carrier for the order delivery. */
  carrier?: Maybe<Scalars['String']>;
  /** Comments about the order. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** @deprecated Use the `order_date` field instead. */
  created_at?: Maybe<Scalars['String']>;
  /** A list of credit memos. */
  credit_memos?: Maybe<Array<Maybe<CreditMemo>>>;
  /** Order customer email. */
  email?: Maybe<Scalars['String']>;
  /** @deprecated Use the `totals.grand_total` field instead. */
  grand_total?: Maybe<Scalars['Float']>;
  /** The attribution id of the order. */
  hp_partner_compensation?: Maybe<PartnerCompensation>;
  /** The unique ID for a `CustomerOrder` object. */
  id: Scalars['ID'];
  /** @deprecated Use the `id` field instead. */
  increment_id?: Maybe<Scalars['String']>;
  /** A list of invoices for the order. */
  invoices: Array<Maybe<Invoice>>;
  /** An array containing the items purchased in this order. */
  items?: Maybe<Array<Maybe<OrderItemInterface>>>;
  /** The order number. */
  number: Scalars['String'];
  /** The date the order was placed. */
  order_date: Scalars['String'];
  /** @deprecated Use the `number` field instead. */
  order_number: Scalars['String'];
  /** Payment details for the order. */
  payment_methods?: Maybe<Array<Maybe<OrderPaymentMethod>>>;
  /** A list of shipments for the order. */
  shipments?: Maybe<Array<Maybe<OrderShipment>>>;
  /** The shipping address for the order. */
  shipping_address?: Maybe<OrderAddress>;
  /** The delivery method for the order. */
  shipping_method?: Maybe<Scalars['String']>;
  /** The current status of the order. */
  status: Scalars['String'];
  /** The token that can be used to retrieve the order using order query. */
  token: Scalars['String'];
  /** Details about the calculated totals for this order. */
  total?: Maybe<OrderTotal>;
};

/** CustomerOrderSortInput specifies the field to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type CustomerOrderSortInput = {
  /** This enumeration indicates whether to return results in ascending or descending order */
  sort_direction: SortEnum;
  /** Specifies the field to use for sorting */
  sort_field: CustomerOrderSortableField;
};

/** Specifies the field to use for sorting */
export type CustomerOrderSortableField =
  /** Sorts customer orders by created_at field */
  | 'CREATED_AT'
  /** Sorts customer orders by number */
  | 'NUMBER';

/** The collection of orders that match the conditions defined in the filter. */
export type CustomerOrders = {
  __typename?: 'CustomerOrders';
  /** An array of customer orders. */
  items: Array<Maybe<CustomerOrder>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total count of customer orders. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Identifies the filter to use for filtering orders. */
export type CustomerOrdersFilterInput = {
  /** Filters by order number. */
  number?: InputMaybe<FilterStringTypeInput>;
  /** Filters by order id. */
  order_id?: InputMaybe<FilterStringTypeInput>;
};

/** Contains details about a newly-created or updated customer. */
export type CustomerOutput = {
  __typename?: 'CustomerOutput';
  /** Customer details after creating or updating a customer. */
  customer: Customer;
};

/** Contains payment tokens stored in the customer's vault. */
export type CustomerPaymentTokens = {
  __typename?: 'CustomerPaymentTokens';
  /** An array of payment tokens. */
  items: Array<Maybe<PaymentToken>>;
};

/** Contains a customer authorization token. */
export type CustomerToken = {
  __typename?: 'CustomerToken';
  /** The customer authorization token. */
  token?: Maybe<Scalars['String']>;
};

/** An input object for updating a customer. */
export type CustomerUpdateInput = {
  /** The customer's custom attributes. */
  custom_attributes?: InputMaybe<Array<InputMaybe<AttributeValueInput>>>;
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']>;
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars['String']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']>;
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']>;
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']>;
};

/** Contains information about a text area that is defined as part of a customizable option. */
export type CustomizableAreaOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableAreaOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An object that defines a text area. */
  value?: Maybe<CustomizableAreaValue>;
};

/** Defines the price and sku of a product whose page contains a customized text area. */
export type CustomizableAreaValue = {
  __typename?: 'CustomizableAreaValue';
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableAreaValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a set of checkbox values that are defined as part of a customizable option. */
export type CustomizableCheckboxOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableCheckboxOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An array that defines a set of checkbox values. */
  value?: Maybe<Array<Maybe<CustomizableCheckboxValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized set of checkbox values. */
export type CustomizableCheckboxValue = {
  __typename?: 'CustomizableCheckboxValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The order in which the checkbox value is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableCheckboxValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a date picker that is defined as part of a customizable option. */
export type CustomizableDateOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableDateOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An object that defines a date field in a customizable option. */
  value?: Maybe<CustomizableDateValue>;
};

/** Defines the customizable date type. */
export type CustomizableDateTypeEnum = 'DATE' | 'DATE_TIME' | 'TIME';

/** Defines the price and sku of a product whose page contains a customized date picker. */
export type CustomizableDateValue = {
  __typename?: 'CustomizableDateValue';
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** DATE, DATE_TIME or TIME */
  type?: Maybe<CustomizableDateTypeEnum>;
  /** The unique ID for a `CustomizableDateValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a drop down menu that is defined as part of a customizable option. */
export type CustomizableDropDownOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableDropDownOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An array that defines the set of options for a drop down menu. */
  value?: Maybe<Array<Maybe<CustomizableDropDownValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized drop down menu. */
export type CustomizableDropDownValue = {
  __typename?: 'CustomizableDropDownValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableDropDownValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a text field that is defined as part of a customizable option. */
export type CustomizableFieldOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableFieldOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An object that defines a text field. */
  value?: Maybe<CustomizableFieldValue>;
};

/** Defines the price and sku of a product whose page contains a customized text field. */
export type CustomizableFieldValue = {
  __typename?: 'CustomizableFieldValue';
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters?: Maybe<Scalars['Int']>;
  /** The price of the custom value. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableFieldValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a file picker that is defined as part of a customizable option. */
export type CustomizableFileOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableFileOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An object that defines a file value. */
  value?: Maybe<CustomizableFileValue>;
};

/** Defines the price and sku of a product whose page contains a customized file picker. */
export type CustomizableFileValue = {
  __typename?: 'CustomizableFileValue';
  /** The file extension to accept. */
  file_extension?: Maybe<Scalars['String']>;
  /** The maximum width of an image. */
  image_size_x?: Maybe<Scalars['Int']>;
  /** The maximum height of an image. */
  image_size_y?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableFileValue` object. */
  uid: Scalars['ID'];
};

/** Contains information about a multiselect that is defined as part of a customizable option. */
export type CustomizableMultipleOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableMultipleOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An array that defines the set of options for a multiselect. */
  value?: Maybe<Array<Maybe<CustomizableMultipleValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized multiselect. */
export type CustomizableMultipleValue = {
  __typename?: 'CustomizableMultipleValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableMultipleValue` object. */
  uid: Scalars['ID'];
};

/** Defines a customizable option. */
export type CustomizableOptionInput = {
  /** The customizable option ID of the product. */
  id?: InputMaybe<Scalars['Int']>;
  /** The unique ID for a `CartItemInterface` object. */
  uid?: InputMaybe<Scalars['ID']>;
  /** The string value of the option. */
  value_string: Scalars['String'];
};

/** Contains basic information about a customizable option. It can be implemented by several types of configurable options. */
export type CustomizableOptionInterface = {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
};

/** Contains information about customizable product options. */
export type CustomizableProductInterface = {
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
};

/** Contains information about a set of radio buttons that are defined as part of a customizable option. */
export type CustomizableRadioOption = CustomizableOptionInterface & {
  __typename?: 'CustomizableRadioOption';
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID'];
  /** An array that defines a set of radio buttons. */
  value?: Maybe<Array<Maybe<CustomizableRadioValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized set of radio buttons. */
export type CustomizableRadioValue = {
  __typename?: 'CustomizableRadioValue';
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']>;
  /** The order in which the radio button is displayed. */
  sort_order?: Maybe<Scalars['Int']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']>;
  /** The unique ID for a `CustomizableRadioValue` object. */
  uid: Scalars['ID'];
};

/** Indicates whether the request succeeded and returns the remaining customer payment tokens. */
export type DeletePaymentTokenOutput = {
  __typename?: 'DeletePaymentTokenOutput';
  /** A container for the customer's remaining payment tokens. */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>;
  /** Indicates whether the request succeeded. */
  result: Scalars['Boolean'];
};

/** Defines an individual discount. A discount can be applied to the cart as a whole or to an item, shipping. */
export type Discount = {
  __typename?: 'Discount';
  /** The amount of the discount. */
  amount: Money;
  /** The type of the entity the discount is applied to. */
  applied_to: CartDiscountType;
  /** The coupon related to the discount. */
  coupon?: Maybe<AppliedCoupon>;
  /** A description of the discount. */
  label: Scalars['String'];
};

/** Contains a single dynamic block. */
export type DynamicBlock = {
  __typename?: 'DynamicBlock';
  /** The renderable HTML code of the dynamic block. */
  content: ComplexTextValue;
  /** The unique ID of a `DynamicBlock` object. */
  uid: Scalars['ID'];
};

/** Indicates the locations the dynamic block can be placed. If this field is not specified, the query returns all locations. */
export type DynamicBlockLocationEnum =
  | 'CONTENT'
  | 'FOOTER'
  | 'HEADER'
  | 'LEFT'
  | 'RIGHT';

/** Indicates the selected Dynamic Blocks Rotator inline widget. */
export type DynamicBlockTypeEnum =
  | 'CART_PRICE_RULE_RELATED'
  | 'CATALOG_PRICE_RULE_RELATED'
  | 'SPECIFIED';

/** Contains an array of dynamic blocks. */
export type DynamicBlocks = {
  __typename?: 'DynamicBlocks';
  /** An array containing individual dynamic blocks. */
  items: Array<Maybe<DynamicBlock>>;
  /** Metadata for pagination rendering. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of returned dynamic blocks. */
  total_count: Scalars['Int'];
};

/** Defines the dynamic block filter. The filter can identify the block type, location and IDs to return. */
export type DynamicBlocksFilterInput = {
  /** An array of dynamic block UIDs to filter on. */
  dynamic_block_uids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** An array indicating the locations the dynamic block can be placed. */
  locations?: InputMaybe<Array<InputMaybe<DynamicBlockLocationEnum>>>;
  /** A value indicating the type of dynamic block to filter on. */
  type: DynamicBlockTypeEnum;
};

/** Defines a customer-entered option. */
export type EnteredOptionInput = {
  /** The unique ID for a `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  uid: Scalars['ID'];
  /** Text the customer entered. */
  value: Scalars['String'];
};

/** Contains the `uid`, `relative_url`, and `type` attributes. */
export type EntityUrl = {
  __typename?: 'EntityUrl';
  /** @deprecated Use `relative_url` instead. */
  canonical_url?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface`, `CategoryInterface`, `CmsPage`, or similar object associated with the specified URL. This could be a product, category, or CMS page UID. */
  entity_uid?: Maybe<Scalars['ID']>;
  /**
   * The ID assigned to the object associated with the specified url. This could be a product ID, category ID, or page ID.
   * @deprecated Use `entity_uid` instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirectCode?: Maybe<Scalars['Int']>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
};

export type ErrorInterface = {
  /** The returned error message. */
  message: Scalars['String'];
};

/** Contains details about an address. */
export type EstimateAddressInput = {
  /** The two-letter code representing the customer's country. */
  country_code: CountryCodeEnum;
  /** The customer's ZIP or postal code. */
  postcode?: InputMaybe<Scalars['String']>;
  /** An object containing the region name, region code, and region ID. */
  region?: InputMaybe<CustomerAddressRegionInput>;
};

export type EstimateTotalsInput = {
  /** Customer's address to estimate totals. */
  address: EstimateAddressInput;
  /** The unique ID of the cart to query. */
  cart_id: Scalars['String'];
  /** Selected shipping method to estimate totals. */
  shipping_method?: InputMaybe<ShippingMethodInput>;
};

/** Estimate totals output. */
export type EstimateTotalsOutput = {
  __typename?: 'EstimateTotalsOutput';
  /** Cart after totals estimation */
  cart?: Maybe<Cart>;
};

/** Lists the exchange rate. */
export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  /** Specifies the store’s default currency to exchange to. */
  currency_to?: Maybe<Scalars['String']>;
  /** The exchange rate for the store’s default currency. */
  rate?: Maybe<Scalars['Float']>;
};

/** Defines a filter that matches the input exactly. */
export type FilterEqualTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific category ID, specify a value such as `5`. */
  eq?: InputMaybe<Scalars['String']>;
  /** Use this attribute to filter on an array of values. For example, to filter on category IDs 4, 5, and 6, specify a value of `["4", "5", "6"]`. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FilterMatchTypeEnum = 'FULL' | 'PARTIAL';

/** Defines a filter that performs a fuzzy search. */
export type FilterMatchTypeInput = {
  /** Use this attribute to fuzzy match the specified string. For example, to filter on a specific SKU, specify a value such as `24-MB01`. */
  match?: InputMaybe<Scalars['String']>;
  /** Filter match type for fine-tuned results. Possible values FULL or PARTIAL. If match_type is not provided, returned results will default to FULL match. */
  match_type?: InputMaybe<FilterMatchTypeEnum>;
};

/** Defines a filter that matches a range of values, such as prices or dates. */
export type FilterRangeTypeInput = {
  /** Use this attribute to specify the lowest possible value in the range. */
  from?: InputMaybe<Scalars['String']>;
  /** Use this attribute to specify the highest possible value in the range. */
  to?: InputMaybe<Scalars['String']>;
};

/** Defines a filter for an input string. */
export type FilterStringTypeInput = {
  /** Filters items that are exactly the same as the specified string. */
  eq?: InputMaybe<Scalars['String']>;
  /** Filters items that are exactly the same as entries specified in an array of strings. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Defines a filter that performs a fuzzy search using the specified string. */
  match?: InputMaybe<Scalars['String']>;
};

/** Defines the comparison operators that can be used in a filter. */
export type FilterTypeInput = {
  /** Equals. */
  eq?: InputMaybe<Scalars['String']>;
  finset?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** From. Must be used with the `to` field. */
  from?: InputMaybe<Scalars['String']>;
  /** Greater than. */
  gt?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to. */
  gteq?: InputMaybe<Scalars['String']>;
  /** In. The value can contain a set of comma-separated values. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Like. The specified value can contain % (percent signs) to allow matching of 0 or more characters. */
  like?: InputMaybe<Scalars['String']>;
  /** Less than. */
  lt?: InputMaybe<Scalars['String']>;
  /** Less than or equal to. */
  lteq?: InputMaybe<Scalars['String']>;
  /** More than or equal to. */
  moreq?: InputMaybe<Scalars['String']>;
  /** Not equal to. */
  neq?: InputMaybe<Scalars['String']>;
  /** Not in. The value can contain a set of comma-separated values. */
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Not null. */
  notnull?: InputMaybe<Scalars['String']>;
  /** Is null. */
  null?: InputMaybe<Scalars['String']>;
  /** To. Must be used with the `from` field. */
  to?: InputMaybe<Scalars['String']>;
};

/** A single FPT that can be applied to a product price. */
export type FixedProductTax = {
  __typename?: 'FixedProductTax';
  /** The amount of the Fixed Product Tax. */
  amount?: Maybe<Money>;
  /** The display label assigned to the Fixed Product Tax. */
  label?: Maybe<Scalars['String']>;
};

/** Lists display settings for the Fixed Product Tax. */
export type FixedProductTaxDisplaySettings =
  /** The displayed price does not include the FPT amount. The values of `ProductPrice.fixed_product_taxes` and the price including the FPT are displayed separately. This value corresponds to 'Excluding FPT, Including FPT description and final price.' */
  | 'EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS'
  /** The displayed price does not include the FPT amount. The values from `ProductPrice.fixed_product_taxes` are not displayed. This value corresponds to 'Excluding FPT'. */
  | 'EXCLUDE_FPT_WITHOUT_DETAILS'
  /** The FPT feature is not enabled. You can omit `ProductPrice.fixed_product_taxes` from your query. */
  | 'FPT_DISABLED'
  /** The displayed price includes the FPT amount without displaying the `ProductPrice.fixed_product_taxes` values. This value corresponds to 'Including FPT only'. */
  | 'INCLUDE_FPT_WITHOUT_DETAILS'
  /** The displayed price includes the FPT amount while displaying the values of `ProductPrice.fixed_product_taxes` separately. This value corresponds to 'Including FPT and FPT description'. */
  | 'INCLUDE_FPT_WITH_DETAILS';

export type Form = {
  __typename?: 'Form';
  /** Fields in this form with their validation rules */
  fields?: Maybe<Array<Maybe<FormField>>>;
  /** Form identifier (usually the mutation name) */
  id?: Maybe<Scalars['String']>;
};

export type FormField = {
  __typename?: 'FormField';
  /** Field identifier to be used in HTML/frontend */
  id?: Maybe<Scalars['String']>;
  /** Validation rules for this field */
  rules?: Maybe<Array<Maybe<ValidationRule>>>;
};

/** Contains target path parameters. */
export type HttpQueryParameter = {
  __typename?: 'HttpQueryParameter';
  /** A parameter name. */
  name?: Maybe<Scalars['String']>;
  /** A parameter value. */
  value?: Maybe<Scalars['String']>;
};

export type ImageSwatchData = SwatchDataInterface & {
  __typename?: 'ImageSwatchData';
  /** The URL assigned to the thumbnail of the swatch image. */
  thumbnail?: Maybe<Scalars['String']>;
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>;
};

/** Output of the initializeCustomerCart mutation. */
export type InitializeCustomerCartOutput = {
  __typename?: 'InitializeCustomerCartOutput';
  /** The initialized customer cart. */
  cart?: Maybe<Cart>;
  /** An array of errors encountered while adding products to the cart. */
  user_errors: Array<Maybe<UserError>>;
};

/** List of templates/filters applied to customer attribute input. */
export type InputFilterEnum =
  /** Forces attribute input to follow the date format. */
  | 'DATE'
  /** Escape HTML Entities. */
  | 'ESCAPEHTML'
  /** There are no templates or filters to be applied. */
  | 'NONE'
  /** Strip HTML Tags. */
  | 'STRIPTAGS'
  /** Strip whitespace (or other characters) from the beginning and end of the input. */
  | 'TRIM';

export type InstantinkUpgrade = {
  __typename?: 'InstantinkUpgrade';
  cancel?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['String']>;
  friendly_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  printer_image_url?: Maybe<Scalars['String']>;
  printer_model_name?: Maybe<Scalars['String']>;
  printer_serial_number?: Maybe<Scalars['String']>;
  subscription_id?: Maybe<Scalars['String']>;
};

/** Contains an error message when an internal error occurred. */
export type InternalError = ErrorInterface & {
  __typename?: 'InternalError';
  /** The returned error message. */
  message: Scalars['String'];
};

/** Contains invoice details. */
export type Invoice = {
  __typename?: 'Invoice';
  /** Comments on the invoice. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `Invoice` object. */
  id: Scalars['ID'];
  /** Invoiced product details. */
  items?: Maybe<Array<Maybe<InvoiceItemInterface>>>;
  /** Sequential invoice number. */
  number: Scalars['String'];
  /** Invoice total amount details. */
  total?: Maybe<InvoiceTotal>;
};

export type InvoiceItem = InvoiceItemInterface & {
  __typename?: 'InvoiceItem';
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
};

/** Contains detailes about invoiced items. */
export type InvoiceItemInterface = {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
};

/** Contains price details from an invoice. */
export type InvoiceTotal = {
  __typename?: 'InvoiceTotal';
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the invoice. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the invoice. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The invoice tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the invoice. */
  total_shipping: Money;
  /** The amount of tax applied to the invoice. */
  total_tax: Money;
};

/** Contains the result of the `isEmailAvailable` query. */
export type IsEmailAvailableOutput = {
  __typename?: 'IsEmailAvailableOutput';
  /** Indicates whether the specified email address can be used to create a customer. */
  is_email_available?: Maybe<Scalars['Boolean']>;
};

export type Item = {
  __typename?: 'Item';
  option_id?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<Option>>>;
  title?: Maybe<Scalars['String']>;
};

/** A list of options of the selected bundle product. */
export type ItemSelectedBundleOption = {
  __typename?: 'ItemSelectedBundleOption';
  /**
   * The unique ID for a `ItemSelectedBundleOption` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars['ID'];
  /** The label of the option. */
  label: Scalars['String'];
  /** The unique ID for a `ItemSelectedBundleOption` object. */
  uid: Scalars['ID'];
  /** A list of products that represent the values of the parent option. */
  values?: Maybe<Array<Maybe<ItemSelectedBundleOptionValue>>>;
};

/** A list of values for the selected bundle product. */
export type ItemSelectedBundleOptionValue = {
  __typename?: 'ItemSelectedBundleOptionValue';
  /** HP Product type of the product. */
  hp_product_type_label?: Maybe<Scalars['String']>;
  /** HP Storage Amount of the product. */
  hp_storage_amount?: Maybe<Scalars['Float']>;
  /** HP Storage Uom of the product. */
  hp_storage_uom_label?: Maybe<Scalars['String']>;
  /**
   * The unique ID for a `ItemSelectedBundleOptionValue` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars['ID'];
  /** The price of the child bundle product. */
  price: Money;
  /** The name of the child bundle product. */
  product_name: Scalars['String'];
  /** The SKU of the child bundle product. */
  product_sku: Scalars['String'];
  /** The number of this bundle product that were ordered. */
  quantity: Scalars['Float'];
  /** The unique ID for a `ItemSelectedBundleOptionValue` object. */
  uid: Scalars['ID'];
};

/** Contains a key-value pair. */
export type KeyValue = {
  __typename?: 'KeyValue';
  /** The name part of the key/value pair. */
  name?: Maybe<Scalars['String']>;
  /** The value part of the key/value pair. */
  value?: Maybe<Scalars['String']>;
};

/** Contains information for rendering layered navigation. */
export type LayerFilter = {
  __typename?: 'LayerFilter';
  /**
   * An array of filter items.
   * @deprecated Use `Aggregation.options` instead.
   */
  filter_items?: Maybe<Array<Maybe<LayerFilterItemInterface>>>;
  /**
   * The count of filter items in filter group.
   * @deprecated Use `Aggregation.count` instead.
   */
  filter_items_count?: Maybe<Scalars['Int']>;
  /**
   * The name of a layered navigation filter.
   * @deprecated Use `Aggregation.label` instead.
   */
  name?: Maybe<Scalars['String']>;
  /**
   * The request variable name for a filter query.
   * @deprecated Use `Aggregation.attribute_code` instead.
   */
  request_var?: Maybe<Scalars['String']>;
};

export type LayerFilterItem = LayerFilterItemInterface & {
  __typename?: 'LayerFilterItem';
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']>;
};

export type LayerFilterItemInterface = {
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']>;
};

export type LineItem = {
  __typename?: 'LineItem';
  features?: Maybe<Array<Maybe<Scalars['String']>>>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sku?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Array<Maybe<LineItemThumbnail>>>;
  title?: Maybe<Scalars['String']>;
};

export type LineItemThumbnail = {
  __typename?: 'LineItemThumbnail';
  src?: Maybe<Scalars['String']>;
};

/** Defines characteristics about images and videos associated with a specific product. */
export type MediaGalleryEntry = {
  __typename?: 'MediaGalleryEntry';
  /** Details about the content of the media gallery item. */
  content?: Maybe<ProductMediaGalleryEntriesContent>;
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The path of the image on the server. */
  file?: Maybe<Scalars['String']>;
  /**
   * The identifier assigned to the object.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The alt text displayed on the storefront when the user points to the image. */
  label?: Maybe<Scalars['String']>;
  /** Either `image` or `video`. */
  media_type?: Maybe<Scalars['String']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The unique ID for a `MediaGalleryEntry` object. */
  uid: Scalars['ID'];
  /** Details about the content of a video item. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>;
};

/** Contains basic information about a product image or video. */
export type MediaGalleryInterface = {
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']>;
};

/** Defines a monetary value, including a numeric value and a currency code. */
export type Money = {
  __typename?: 'Money';
  /** A three-letter currency code, such as USD or EUR. */
  currency?: Maybe<CurrencyEnum>;
  /** A number expressing a monetary value. */
  value?: Maybe<Scalars['Float']>;
};

export type MonthlyTotal = {
  __typename?: 'MonthlyTotal';
  /** Device Monthly Total With Tax */
  device_monthly_total_with_tax: Money;
  /** Device Monthly Total Without Tax */
  device_monthly_total_without_tax: Money;
  /** Subscription Monthly Total With Tax */
  subscription_monthly_total_with_tax: Money;
  /** Subscription Monthly Total Without Tax */
  subscription_monthly_total_without_tax: Money;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Add one or more bundle products to the specified cart. We recommend using `addProductsToCart` instead. */
  addBundleProductsToCart?: Maybe<AddBundleProductsToCartOutput>;
  /** Add one or more configurable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addConfigurableProductsToCart?: Maybe<AddConfigurableProductsToCartOutput>;
  /** Add paper to the cart. */
  addPaperToCart?: Maybe<AddPaperToCartOutput>;
  /** Add any type of product to the cart. */
  addProductsToCart?: Maybe<AddProductsToCartOutput>;
  /** Add any type of product to the cart. */
  addProductsToUpgradeCart?: Maybe<AddProductsToCartOutput>;
  /** Add one or more products to the specified wish list. This mutation supports all product types. */
  addProductsToWishlist?: Maybe<AddProductsToWishlistOutput>;
  /** Add one or more simple products to the specified cart. We recommend using `addProductsToCart` instead. */
  addSimpleProductsToCart?: Maybe<AddSimpleProductsToCartOutput>;
  /** Add one or more virtual products to the specified cart. We recommend using `addProductsToCart` instead. */
  addVirtualProductsToCart?: Maybe<AddVirtualProductsToCartOutput>;
  /** Add items in the specified wishlist to the customer's cart. */
  addWishlistItemsToCart?: Maybe<AddWishlistItemsToCartOutput>;
  /** Apply a pre-defined coupon code to the specified cart. */
  applyCouponToCart?: Maybe<ApplyCouponToCartOutput>;
  /** Apply a pre-defined coupon code to the specified cart. */
  applyCouponsToCart?: Maybe<ApplyCouponToCartOutput>;
  /** Assign a logged-in customer to the specified guest shopping cart. */
  assignCustomerToGuestCart: Cart;
  /** Cancel the specified customer order. */
  cancelOrder?: Maybe<CancelOrderOutput>;
  /** Change the password for the logged-in customer. */
  changeCustomerPassword?: Maybe<Customer>;
  /** Remove all items from the specified cart. */
  clearCart: ClearCartOutput;
  /** Remove all items from the specified cart. */
  clearCustomerCart?: Maybe<ClearCustomerCartOutput>;
  /** Confirms the email address for a customer. */
  confirmEmail?: Maybe<CustomerOutput>;
  /** Send a 'Contact Us' email to the merchant. */
  contactUs?: Maybe<ContactUsOutput>;
  /** Use `createCustomerV2` instead. */
  createCustomer?: Maybe<CustomerOutput>;
  /** Create a billing or shipping address for a customer or guest. */
  createCustomerAddress?: Maybe<CustomerAddress>;
  /** Create a customer account. */
  createCustomerV2?: Maybe<CustomerOutput>;
  /**
   * Create an empty shopping cart for a guest or logged in user
   * @deprecated Use `Mutation.createGuestCart` or `Query.customerCart` for logged in customer
   */
  createEmptyCart?: Maybe<Scalars['String']>;
  /** Create a new shopping cart */
  createGuestCart?: Maybe<CreateGuestCartOutput>;
  /** Create payment method using pickup code. */
  createPaymentMethodOnCartFromCode?: Maybe<CreatePaymentMethodOnCartOutput>;
  /** Delete customer account */
  deleteCustomer?: Maybe<Scalars['Boolean']>;
  /** Delete the billing or shipping address of a customer. */
  deleteCustomerAddress?: Maybe<Scalars['Boolean']>;
  /** Delete a customer's payment token. */
  deletePaymentToken?: Maybe<DeletePaymentTokenOutput>;
  /** Estimate shipping method(s) for cart based on address */
  estimateShippingMethods?: Maybe<Array<Maybe<AvailableShippingMethod>>>;
  /** Estimate totals for cart based on the address */
  estimateTotals: EstimateTotalsOutput;
  /** Generate a token for specified customer. */
  generateCustomerToken?: Maybe<CustomerToken>;
  /** Creates a customer cart, adds the specified product, and returns the cart. */
  initializeCustomerCart?: Maybe<InitializeCustomerCartOutput>;
  /** Transfer the contents of a guest cart into the cart of a logged-in customer. */
  mergeCarts: Cart;
  /** Convert the quote into an order. */
  placeOrder?: Maybe<PlaceOrderOutput>;
  /** Remove a previously-applied coupon from the cart. The cart must contain at least one item in order to remove the coupon. */
  removeCouponFromCart?: Maybe<RemoveCouponFromCartOutput>;
  /** Remove a previously-applied coupon from the cart. The cart must contain at least one item in order to remove the coupon. */
  removeCouponsFromCart?: Maybe<RemoveCouponFromCartOutput>;
  /** Delete the entire quantity of a specified item from the cart. If you remove all items from the cart, the cart continues to exist. */
  removeItemFromCart?: Maybe<RemoveItemFromCartOutput>;
  /** Removes a paper from the cart. */
  removePaperFromCart?: Maybe<RemovePaperFromCartOutput>;
  /** Remove one or more products from the specified wish list. */
  removeProductsFromWishlist?: Maybe<RemoveProductsFromWishlistOutput>;
  /** Add all products from a customer's previous order to the cart. */
  reorderItems?: Maybe<ReorderItemsOutput>;
  /** Request an email with a reset password token for the registered customer identified by the specified email. */
  requestPasswordResetEmail?: Maybe<Scalars['Boolean']>;
  /** Reset a customer's password using the reset password token that the customer received in an email after requesting it using `requestPasswordResetEmail`. */
  resetPassword?: Maybe<Scalars['Boolean']>;
  /** Revoke the customer token. */
  revokeCustomerToken?: Maybe<RevokeCustomerTokenOutput>;
  /** Set the billing address on a specific cart. */
  setBillingAddressOnCart?: Maybe<SetBillingAddressOnCartOutput>;
  /** Assign the email address of a guest to the cart. */
  setGuestEmailOnCart?: Maybe<SetGuestEmailOnCartOutput>;
  /**
   * Set the cart payment method and convert the cart into an order.
   * @deprecated Should use setPaymentMethodOnCart and placeOrder mutations in single request.
   */
  setPaymentMethodAndPlaceOrder?: Maybe<PlaceOrderOutput>;
  /** Set payment method ID directly on cart for post-enrollment flow. */
  setPaymentMethodIdOnCart?: Maybe<CreatePaymentMethodOnCartOutput>;
  /** Apply a payment method to the cart. */
  setPaymentMethodOnCart?: Maybe<SetPaymentMethodOnCartOutput>;
  /** Set one or more shipping addresses on a specific cart. */
  setShippingAddressesOnCart?: Maybe<SetShippingAddressesOnCartOutput>;
  /** Set one or more delivery methods on a cart. */
  setShippingMethodsOnCart?: Maybe<SetShippingMethodsOnCartOutput>;
  /** Set subscription upgrades for a customer's cart */
  setSubscriptionUpgrades?: Maybe<SetSubscriptionUpgradesOutput>;
  /** Subscribe the specified email to the store's newsletter. */
  subscribeEmailToNewsletter?: Maybe<SubscribeEmailToNewsletterOutput>;
  /** Modify items in the cart. */
  updateCartItems?: Maybe<UpdateCartItemsOutput>;
  /** Use `updateCustomerV2` instead. */
  updateCustomer?: Maybe<CustomerOutput>;
  /** Update the billing or shipping address of a customer or guest. */
  updateCustomerAddress?: Maybe<CustomerAddress>;
  /** Change the email address for the logged-in customer. */
  updateCustomerEmail?: Maybe<CustomerOutput>;
  /** Update the customer's personal information. */
  updateCustomerV2?: Maybe<CustomerOutput>;
  /** Update payment method CVV using pickup code for card reuse flow. */
  updatePaymentMethodCvvOnCartFromCode?: Maybe<UpdatePaymentMethodCvvOutput>;
  /** Update one or more products in the specified wish list. */
  updateProductsInWishlist?: Maybe<UpdateProductsInWishlistOutput>;
};

export type MutationAddBundleProductsToCartArgs = {
  input?: InputMaybe<AddBundleProductsToCartInput>;
};

export type MutationAddConfigurableProductsToCartArgs = {
  input?: InputMaybe<AddConfigurableProductsToCartInput>;
};

export type MutationAddPaperToCartArgs = {
  input: AddPaperToCartInput;
};

export type MutationAddProductsToCartArgs = {
  cartId: Scalars['String'];
  cartItems: Array<CartItemInput>;
  partner_input?: InputMaybe<PartnerInput>;
};

export type MutationAddProductsToUpgradeCartArgs = {
  cartItems: Array<CartItemInput>;
  hp_subscription_id: Scalars['String'];
  partner_input?: InputMaybe<PartnerInput>;
};

export type MutationAddProductsToWishlistArgs = {
  wishlistId: Scalars['ID'];
  wishlistItems: Array<WishlistItemInput>;
};

export type MutationAddSimpleProductsToCartArgs = {
  input?: InputMaybe<AddSimpleProductsToCartInput>;
};

export type MutationAddVirtualProductsToCartArgs = {
  input?: InputMaybe<AddVirtualProductsToCartInput>;
};

export type MutationAddWishlistItemsToCartArgs = {
  wishlistId: Scalars['ID'];
  wishlistItemIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type MutationApplyCouponToCartArgs = {
  input?: InputMaybe<ApplyCouponToCartInput>;
};

export type MutationApplyCouponsToCartArgs = {
  input?: InputMaybe<ApplyCouponsToCartInput>;
};

export type MutationAssignCustomerToGuestCartArgs = {
  cart_id: Scalars['String'];
  subscription_id?: InputMaybe<Scalars['String']>;
};

export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};

export type MutationChangeCustomerPasswordArgs = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

export type MutationClearCartArgs = {
  input: ClearCartInput;
};

export type MutationClearCustomerCartArgs = {
  cartUid: Scalars['String'];
};

export type MutationConfirmEmailArgs = {
  input: ConfirmEmailInput;
};

export type MutationContactUsArgs = {
  input: ContactUsInput;
};

export type MutationCreateCustomerArgs = {
  input: CustomerInput;
};

export type MutationCreateCustomerAddressArgs = {
  input: CustomerAddressInput;
};

export type MutationCreateCustomerV2Args = {
  input: CustomerCreateInput;
};

export type MutationCreateEmptyCartArgs = {
  input?: InputMaybe<CreateEmptyCartInput>;
};

export type MutationCreateGuestCartArgs = {
  input?: InputMaybe<CreateGuestCartInput>;
};

export type MutationCreatePaymentMethodOnCartFromCodeArgs = {
  input?: InputMaybe<PaymentOptionsInput>;
  pickupCode: Scalars['String'];
};

export type MutationDeleteCustomerAddressArgs = {
  id: Scalars['Int'];
};

export type MutationDeletePaymentTokenArgs = {
  public_hash: Scalars['String'];
};

export type MutationEstimateShippingMethodsArgs = {
  input: EstimateTotalsInput;
};

export type MutationEstimateTotalsArgs = {
  input: EstimateTotalsInput;
};

export type MutationGenerateCustomerTokenArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type MutationInitializeCustomerCartArgs = {
  cartItems: Array<CartItemInput>;
};

export type MutationMergeCartsArgs = {
  destination_cart_id?: InputMaybe<Scalars['String']>;
  source_cart_id: Scalars['String'];
};

export type MutationPlaceOrderArgs = {
  input?: InputMaybe<PlaceOrderInput>;
};

export type MutationRemoveCouponFromCartArgs = {
  input?: InputMaybe<RemoveCouponFromCartInput>;
};

export type MutationRemoveCouponsFromCartArgs = {
  input?: InputMaybe<RemoveCouponsFromCartInput>;
};

export type MutationRemoveItemFromCartArgs = {
  input?: InputMaybe<RemoveItemFromCartInput>;
};

export type MutationRemovePaperFromCartArgs = {
  input: RemovePaperFromCartInput;
};

export type MutationRemoveProductsFromWishlistArgs = {
  wishlistId: Scalars['ID'];
  wishlistItemsIds: Array<Scalars['ID']>;
};

export type MutationReorderItemsArgs = {
  orderNumber: Scalars['String'];
};

export type MutationRequestPasswordResetEmailArgs = {
  email: Scalars['String'];
};

export type MutationResetPasswordArgs = {
  email: Scalars['String'];
  newPassword: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};

export type MutationSetBillingAddressOnCartArgs = {
  input?: InputMaybe<SetBillingAddressOnCartInput>;
};

export type MutationSetGuestEmailOnCartArgs = {
  input?: InputMaybe<SetGuestEmailOnCartInput>;
};

export type MutationSetPaymentMethodAndPlaceOrderArgs = {
  input?: InputMaybe<SetPaymentMethodAndPlaceOrderInput>;
};

export type MutationSetPaymentMethodIdOnCartArgs = {
  input?: InputMaybe<PaymentOptionsInput>;
  paymentMethodId: Scalars['String'];
};

export type MutationSetPaymentMethodOnCartArgs = {
  input?: InputMaybe<SetPaymentMethodOnCartInput>;
};

export type MutationSetShippingAddressesOnCartArgs = {
  input?: InputMaybe<SetShippingAddressesOnCartInput>;
};

export type MutationSetShippingMethodsOnCartArgs = {
  input?: InputMaybe<SetShippingMethodsOnCartInput>;
};

export type MutationSetSubscriptionUpgradesArgs = {
  input: SetSubscriptionUpgradesInput;
};

export type MutationSubscribeEmailToNewsletterArgs = {
  email: Scalars['String'];
};

export type MutationUpdateCartItemsArgs = {
  input?: InputMaybe<UpdateCartItemsInput>;
};

export type MutationUpdateCustomerArgs = {
  input: CustomerInput;
};

export type MutationUpdateCustomerAddressArgs = {
  id: Scalars['Int'];
  input?: InputMaybe<CustomerAddressInput>;
};

export type MutationUpdateCustomerEmailArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type MutationUpdateCustomerV2Args = {
  input: CustomerUpdateInput;
};

export type MutationUpdatePaymentMethodCvvOnCartFromCodeArgs = {
  input?: InputMaybe<PaymentOptionsInput>;
  pickupCode: Scalars['String'];
};

export type MutationUpdateProductsInWishlistArgs = {
  wishlistId: Scalars['ID'];
  wishlistItems: Array<WishlistItemUpdateInput>;
};

/** Contains an error message when an invalid UID was specified. */
export type NoSuchEntityUidError = ErrorInterface & {
  __typename?: 'NoSuchEntityUidError';
  /** The returned error message. */
  message: Scalars['String'];
  /** The specified invalid unique ID of an object. */
  uid: Scalars['ID'];
};

export type Option = {
  __typename?: 'Option';
  label?: Maybe<Scalars['String']>;
  product?: Maybe<ProductDetail>;
  required_sku?: Maybe<Scalars['String']>;
};

/** Contains the order ID. */
export type Order = {
  __typename?: 'Order';
  /** Get a list of Instant Ink subscriptions. */
  instantinkUpgrades?: Maybe<Array<Maybe<InstantinkUpgrade>>>;
  /** @deprecated Use `order_number` instead. */
  order_id?: Maybe<Scalars['String']>;
  /** The unique ID for an `Order` object. */
  order_number: Scalars['String'];
};

/** Contains detailed information about an order's billing and shipping addresses. */
export type OrderAddress = {
  __typename?: 'OrderAddress';
  /** The city or town. */
  city: Scalars['String'];
  /** The customer's company. */
  company?: Maybe<Scalars['String']>;
  /** The customer's country. */
  country_code?: Maybe<CountryCodeEnum>;
  /** The fax number. */
  fax?: Maybe<Scalars['String']>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname: Scalars['String'];
  /** The family name of the person associated with the shipping/billing address. */
  lastname: Scalars['String'];
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']>;
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>;
  /** The state or province name. */
  region?: Maybe<Scalars['String']>;
  /** The unique ID for a `Region` object of a pre-defined region. */
  region_id?: Maybe<Scalars['ID']>;
  /** An array of strings that define the street number and name. */
  street: Array<Maybe<Scalars['String']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>;
  /** The telephone number. */
  telephone?: Maybe<Scalars['String']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars['String']>;
};

/** Input to retrieve an order based on details. */
export type OrderInformationInput = {
  /** Order billing address email. */
  email: Scalars['String'];
  /** Order number. */
  number: Scalars['String'];
  /** Order billing address postcode. */
  postcode: Scalars['String'];
};

export type OrderItem = OrderItemInterface & {
  __typename?: 'OrderItem';
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** Product number of the product. */
  hp_product_number?: Maybe<Scalars['String']>;
  /** Product type of the product. */
  hp_product_type_label?: Maybe<Scalars['String']>;
  /** Product hp_short_config_name of the product. */
  hp_short_config_name?: Maybe<Scalars['String']>;
  /** HP Storage Amount of the product. */
  hp_storage_amount?: Maybe<Scalars['Float']>;
  /** HP Storage Uom of the product. */
  hp_storage_uom_label?: Maybe<Scalars['String']>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID'];
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<ProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>;
};

/** Order item details. */
export type OrderItemInterface = {
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** Product number of the product. */
  hp_product_number?: Maybe<Scalars['String']>;
  /** Product type of the product. */
  hp_product_type_label?: Maybe<Scalars['String']>;
  /** Product hp_short_config_name of the product. */
  hp_short_config_name?: Maybe<Scalars['String']>;
  /** HP Storage Amount of the product. */
  hp_storage_amount?: Maybe<Scalars['Float']>;
  /** HP Storage Uom of the product. */
  hp_storage_uom_label?: Maybe<Scalars['String']>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID'];
  /** The ProductInterface object, which contains details about the base product */
  product?: Maybe<ProductInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']>;
};

/** Represents order item options like selected or entered. */
export type OrderItemOption = {
  __typename?: 'OrderItemOption';
  /** The name of the option. */
  label: Scalars['String'];
  /** The value of the option. */
  value: Scalars['String'];
};

/** Contains details about the payment method used to pay for the order. */
export type OrderPaymentMethod = {
  __typename?: 'OrderPaymentMethod';
  /** Additional data per payment method type. */
  additional_data?: Maybe<Array<Maybe<KeyValue>>>;
  /** The label that describes the payment method. */
  name: Scalars['String'];
  /** The payment method code that indicates how the order was paid for. */
  type: Scalars['String'];
};

/** Contains order shipment details. */
export type OrderShipment = {
  __typename?: 'OrderShipment';
  /** Comments added to the shipment. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `OrderShipment` object. */
  id: Scalars['ID'];
  /** An array of items included in the shipment. */
  items?: Maybe<Array<Maybe<ShipmentItemInterface>>>;
  /** The sequential credit shipment number. */
  number: Scalars['String'];
  /** An array of shipment tracking details. */
  tracking?: Maybe<Array<Maybe<ShipmentTracking>>>;
};

/** Input to retrieve an order based on token. */
export type OrderTokenInput = {
  /** Order token. */
  token: Scalars['String'];
};

/** Contains details about the sales total amounts used to calculate the final price. */
export type OrderTotal = {
  __typename?: 'OrderTotal';
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** Hardware cost applied to the order. */
  device_total_with_tax: Money;
  /** The applied discounts to the order. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Total Subscription applied to the order. */
  hp_total_subscription_price: Money;
  /** Service Cost applied to the order. */
  services_total_with_tax: Money;
  /** Details about the shipping and handling costs for the order. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the order, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The order tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the order. */
  total_shipping: Money;
  /** The amount of tax applied to the order. */
  total_tax: Money;
};

export type PartnerCompensation = {
  __typename?: 'PartnerCompensation';
  /** The attribution id of the partner channel. */
  hp_attribution_id?: Maybe<Scalars['String']>;
  /** The offramp redirect url of the partner channel. */
  hp_off_ramp_redirect_url?: Maybe<Scalars['String']>;
  /** The URL of the partner logo. */
  hp_partner_logo_url?: Maybe<Scalars['String']>;
  /** The name of the partner. */
  hp_partner_name?: Maybe<Scalars['String']>;
};

export type PartnerFmv = {
  __typename?: 'PartnerFmv';
  /** The fare market value of product for Partner. */
  fmv?: Maybe<Scalars['Float']>;
  /** The Partner Code. */
  partner_code?: Maybe<Scalars['String']>;
};

export type PartnerInput = {
  /** The partner channel_code. */
  channel_code?: InputMaybe<Scalars['String']>;
  /** The partner pin_code. */
  pin_code?: InputMaybe<Scalars['String']>;
  /** The partner promo_code. */
  promo_code?: InputMaybe<Scalars['String']>;
};

/** Defines the payment method. */
export type PaymentMethodInput = {
  /** The internal name for the payment method. */
  code: Scalars['String'];
  /** The purchase order number. Optional for most payment methods. */
  purchase_order_number?: InputMaybe<Scalars['String']>;
};

/** Payment options */
export type PaymentOptionsInput = {
  subscription_default?: InputMaybe<Scalars['Boolean']>;
  transaction_default?: InputMaybe<Scalars['Boolean']>;
};

/** The stored payment method available to the customer. */
export type PaymentToken = {
  __typename?: 'PaymentToken';
  /** A description of the stored account details. */
  details?: Maybe<Scalars['String']>;
  /** The payment method code associated with the token. */
  payment_method_code: Scalars['String'];
  /** The public hash of the token. */
  public_hash: Scalars['String'];
  /** Specifies the payment token type. */
  type: PaymentTokenTypeEnum;
};

/** The list of available payment token types. */
export type PaymentTokenTypeEnum =
  /** phpcs:ignore Magento2.GraphQL.ValidArgumentName */
  | 'account'
  /** phpcs:ignore Magento2.GraphQL.ValidArgumentName */
  | 'card';

export type PdpConfigState = {
  __typename?: 'PdpConfigState';
  prices: Prices;
  selected_options: Array<Scalars['String']>;
};

export type PgsDetails = {
  __typename?: 'PgsDetails';
  /** Type of the credit card (e.g., Visa, Mastercard) */
  card_type?: Maybe<Scalars['String']>;
  /** Expiration date of the credit card */
  expiration_date?: Maybe<Scalars['String']>;
  iframe_url?: Maybe<Scalars['String']>;
  /** Last 4 digits of the credit card */
  last_four?: Maybe<Scalars['String']>;
  merchant_name?: Maybe<Scalars['String']>;
  /** Name on the credit card */
  name_on_card?: Maybe<Scalars['String']>;
  quote_id?: Maybe<Scalars['Int']>;
  request_time?: Maybe<Scalars['String']>;
  stratus_customer_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['String']>;
};

/** Contains attributes specific to tangible products. */
export type PhysicalProductInterface = {
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']>;
};

/** Defines Pickup Location information. */
export type PickupLocation = {
  __typename?: 'PickupLocation';
  city?: Maybe<Scalars['String']>;
  contact_name?: Maybe<Scalars['String']>;
  country_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  pickup_location_code?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  region_id?: Maybe<Scalars['Int']>;
  street?: Maybe<Scalars['String']>;
};

/** PickupLocationFilterInput defines the list of attributes and filters for the search. */
export type PickupLocationFilterInput = {
  /** Filter by city. */
  city?: InputMaybe<FilterTypeInput>;
  /** Filter by country. */
  country_id?: InputMaybe<FilterTypeInput>;
  /** Filter by pickup location name. */
  name?: InputMaybe<FilterTypeInput>;
  /** Filter by pickup location code. */
  pickup_location_code?: InputMaybe<FilterTypeInput>;
  /** Filter by postcode. */
  postcode?: InputMaybe<FilterTypeInput>;
  /** Filter by region. */
  region?: InputMaybe<FilterTypeInput>;
  /** Filter by region id. */
  region_id?: InputMaybe<FilterTypeInput>;
  /** Filter by street. */
  street?: InputMaybe<FilterTypeInput>;
};

/** PickupLocationSortInput specifies attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type PickupLocationSortInput = {
  /** City where pickup location is placed. */
  city?: InputMaybe<SortEnum>;
  /** Name of the contact person. */
  contact_name?: InputMaybe<SortEnum>;
  /** Id of the country in two letters. */
  country_id?: InputMaybe<SortEnum>;
  /** Description of the pickup location. */
  description?: InputMaybe<SortEnum>;
  /** Distance to the address, requested by distance filter. Applicable only with distance filter. If distance sort order is present, all other sort orders will be ignored. */
  distance?: InputMaybe<SortEnum>;
  /** Contact email of the pickup location. */
  email?: InputMaybe<SortEnum>;
  /** Contact fax of the pickup location. */
  fax?: InputMaybe<SortEnum>;
  /** Geographic latitude where pickup location is placed. */
  latitude?: InputMaybe<SortEnum>;
  /** Geographic longitude where pickup location is placed. */
  longitude?: InputMaybe<SortEnum>;
  /** The pickup location name. Customer use this to identify the pickup location. */
  name?: InputMaybe<SortEnum>;
  /** Contact phone number of the pickup location. */
  phone?: InputMaybe<SortEnum>;
  /** A code assigned to pickup location to identify the source. */
  pickup_location_code?: InputMaybe<SortEnum>;
  /** Postcode where pickup location is placed. */
  postcode?: InputMaybe<SortEnum>;
  /** Name of the region. */
  region?: InputMaybe<SortEnum>;
  /** Id of the region. */
  region_id?: InputMaybe<SortEnum>;
  /** Street where pickup location is placed. */
  street?: InputMaybe<SortEnum>;
};

/** Top level object returned in a pickup locations search. */
export type PickupLocations = {
  __typename?: 'PickupLocations';
  /** An array of pickup locations that match the specific search request. */
  items?: Maybe<Array<Maybe<PickupLocation>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of products returned. */
  total_count?: Maybe<Scalars['Int']>;
};

/** An error encountered while placing an order. */
export type PlaceOrderError = {
  __typename?: 'PlaceOrderError';
  /** An error code that is specific to place order. */
  code: PlaceOrderErrorCodes;
  /** A localized error message. */
  message: Scalars['String'];
};

export type PlaceOrderErrorCodes =
  | 'CART_NOT_ACTIVE'
  | 'CART_NOT_FOUND'
  | 'GUEST_EMAIL_MISSING'
  | 'UNABLE_TO_PLACE_ORDER'
  | 'UNDEFINED';

/** Specifies the quote to be converted to an order. */
export type PlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** The Visit UUID of a `Cart` object */
  hp_visituuid?: InputMaybe<Scalars['String']>;
  /** The Threat metrix profiling id of a `Cart` object */
  tm_profiling_id?: InputMaybe<Scalars['String']>;
  /** The User consents. */
  user_consents?: InputMaybe<Scalars['String']>;
};

/** Contains the results of the request to place an order. */
export type PlaceOrderOutput = {
  __typename?: 'PlaceOrderOutput';
  /** An array of place order errors. */
  errors: Array<Maybe<PlaceOrderError>>;
  /**
   * The ID of the order.
   * @deprecated Use `orderV2` instead.
   */
  order: Order;
  /** Full order information. */
  orderV2?: Maybe<CustomerOrder>;
};

/** Deprecated. Use `ProductPrice` instead. Defines the price of a product as well as any tax-related adjustments. */
export type Price = {
  __typename?: 'Price';
  /**
   * An array that provides information about tax, weee, or weee_tax adjustments.
   * @deprecated Use `ProductPrice` instead.
   */
  adjustments?: Maybe<Array<Maybe<PriceAdjustment>>>;
  /**
   * The price of a product plus a three-letter currency code.
   * @deprecated Use `ProductPrice` instead.
   */
  amount?: Maybe<Money>;
};

/** Deprecated. Taxes will be included or excluded in the price. Defines the amount of money to apply as an adjustment, the type of adjustment to apply, and whether the item is included or excluded from the adjustment. */
export type PriceAdjustment = {
  __typename?: 'PriceAdjustment';
  /** The amount of the price adjustment and its currency code. */
  amount?: Maybe<Money>;
  /**
   * Indicates whether the adjustment involves tax, weee, or weee_tax.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  code?: Maybe<PriceAdjustmentCodesEnum>;
  /**
   * Indicates whether the entity described by the code attribute is included or excluded from the adjustment.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  description?: Maybe<PriceAdjustmentDescriptionEnum>;
};

/** `PriceAdjustment.code` is deprecated. */
export type PriceAdjustmentCodesEnum = 'TAX' | 'WEEE' | 'WEEE_TAX';

/** `PriceAdjustmentDescriptionEnum` is deprecated. States whether a price adjustment is included or excluded. */
export type PriceAdjustmentDescriptionEnum = 'EXCLUDED' | 'INCLUDED';

/** Can be used to retrieve the main price details in case of bundle product */
export type PriceDetails = {
  __typename?: 'PriceDetails';
  /** The percentage of discount applied to the main product price */
  discount_percentage?: Maybe<Scalars['Float']>;
  /** The final price after applying the discount to the main product */
  main_final_price?: Maybe<Scalars['Float']>;
  /** The regular price of the main product */
  main_price?: Maybe<Scalars['Float']>;
};

/** Contains the price range for a product. If the product has a single price, the minimum and maximum price will be the same. */
export type PriceRange = {
  __typename?: 'PriceRange';
  /** The highest possible price for the product. */
  maximum_price?: Maybe<ProductPrice>;
  /** The lowest possible price for the product. */
  minimum_price: ProductPrice;
};

/** Defines the price type. */
export type PriceTypeEnum = 'DYNAMIC' | 'FIXED' | 'PERCENT';

/** Defines whether a bundle product's price is displayed as the lowest possible value or as a range. */
export type PriceViewEnum = 'AS_LOW_AS' | 'PRICE_RANGE';

export type Prices = {
  __typename?: 'Prices';
  totalDevice: Scalars['Float'];
  totalDevicePricePerMonth: Scalars['Float'];
  totalPrice: Scalars['Float'];
  totalPricePerMonth: Scalars['Float'];
  totalSubscriptionPricePerMonth: Scalars['Float'];
};

/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductAttributeFilterInput = {
  /** Deprecated: use `category_uid` to filter product by category ID. */
  category_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter product by the unique ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Filter product by category URL path. */
  category_url_path?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Color */
  color?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Description */
  description?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: External Product ID */
  hp_external_product_id?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Solution ID */
  hp_solution_id?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Product Name */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Price */
  price?: InputMaybe<FilterRangeTypeInput>;
  /** Attribute label: Short Description */
  short_description?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: SKU */
  sku?: InputMaybe<FilterEqualTypeInput>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<FilterEqualTypeInput>;
};

/** Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. It's possible to sort products using searchable attributes with enabled 'Use in Filter Options' option */
export type ProductAttributeSortInput = {
  /** Attribute label: Product Name */
  name?: InputMaybe<SortEnum>;
  /** Sort by the position assigned to each product. */
  position?: InputMaybe<SortEnum>;
  /** Attribute label: Price */
  price?: InputMaybe<SortEnum>;
  /** Sort by the search relevance score (default). */
  relevance?: InputMaybe<SortEnum>;
};

/** Product custom attributes */
export type ProductCustomAttributes = {
  __typename?: 'ProductCustomAttributes';
  /** Errors when retrieving custom attributes metadata. */
  errors: Array<Maybe<AttributeMetadataError>>;
  /** Requested custom attributes */
  items: Array<Maybe<AttributeValueInterface>>;
};

export type ProductDetail = {
  __typename?: 'ProductDetail';
  fmv?: Maybe<Scalars['String']>;
  hp_allocated_revenue?: Maybe<Scalars['Float']>;
  hp_max_rollover_pages?: Maybe<Scalars['String']>;
  hp_overage_block_price?: Maybe<Scalars['String']>;
  hp_overage_block_size?: Maybe<Scalars['String']>;
  hp_pages_per_month?: Maybe<Scalars['String']>;
  hp_product_type_label?: Maybe<Scalars['String']>;
  hp_return_shipping_fee_sku?: Maybe<Scalars['Float']>;
  hp_rollover_pages?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<RevisionPrice>;
  sku?: Maybe<Scalars['String']>;
};

/** Contains the discount applied to a product price. */
export type ProductDiscount = {
  __typename?: 'ProductDiscount';
  /** The actual value of the discount. */
  amount_off?: Maybe<Scalars['Float']>;
  /** The discount expressed a percentage. */
  percent_off?: Maybe<Scalars['Float']>;
};

/** ProductFilterInput is deprecated, use @ProductAttributeFilterInput instead. ProductFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductFilterInput = {
  /** The category ID the product belongs to. */
  category_id?: InputMaybe<FilterTypeInput>;
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<FilterTypeInput>;
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<FilterTypeInput>;
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<FilterTypeInput>;
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<FilterTypeInput>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<FilterTypeInput>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<FilterTypeInput>;
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<FilterTypeInput>;
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product image. */
  image_label?: InputMaybe<FilterTypeInput>;
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<FilterTypeInput>;
  /** The numeric maximal price of the product. Do not include the currency code. */
  max_price?: InputMaybe<FilterTypeInput>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<FilterTypeInput>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<FilterTypeInput>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<FilterTypeInput>;
  /** The numeric minimal price of the product. Do not include the currency code. */
  min_price?: InputMaybe<FilterTypeInput>;
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<FilterTypeInput>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<FilterTypeInput>;
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<FilterTypeInput>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<FilterTypeInput>;
  /** The keyword required to perform a logical OR comparison. */
  or?: InputMaybe<ProductFilterInput>;
  /** The price of an item. */
  price?: InputMaybe<FilterTypeInput>;
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<FilterTypeInput>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<FilterTypeInput>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<FilterTypeInput>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<FilterTypeInput>;
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<FilterTypeInput>;
  /** The discounted price of the product. Do not include the currency code. */
  special_price?: InputMaybe<FilterTypeInput>;
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<FilterTypeInput>;
  /** The file name of a swatch image. */
  swatch_image?: InputMaybe<FilterTypeInput>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<FilterTypeInput>;
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<FilterTypeInput>;
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<FilterTypeInput>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<FilterTypeInput>;
  url_path?: InputMaybe<FilterTypeInput>;
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<FilterTypeInput>;
};

/** Contains product image information, including the image URL and label. */
export type ProductImage = MediaGalleryInterface & {
  __typename?: 'ProductImage';
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']>;
};

/** Product Information used for Pickup Locations search. */
export type ProductInfoInput = {
  /** Product SKU. */
  sku: Scalars['String'];
};

/** Contains fields that are common to all types of products. */
export type ProductInterface = {
  a12345?: Maybe<Scalars['String']>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']>;
  /** Base Accessories Image for Catalog Product Image */
  base_accessories?: Maybe<ProductImage>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  color?: Maybe<Scalars['Int']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']>;
  /** An array of cross-sell products. */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Product custom attributes. */
  custom_attributesV2?: Maybe<ProductCustomAttributes>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']>;
  hp_allowed_payment_type?: Maybe<Scalars['String']>;
  /** Allowed Payment Type. */
  hp_allowed_payment_type_label?: Maybe<Scalars['String']>;
  hp_as_low_as_price?: Maybe<Scalars['Float']>;
  hp_auto_renewal?: Maybe<Scalars['Int']>;
  hp_billing_cycle?: Maybe<Scalars['Int']>;
  hp_billing_cycle_uom?: Maybe<Scalars['Int']>;
  /** Billing cycle UOM of the product. */
  hp_billing_cycle_uom_label?: Maybe<Scalars['String']>;
  hp_billing_period?: Maybe<Scalars['Int']>;
  /** Billing Period label */
  hp_billing_period_label?: Maybe<Scalars['String']>;
  hp_bundle_lease_type?: Maybe<Scalars['String']>;
  hp_bundle_type?: Maybe<Scalars['Int']>;
  /** Bundle type of the product, like On Books or Hp One. */
  hp_bundle_type_label?: Maybe<Scalars['String']>;
  hp_can_be_ordered_individually?: Maybe<Scalars['Int']>;
  hp_cancellation_json?: Maybe<Scalars['String']>;
  hp_charge_type?: Maybe<Scalars['Int']>;
  /** Charge Type label */
  hp_charge_type_label?: Maybe<Scalars['String']>;
  hp_contract_duration?: Maybe<Scalars['Int']>;
  hp_contract_duration_uom?: Maybe<Scalars['Int']>;
  /** Contract duration UOM of the product. */
  hp_contract_duration_uom_label?: Maybe<Scalars['String']>;
  /** Delivery method value */
  hp_delivery_method?: Maybe<Scalars['Int']>;
  /** Delivery method label */
  hp_delivery_method_label?: Maybe<Scalars['String']>;
  hp_disclaimer?: Maybe<Scalars['String']>;
  hp_downgrade_cost_change?: Maybe<Scalars['Float']>;
  hp_early_accessibility?: Maybe<Scalars['Int']>;
  hp_eligibility_ruleset_id?: Maybe<Scalars['String']>;
  hp_external_product_id?: Maybe<Scalars['String']>;
  hp_fair_market_value?: Maybe<Scalars['Float']>;
  hp_initial_hpone_subscription_cost?: Maybe<Scalars['Float']>;
  hp_is_popular?: Maybe<Scalars['Int']>;
  hp_lease_fmv?: Maybe<Scalars['Float']>;
  hp_lease_type?: Maybe<Scalars['String']>;
  hp_limit_per_org?: Maybe<Scalars['Int']>;
  hp_marketing_name?: Maybe<Scalars['String']>;
  hp_max_days_to_return?: Maybe<Scalars['Int']>;
  hp_max_rollover_pages?: Maybe<Scalars['Int']>;
  hp_model_name?: Maybe<Scalars['String']>;
  /** Model Purpose of the Bundle Product */
  hp_model_purpose?: Maybe<Scalars['String']>;
  hp_offer_type?: Maybe<Scalars['Int']>;
  /** Offer Type label */
  hp_offer_type_label?: Maybe<Scalars['String']>;
  hp_order_type?: Maybe<Scalars['String']>;
  hp_overage_block_price?: Maybe<Scalars['Float']>;
  hp_overage_block_size?: Maybe<Scalars['Int']>;
  hp_overage_block_uom?: Maybe<Scalars['String']>;
  hp_pages_per_month?: Maybe<Scalars['Int']>;
  hp_partner_fmvs?: Maybe<Array<Maybe<PartnerFmv>>>;
  hp_plan_change_freeze_period?: Maybe<Scalars['Int']>;
  hp_plan_change_freeze_period_uom?: Maybe<Scalars['Int']>;
  /** Plan Change Freeze Period UOM. */
  hp_plan_change_freeze_period_uom_label?: Maybe<Scalars['String']>;
  hp_price_type?: Maybe<Scalars['Int']>;
  /** Price type of the product. */
  hp_price_type_label?: Maybe<Scalars['String']>;
  hp_product_full_specification?: Maybe<Scalars['String']>;
  /** Product number of the product. */
  hp_product_number?: Maybe<Scalars['String']>;
  hp_product_type?: Maybe<Scalars['Int']>;
  /** Product type of the product. */
  hp_product_type_label?: Maybe<Scalars['String']>;
  hp_return_json?: Maybe<Scalars['String']>;
  hp_return_shipping_fee_sku?: Maybe<Scalars['String']>;
  hp_rollover_pages?: Maybe<Scalars['Int']>;
  hp_short_config_name?: Maybe<Scalars['String']>;
  hp_solution_id?: Maybe<Scalars['String']>;
  hp_source_system?: Maybe<Scalars['String']>;
  hp_specifications_json?: Maybe<Scalars['String']>;
  hp_storage_amount?: Maybe<Scalars['Int']>;
  hp_storage_uom?: Maybe<Scalars['Int']>;
  /** HP Storage Uom of the product. */
  hp_storage_uom_label?: Maybe<Scalars['String']>;
  hp_storefront_group?: Maybe<Scalars['Int']>;
  /** Storefront group of the product. */
  hp_storefront_group_label?: Maybe<Scalars['String']>;
  hp_supply_type?: Maybe<Scalars['Int']>;
  /** Supply type of the product on printers. */
  hp_supply_type_label?: Maybe<Scalars['String']>;
  hp_support_coverage_included_with_hw?: Maybe<Scalars['Int']>;
  /** support coverage of the product. */
  hp_support_coverage_included_with_hw_label?: Maybe<Scalars['String']>;
  hp_tokens_count?: Maybe<Scalars['Int']>;
  hp_trial_duration?: Maybe<Scalars['Int']>;
  hp_trial_duration_unit?: Maybe<Scalars['Int']>;
  /** Trial duration unit of the product. */
  hp_trial_duration_unit_label?: Maybe<Scalars['String']>;
  hp_trial_pages_per_month?: Maybe<Scalars['Int']>;
  hp_trial_price?: Maybe<Scalars['Float']>;
  hp_unit_of_measure?: Maybe<Scalars['Int']>;
  /** Unit of Measure label */
  hp_unit_of_measure_label?: Maybe<Scalars['String']>;
  hp_updated_hpone_subscription_cost?: Maybe<Scalars['Float']>;
  hp_upgrade_cost_change?: Maybe<Scalars['Float']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']>;
  operational_system?: Maybe<Scalars['String']>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** An array of related products. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']>;
  /** Small Accessories Image for Catalog Product Image */
  small_accessories?: Maybe<ProductImage>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']>;
  /** Indicates whether the product is staged for a future campaign. */
  staged: Scalars['Boolean'];
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  storage?: Maybe<Scalars['String']>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /** Thumbnail Accessories Image for Catalog Product Image */
  thumbnail_accessories?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID'];
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']>;
  /** An array of up-sell products. */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']>;
  usage?: Maybe<Scalars['String']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
};

/** Contains fields that are common to all types of products. */
export type ProductInterfaceCustom_AttributesV2Args = {
  filters?: InputMaybe<AttributeFilterInput>;
};

/** An implementation of `ProductLinksInterface`. */
export type ProductLinks = ProductLinksInterface & {
  __typename?: 'ProductLinks';
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars['String']>;
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars['String']>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars['String']>;
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']>;
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']>;
};

/** Contains information about linked products, including the link type and product type of each item. */
export type ProductLinksInterface = {
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars['String']>;
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars['String']>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars['String']>;
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']>;
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']>;
};

/** Contains an image in base64 format and basic information about the image. */
export type ProductMediaGalleryEntriesContent = {
  __typename?: 'ProductMediaGalleryEntriesContent';
  /** The image in base64 format. */
  base64_encoded_data?: Maybe<Scalars['String']>;
  /** The file name of the image. */
  name?: Maybe<Scalars['String']>;
  /** The MIME type of the file, such as image/png. */
  type?: Maybe<Scalars['String']>;
};

/** Contains a link to a video file and basic information about the video. */
export type ProductMediaGalleryEntriesVideoContent = {
  __typename?: 'ProductMediaGalleryEntriesVideoContent';
  /** Must be external-video. */
  media_type?: Maybe<Scalars['String']>;
  /** A description of the video. */
  video_description?: Maybe<Scalars['String']>;
  /** Optional data about the video. */
  video_metadata?: Maybe<Scalars['String']>;
  /** Describes the video source. */
  video_provider?: Maybe<Scalars['String']>;
  /** The title of the video. */
  video_title?: Maybe<Scalars['String']>;
  /** The URL to the video. */
  video_url?: Maybe<Scalars['String']>;
};

/** Represents a product price. */
export type ProductPrice = {
  __typename?: 'ProductPrice';
  /** The price discount. Represents the difference between the regular and final price. */
  discount?: Maybe<ProductDiscount>;
  /** The final price of the product after applying discounts. */
  final_price: Money;
  /** An array of the multiple Fixed Product Taxes that can be applied to a product price. */
  fixed_product_taxes?: Maybe<Array<Maybe<FixedProductTax>>>;
  /** The regular price of the product. */
  regular_price: Money;
};

/** Deprecated. Use `PriceRange` instead. Contains the regular price of an item, as well as its minimum and maximum prices. Only composite products, which include bundle, configurable, and grouped products, can contain a minimum and maximum price. */
export type ProductPrices = {
  __typename?: 'ProductPrices';
  /**
   * The highest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `to` value.
   * @deprecated Use `PriceRange.maximum_price` instead.
   */
  maximalPrice?: Maybe<Price>;
  /**
   * The lowest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `from` value.
   * @deprecated Use `PriceRange.minimum_price` instead.
   */
  minimalPrice?: Maybe<Price>;
  /**
   * The base price of a product.
   * @deprecated Use `regular_price` from `PriceRange.minimum_price` or `PriceRange.maximum_price` instead.
   */
  regularPrice?: Maybe<Price>;
};

/** Deprecated. Use `ProductAttributeSortInput` instead. Specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type ProductSortInput = {
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<SortEnum>;
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<SortEnum>;
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<SortEnum>;
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<SortEnum>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<SortEnum>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<SortEnum>;
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<SortEnum>;
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<SortEnum>;
  /** The label assigned to a product image. */
  image_label?: InputMaybe<SortEnum>;
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<SortEnum>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<SortEnum>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<SortEnum>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<SortEnum>;
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<SortEnum>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<SortEnum>;
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<SortEnum>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<SortEnum>;
  /** The price of the item. */
  price?: InputMaybe<SortEnum>;
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<SortEnum>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<SortEnum>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<SortEnum>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<SortEnum>;
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<SortEnum>;
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<SortEnum>;
  /** The discounted price of the product. */
  special_price?: InputMaybe<SortEnum>;
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<SortEnum>;
  /** Indicates the criteria to sort swatches. */
  swatch_image?: InputMaybe<SortEnum>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<SortEnum>;
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<SortEnum>;
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<SortEnum>;
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<SortEnum>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<SortEnum>;
  url_path?: InputMaybe<SortEnum>;
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<SortEnum>;
};

/** This enumeration states whether a product stock status is in stock or out of stock */
export type ProductStockStatus = 'IN_STOCK' | 'OUT_OF_STOCK';

/** Deprecated. Use `TierPrice` instead. Defines a tier price, which is a quantity discount offered to a specific customer group. */
export type ProductTierPrices = {
  __typename?: 'ProductTierPrices';
  /**
   * The ID of the customer group.
   * @deprecated Not relevant for the storefront.
   */
  customer_group_id?: Maybe<Scalars['String']>;
  /**
   * The percentage discount of the item.
   * @deprecated Use `TierPrice.discount` instead.
   */
  percentage_value?: Maybe<Scalars['Float']>;
  /**
   * The number of items that must be purchased to qualify for tier pricing.
   * @deprecated Use `TierPrice.quantity` instead.
   */
  qty?: Maybe<Scalars['Float']>;
  /**
   * The price of the fixed price item.
   * @deprecated Use `TierPrice.final_price` instead.
   */
  value?: Maybe<Scalars['Float']>;
  /**
   * The ID assigned to the website.
   * @deprecated Not relevant for the storefront.
   */
  website_id?: Maybe<Scalars['Float']>;
};

/** Contains information about a product video. */
export type ProductVideo = MediaGalleryInterface & {
  __typename?: 'ProductVideo';
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']>;
  /** Contains a `ProductMediaGalleryEntriesVideoContent` object. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>;
};

/** Contains the results of a `products` query. */
export type Products = {
  __typename?: 'Products';
  /** A bucket that contains the attribute code and label for each filterable option. */
  aggregations?: Maybe<Array<Maybe<Aggregation>>>;
  /**
   * Layered navigation filters array.
   * @deprecated Use `aggregations` instead.
   */
  filters?: Maybe<Array<Maybe<LayerFilter>>>;
  /** An array of products that match the specified search criteria. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** An object that includes the default sort field and all available sort fields. */
  sort_fields?: Maybe<SortFields>;
  /** An array of search suggestions for case when search query have no results. */
  suggestions?: Maybe<Array<Maybe<SearchSuggestion>>>;
  /** The number of products that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count?: Maybe<Scalars['Int']>;
};

/** Contains the results of a `products` query. */
export type ProductsAggregationsArgs = {
  filter?: InputMaybe<AggregationsFilterInput>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve EAV attributes associated to a frontend form. Use countries query provided by DirectoryGraphQl module to retrieve region_id and country_id attribute options. */
  attributesForm: AttributesFormOutput;
  /** Returns a list of attributes metadata for a given entity type. */
  attributesList?: Maybe<AttributesMetadataOutput>;
  /** Get a list of available store views and their config information. */
  availableStores?: Maybe<Array<Maybe<StoreConfig>>>;
  /** Return information about the specified shopping cart. */
  cart?: Maybe<Cart>;
  /** Return a list of categories that match the specified filter. */
  categories?: Maybe<CategoryResult>;
  /**
   * Search for categories that match the criteria specified in the `search` and `filter` attributes.
   * @deprecated Use `categories` instead.
   */
  category?: Maybe<CategoryTree>;
  /**
   * Return an array of categories based on the specified filters.
   * @deprecated Use `categories` instead.
   */
  categoryList?: Maybe<Array<Maybe<CategoryTree>>>;
  /** Return Terms and Conditions configuration information. */
  checkoutAgreements?: Maybe<Array<Maybe<CheckoutAgreement>>>;
  /** Return information about CMS blocks. */
  cmsBlocks?: Maybe<CmsBlocks>;
  /** Return details about a CMS page. */
  cmsPage?: Maybe<CmsPage>;
  /** The countries query provides information for all countries. */
  countries?: Maybe<Array<Maybe<Country>>>;
  /** The countries query provides information for a single country. */
  country?: Maybe<Country>;
  /** Return information about the store's currency. */
  currency?: Maybe<Currency>;
  /**
   * Return the attribute type, given an attribute code and entity type.
   * @deprecated Use `customAttributeMetadataV2` query instead.
   */
  customAttributeMetadata?: Maybe<CustomAttributeMetadata>;
  /** Retrieve EAV attributes metadata. */
  customAttributeMetadataV2: AttributesMetadataOutput;
  /** Return detailed information about a customer account. */
  customer?: Maybe<Customer>;
  /** Return information about the customer's shopping cart. */
  customerCart: Cart;
  /** @deprecated Use the `customer` query instead. */
  customerOrders?: Maybe<CustomerOrders>;
  /** Return a list of customer payment tokens stored in the vault. */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>;
  /** Return a list of dynamic blocks filtered by type, location, or UIDs. */
  dynamicBlocks: DynamicBlocks;
  /** This query returns information about partner channel */
  getPartnerCompensation?: Maybe<PartnerCompensation>;
  /** Gets validation rules for form fields, optionally filtered by mutation */
  getValidationSchema?: Maybe<ValidationSchema>;
  /** Retrieve guest order details based on number, email and postcode. */
  guestOrder: CustomerOrder;
  /** Retrieve guest order details based on token. */
  guestOrderByToken: CustomerOrder;
  /** Check whether the specified email has already been used to create a customer account. */
  isEmailAvailable?: Maybe<IsEmailAvailableOutput>;
  pdpConfig: PdpConfigState;
  /** The pickup locations query searches for locations that match the search request requirements. */
  pickupLocations?: Maybe<PickupLocations>;
  /** Search for products that match the criteria specified in the `search` and `filter` attributes. */
  products?: Maybe<Products>;
  /** Return the full details for a specified product, category, or CMS page. */
  route?: Maybe<RoutableInterface>;
  /** Return details about the store's configuration. */
  storeConfig?: Maybe<StoreConfig>;
  /** This query returns information about subscription revision */
  subscriptionRevision?: Maybe<SubscriptionRevision>;
  /**
   * Return the relative URL for a specified product, category or CMS page.
   * @deprecated Use the `route` query instead.
   */
  urlResolver?: Maybe<EntityUrl>;
  /**
   * Return the contents of a customer's wish list.
   * @deprecated Moved under `Customer.wishlist`.
   */
  wishlist?: Maybe<WishlistOutput>;
  /** The wsreg_order query returns information about wsreg amounts of the order */
  wsreg_order?: Maybe<WsregOrder>;
  /** The wsreg_quote query returns information about wsreg rates */
  wsreg_quote?: Maybe<WsregQuote>;
};

export type QueryAttributesFormArgs = {
  formCode: Scalars['String'];
};

export type QueryAttributesListArgs = {
  entityType: AttributeEntityTypeEnum;
  filters?: InputMaybe<AttributeFilterInput>;
};

export type QueryAvailableStoresArgs = {
  useCurrentGroup?: InputMaybe<Scalars['Boolean']>;
};

export type QueryCartArgs = {
  cart_id: Scalars['String'];
};

export type QueryCategoriesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<CategoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['Int']>;
};

export type QueryCategoryListArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<CategoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QueryCheckoutAgreementsArgs = {
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type QueryCmsBlocksArgs = {
  identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryCmsPageArgs = {
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
};

export type QueryCountryArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type QueryCustomAttributeMetadataArgs = {
  attributes: Array<AttributeInput>;
};

export type QueryCustomAttributeMetadataV2Args = {
  attributes?: InputMaybe<Array<AttributeInput>>;
};

export type QueryDynamicBlocksArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<DynamicBlocksFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QueryGetPartnerCompensationArgs = {
  hpChannelCode: Scalars['String'];
};

export type QueryGetValidationSchemaArgs = {
  mutation?: InputMaybe<Scalars['String']>;
};

export type QueryGuestOrderArgs = {
  input: OrderInformationInput;
};

export type QueryGuestOrderByTokenArgs = {
  input: OrderTokenInput;
};

export type QueryIsEmailAvailableArgs = {
  email: Scalars['String'];
};

export type QueryPickupLocationsArgs = {
  area?: InputMaybe<AreaInput>;
  currentPage?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<PickupLocationFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  productsInfo?: InputMaybe<Array<InputMaybe<ProductInfoInput>>>;
  sort?: InputMaybe<PickupLocationSortInput>;
};

export type QueryProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

export type QueryRouteArgs = {
  url: Scalars['String'];
};

export type QuerySubscriptionRevisionArgs = {
  order_id: Scalars['String'];
};

export type QueryUrlResolverArgs = {
  url: Scalars['String'];
};

export type QueryWsreg_OrderArgs = {
  orderId: Scalars['Int'];
};

export type QueryWsreg_QuoteArgs = {
  cartId: Scalars['String'];
};

/** Specifies the field to use for sorting quote items */
export type QuoteItemsSortInput = {
  /** Specifies the quote items field to sort by */
  field: SortQuoteItemsEnum;
  /** Specifies the order of quote items' sorting */
  order: SortEnum;
};

export type Region = {
  __typename?: 'Region';
  /** The two-letter code for the region, such as TX for Texas. */
  code?: Maybe<Scalars['String']>;
  /** The unique ID for a `Region` object. */
  id?: Maybe<Scalars['Int']>;
  /** The name of the region, such as Texas. */
  name?: Maybe<Scalars['String']>;
};

export type RegularPrice = {
  __typename?: 'RegularPrice';
  amount?: Maybe<Amount>;
};

/** Specifies the cart from which to remove a coupon. */
export type RemoveCouponFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
};

/** Contains details about the cart after removing a coupon. */
export type RemoveCouponFromCartOutput = {
  __typename?: 'RemoveCouponFromCartOutput';
  /** The cart after removing a coupon. */
  cart?: Maybe<Cart>;
};

/** Remove coupons from the cart. */
export type RemoveCouponsFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of coupon codes to be removed from the quote. If coupon_codes is empty all coupons will be removed from the quote. */
  coupon_codes: Array<InputMaybe<Scalars['String']>>;
};

/** Specifies which items to remove from the cart. */
export type RemoveItemFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars['Int']>;
  /** Required field. The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars['ID']>;
};

/** Contains details about the cart after removing an item. */
export type RemoveItemFromCartOutput = {
  __typename?: 'RemoveItemFromCartOutput';
  /** The cart after removing an item. */
  cart: Cart;
};

export type RemovePaperFromCartInput = {
  cart_id: Scalars['String'];
};

export type RemovePaperFromCartOutput = {
  __typename?: 'RemovePaperFromCartOutput';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Contains the customer's wish list and any errors encountered. */
export type RemoveProductsFromWishlistOutput = {
  __typename?: 'RemoveProductsFromWishlistOutput';
  /** An array of errors encountered while deleting products from a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with after items were successfully deleted. */
  wishlist: Wishlist;
};

/** Contains the cart and any errors after adding products. */
export type ReorderItemsOutput = {
  __typename?: 'ReorderItemsOutput';
  /** Detailed information about the customer's cart. */
  cart: Cart;
  /** An array of reordering errors. */
  userInputErrors: Array<Maybe<CheckoutUserInputError>>;
};

export type RevisionPrice = {
  __typename?: 'RevisionPrice';
  regularPrice?: Maybe<RegularPrice>;
};

/** Contains the result of a request to revoke a customer token. */
export type RevokeCustomerTokenOutput = {
  __typename?: 'RevokeCustomerTokenOutput';
  /** The result of a request to revoke a customer token. */
  result: Scalars['Boolean'];
};

/** Routable entities serve as the model for a rendered page. */
export type RoutableInterface = {
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
};

/** Default implementation of RoutableInterface. This type is returned when the URL is not linked to an entity. */
export type RoutableUrl = RoutableInterface & {
  __typename?: 'RoutableUrl';
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
};

/** Contains details about a comment. */
export type SalesCommentItem = {
  __typename?: 'SalesCommentItem';
  /** The text of the message. */
  message: Scalars['String'];
  /** The timestamp of the comment. */
  timestamp: Scalars['String'];
};

/** This enumeration defines the scope type for customer orders. */
export type ScopeTypeEnum = 'GLOBAL' | 'STORE' | 'WEBSITE';

/** Provides navigation for the query response. */
export type SearchResultPageInfo = {
  __typename?: 'SearchResultPageInfo';
  /** The specific page to return. */
  current_page?: Maybe<Scalars['Int']>;
  /** The maximum number of items to return per page of results. */
  page_size?: Maybe<Scalars['Int']>;
  /** The total number of pages in the response. */
  total_pages?: Maybe<Scalars['Int']>;
};

/** A string that contains search suggestion */
export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  /** The search suggestion of existing product. */
  search: Scalars['String'];
};

/** Contains details about a selected bundle option. */
export type SelectedBundleOption = {
  __typename?: 'SelectedBundleOption';
  /** @deprecated Use `uid` instead */
  id: Scalars['Int'];
  /** The display name of the selected bundle product option. */
  label: Scalars['String'];
  /** The type of selected bundle product option. */
  type: Scalars['String'];
  /** The unique ID for a `SelectedBundleOption` object */
  uid: Scalars['ID'];
  /** An array of selected bundle option values. */
  values: Array<Maybe<SelectedBundleOptionValue>>;
};

/** Contains details about a value for a selected bundle option. */
export type SelectedBundleOptionValue = {
  __typename?: 'SelectedBundleOptionValue';
  /** Applied tax for bundle product option. */
  applied_tax: Scalars['Float'];
  /** Price type for bundle product option. */
  hp_price_type?: Maybe<Scalars['String']>;
  /** Use `uid` instead */
  id: Scalars['Int'];
  /** The display name of the value for the selected bundle product option. */
  label: Scalars['String'];
  /** Monthly price with tax for bundle product option. */
  monthly_price_with_tax: Scalars['Float'];
  /** Monthly price without tax for bundle product option. */
  monthly_price_without_tax: Scalars['Float'];
  /** The price of the value for the selected bundle product option. */
  price: Scalars['Float'];
  /** The quantity of the value for the selected bundle product option. */
  quantity: Scalars['Float'];
  /** Sku for bundle product option. */
  sku?: Maybe<Scalars['String']>;
  /** The unique ID for a `SelectedBundleOptionValue` object */
  uid: Scalars['ID'];
};

/** Contains details about a selected configurable option. */
export type SelectedConfigurableOption = {
  __typename?: 'SelectedConfigurableOption';
  /** The unique ID for a `ConfigurableProductOptions` object. */
  configurable_product_option_uid: Scalars['ID'];
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  configurable_product_option_value_uid: Scalars['ID'];
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_uid` instead. */
  id: Scalars['Int'];
  /** The display text for the option. */
  option_label: Scalars['String'];
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_value_uid` instead. */
  value_id: Scalars['Int'];
  /** The display name of the selected configurable option. */
  value_label: Scalars['String'];
};

/** Identifies a customized product that has been placed in a cart. */
export type SelectedCustomizableOption = {
  __typename?: 'SelectedCustomizableOption';
  /** The unique ID for a specific `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  customizable_option_uid: Scalars['ID'];
  /** @deprecated Use `SelectedCustomizableOption.customizable_option_uid` instead. */
  id: Scalars['Int'];
  /** Indicates whether the customizable option is required. */
  is_required: Scalars['Boolean'];
  /** The display name of the selected customizable option. */
  label: Scalars['String'];
  /** A value indicating the order to display this option. */
  sort_order: Scalars['Int'];
  /** The type of `CustomizableOptionInterface` object. */
  type: Scalars['String'];
  /** An array of selectable values. */
  values: Array<Maybe<SelectedCustomizableOptionValue>>;
};

/** Identifies the value of the selected customized option. */
export type SelectedCustomizableOptionValue = {
  __typename?: 'SelectedCustomizableOptionValue';
  /** The unique ID for a value object that corresponds to the object represented by the `customizable_option_uid` attribute. */
  customizable_option_value_uid: Scalars['ID'];
  /** @deprecated Use `SelectedCustomizableOptionValue.customizable_option_value_uid` instead. */
  id: Scalars['Int'];
  /** The display name of the selected value. */
  label: Scalars['String'];
  /** The price of the selected customizable value. */
  price: CartItemSelectedOptionValuePrice;
  /** The text identifying the selected value. */
  value: Scalars['String'];
};

/** Describes the payment method the shopper selected. */
export type SelectedPaymentMethod = {
  __typename?: 'SelectedPaymentMethod';
  /** The payment method code. */
  code: Scalars['String'];
  /** PGS Details of PaymentCC Method */
  pgs_details?: Maybe<PgsDetails>;
  /** The purchase order number. */
  purchase_order_number?: Maybe<Scalars['String']>;
  /** The payment method title. */
  title: Scalars['String'];
};

/** Contains details about the selected shipping method and carrier. */
export type SelectedShippingMethod = {
  __typename?: 'SelectedShippingMethod';
  /** The cost of shipping using this shipping method. */
  amount: Money;
  /** @deprecated The field should not be used on the storefront. */
  base_amount?: Maybe<Money>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars['String'];
  /** The label for the carrier code. */
  carrier_title: Scalars['String'];
  /** A shipping method code associated with a carrier. */
  method_code: Scalars['String'];
  /** The label for the method code. */
  method_title: Scalars['String'];
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: Money;
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: Money;
};

/** Sets the billing address. */
export type SetBillingAddressOnCartInput = {
  /** The billing address. */
  billing_address: BillingAddressInput;
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
};

/** Contains details about the cart after setting the billing address. */
export type SetBillingAddressOnCartOutput = {
  __typename?: 'SetBillingAddressOnCartOutput';
  /** The cart after setting the billing address. */
  cart: Cart;
};

/** Defines the guest email and cart. */
export type SetGuestEmailOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** The email address of the guest. */
  email: Scalars['String'];
};

/** Contains details about the cart after setting the email of a guest. */
export type SetGuestEmailOnCartOutput = {
  __typename?: 'SetGuestEmailOnCartOutput';
  /** The cart after setting the guest email. */
  cart: Cart;
};

/** Applies a payment method to the quote. */
export type SetPaymentMethodAndPlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** The payment method data to apply to the cart. */
  payment_method: PaymentMethodInput;
};

/** Applies a payment method to the cart. */
export type SetPaymentMethodOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** The payment method data to apply to the cart. */
  payment_method: PaymentMethodInput;
};

/** Contains details about the cart after setting the payment method. */
export type SetPaymentMethodOnCartOutput = {
  __typename?: 'SetPaymentMethodOnCartOutput';
  /** The cart after setting the payment method. */
  cart: Cart;
};

/** Specifies an array of addresses to use for shipping. */
export type SetShippingAddressesOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of shipping addresses. */
  shipping_addresses: Array<InputMaybe<ShippingAddressInput>>;
};

/** Contains details about the cart after setting the shipping addresses. */
export type SetShippingAddressesOnCartOutput = {
  __typename?: 'SetShippingAddressesOnCartOutput';
  /** The cart after setting the shipping addresses. */
  cart: Cart;
};

/** Applies one or shipping methods to the cart. */
export type SetShippingMethodsOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of shipping methods. */
  shipping_methods: Array<InputMaybe<ShippingMethodInput>>;
};

/** Contains details about the cart after setting the shipping methods. */
export type SetShippingMethodsOnCartOutput = {
  __typename?: 'SetShippingMethodsOnCartOutput';
  /** The cart after setting the shipping methods. */
  cart: Cart;
};

export type SetSubscriptionUpgradesInput = {
  /** Order ID for upgrades */
  orderIncrementId: Scalars['String'];
  /** Subscription ID to cancel subscription */
  subscriptionId?: InputMaybe<Scalars['String']>;
};

export type SetSubscriptionUpgradesOutput = {
  __typename?: 'SetSubscriptionUpgradesOutput';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Defines whether bundle items must be shipped together. */
export type ShipBundleItemsEnum = 'SEPARATELY' | 'TOGETHER';

export type ShipmentItem = ShipmentItemInterface & {
  __typename?: 'ShipmentItem';
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float'];
};

/** Order shipment item details. */
export type ShipmentItemInterface = {
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float'];
};

/** Contains order shipment tracking details. */
export type ShipmentTracking = {
  __typename?: 'ShipmentTracking';
  /** The shipping carrier for the order delivery. */
  carrier: Scalars['String'];
  /** The tracking number of the order shipment. */
  number?: Maybe<Scalars['String']>;
  /** The shipment tracking title. */
  title: Scalars['String'];
};

/** Defines a single shipping address. */
export type ShippingAddressInput = {
  /** Defines a shipping address. */
  address?: InputMaybe<CartAddressInput>;
  /** An ID from the customer's address book that uniquely identifies the address to be used for shipping. */
  customer_address_id?: InputMaybe<Scalars['Int']>;
  /** Text provided by the shopper. */
  customer_notes?: InputMaybe<Scalars['String']>;
  /** The code of Pickup Location which will be used for In-Store Pickup. */
  pickup_location_code?: InputMaybe<Scalars['String']>;
};

/** Contains shipping addresses and methods. */
export type ShippingCartAddress = CartAddressInterface & {
  __typename?: 'ShippingCartAddress';
  /** An array that lists the shipping methods that can be applied to the cart. */
  available_shipping_methods?: Maybe<Array<Maybe<AvailableShippingMethod>>>;
  /** @deprecated Use `cart_items_v2` instead. */
  cart_items?: Maybe<Array<Maybe<CartItemQuantity>>>;
  /** An array that lists the items in the cart. */
  cart_items_v2?: Maybe<Array<Maybe<CartItemInterface>>>;
  /** The city specified for the billing or shipping address. */
  city: Scalars['String'];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']>;
  /** An object containing the country label and code. */
  country: CartAddressCountry;
  /** The custom attribute values of the billing or shipping address. */
  custom_attributes: Array<Maybe<AttributeValueInterface>>;
  /** Text provided by the shopper. */
  customer_notes?: Maybe<Scalars['String']>;
  /** The customer's fax number. */
  fax?: Maybe<Scalars['String']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String'];
  /** hp address id */
  hp_address_id?: Maybe<Scalars['String']>;
  /** @deprecated This information should not be exposed on the frontend. */
  items_weight?: Maybe<Scalars['Float']>;
  /** The last name of the customer or guest. */
  lastname: Scalars['String'];
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: Maybe<Scalars['String']>;
  pickup_location_code?: Maybe<Scalars['String']>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']>;
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>;
  /** An object that describes the selected shipping method. */
  selected_shipping_method?: Maybe<SelectedShippingMethod>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']>;
  /** The unique id of the customer address. */
  uid: Scalars['String'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']>;
};

/** Defines an individual shipping discount. This discount can be applied to shipping. */
export type ShippingDiscount = {
  __typename?: 'ShippingDiscount';
  /** The amount of the discount. */
  amount: Money;
};

/** Contains details about shipping and handling costs. */
export type ShippingHandling = {
  __typename?: 'ShippingHandling';
  /** The shipping amount, excluding tax. */
  amount_excluding_tax?: Maybe<Money>;
  /** The shipping amount, including tax. */
  amount_including_tax?: Maybe<Money>;
  /** The applied discounts to the shipping. */
  discounts?: Maybe<Array<Maybe<ShippingDiscount>>>;
  /** Details about taxes applied for shipping. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The total amount for shipping. */
  total_amount: Money;
};

/** Defines the shipping carrier and method. */
export type ShippingMethodInput = {
  /** A string that identifies a commercial carrier or an offline delivery method. */
  carrier_code: Scalars['String'];
  /** A string that indicates which service a commercial carrier will use to ship items. For offline delivery methods, this value is similar to the label displayed on the checkout page. */
  method_code: Scalars['String'];
};

/** An implementation for simple product cart items. */
export type SimpleCartItem = CartItemInterface & {
  __typename?: 'SimpleCartItem';
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars['Boolean'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProduct = CustomizableProductInterface &
  PhysicalProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'SimpleProduct';
    a12345?: Maybe<Scalars['String']>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars['Int']>;
    /** Base Accessories Image for Catalog Product Image */
    base_accessories?: Maybe<ProductImage>;
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars['String']>;
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>;
    color?: Maybe<Scalars['Int']>;
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars['String']>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars['String']>;
    /** An array of cross-sell products. */
    crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2?: Maybe<ProductCustomAttributes>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>;
    /** Indicates whether a gift message is available. */
    gift_message_available?: Maybe<Scalars['String']>;
    hp_allowed_payment_type?: Maybe<Scalars['String']>;
    /** Allowed Payment Type. */
    hp_allowed_payment_type_label?: Maybe<Scalars['String']>;
    hp_as_low_as_price?: Maybe<Scalars['Float']>;
    hp_auto_renewal?: Maybe<Scalars['Int']>;
    hp_billing_cycle?: Maybe<Scalars['Int']>;
    hp_billing_cycle_uom?: Maybe<Scalars['Int']>;
    /** Billing cycle UOM of the product. */
    hp_billing_cycle_uom_label?: Maybe<Scalars['String']>;
    hp_billing_period?: Maybe<Scalars['Int']>;
    /** Billing Period label */
    hp_billing_period_label?: Maybe<Scalars['String']>;
    hp_bundle_lease_type?: Maybe<Scalars['String']>;
    hp_bundle_type?: Maybe<Scalars['Int']>;
    /** Bundle type of the product, like On Books or Hp One. */
    hp_bundle_type_label?: Maybe<Scalars['String']>;
    hp_can_be_ordered_individually?: Maybe<Scalars['Int']>;
    hp_cancellation_json?: Maybe<Scalars['String']>;
    hp_charge_type?: Maybe<Scalars['Int']>;
    /** Charge Type label */
    hp_charge_type_label?: Maybe<Scalars['String']>;
    hp_contract_duration?: Maybe<Scalars['Int']>;
    hp_contract_duration_uom?: Maybe<Scalars['Int']>;
    /** Contract duration UOM of the product. */
    hp_contract_duration_uom_label?: Maybe<Scalars['String']>;
    /** Delivery method value */
    hp_delivery_method?: Maybe<Scalars['Int']>;
    /** Delivery method label */
    hp_delivery_method_label?: Maybe<Scalars['String']>;
    hp_disclaimer?: Maybe<Scalars['String']>;
    hp_downgrade_cost_change?: Maybe<Scalars['Float']>;
    hp_early_accessibility?: Maybe<Scalars['Int']>;
    hp_eligibility_ruleset_id?: Maybe<Scalars['String']>;
    hp_external_product_id?: Maybe<Scalars['String']>;
    hp_fair_market_value?: Maybe<Scalars['Float']>;
    hp_initial_hpone_subscription_cost?: Maybe<Scalars['Float']>;
    hp_is_popular?: Maybe<Scalars['Int']>;
    hp_lease_fmv?: Maybe<Scalars['Float']>;
    hp_lease_type?: Maybe<Scalars['String']>;
    hp_limit_per_org?: Maybe<Scalars['Int']>;
    hp_marketing_name?: Maybe<Scalars['String']>;
    hp_max_days_to_return?: Maybe<Scalars['Int']>;
    hp_max_rollover_pages?: Maybe<Scalars['Int']>;
    hp_model_name?: Maybe<Scalars['String']>;
    /** Model Purpose of the Bundle Product */
    hp_model_purpose?: Maybe<Scalars['String']>;
    hp_offer_type?: Maybe<Scalars['Int']>;
    /** Offer Type label */
    hp_offer_type_label?: Maybe<Scalars['String']>;
    hp_order_type?: Maybe<Scalars['String']>;
    hp_overage_block_price?: Maybe<Scalars['Float']>;
    hp_overage_block_size?: Maybe<Scalars['Int']>;
    hp_overage_block_uom?: Maybe<Scalars['String']>;
    hp_pages_per_month?: Maybe<Scalars['Int']>;
    hp_partner_fmvs?: Maybe<Array<Maybe<PartnerFmv>>>;
    hp_plan_change_freeze_period?: Maybe<Scalars['Int']>;
    hp_plan_change_freeze_period_uom?: Maybe<Scalars['Int']>;
    /** Plan Change Freeze Period UOM. */
    hp_plan_change_freeze_period_uom_label?: Maybe<Scalars['String']>;
    hp_price_type?: Maybe<Scalars['Int']>;
    /** Price type of the product. */
    hp_price_type_label?: Maybe<Scalars['String']>;
    hp_product_full_specification?: Maybe<Scalars['String']>;
    /** Product number of the product. */
    hp_product_number?: Maybe<Scalars['String']>;
    hp_product_type?: Maybe<Scalars['Int']>;
    /** Product type of the product. */
    hp_product_type_label?: Maybe<Scalars['String']>;
    hp_return_json?: Maybe<Scalars['String']>;
    hp_return_shipping_fee_sku?: Maybe<Scalars['String']>;
    hp_rollover_pages?: Maybe<Scalars['Int']>;
    hp_short_config_name?: Maybe<Scalars['String']>;
    hp_solution_id?: Maybe<Scalars['String']>;
    hp_source_system?: Maybe<Scalars['String']>;
    hp_specifications_json?: Maybe<Scalars['String']>;
    hp_storage_amount?: Maybe<Scalars['Int']>;
    hp_storage_uom?: Maybe<Scalars['Int']>;
    /** HP Storage Uom of the product. */
    hp_storage_uom_label?: Maybe<Scalars['String']>;
    hp_storefront_group?: Maybe<Scalars['Int']>;
    /** Storefront group of the product. */
    hp_storefront_group_label?: Maybe<Scalars['String']>;
    hp_supply_type?: Maybe<Scalars['Int']>;
    /** Supply type of the product on printers. */
    hp_supply_type_label?: Maybe<Scalars['String']>;
    hp_support_coverage_included_with_hw?: Maybe<Scalars['Int']>;
    /** support coverage of the product. */
    hp_support_coverage_included_with_hw_label?: Maybe<Scalars['String']>;
    hp_tokens_count?: Maybe<Scalars['Int']>;
    hp_trial_duration?: Maybe<Scalars['Int']>;
    hp_trial_duration_unit?: Maybe<Scalars['Int']>;
    /** Trial duration unit of the product. */
    hp_trial_duration_unit_label?: Maybe<Scalars['String']>;
    hp_trial_pages_per_month?: Maybe<Scalars['Int']>;
    hp_trial_price?: Maybe<Scalars['Float']>;
    hp_unit_of_measure?: Maybe<Scalars['Int']>;
    /** Unit of Measure label */
    hp_unit_of_measure_label?: Maybe<Scalars['String']>;
    hp_updated_hpone_subscription_cost?: Maybe<Scalars['Float']>;
    hp_upgrade_cost_change?: Maybe<Scalars['Float']>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars['Int']>;
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>;
    /** A number representing the product's manufacturer. */
    manufacturer?: Maybe<Scalars['Int']>;
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars['String']>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars['String']>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars['String']>;
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars['String']>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars['String']>;
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars['String']>;
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars['Float']>;
    operational_system?: Maybe<Scalars['String']>;
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars['String']>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>;
    /** The range of prices for the product */
    price_range: PriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars['Int'];
    /** An array of related products. */
    related_products?: Maybe<Array<Maybe<ProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars['String']>;
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<ComplexTextValue>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars['String']>;
    /** Small Accessories Image for Catalog Product Image */
    small_accessories?: Maybe<ProductImage>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<ProductImage>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars['String']>;
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars['Float']>;
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars['String']>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars['Boolean'];
    /** Stock status of the product */
    stock_status?: Maybe<ProductStockStatus>;
    storage?: Maybe<Scalars['String']>;
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars['String']>;
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>;
    /** Thumbnail Accessories Image for Catalog Product Image */
    thumbnail_accessories?: Maybe<ProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars['Float']>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars['String']>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID'];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars['String']>;
    /** An array of up-sell products. */
    upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars['String']>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars['String']>;
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars['String']>;
    usage?: Maybe<Scalars['String']>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>;
    /** The weight of the item, in units defined by the store. */
    weight?: Maybe<Scalars['Float']>;
  };

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProductCustom_AttributesV2Args = {
  filters?: InputMaybe<AttributeFilterInput>;
};

/** Defines a single product to add to the cart. */
export type SimpleProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: CartItemInput;
};

/** Contains a simple product wish list item. */
export type SimpleWishlistItem = WishlistItemInterface & {
  __typename?: 'SimpleWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

/** Indicates whether to return results in ascending or descending order. */
export type SortEnum = 'ASC' | 'DESC';

/** Defines a possible sort field. */
export type SortField = {
  __typename?: 'SortField';
  /** The label of the sort field. */
  label?: Maybe<Scalars['String']>;
  /** The attribute code of the sort field. */
  value?: Maybe<Scalars['String']>;
};

/** Contains a default value for sort fields and all available sort fields. */
export type SortFields = {
  __typename?: 'SortFields';
  /** The default sort field value. */
  default?: Maybe<Scalars['String']>;
  /** An array of possible sort fields. */
  options?: Maybe<Array<Maybe<SortField>>>;
};

/** Specifies the field to use for sorting quote items */
export type SortQuoteItemsEnum =
  | 'BASE_DISCOUNT_AMOUNT'
  | 'BASE_DISCOUNT_TAX_COMPENSATION_AMOUNT'
  | 'BASE_PRICE'
  | 'BASE_PRICE_INC_TAX'
  | 'BASE_ROW_TOTAL'
  | 'BASE_ROW_TOTAL_INC_TAX'
  | 'BASE_TAX_AMOUNT'
  | 'BASE_TAX_BEFORE_DISCOUNT'
  | 'CREATED_AT'
  | 'CUSTOM_PRICE'
  | 'DESCRIPTION'
  | 'DISCOUNT_AMOUNT'
  | 'DISCOUNT_PERCENT'
  | 'DISCOUNT_TAX_COMPENSATION_AMOUNT'
  | 'FREE_SHIPPING'
  | 'ITEM_ID'
  | 'NAME'
  | 'ORIGINAL_CUSTOM_PRICE'
  | 'PRICE'
  | 'PRICE_INC_TAX'
  | 'PRODUCT_ID'
  | 'PRODUCT_TYPE'
  | 'QTY'
  | 'ROW_TOTAL'
  | 'ROW_TOTAL_INC_TAX'
  | 'ROW_TOTAL_WITH_DISCOUNT'
  | 'ROW_WEIGHT'
  | 'SKU'
  | 'TAX_AMOUNT'
  | 'TAX_BEFORE_DISCOUNT'
  | 'TAX_PERCENT'
  | 'UPDATED_AT'
  | 'WEIGHT';

/** Contains information about a store's configuration. */
export type StoreConfig = {
  __typename?: 'StoreConfig';
  /** Contains scripts that must be included in the HTML before the closing `<body>` tag. */
  absolute_footer?: Maybe<Scalars['String']>;
  /** Indicates whether to enable autocomplete on login and forgot password forms. */
  autocomplete_on_storefront?: Maybe<Scalars['Boolean']>;
  /** The base currency code. */
  base_currency_code?: Maybe<Scalars['String']>;
  /** A fully-qualified URL that is used to create relative links to the `base_url`. */
  base_link_url?: Maybe<Scalars['String']>;
  /** The fully-qualified URL that specifies the location of media files. */
  base_media_url?: Maybe<Scalars['String']>;
  /** The fully-qualified URL that specifies the location of static view files. */
  base_static_url?: Maybe<Scalars['String']>;
  /** The store’s fully-qualified base URL. */
  base_url?: Maybe<Scalars['String']>;
  /** Extended Config Data - checkout/cart/delete_quote_after */
  cart_expires_in_days?: Maybe<Scalars['Int']>;
  /** Extended Config Data - checkout/cart_link/use_qty */
  cart_summary_display_quantity?: Maybe<Scalars['Int']>;
  /** The default sort order of the search results list. */
  catalog_default_sort_by?: Maybe<Scalars['String']>;
  /** Corresponds to the 'Display Prices In Product Lists' field in the Admin. It indicates how FPT information is displayed on category pages. */
  category_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** The suffix applied to category pages, such as `.htm` or `.html`. */
  category_url_suffix?: Maybe<Scalars['String']>;
  /** Indicates whether only specific countries can use this payment method. */
  check_money_order_enable_for_specific_countries?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the Check/Money Order payment method is enabled. */
  check_money_order_enabled?: Maybe<Scalars['Boolean']>;
  /** The name of the party to whom the check must be payable. */
  check_money_order_make_check_payable_to?: Maybe<Scalars['String']>;
  /** The maximum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_max_order_total?: Maybe<Scalars['String']>;
  /** The minimum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_min_order_total?: Maybe<Scalars['String']>;
  /** The status of new orders placed using the Check/Money Order payment method. */
  check_money_order_new_order_status?: Maybe<Scalars['String']>;
  /** A comma-separated list of specific countries allowed to use the Check/Money Order payment method. */
  check_money_order_payment_from_specific_countries?: Maybe<Scalars['String']>;
  /** The full street address or PO Box where the checks are mailed. */
  check_money_order_send_check_to?: Maybe<Scalars['String']>;
  /** A number indicating the position of the Check/Money Order payment method in the list of available payment methods during checkout. */
  check_money_order_sort_order?: Maybe<Scalars['Int']>;
  /** The title of the Check/Money Order payment method displayed on the storefront. */
  check_money_order_title?: Maybe<Scalars['String']>;
  /** The name of the CMS page that identifies the home page for the store. */
  cms_home_page?: Maybe<Scalars['String']>;
  /** A specific CMS page that displays when cookies are not enabled for the browser. */
  cms_no_cookies?: Maybe<Scalars['String']>;
  /** A specific CMS page that displays when a 404 'Page Not Found' error occurs. */
  cms_no_route?: Maybe<Scalars['String']>;
  /**
   * A code assigned to the store to identify it.
   * @deprecated Use `store_code` instead.
   */
  code?: Maybe<Scalars['String']>;
  /** Indicates whether the `parent` or child (`itself`) thumbnail should be used in the cart for configurable products. */
  configurable_thumbnail_source?: Maybe<Scalars['String']>;
  /** Indicates whether the Contact Us form in enabled. */
  contact_enabled: Scalars['Boolean'];
  /** The copyright statement that appears at the bottom of each page. */
  copyright?: Maybe<Scalars['String']>;
  /** Extended Config Data - general/region/state_required */
  countries_with_required_region?: Maybe<Scalars['String']>;
  /** Indicates if the new accounts need confirmation. */
  create_account_confirmation?: Maybe<Scalars['Boolean']>;
  /** Customer access token lifetime. */
  customer_access_token_lifetime?: Maybe<Scalars['Float']>;
  /** Extended Config Data - general/country/default */
  default_country?: Maybe<Scalars['String']>;
  /** The description that provides a summary of your site for search engine listings. It should not be more than 160 characters in length. */
  default_description?: Maybe<Scalars['String']>;
  /** The default display currency code. */
  default_display_currency_code?: Maybe<Scalars['String']>;
  /** A series of keywords that describe your store, each separated by a comma. */
  default_keywords?: Maybe<Scalars['String']>;
  /** The title that appears at the title bar of each page when viewed in a browser. */
  default_title?: Maybe<Scalars['String']>;
  /** Controls the display of the demo store notice at the top of the page. Options: 0 (No) or 1 (Yes). */
  demonotice?: Maybe<Scalars['Int']>;
  /** Extended Config Data - general/region/display_all */
  display_state_if_optional?: Maybe<Scalars['Boolean']>;
  /** The landing page that is associated with the base URL. */
  front?: Maybe<Scalars['String']>;
  /** The default number of products per page in Grid View. */
  grid_per_page?: Maybe<Scalars['Int']>;
  /** A list of numbers that define how many products can be displayed in Grid View. */
  grid_per_page_values?: Maybe<Scalars['String']>;
  /** Scripts that must be included in the HTML before the closing `<head>` tag. */
  head_includes?: Maybe<Scalars['String']>;
  /** The small graphic image (favicon) that appears in the address bar and tab of the browser. */
  head_shortcut_icon?: Maybe<Scalars['String']>;
  /** The path to the logo that appears in the header. */
  header_logo_src?: Maybe<Scalars['String']>;
  /**
   * The ID number assigned to the store.
   * @deprecated Use `store_code` instead.
   */
  id?: Maybe<Scalars['Int']>;
  /** Indicates whether the store view has been designated as the default within the store group. */
  is_default_store?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the store group has been designated as the default within the website. */
  is_default_store_group?: Maybe<Scalars['Boolean']>;
  /** Extended Config Data - checkout/options/guest_checkout */
  is_guest_checkout_enabled?: Maybe<Scalars['Boolean']>;
  /** Extended Config Data - checkout/options/onepage_checkout_enabled */
  is_one_page_checkout_enabled?: Maybe<Scalars['Boolean']>;
  /** The format of the search results list. */
  list_mode?: Maybe<Scalars['String']>;
  /** The default number of products per page in List View. */
  list_per_page?: Maybe<Scalars['Int']>;
  /** A list of numbers that define how many products can be displayed in List View. */
  list_per_page_values?: Maybe<Scalars['String']>;
  /** The store locale. */
  locale?: Maybe<Scalars['String']>;
  /** The Alt text that is associated with the logo. */
  logo_alt?: Maybe<Scalars['String']>;
  /** The height of the logo image, in pixels. */
  logo_height?: Maybe<Scalars['Int']>;
  /** The width of the logo image, in pixels. */
  logo_width?: Maybe<Scalars['Int']>;
  /** Indicates whether wishlists are enabled (1) or disabled (0). */
  magento_wishlist_general_is_enabled?: Maybe<Scalars['String']>;
  /** Extended Config Data - checkout/options/max_items_display_count */
  max_items_in_order_summary?: Maybe<Scalars['Int']>;
  /** Extended Config Data - checkout/sidebar/display */
  minicart_display?: Maybe<Scalars['Boolean']>;
  /** Extended Config Data - checkout/sidebar/count */
  minicart_max_items?: Maybe<Scalars['Int']>;
  /** The minimum number of characters required for a valid password. */
  minimum_password_length?: Maybe<Scalars['String']>;
  /** Indicates whether newsletters are enabled. */
  newsletter_enabled: Scalars['Boolean'];
  /** The default page that displays when a 404 'Page not Found' error occurs. */
  no_route?: Maybe<Scalars['String']>;
  /** Extended Config Data - general/country/optional_zip_countries */
  optional_zip_countries?: Maybe<Scalars['String']>;
  /** Indicates whether orders can be cancelled by customers or not. */
  order_cancellation_enabled: Scalars['Boolean'];
  /** An array containing available cancellation reasons. */
  order_cancellation_reasons: Array<Maybe<CancellationReason>>;
  /** Corresponds to the 'Display Prices On Product View Page' field in the Admin. It indicates how FPT information is displayed on product pages. */
  product_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** The suffix applied to product pages, such as `.htm` or `.html`. */
  product_url_suffix?: Maybe<Scalars['String']>;
  /** The number of different character classes (lowercase, uppercase, digits, special characters) required in a password. */
  required_character_classes_number?: Maybe<Scalars['String']>;
  /**
   * The ID of the root category.
   * @deprecated Use `root_category_uid` instead.
   */
  root_category_id?: Maybe<Scalars['Int']>;
  /** The unique ID for a `CategoryInterface` object. */
  root_category_uid?: Maybe<Scalars['ID']>;
  /** Corresponds to the 'Display Prices In Sales Modules' field in the Admin. It indicates how FPT information is displayed on cart, checkout, and order pages. */
  sales_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** A secure fully-qualified URL that is used to create relative links to the `base_url`. */
  secure_base_link_url?: Maybe<Scalars['String']>;
  /** The secure fully-qualified URL that specifies the location of media files. */
  secure_base_media_url?: Maybe<Scalars['String']>;
  /** The secure fully-qualified URL that specifies the location of static view files. */
  secure_base_static_url?: Maybe<Scalars['String']>;
  /** The store’s fully-qualified secure base URL. */
  secure_base_url?: Maybe<Scalars['String']>;
  /** Extended Config Data - tax/cart_display/full_summary */
  shopping_cart_display_full_summary?: Maybe<Scalars['Boolean']>;
  /** Extended Config Data - tax/cart_display/grandtotal */
  shopping_cart_display_grand_total?: Maybe<Scalars['Boolean']>;
  /** Extended Config Data - tax/cart_display/price */
  shopping_cart_display_price?: Maybe<Scalars['Int']>;
  /** Extended Config Data - tax/cart_display/shipping */
  shopping_cart_display_shipping?: Maybe<Scalars['Int']>;
  /** Extended Config Data - tax/cart_display/subtotal */
  shopping_cart_display_subtotal?: Maybe<Scalars['Int']>;
  /** Extended Config Data - tax/cart_display/gift_wrapping */
  shopping_cart_display_tax_gift_wrapping?: Maybe<TaxWrappingEnum>;
  /** Extended Config Data - tax/cart_display/zero_tax */
  shopping_cart_display_zero_tax?: Maybe<Scalars['Boolean']>;
  /** Indicates whether a breadcrumb trail appears on all CMS pages in the catalog. 0 (No) or 1 (Yes). */
  show_cms_breadcrumbs?: Maybe<Scalars['Int']>;
  /** The unique ID of the store view. In the Admin, this is called the Store View Code. When making a GraphQL call, assign this value to the `Store` header to provide the scope. */
  store_code?: Maybe<Scalars['ID']>;
  /** The unique ID assigned to the store group. In the Admin, this is called the Store Name. */
  store_group_code?: Maybe<Scalars['ID']>;
  /** The label assigned to the store group. */
  store_group_name?: Maybe<Scalars['String']>;
  /** The label assigned to the store view. */
  store_name?: Maybe<Scalars['String']>;
  /** The store view sort order. */
  store_sort_order?: Maybe<Scalars['Int']>;
  /** The time zone of the store. */
  timezone?: Maybe<Scalars['String']>;
  /** A prefix that appears before the title to create a two- or three-part title. */
  title_prefix?: Maybe<Scalars['String']>;
  /** The character that separates the category name and subcategory in the browser title bar. */
  title_separator?: Maybe<Scalars['String']>;
  /** A suffix that appears after the title to create a two- or three-part title. */
  title_suffix?: Maybe<Scalars['String']>;
  /** Indicates whether the store code should be used in the URL. */
  use_store_in_url?: Maybe<Scalars['Boolean']>;
  /** The unique ID for the website. */
  website_code?: Maybe<Scalars['ID']>;
  /**
   * The ID number assigned to the website store.
   * @deprecated The field should not be used on the storefront.
   */
  website_id?: Maybe<Scalars['Int']>;
  /** The label assigned to the website. */
  website_name?: Maybe<Scalars['String']>;
  /** The unit of weight. */
  weight_unit?: Maybe<Scalars['String']>;
  /** Text that appears in the header of the page and includes the name of the logged in customer. */
  welcome?: Maybe<Scalars['String']>;
  /** Indicates whether only specific countries can use this payment method. */
  zero_subtotal_enable_for_specific_countries?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the Zero Subtotal payment method is enabled. */
  zero_subtotal_enabled?: Maybe<Scalars['Boolean']>;
  /** The status of new orders placed using the Zero Subtotal payment method. */
  zero_subtotal_new_order_status?: Maybe<Scalars['String']>;
  /** When the new order status is 'Processing', this can be set to `authorize_capture` to automatically invoice all items that have a zero balance. */
  zero_subtotal_payment_action?: Maybe<Scalars['String']>;
  /** A comma-separated list of specific countries allowed to use the Zero Subtotal payment method. */
  zero_subtotal_payment_from_specific_countries?: Maybe<Scalars['String']>;
  /** A number indicating the position of the Zero Subtotal payment method in the list of available payment methods during checkout. */
  zero_subtotal_sort_order?: Maybe<Scalars['Int']>;
  /** The title of the Zero Subtotal payment method displayed on the storefront. */
  zero_subtotal_title?: Maybe<Scalars['String']>;
};

/** Indicates where an attribute can be displayed. */
export type StorefrontProperties = {
  __typename?: 'StorefrontProperties';
  /** The relative position of the attribute in the layered navigation block. */
  position?: Maybe<Scalars['Int']>;
  /** Indicates whether the attribute is filterable with results, without results, or not at all. */
  use_in_layered_navigation?: Maybe<UseInLayeredNavigationOptions>;
  /** Indicates whether the attribute is displayed in product listings. */
  use_in_product_listing?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the attribute can be used in layered navigation on search results pages. */
  use_in_search_results_layered_navigation?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the attribute is displayed on product pages. */
  visible_on_catalog_pages?: Maybe<Scalars['Boolean']>;
};

/** Contains the result of the `subscribeEmailToNewsletter` operation. */
export type SubscribeEmailToNewsletterOutput = {
  __typename?: 'SubscribeEmailToNewsletterOutput';
  /** The status of the subscription request. */
  status?: Maybe<SubscriptionStatusesEnum>;
};

export type SubscriptionRevision = {
  __typename?: 'SubscriptionRevision';
  hp_return_shipping_fee_sku?: Maybe<Scalars['String']>;
  hp_upgrade_cutoff_time?: Maybe<Scalars['String']>;
  hp_upgrade_cutoff_time_uom?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<Item>>>;
  name: Scalars['String'];
  sku: Scalars['String'];
};

/** Indicates the status of the request. */
export type SubscriptionStatusesEnum =
  | 'NOT_ACTIVE'
  | 'SUBSCRIBED'
  | 'UNCONFIRMED'
  | 'UNSUBSCRIBED';

/** Describes the swatch type and a value. */
export type SwatchData = {
  __typename?: 'SwatchData';
  /** The type of swatch filter item: 1 - text; 2 - image. */
  type?: Maybe<Scalars['String']>;
  /** The value for the swatch item. It could be text or an image link. */
  value?: Maybe<Scalars['String']>;
};

export type SwatchDataInterface = {
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>;
};

/** Swatch attribute metadata input types. */
export type SwatchInputTypeEnum =
  | 'BOOLEAN'
  | 'DATE'
  | 'DATETIME'
  | 'DROPDOWN'
  | 'FILE'
  | 'GALLERY'
  | 'HIDDEN'
  | 'IMAGE'
  | 'MEDIA_IMAGE'
  | 'MULTILINE'
  | 'MULTISELECT'
  | 'PRICE'
  | 'SELECT'
  | 'TEXT'
  | 'TEXTAREA'
  | 'UNDEFINED'
  | 'VISUAL'
  | 'WEIGHT';

export type SwatchLayerFilterItem = LayerFilterItemInterface &
  SwatchLayerFilterItemInterface & {
    __typename?: 'SwatchLayerFilterItem';
    /**
     * The count of items per filter.
     * @deprecated Use `AggregationOption.count` instead.
     */
    items_count?: Maybe<Scalars['Int']>;
    /**
     * The label for a filter.
     * @deprecated Use `AggregationOption.label` instead.
     */
    label?: Maybe<Scalars['String']>;
    /** Data required to render a swatch filter item. */
    swatch_data?: Maybe<SwatchData>;
    /**
     * The value of a filter request variable to be used in query.
     * @deprecated Use `AggregationOption.value` instead.
     */
    value_string?: Maybe<Scalars['String']>;
  };

export type SwatchLayerFilterItemInterface = {
  /** Data required to render a swatch filter item. */
  swatch_data?: Maybe<SwatchData>;
};

/** Contains tax item details. */
export type TaxItem = {
  __typename?: 'TaxItem';
  /** The amount of tax applied to the item. */
  amount: Money;
  /** The rate used to calculate the tax. */
  rate: Scalars['Float'];
  /** A title that describes the tax. */
  title: Scalars['String'];
};

export type TaxWrappingEnum =
  | 'DISPLAY_EXCLUDING_TAX'
  | 'DISPLAY_INCLUDING_TAX'
  | 'DISPLAY_TYPE_BOTH';

export type TextSwatchData = SwatchDataInterface & {
  __typename?: 'TextSwatchData';
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']>;
};

/** Defines a price based on the quantity purchased. */
export type TierPrice = {
  __typename?: 'TierPrice';
  /** The price discount that this tier represents. */
  discount?: Maybe<ProductDiscount>;
  /** The price of the product at this tier. */
  final_price?: Maybe<Money>;
  /** The minimum number of items that must be purchased to qualify for this price tier. */
  quantity?: Maybe<Scalars['Float']>;
};

/** Modifies the specified items in the cart. */
export type UpdateCartItemsInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String'];
  /** An array of items to be updated. */
  cart_items: Array<InputMaybe<CartItemUpdateInput>>;
};

/** Contains details about the cart after updating items. */
export type UpdateCartItemsOutput = {
  __typename?: 'UpdateCartItemsOutput';
  /** The cart after updating products. */
  cart: Cart;
};

/** Output of the request to update CVV on payment method. */
export type UpdatePaymentMethodCvvOutput = {
  __typename?: 'UpdatePaymentMethodCvvOutput';
  /** Payment method ID */
  payment_method_id?: Maybe<Scalars['String']>;
};

/** Contains the customer's wish list and any errors encountered. */
export type UpdateProductsInWishlistOutput = {
  __typename?: 'UpdateProductsInWishlistOutput';
  /** An array of errors encountered while updating products in a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with all items that were successfully updated. */
  wishlist: Wishlist;
};

/** Contains URL rewrite details. */
export type UrlRewrite = {
  __typename?: 'UrlRewrite';
  /** An array of request parameters. */
  parameters?: Maybe<Array<Maybe<HttpQueryParameter>>>;
  /** The request URL. */
  url?: Maybe<Scalars['String']>;
};

/** This enumeration defines the entity type. */
export type UrlRewriteEntityTypeEnum = 'CATEGORY' | 'CMS_PAGE' | 'PRODUCT';

/** Defines whether the attribute is filterable in layered navigation. */
export type UseInLayeredNavigationOptions =
  | 'FILTERABLE_NO_RESULT'
  | 'FILTERABLE_WITH_RESULTS'
  | 'NO';

export type UserError = {
  __typename?: 'UserError';
  /** An error code. */
  code?: Maybe<Scalars['String']>;
  /** A localized error message. */
  message?: Maybe<Scalars['String']>;
};

/** Defines a customer attribute validation rule. */
export type ValidationRule = {
  __typename?: 'ValidationRule';
  /** Error message to display when validation fails */
  message?: Maybe<Scalars['String']>;
  /** Validation rule name applied to a customer attribute. */
  name?: Maybe<ValidationRuleEnum>;
  /** Rule type (required, email, etc.) */
  type?: Maybe<Scalars['String']>;
  /** Rule parameters */
  value?: Maybe<Scalars['String']>;
};

/** List of validation rule names applied to a customer attribute. */
export type ValidationRuleEnum =
  | 'DATE_RANGE_MAX'
  | 'DATE_RANGE_MIN'
  | 'FILE_EXTENSIONS'
  | 'INPUT_VALIDATION'
  | 'MAX_FILE_SIZE'
  | 'MAX_IMAGE_HEIGHT'
  | 'MAX_IMAGE_WIDTH'
  | 'MAX_TEXT_LENGTH'
  | 'MIN_TEXT_LENGTH';

export type ValidationSchema = {
  __typename?: 'ValidationSchema';
  /** List of forms with their validation rules */
  forms?: Maybe<Array<Maybe<Form>>>;
};

/** An implementation for virtual product cart items. */
export type VirtualCartItem = CartItemInterface & {
  __typename?: 'VirtualCartItem';
  /** An array containing customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String'];
  /** True if requested quantity is less than available stock, false otherwise. */
  is_available: Scalars['Boolean'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float'];
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID'];
};

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProduct = CustomizableProductInterface &
  ProductInterface &
  RoutableInterface & {
    __typename?: 'VirtualProduct';
    a12345?: Maybe<Scalars['String']>;
    /**
     * The attribute set assigned to the product.
     * @deprecated The field should not be used on the storefront.
     */
    attribute_set_id?: Maybe<Scalars['Int']>;
    /** Base Accessories Image for Catalog Product Image */
    base_accessories?: Maybe<ProductImage>;
    /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
    canonical_url?: Maybe<Scalars['String']>;
    /** The categories assigned to a product. */
    categories?: Maybe<Array<Maybe<CategoryInterface>>>;
    color?: Maybe<Scalars['Int']>;
    /** The product's country of origin. */
    country_of_manufacture?: Maybe<Scalars['String']>;
    /**
     * Timestamp indicating when the product was created.
     * @deprecated The field should not be used on the storefront.
     */
    created_at?: Maybe<Scalars['String']>;
    /** An array of cross-sell products. */
    crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
    /** Product custom attributes. */
    custom_attributesV2?: Maybe<ProductCustomAttributes>;
    /** Detailed information about the product. The value can include simple HTML tags. */
    description?: Maybe<ComplexTextValue>;
    /** Indicates whether a gift message is available. */
    gift_message_available?: Maybe<Scalars['String']>;
    hp_allowed_payment_type?: Maybe<Scalars['String']>;
    /** Allowed Payment Type. */
    hp_allowed_payment_type_label?: Maybe<Scalars['String']>;
    hp_as_low_as_price?: Maybe<Scalars['Float']>;
    hp_auto_renewal?: Maybe<Scalars['Int']>;
    hp_billing_cycle?: Maybe<Scalars['Int']>;
    hp_billing_cycle_uom?: Maybe<Scalars['Int']>;
    /** Billing cycle UOM of the product. */
    hp_billing_cycle_uom_label?: Maybe<Scalars['String']>;
    hp_billing_period?: Maybe<Scalars['Int']>;
    /** Billing Period label */
    hp_billing_period_label?: Maybe<Scalars['String']>;
    hp_bundle_lease_type?: Maybe<Scalars['String']>;
    hp_bundle_type?: Maybe<Scalars['Int']>;
    /** Bundle type of the product, like On Books or Hp One. */
    hp_bundle_type_label?: Maybe<Scalars['String']>;
    hp_can_be_ordered_individually?: Maybe<Scalars['Int']>;
    hp_cancellation_json?: Maybe<Scalars['String']>;
    hp_charge_type?: Maybe<Scalars['Int']>;
    /** Charge Type label */
    hp_charge_type_label?: Maybe<Scalars['String']>;
    hp_contract_duration?: Maybe<Scalars['Int']>;
    hp_contract_duration_uom?: Maybe<Scalars['Int']>;
    /** Contract duration UOM of the product. */
    hp_contract_duration_uom_label?: Maybe<Scalars['String']>;
    /** Delivery method value */
    hp_delivery_method?: Maybe<Scalars['Int']>;
    /** Delivery method label */
    hp_delivery_method_label?: Maybe<Scalars['String']>;
    hp_disclaimer?: Maybe<Scalars['String']>;
    hp_downgrade_cost_change?: Maybe<Scalars['Float']>;
    hp_early_accessibility?: Maybe<Scalars['Int']>;
    hp_eligibility_ruleset_id?: Maybe<Scalars['String']>;
    hp_external_product_id?: Maybe<Scalars['String']>;
    hp_fair_market_value?: Maybe<Scalars['Float']>;
    hp_initial_hpone_subscription_cost?: Maybe<Scalars['Float']>;
    hp_is_popular?: Maybe<Scalars['Int']>;
    hp_lease_fmv?: Maybe<Scalars['Float']>;
    hp_lease_type?: Maybe<Scalars['String']>;
    hp_limit_per_org?: Maybe<Scalars['Int']>;
    hp_marketing_name?: Maybe<Scalars['String']>;
    hp_max_days_to_return?: Maybe<Scalars['Int']>;
    hp_max_rollover_pages?: Maybe<Scalars['Int']>;
    hp_model_name?: Maybe<Scalars['String']>;
    /** Model Purpose of the Bundle Product */
    hp_model_purpose?: Maybe<Scalars['String']>;
    hp_offer_type?: Maybe<Scalars['Int']>;
    /** Offer Type label */
    hp_offer_type_label?: Maybe<Scalars['String']>;
    hp_order_type?: Maybe<Scalars['String']>;
    hp_overage_block_price?: Maybe<Scalars['Float']>;
    hp_overage_block_size?: Maybe<Scalars['Int']>;
    hp_overage_block_uom?: Maybe<Scalars['String']>;
    hp_pages_per_month?: Maybe<Scalars['Int']>;
    hp_partner_fmvs?: Maybe<Array<Maybe<PartnerFmv>>>;
    hp_plan_change_freeze_period?: Maybe<Scalars['Int']>;
    hp_plan_change_freeze_period_uom?: Maybe<Scalars['Int']>;
    /** Plan Change Freeze Period UOM. */
    hp_plan_change_freeze_period_uom_label?: Maybe<Scalars['String']>;
    hp_price_type?: Maybe<Scalars['Int']>;
    /** Price type of the product. */
    hp_price_type_label?: Maybe<Scalars['String']>;
    hp_product_full_specification?: Maybe<Scalars['String']>;
    /** Product number of the product. */
    hp_product_number?: Maybe<Scalars['String']>;
    hp_product_type?: Maybe<Scalars['Int']>;
    /** Product type of the product. */
    hp_product_type_label?: Maybe<Scalars['String']>;
    hp_return_json?: Maybe<Scalars['String']>;
    hp_return_shipping_fee_sku?: Maybe<Scalars['String']>;
    hp_rollover_pages?: Maybe<Scalars['Int']>;
    hp_short_config_name?: Maybe<Scalars['String']>;
    hp_solution_id?: Maybe<Scalars['String']>;
    hp_source_system?: Maybe<Scalars['String']>;
    hp_specifications_json?: Maybe<Scalars['String']>;
    hp_storage_amount?: Maybe<Scalars['Int']>;
    hp_storage_uom?: Maybe<Scalars['Int']>;
    /** HP Storage Uom of the product. */
    hp_storage_uom_label?: Maybe<Scalars['String']>;
    hp_storefront_group?: Maybe<Scalars['Int']>;
    /** Storefront group of the product. */
    hp_storefront_group_label?: Maybe<Scalars['String']>;
    hp_supply_type?: Maybe<Scalars['Int']>;
    /** Supply type of the product on printers. */
    hp_supply_type_label?: Maybe<Scalars['String']>;
    hp_support_coverage_included_with_hw?: Maybe<Scalars['Int']>;
    /** support coverage of the product. */
    hp_support_coverage_included_with_hw_label?: Maybe<Scalars['String']>;
    hp_tokens_count?: Maybe<Scalars['Int']>;
    hp_trial_duration?: Maybe<Scalars['Int']>;
    hp_trial_duration_unit?: Maybe<Scalars['Int']>;
    /** Trial duration unit of the product. */
    hp_trial_duration_unit_label?: Maybe<Scalars['String']>;
    hp_trial_pages_per_month?: Maybe<Scalars['Int']>;
    hp_trial_price?: Maybe<Scalars['Float']>;
    hp_unit_of_measure?: Maybe<Scalars['Int']>;
    /** Unit of Measure label */
    hp_unit_of_measure_label?: Maybe<Scalars['String']>;
    hp_updated_hpone_subscription_cost?: Maybe<Scalars['Float']>;
    hp_upgrade_cost_change?: Maybe<Scalars['Float']>;
    /**
     * The ID number assigned to the product.
     * @deprecated Use the `uid` field instead.
     */
    id?: Maybe<Scalars['Int']>;
    /** The relative path to the main image on the product page. */
    image?: Maybe<ProductImage>;
    /** A number representing the product's manufacturer. */
    manufacturer?: Maybe<Scalars['Int']>;
    /** An array of media gallery objects. */
    media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
    /**
     * An array of MediaGalleryEntry objects.
     * @deprecated Use `media_gallery` instead.
     */
    media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
    /** A brief overview of the product for search results listings, maximum 255 characters. */
    meta_description?: Maybe<Scalars['String']>;
    /** A comma-separated list of keywords that are visible only to search engines. */
    meta_keyword?: Maybe<Scalars['String']>;
    /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
    meta_title?: Maybe<Scalars['String']>;
    /** The product name. Customers use this name to identify the product. */
    name?: Maybe<Scalars['String']>;
    /** The beginning date for new product listings, and determines if the product is featured as a new product. */
    new_from_date?: Maybe<Scalars['String']>;
    /** The end date for new product listings. */
    new_to_date?: Maybe<Scalars['String']>;
    /** Product stock only x left count */
    only_x_left_in_stock?: Maybe<Scalars['Float']>;
    operational_system?: Maybe<Scalars['String']>;
    /** An array of options for a customizable product. */
    options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
    /** If the product has multiple options, determines where they appear on the product page. */
    options_container?: Maybe<Scalars['String']>;
    /**
     * Indicates the price of an item.
     * @deprecated Use `price_range` for product price information.
     */
    price?: Maybe<ProductPrices>;
    /** The range of prices for the product */
    price_range: PriceRange;
    /** An array of `TierPrice` objects. */
    price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
    /** An array of `ProductLinks` objects. */
    product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
    /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
    redirect_code: Scalars['Int'];
    /** An array of related products. */
    related_products?: Maybe<Array<Maybe<ProductInterface>>>;
    /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
    relative_url?: Maybe<Scalars['String']>;
    /** A short description of the product. Its use depends on the theme. */
    short_description?: Maybe<ComplexTextValue>;
    /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
    sku?: Maybe<Scalars['String']>;
    /** Small Accessories Image for Catalog Product Image */
    small_accessories?: Maybe<ProductImage>;
    /** The relative path to the small image, which is used on catalog pages. */
    small_image?: Maybe<ProductImage>;
    /**
     * The beginning date that a product has a special price.
     * @deprecated The field should not be used on the storefront.
     */
    special_from_date?: Maybe<Scalars['String']>;
    /** The discounted price of the product. */
    special_price?: Maybe<Scalars['Float']>;
    /** The end date for a product with a special price. */
    special_to_date?: Maybe<Scalars['String']>;
    /** Indicates whether the product is staged for a future campaign. */
    staged: Scalars['Boolean'];
    /** Stock status of the product */
    stock_status?: Maybe<ProductStockStatus>;
    storage?: Maybe<Scalars['String']>;
    /** The file name of a swatch image. */
    swatch_image?: Maybe<Scalars['String']>;
    /** The relative path to the product's thumbnail image. */
    thumbnail?: Maybe<ProductImage>;
    /** Thumbnail Accessories Image for Catalog Product Image */
    thumbnail_accessories?: Maybe<ProductImage>;
    /**
     * The price when tier pricing is in effect and the items purchased threshold has been reached.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_price?: Maybe<Scalars['Float']>;
    /**
     * An array of ProductTierPrices objects.
     * @deprecated Use `price_tiers` for product tier price information.
     */
    tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
    /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
    type?: Maybe<UrlRewriteEntityTypeEnum>;
    /**
     * One of simple, virtual, bundle, downloadable, grouped, or configurable.
     * @deprecated Use `__typename` instead.
     */
    type_id?: Maybe<Scalars['String']>;
    /** The unique ID for a `ProductInterface` object. */
    uid: Scalars['ID'];
    /**
     * Timestamp indicating when the product was updated.
     * @deprecated The field should not be used on the storefront.
     */
    updated_at?: Maybe<Scalars['String']>;
    /** An array of up-sell products. */
    upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
    /** The part of the URL that identifies the product */
    url_key?: Maybe<Scalars['String']>;
    /** @deprecated Use product's `canonical_url` or url rewrites instead */
    url_path?: Maybe<Scalars['String']>;
    /** URL rewrites list */
    url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
    /** The part of the product URL that is appended after the url key */
    url_suffix?: Maybe<Scalars['String']>;
    usage?: Maybe<Scalars['String']>;
    /**
     * An array of websites in which the product is available.
     * @deprecated The field should not be used on the storefront.
     */
    websites?: Maybe<Array<Maybe<Website>>>;
  };

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProductCustom_AttributesV2Args = {
  filters?: InputMaybe<AttributeFilterInput>;
};

/** Defines a single product to add to the cart. */
export type VirtualProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: CartItemInput;
};

/** Contains a virtual product wish list item. */
export type VirtualWishlistItem = WishlistItemInterface & {
  __typename?: 'VirtualWishlistItem';
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

/** Deprecated. It should not be used on the storefront. Contains information about a website. */
export type Website = {
  __typename?: 'Website';
  /**
   * A code assigned to the website to identify it.
   * @deprecated The field should not be used on the storefront.
   */
  code?: Maybe<Scalars['String']>;
  /**
   * The default group ID of the website.
   * @deprecated The field should not be used on the storefront.
   */
  default_group_id?: Maybe<Scalars['String']>;
  /**
   * The ID number assigned to the website.
   * @deprecated The field should not be used on the storefront.
   */
  id?: Maybe<Scalars['Int']>;
  /**
   * Indicates whether this is the default website.
   * @deprecated The field should not be used on the storefront.
   */
  is_default?: Maybe<Scalars['Boolean']>;
  /**
   * The website name. Websites use this name to identify it easier.
   * @deprecated The field should not be used on the storefront.
   */
  name?: Maybe<Scalars['String']>;
  /**
   * The attribute to use for sorting websites.
   * @deprecated The field should not be used on the storefront.
   */
  sort_order?: Maybe<Scalars['Int']>;
};

/** An error encountered while performing operations with WishList. */
export type WishListUserInputError = {
  __typename?: 'WishListUserInputError';
  /** A wish list-specific error code. */
  code: WishListUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String'];
};

/** A list of possible error types. */
export type WishListUserInputErrorType = 'PRODUCT_NOT_FOUND' | 'UNDEFINED';

/** Contains a customer wish list. */
export type Wishlist = {
  __typename?: 'Wishlist';
  /** The unique ID for a `Wishlist` object. */
  id?: Maybe<Scalars['ID']>;
  /** @deprecated Use the `items_v2` field instead. */
  items?: Maybe<Array<Maybe<WishlistItem>>>;
  /** The number of items in the wish list. */
  items_count?: Maybe<Scalars['Int']>;
  /** An array of items in the customer's wish list. */
  items_v2?: Maybe<WishlistItems>;
  /** An encrypted code that Magento uses to link to the wish list. */
  sharing_code?: Maybe<Scalars['String']>;
  /** The time of the last modification to the wish list. */
  updated_at?: Maybe<Scalars['String']>;
};

/** Contains a customer wish list. */
export type WishlistItems_V2Args = {
  currentPage?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Contains details about errors encountered when a customer added wish list items to the cart. */
export type WishlistCartUserInputError = {
  __typename?: 'WishlistCartUserInputError';
  /** An error code that describes the error encountered. */
  code: WishlistCartUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String'];
  /** The unique ID of the `Wishlist` object containing an error. */
  wishlistId: Scalars['ID'];
  /** The unique ID of the wish list item containing an error. */
  wishlistItemId: Scalars['ID'];
};

/** A list of possible error types. */
export type WishlistCartUserInputErrorType =
  | 'INSUFFICIENT_STOCK'
  | 'NOT_SALABLE'
  | 'PRODUCT_NOT_FOUND'
  | 'UNDEFINED';

/** Contains details about a wish list item. */
export type WishlistItem = {
  __typename?: 'WishlistItem';
  /** The time when the customer added the item to the wish list. */
  added_at?: Maybe<Scalars['String']>;
  /** The customer's comment about this item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItem` object. */
  id?: Maybe<Scalars['Int']>;
  /** Details about the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item */
  qty?: Maybe<Scalars['Float']>;
};

/** Defines the items to add to a wish list. */
export type WishlistItemInput = {
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** For complex product types, the SKU of the parent product. */
  parent_sku?: InputMaybe<Scalars['String']>;
  /** The amount or number of items to add. */
  quantity: Scalars['Float'];
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The SKU of the product to add. For complex product types, specify the child product SKU. */
  sku: Scalars['String'];
};

/** The interface for wish list items. */
export type WishlistItemInterface = {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float'];
};

/** Defines updates to items in a wish list. */
export type WishlistItemUpdateInput = {
  /** Customer-entered comments about the item. */
  description?: InputMaybe<Scalars['String']>;
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** The new amount or number of this item. */
  quantity?: InputMaybe<Scalars['Float']>;
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The unique ID for a `WishlistItemInterface` object. */
  wishlist_item_id: Scalars['ID'];
};

/** Contains an array of items in a wish list. */
export type WishlistItems = {
  __typename?: 'WishlistItems';
  /** A list of items in the wish list. */
  items: Array<Maybe<WishlistItemInterface>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
};

/** Deprecated: Use the `Wishlist` type instead. */
export type WishlistOutput = {
  __typename?: 'WishlistOutput';
  /**
   * An array of items in the customer's wish list
   * @deprecated Use the `Wishlist.items` field instead.
   */
  items?: Maybe<Array<Maybe<WishlistItem>>>;
  /**
   * The number of items in the wish list.
   * @deprecated Use the `Wishlist.items_count` field instead.
   */
  items_count?: Maybe<Scalars['Int']>;
  /**
   * When multiple wish lists are enabled, the name the customer assigns to the wishlist.
   * @deprecated This field is related to Commerce functionality and is always `null` in Open Source.
   */
  name?: Maybe<Scalars['String']>;
  /**
   * An encrypted code that links to the wish list.
   * @deprecated Use the `Wishlist.sharing_code` field instead.
   */
  sharing_code?: Maybe<Scalars['String']>;
  /**
   * The time of the last modification to the wish list.
   * @deprecated Use the `Wishlist.updated_at` field instead.
   */
  updated_at?: Maybe<Scalars['String']>;
};

/** wsreg defines information about wsreg fee */
export type WsRegFees = {
  __typename?: 'WsRegFees';
  /** The Battery Fee for all the products in cart. */
  total_battery_fee_for_products?: Maybe<Money>;
  /** The Chemical Fee for all the products in cart. */
  total_chemical_fee_for_products?: Maybe<Money>;
  /** The Copyright Fee for all the products in cart. */
  total_copyright_fee_for_products?: Maybe<Money>;
  /** The Recycle Fee for all the products in cart. */
  total_recycle_fee_for_products?: Maybe<Money>;
};

/** wsreg defines information about wsreg rates */
export type WsregOrder = {
  __typename?: 'WsregOrder';
  /** The Battery Fee for all the products in order. */
  total_battery_fee_for_products?: Maybe<Money>;
  /** The Chemical Fee for all the products in order. */
  total_chemical_fee_for_products?: Maybe<Money>;
  /** The Copyright Fee for all the products in order. */
  total_copyright_fee_for_products?: Maybe<Money>;
  /** The Recycle Fee for all the products in order. */
  total_recycle_fee_for_products?: Maybe<Money>;
  /** The array with wsreg rates of each item in the order. */
  wsreg_order_item?: Maybe<Array<Maybe<WsregOrderItem>>>;
};

/** Contains wsreg rates of each item in the order. */
export type WsregOrderItem = {
  __typename?: 'WsregOrderItem';
  /** Battery Fee Code for this item in order. */
  battery_fee_type_code: Scalars['String'];
  /** Chemical Fee Code for this item in order. */
  chemical_fee_type_code: Scalars['String'];
  /** Copyright Fee Code for for this item in order. */
  copyright_fee_type_code: Scalars['String'];
  /** Order Item Id. */
  label: Scalars['String'];
  /** The number of units in order for this item. */
  qty?: Maybe<Scalars['Float']>;
  /** Recycle Fee Code for this item in order. */
  recycle_fee_type_code: Scalars['String'];
  /** The SKU of the product in order. */
  sku: Scalars['String'];
  /** The Battery Fee for this item in order. */
  total_battery_fee_for_product?: Maybe<Money>;
  /** The Chemical Fee for this item in order. */
  total_chemical_fee_for_product?: Maybe<Money>;
  /** The Copyright Fee for this item in order. */
  total_copyright_fee_for_product?: Maybe<Money>;
  /** The Recycle Fee for this item in order. */
  total_recycle_fee_for_product?: Maybe<Money>;
};

/** wsreg defines information about wsreg rates */
export type WsregQuote = {
  __typename?: 'WsregQuote';
  /** The Battery Fee for all the products in cart. */
  total_battery_fee_for_products?: Maybe<Money>;
  /** The Chemical Fee for all the products in cart. */
  total_chemical_fee_for_products?: Maybe<Money>;
  /** The Copyright Fee for all the products in cart. */
  total_copyright_fee_for_products?: Maybe<Money>;
  /** The Recycle Fee for all the products in cart. */
  total_recycle_fee_for_products?: Maybe<Money>;
  /** The array with wsreg rates of each item in the cart. */
  wsreg_quote_item?: Maybe<Array<Maybe<WsregQuoteItem>>>;
};

/** Contains wsreg rates of each item in the cart. */
export type WsregQuoteItem = {
  __typename?: 'WsregQuoteItem';
  /** Battery Fee Code for the product in cart. */
  battery_fee_type_code: Scalars['String'];
  /** Chemical Fee Code for the product in cart. */
  chemical_fee_type_code: Scalars['String'];
  /** Copyright Fee Code for the product in cart. */
  copyright_fee_type_code: Scalars['String'];
  /** Cart item Id. */
  label: Scalars['String'];
  /** The number of units in cart for this item. */
  qty?: Maybe<Scalars['Float']>;
  /** Recycle Fee Code for the product in cart. */
  recycle_fee_type_code: Scalars['String'];
  /** The SKU of the product. */
  sku: Scalars['String'];
  /** The Battery Fee for the product in cart. */
  total_battery_fee_for_product?: Maybe<Money>;
  /** The Chemical Fee for the product in cart. */
  total_chemical_fee_for_product?: Maybe<Money>;
  /** The Copyright Fee for the product in cart. */
  total_copyright_fee_for_product?: Maybe<Money>;
  /** The Recycle Fee for the product in cart. */
  total_recycle_fee_for_product?: Maybe<Money>;
};

/** Assigns a specific `cart_id` to the empty cart. */
export type CreateEmptyCartInput = {
  /** The ID to assign to the cart. */
  cart_id?: InputMaybe<Scalars['String']>;
};

export const AddPaperToCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addPaperToCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cart_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addPaperToCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cart_id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddPaperToCartMutation,
  AddPaperToCartMutationVariables
>;
export const AddProductsToCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addProductsToCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cart_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cartItems' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CartItemInput' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'partnerInput' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PartnerInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addProductsToCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cartId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cart_id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cartItems' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cartItems' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'partner_input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'partnerInput' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'product' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sku' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uid' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'quantity' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_quantity' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user_errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddProductsToCartMutation,
  AddProductsToCartMutationVariables
>;
export const ApplyCouponToCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'applyCouponToCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cart_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'coupon_code' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyCouponToCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cart_id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'coupon_code' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'coupon_code' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'product' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'quantity' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applied_coupons' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'prices' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'monthly_total' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'device_monthly_total_with_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'device_monthly_total_without_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'subscription_monthly_total_with_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'subscription_monthly_total_without_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'grand_total' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'discounts' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'applied_to' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplyCouponToCartMutation,
  ApplyCouponToCartMutationVariables
>;
export const ClearCustomerCartAndAssignGuestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'clearCustomerCartAndAssignGuest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'customer_cart_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cart_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clearCustomerCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cartUid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'customer_cart_id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignCustomerToGuestCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cart_id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cart_id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClearCustomerCartAndAssignGuestMutation,
  ClearCustomerCartAndAssignGuestMutationVariables
>;
export const CreateEmptyCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createEmptyCart' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createEmptyCart' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateEmptyCartMutation,
  CreateEmptyCartMutationVariables
>;
export const CreatePaymentMethodOnCartFromCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPaymentMethodOnCartFromCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pickup_code' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPaymentMethodOnCartFromCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pickupCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pickup_code' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payment_method_id' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePaymentMethodOnCartFromCodeMutation,
  CreatePaymentMethodOnCartFromCodeMutationVariables
>;
export const GetArlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetArl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checkoutAgreements' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'name' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agreement_id' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'checkbox_text' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content_height' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'is_html' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetArlQuery, GetArlQueryVariables>;
export const GetCartItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCartItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cart_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cart_id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cart_id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grand_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currency' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'monthly_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'device_monthly_total_without_tax',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'device_monthly_total_with_tax',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'subscription_monthly_total_without_tax',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'subscription_monthly_total_with_tax',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_payment_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipping_addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'selected_shipping_method',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'BundleCartItem' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lineItems' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'client' },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'title' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'thumbnail' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'src' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'features' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sku' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'price' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'quantity' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bundle_options' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uid' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'values' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'uid' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'sku' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'label',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'price',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uid' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_bundle_lease_type',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_allowed_payment_type_label',
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'BundleProduct' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uid' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'price_range',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'maximum_price',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'regular_price',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'value',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'minimum_price',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'regular_price',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'value',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'uid' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'options',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'uid',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'required_sku',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_plan_option',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'product',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'uid',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_product_type_label',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_short_config_name',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_product_type',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_contract_duration',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_pages_per_month',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'sku',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'price_range',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'minimum_price',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'regular_price',
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: 'SelectionSet',
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: 'Field',
                                                                            name: {
                                                                              kind: 'Name',
                                                                              value:
                                                                                'value',
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'final_price',
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: 'SelectionSet',
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: 'Field',
                                                                            name: {
                                                                              kind: 'Name',
                                                                              value:
                                                                                'value',
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'maximum_price',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'regular_price',
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: 'SelectionSet',
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: 'Field',
                                                                            name: {
                                                                              kind: 'Name',
                                                                              value:
                                                                                'value',
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'media_gallery',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'url',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'label',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'thumbnail',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'url',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sku' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hp_product_type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_product_type_label',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumbnail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quantity' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'prices' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'price_including_tax',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_upcoming_price_including_tax',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCartItemsQuery, GetCartItemsQueryVariables>;
export const GetCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cart_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cart_id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cart_id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grand_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currency' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_payment_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_payment_method' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipping_addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'selected_shipping_method',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_allowed_payment_type_label',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_short_config_name',
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'BundleProduct' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'options',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'product',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_product_type_label',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'sku',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sku' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hp_product_type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_product_type_label',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quantity' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'prices' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'price_including_tax',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_upcoming_price_including_tax',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCartQuery, GetCartQueryVariables>;
export const GetCartByIdWithAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCartByIdWithAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cart_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'customerCart' },
            name: { kind: 'Name', value: 'cart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cart_id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cart_id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipping_addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'country' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hp_address_id' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_allowed_payment_type_label',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stock_status' },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'BundleProduct' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'uid' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'options',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'uid',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'product',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_product_type',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_product_type_label',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCartByIdWithAddressQuery,
  GetCartByIdWithAddressQueryVariables
>;
export const GetCmsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCmsPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'identifier' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cmsPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'identifier' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'identifier' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url_key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content_heading' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'page_layout' } },
                { kind: 'Field', name: { kind: 'Name', value: 'meta_title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCmsPageQuery, GetCmsPageQueryVariables>;
export const GetCustomerCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCustomerCart' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerCart' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sku' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_product_type_label',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_bundle_lease_type',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hp_product_type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumbnail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'BundleProduct' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'hp_cancellation_json',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'price_range',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'maximum_price',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'regular_price',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'value',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'minimum_price',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'regular_price',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'value',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'uid' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'hidden',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'json_option',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'options',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'uid',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: '__typename',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'product',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'uid',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'price_range',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'minimum_price',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'regular_price',
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: 'SelectionSet',
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: 'Field',
                                                                            name: {
                                                                              kind: 'Name',
                                                                              value:
                                                                                'value',
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'maximum_price',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'regular_price',
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: 'SelectionSet',
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: 'Field',
                                                                            name: {
                                                                              kind: 'Name',
                                                                              value:
                                                                                'value',
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'sku',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'name',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_pages_per_month',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_short_config_name',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_product_type',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_product_type_label',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_contract_duration',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_support_coverage_included_with_hw_label',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'thumbnail',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'label',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'url',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'media_gallery',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'url',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'label',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'BundleCartItem' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_cancellation_json',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bundle_options' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uid' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'values' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'uid' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'sku' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'label',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'price',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'quantity',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quantity' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'prices' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'price_including_tax',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_upcoming_price_including_tax',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'available_payment_methods' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'billing_address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hp_address_id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'telephone' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postcode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'company' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'country' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'region' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'region_id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'street' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipping_addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hp_address_id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postcode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'telephone' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'company' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'country' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'region' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'region_id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'street' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'selected_shipping_method',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'monthly_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'device_monthly_total_with_tax',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'device_monthly_total_without_tax',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'subscription_monthly_total_with_tax',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'subscription_monthly_total_without_tax',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grand_total' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currency' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discounts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'applied_to' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applied_coupons' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCustomerCartQuery,
  GetCustomerCartQueryVariables
>;
export const GetCustomerCartWithAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCustomerCartWithAddress' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerCart' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shipping_addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'country' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hp_address_id' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'billing_address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postcode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'region' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'region_id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'street' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stock_status' },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'BundleProduct' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'uid' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'options',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'uid',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'product',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_product_type',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'hp_product_type_label',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCustomerCartWithAddressQuery,
  GetCustomerCartWithAddressQueryVariables
>;
export const GetCustomerCartIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCustomerCartId' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerCart' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCustomerCartIdQuery,
  GetCustomerCartIdQueryVariables
>;
export const GetOrdersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOrders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'order_number' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orders' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'number' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'order_number',
                                    },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_count' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_partner_compensation',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'hp_partner_name',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'hp_off_ramp_redirect_url',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'hp_partner_logo_url',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'total' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'base_grand_total',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'grand_total',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total_tax' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subtotal' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'device_total_with_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'services_total_with_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'taxes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'value',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'currency',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'title',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'rate' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'total_shipping',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'shipping_handling',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount_including_tax',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'value',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount_excluding_tax',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'value',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'total_amount',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'currency',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'value',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'taxes',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'amount',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'currency',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'value',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'title',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'rate',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'discounts' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'amount',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'value',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'currency',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'label',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'number' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'order_date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'payment_methods' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'additional_data',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'product_name',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'product_sku',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'product_url_key',
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value: 'BundleOrderItem',
                                      },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'product_sku',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'bundle_options',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                  kind: 'NamedType',
                                                  name: {
                                                    kind: 'Name',
                                                    value:
                                                      'ItemSelectedBundleOption',
                                                  },
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'uid',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'label',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'values',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'product_name',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'product_sku',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'hp_product_type_label',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'price',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'value',
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'quantity',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrdersQuery, GetOrdersQueryVariables>;
export const GetPaperEligibleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPaperEligible' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerCart' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hp_paper_eligible' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPaperEligibleQuery,
  GetPaperEligibleQueryVariables
>;
export const GetPartnerCompensationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPartnerCompensation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'hpChannelCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPartnerCompensation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hpChannelCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'hpChannelCode' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hp_attribution_id' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hp_off_ramp_redirect_url' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hp_partner_name' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hp_partner_logo_url' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPartnerCompensationQuery,
  GetPartnerCompensationQueryVariables
>;
export const GetTotalOrdersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTotalOrders' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_count' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTotalOrdersQuery, GetTotalOrdersQueryVariables>;
export const GetSkuProductsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSKUProducts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skuList' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sku' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'skuList' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'hp_allowed_payment_type_label',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hp_is_popular' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'html' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_description' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'html' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price_range' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'minimum_price' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'regular_price',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'small_image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'base_accessories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'small_accessories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hp_model_purpose' },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'BundleProduct' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lowest_price' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'client' },
                                },
                              ],
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_cancellation_json',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_early_accessibility',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'json_option',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hidden' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'title' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uid' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'required' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'required_sku',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'options' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: '__typename',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'lowest_price',
                                          },
                                          directives: [
                                            {
                                              kind: 'Directive',
                                              name: {
                                                kind: 'Name',
                                                value: 'client',
                                              },
                                            },
                                          ],
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'hp_plan_option',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'is_default',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'label',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'position',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'price',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'hp_is_popular',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'product',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_early_accessibility',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_supply_type',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_supply_type_label',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_product_full_specification',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_overage_block_price',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_overage_block_size',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_specifications_json',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_short_config_name',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'description',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'html',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'price_range',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'maximum_price',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'regular_price',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'currency',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'value',
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'minimum_price',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'regular_price',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'currency',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'value',
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_pages_per_month',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_price_type',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_product_type',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_product_type_label',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_contract_duration',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_contract_duration_uom',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_contract_duration_uom_label',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_as_low_as_price',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'image',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'disabled',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'label',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'position',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'url',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'media_gallery',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'disabled',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'label',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'position',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'url',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'name',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'short_description',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'html',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'sku',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'small_image',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'disabled',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'label',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'position',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'url',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'stock_status',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'thumbnail',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'disabled',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'label',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'position',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'url',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'thumbnail_accessories',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'disabled',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'label',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'position',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'url',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'uid',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'quantity',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'uid' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'required_sku',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSkuProductsQuery, GetSkuProductsQueryVariables>;
export const GetSkuProductsWithRelationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSKUProductsWithRelations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skuList' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sku' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'skuList' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'hp_allowed_payment_type_label',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hp_is_popular' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'html' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_description' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'html' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'price_range' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'minimum_price' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'regular_price',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stock_status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'small_image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'base_accessories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'small_accessories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hp_model_purpose' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'crosssell_products' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sku' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price_range' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'minimum_price',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'regular_price',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'value',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'currency',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stock_status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'canonical_url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'related_products' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sku' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price_range' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'minimum_price',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'regular_price',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'value',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'currency',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stock_status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'canonical_url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'upsell_products' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sku' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price_range' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'minimum_price',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'regular_price',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'value',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'currency',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stock_status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'canonical_url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'BundleProduct' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lowest_price' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'client' },
                                },
                              ],
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_cancellation_json',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hp_early_accessibility',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'json_option',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hidden' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'title' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uid' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'required' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'required_sku',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'options' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: '__typename',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'lowest_price',
                                          },
                                          directives: [
                                            {
                                              kind: 'Directive',
                                              name: {
                                                kind: 'Name',
                                                value: 'client',
                                              },
                                            },
                                          ],
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'hp_plan_option',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'is_default',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'label',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'position',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'price',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'hp_is_popular',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'product',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_early_accessibility',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_supply_type',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_supply_type_label',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_product_full_specification',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_overage_block_price',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_overage_block_size',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_specifications_json',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_short_config_name',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'description',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'html',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'price_range',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'maximum_price',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'regular_price',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'currency',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'value',
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'minimum_price',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'regular_price',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'currency',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'value',
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_pages_per_month',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_price_type',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_product_type',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_product_type_label',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_contract_duration',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_contract_duration_uom',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'hp_contract_duration_uom_label',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'hp_as_low_as_price',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'image',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'disabled',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'label',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'position',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'url',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'media_gallery',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'disabled',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'label',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'position',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'url',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'name',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'short_description',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'html',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'sku',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'small_image',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'disabled',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'label',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'position',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'url',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'stock_status',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'thumbnail',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'disabled',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'label',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'position',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'url',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'uid',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'quantity',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'uid' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'required_sku',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSkuProductsWithRelationsQuery,
  GetSkuProductsWithRelationsQueryVariables
>;
export const GetPdpStateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPdpState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skuList' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdpConfig' },
            directives: [
              { kind: 'Directive', name: { kind: 'Name', value: 'client' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'selected_options' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'prices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPricePerMonth' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'totalSubscriptionPricePerMonth',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'totalDevicePricePerMonth',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalDevice' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPdpStateQuery, GetPdpStateQueryVariables>;
export const PlaceOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'placeOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cart_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'visitUUID' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tm_profiling_id' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'user_consents' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cart_id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hp_visituuid' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'visitUUID' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tm_profiling_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'tm_profiling_id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_consents' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'user_consents' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'order' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'order_number' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'instantinkUpgrades' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'created_at' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'friendly_name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'printer_image_url',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'printer_model_name',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'printer_serial_number',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subscription_id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cancel' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlaceOrderMutation, PlaceOrderMutationVariables>;
export const RemoveCouponFromCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeCouponFromCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cart_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeCouponFromCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cart_id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'product' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sku' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'quantity' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applied_coupons' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'prices' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'monthly_total' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'device_monthly_total_with_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'device_monthly_total_without_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'subscription_monthly_total_with_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'subscription_monthly_total_without_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'grand_total' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'discounts' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'applied_to' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveCouponFromCartMutation,
  RemoveCouponFromCartMutationVariables
>;
export const RemovePaperFromCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removePaperFromCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cart_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removePaperFromCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cart_id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemovePaperFromCartMutation,
  RemovePaperFromCartMutationVariables
>;
export const SetPaymentMethodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetPaymentMethod' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cart_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'payment_method' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setPaymentMethodOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cart_id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'payment_method' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'code' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'payment_method' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'selected_payment_method',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pgs_details' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'iframe_url' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'merchant_name',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'quote_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'request_time',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetPaymentMethodMutation,
  SetPaymentMethodMutationVariables
>;
export const SetShippingAddressAndMethodOnCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetShippingAddressAndMethodOnCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cart_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'firstname' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lastname' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'company' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'street' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'region' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'postcode' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'country_code' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'hp_address_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'telephone' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'save_in_address_book' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setShippingAddressesOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cart_id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'shipping_addresses' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'address' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: {
                                        kind: 'Name',
                                        value: 'firstname',
                                      },
                                      value: {
                                        kind: 'Variable',
                                        name: {
                                          kind: 'Name',
                                          value: 'firstname',
                                        },
                                      },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'lastname' },
                                      value: {
                                        kind: 'Variable',
                                        name: {
                                          kind: 'Name',
                                          value: 'lastname',
                                        },
                                      },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'company' },
                                      value: {
                                        kind: 'Variable',
                                        name: {
                                          kind: 'Name',
                                          value: 'company',
                                        },
                                      },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'street' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'street' },
                                      },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'city' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'city' },
                                      },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'region' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'region' },
                                      },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'postcode' },
                                      value: {
                                        kind: 'Variable',
                                        name: {
                                          kind: 'Name',
                                          value: 'postcode',
                                        },
                                      },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: {
                                        kind: 'Name',
                                        value: 'country_code',
                                      },
                                      value: {
                                        kind: 'Variable',
                                        name: {
                                          kind: 'Name',
                                          value: 'country_code',
                                        },
                                      },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: {
                                        kind: 'Name',
                                        value: 'telephone',
                                      },
                                      value: {
                                        kind: 'Variable',
                                        name: {
                                          kind: 'Name',
                                          value: 'telephone',
                                        },
                                      },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: {
                                        kind: 'Name',
                                        value: 'hp_address_id',
                                      },
                                      value: {
                                        kind: 'Variable',
                                        name: {
                                          kind: 'Name',
                                          value: 'hp_address_id',
                                        },
                                      },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: {
                                        kind: 'Name',
                                        value: 'save_in_address_book',
                                      },
                                      value: {
                                        kind: 'Variable',
                                        name: {
                                          kind: 'Name',
                                          value: 'save_in_address_book',
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setShippingMethodsOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cart_id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'shipping_methods' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'carrier_code' },
                                value: {
                                  kind: 'StringValue',
                                  value: 'flatrate',
                                  block: false,
                                },
                              },
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'method_code' },
                                value: {
                                  kind: 'StringValue',
                                  value: 'flatrate',
                                  block: false,
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'prices' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'price' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'price_including_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'hp_upcoming_price_including_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'prices' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'monthly_total' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'device_monthly_total_with_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'device_monthly_total_without_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'subscription_monthly_total_with_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'subscription_monthly_total_without_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'grand_total' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'discounts' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'applied_to' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shipping_addresses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hp_address_id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstname' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastname' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'postcode' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'telephone' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'company' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'country' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'code' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'region' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'code' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'region_id' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'street' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'selected_shipping_method',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetShippingAddressAndMethodOnCartMutation,
  SetShippingAddressAndMethodOnCartMutationVariables
>;
export const SetSubscriptionUpgradesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetSubscriptionUpgrades' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'subscriptionId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderIncrementId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setSubscriptionUpgrades' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'subscriptionId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'subscriptionId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'orderIncrementId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'orderIncrementId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetSubscriptionUpgradesMutation,
  SetSubscriptionUpgradesMutationVariables
>;
export const SetBillingAddressOnCartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetBillingAddressOnCart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cart_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'firstname' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lastname' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'company' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'street' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'region' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'postcode' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'country_code' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'hp_address_id' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'telephone' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'save_in_address_book' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'same_as_shipping' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'use_for_shipping' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setBillingAddressOnCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cart_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cart_id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'billing_address' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'address' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'firstname' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'firstname' },
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'lastname' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'lastname' },
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'company' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'company' },
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'street' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'street' },
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'city' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'city' },
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'region' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'region' },
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'postcode' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'postcode' },
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'country_code' },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'country_code',
                                    },
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'telephone' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'telephone' },
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: {
                                    kind: 'Name',
                                    value: 'hp_address_id',
                                  },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'hp_address_id',
                                    },
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: {
                                    kind: 'Name',
                                    value: 'save_in_address_book',
                                  },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'save_in_address_book',
                                    },
                                  },
                                },
                              ],
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'same_as_shipping' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'same_as_shipping' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'use_for_shipping' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'use_for_shipping' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'available_payment_methods',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'prices' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'price' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'price_including_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'hp_upcoming_price_including_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'prices' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'monthly_total' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'device_monthly_total_with_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'device_monthly_total_without_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'subscription_monthly_total_with_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'subscription_monthly_total_without_tax',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'grand_total' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'currency' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'discounts' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'amount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'currency',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'value',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'applied_to' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billing_address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hp_address_id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstname' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastname' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'telephone' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'postcode' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'company' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'country' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'code' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'region' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'code' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'region_id' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'street' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetBillingAddressOnCartMutation,
  SetBillingAddressOnCartMutationVariables
>;
export const UpdatePaymentMethodCvvOnCartFromCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePaymentMethodCvvOnCartFromCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pickup_code' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'updatePaymentMethodCvvOnCartFromCode',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pickupCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pickup_code' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'transaction_default' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'subscription_default' },
                      value: { kind: 'BooleanValue', value: false },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payment_method_id' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePaymentMethodCvvOnCartFromCodeMutation,
  UpdatePaymentMethodCvvOnCartFromCodeMutationVariables
>;
export type AddPaperToCartMutationVariables = Exact<{
  cart_id: Scalars['String'];
}>;

export type AddPaperToCartMutation = {
  __typename?: 'Mutation';
  addPaperToCart?: {
    __typename?: 'AddPaperToCartOutput';
    message?: string | null;
    success: boolean;
  } | null;
};

export type AddProductsToCartMutationVariables = Exact<{
  cart_id: Scalars['String'];
  cartItems: Array<CartItemInput> | CartItemInput;
  partnerInput?: InputMaybe<PartnerInput>;
}>;

export type AddProductsToCartMutation = {
  __typename?: 'Mutation';
  addProductsToCart?: {
    __typename?: 'AddProductsToCartOutput';
    cart: {
      __typename?: 'Cart';
      id: string;
      total_quantity: number;
      items?: Array<
        | {
            __typename?: 'BundleCartItem';
            quantity: number;
            product:
              | {
                  __typename?: 'BundleProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                }
              | {
                  __typename?: 'ConfigurableProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                }
              | {
                  __typename?: 'SimpleProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                }
              | {
                  __typename?: 'VirtualProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                };
          }
        | {
            __typename?: 'ConfigurableCartItem';
            quantity: number;
            product:
              | {
                  __typename?: 'BundleProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                }
              | {
                  __typename?: 'ConfigurableProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                }
              | {
                  __typename?: 'SimpleProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                }
              | {
                  __typename?: 'VirtualProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                };
          }
        | {
            __typename?: 'SimpleCartItem';
            quantity: number;
            product:
              | {
                  __typename?: 'BundleProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                }
              | {
                  __typename?: 'ConfigurableProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                }
              | {
                  __typename?: 'SimpleProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                }
              | {
                  __typename?: 'VirtualProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                };
          }
        | {
            __typename?: 'VirtualCartItem';
            quantity: number;
            product:
              | {
                  __typename?: 'BundleProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                }
              | {
                  __typename?: 'ConfigurableProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                }
              | {
                  __typename?: 'SimpleProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                }
              | {
                  __typename?: 'VirtualProduct';
                  name?: string | null;
                  sku?: string | null;
                  uid: string;
                };
          }
        | null
      > | null;
    };
    user_errors: Array<{
      __typename?: 'CartUserInputError';
      code: CartUserInputErrorType;
      message: string;
    } | null>;
  } | null;
};

export type ApplyCouponToCartMutationVariables = Exact<{
  cart_id: Scalars['String'];
  coupon_code: Scalars['String'];
}>;

export type ApplyCouponToCartMutation = {
  __typename?: 'Mutation';
  applyCouponToCart?: {
    __typename?: 'ApplyCouponToCartOutput';
    cart: {
      __typename?: 'Cart';
      items?: Array<
        | {
            __typename?: 'BundleCartItem';
            quantity: number;
            product:
              | { __typename?: 'BundleProduct'; name?: string | null }
              | { __typename?: 'ConfigurableProduct'; name?: string | null }
              | { __typename?: 'SimpleProduct'; name?: string | null }
              | { __typename?: 'VirtualProduct'; name?: string | null };
          }
        | {
            __typename?: 'ConfigurableCartItem';
            quantity: number;
            product:
              | { __typename?: 'BundleProduct'; name?: string | null }
              | { __typename?: 'ConfigurableProduct'; name?: string | null }
              | { __typename?: 'SimpleProduct'; name?: string | null }
              | { __typename?: 'VirtualProduct'; name?: string | null };
          }
        | {
            __typename?: 'SimpleCartItem';
            quantity: number;
            product:
              | { __typename?: 'BundleProduct'; name?: string | null }
              | { __typename?: 'ConfigurableProduct'; name?: string | null }
              | { __typename?: 'SimpleProduct'; name?: string | null }
              | { __typename?: 'VirtualProduct'; name?: string | null };
          }
        | {
            __typename?: 'VirtualCartItem';
            quantity: number;
            product:
              | { __typename?: 'BundleProduct'; name?: string | null }
              | { __typename?: 'ConfigurableProduct'; name?: string | null }
              | { __typename?: 'SimpleProduct'; name?: string | null }
              | { __typename?: 'VirtualProduct'; name?: string | null };
          }
        | null
      > | null;
      applied_coupons?: Array<{
        __typename?: 'AppliedCoupon';
        code: string;
      } | null> | null;
      prices?: {
        __typename?: 'CartPrices';
        monthly_total: {
          __typename?: 'MonthlyTotal';
          device_monthly_total_with_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
          device_monthly_total_without_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
          subscription_monthly_total_with_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
          subscription_monthly_total_without_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
        };
        grand_total?: {
          __typename?: 'Money';
          currency?: CurrencyEnum | null;
          value?: number | null;
        } | null;
        discounts?: Array<{
          __typename?: 'Discount';
          applied_to: CartDiscountType;
          label: string;
          amount: {
            __typename?: 'Money';
            currency?: CurrencyEnum | null;
            value?: number | null;
          };
        } | null> | null;
      } | null;
    };
  } | null;
};

export type ClearCustomerCartAndAssignGuestMutationVariables = Exact<{
  customer_cart_id: Scalars['String'];
  cart_id: Scalars['String'];
}>;

export type ClearCustomerCartAndAssignGuestMutation = {
  __typename?: 'Mutation';
  clearCustomerCart?: {
    __typename?: 'ClearCustomerCartOutput';
    status: boolean;
  } | null;
  assignCustomerToGuestCart: { __typename?: 'Cart'; id: string };
};

export type CreateEmptyCartMutationVariables = Exact<{ [key: string]: never }>;

export type CreateEmptyCartMutation = {
  __typename?: 'Mutation';
  createEmptyCart?: string | null;
};

export type CreatePaymentMethodOnCartFromCodeMutationVariables = Exact<{
  pickup_code: Scalars['String'];
}>;

export type CreatePaymentMethodOnCartFromCodeMutation = {
  __typename?: 'Mutation';
  createPaymentMethodOnCartFromCode?: {
    __typename?: 'CreatePaymentMethodOnCartOutput';
    payment_method_id?: string | null;
  } | null;
};

export type GetArlQueryVariables = Exact<{
  name: Scalars['String'];
}>;

export type GetArlQuery = {
  __typename?: 'Query';
  checkoutAgreements?: Array<{
    __typename?: 'CheckoutAgreement';
    agreement_id: number;
    checkbox_text: string;
    content: string;
    content_height?: string | null;
    is_html: boolean;
    mode: CheckoutAgreementMode;
    name: string;
  } | null> | null;
};

export type GetCartItemsQueryVariables = Exact<{
  cart_id: Scalars['String'];
}>;

export type GetCartItemsQuery = {
  __typename?: 'Query';
  cart?: {
    __typename?: 'Cart';
    id: string;
    prices?: {
      __typename?: 'CartPrices';
      grand_total?: {
        __typename?: 'Money';
        value?: number | null;
        currency?: CurrencyEnum | null;
      } | null;
      monthly_total: {
        __typename?: 'MonthlyTotal';
        device_monthly_total_without_tax: {
          __typename?: 'Money';
          value?: number | null;
        };
        device_monthly_total_with_tax: {
          __typename?: 'Money';
          value?: number | null;
        };
        subscription_monthly_total_without_tax: {
          __typename?: 'Money';
          value?: number | null;
        };
        subscription_monthly_total_with_tax: {
          __typename?: 'Money';
          value?: number | null;
        };
      };
    } | null;
    available_payment_methods?: Array<{
      __typename?: 'AvailablePaymentMethod';
      code: string;
      title: string;
    } | null> | null;
    shipping_addresses: Array<{
      __typename?: 'ShippingCartAddress';
      selected_shipping_method?: {
        __typename?: 'SelectedShippingMethod';
        amount: {
          __typename?: 'Money';
          value?: number | null;
          currency?: CurrencyEnum | null;
        };
      } | null;
    } | null>;
    items?: Array<
      | {
          __typename?: 'BundleCartItem';
          uid: string;
          quantity: number;
          lineItems?: Array<{
            __typename?: 'LineItem';
            title?: string | null;
            features?: Array<string | null> | null;
            label?: string | null;
            name?: string | null;
            sku?: string | null;
            price?: number | null;
            quantity?: number | null;
            thumbnail?: Array<{
              __typename?: 'LineItemThumbnail';
              src?: string | null;
            } | null> | null;
          } | null> | null;
          bundle_options: Array<{
            __typename: 'SelectedBundleOption';
            uid: string;
            label: string;
            values: Array<{
              __typename?: 'SelectedBundleOptionValue';
              uid: string;
              sku?: string | null;
              label: string;
              price: number;
            } | null>;
          } | null>;
          product:
            | {
                __typename?: 'BundleProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                price_range: {
                  __typename?: 'PriceRange';
                  maximum_price?: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  } | null;
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  };
                };
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    uid: string;
                    label?: string | null;
                    required_sku?: string | null;
                    hp_plan_option?: string | null;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'SimpleProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'VirtualProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              };
          prices?: {
            __typename?: 'CartItemPrices';
            price: { __typename?: 'Money'; value?: number | null };
            price_including_tax: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            };
            hp_upcoming_price_including_tax?: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ConfigurableCartItem';
          uid: string;
          quantity: number;
          product:
            | {
                __typename?: 'BundleProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                price_range: {
                  __typename?: 'PriceRange';
                  maximum_price?: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  } | null;
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  };
                };
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    uid: string;
                    label?: string | null;
                    required_sku?: string | null;
                    hp_plan_option?: string | null;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'SimpleProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'VirtualProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              };
          prices?: {
            __typename?: 'CartItemPrices';
            price: { __typename?: 'Money'; value?: number | null };
            price_including_tax: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            };
            hp_upcoming_price_including_tax?: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'SimpleCartItem';
          uid: string;
          quantity: number;
          product:
            | {
                __typename?: 'BundleProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                price_range: {
                  __typename?: 'PriceRange';
                  maximum_price?: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  } | null;
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  };
                };
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    uid: string;
                    label?: string | null;
                    required_sku?: string | null;
                    hp_plan_option?: string | null;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'SimpleProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'VirtualProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              };
          prices?: {
            __typename?: 'CartItemPrices';
            price: { __typename?: 'Money'; value?: number | null };
            price_including_tax: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            };
            hp_upcoming_price_including_tax?: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'VirtualCartItem';
          uid: string;
          quantity: number;
          product:
            | {
                __typename?: 'BundleProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                price_range: {
                  __typename?: 'PriceRange';
                  maximum_price?: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  } | null;
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  };
                };
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    uid: string;
                    label?: string | null;
                    required_sku?: string | null;
                    hp_plan_option?: string | null;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          uid: string;
                          hp_product_type_label?: string | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_contract_duration?: number | null;
                          hp_pages_per_month?: number | null;
                          sku?: string | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                              final_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            url?: string | null;
                          } | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'SimpleProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'VirtualProduct';
                uid: string;
                hp_bundle_lease_type?: string | null;
                hp_allowed_payment_type_label?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              };
          prices?: {
            __typename?: 'CartItemPrices';
            price: { __typename?: 'Money'; value?: number | null };
            price_including_tax: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            };
            hp_upcoming_price_including_tax?: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            } | null;
          } | null;
        }
      | null
    > | null;
  } | null;
};

export type GetCartQueryVariables = Exact<{
  cart_id: Scalars['String'];
}>;

export type GetCartQuery = {
  __typename?: 'Query';
  cart?: {
    __typename?: 'Cart';
    id: string;
    prices?: {
      __typename?: 'CartPrices';
      grand_total?: {
        __typename?: 'Money';
        value?: number | null;
        currency?: CurrencyEnum | null;
      } | null;
    } | null;
    available_payment_methods?: Array<{
      __typename?: 'AvailablePaymentMethod';
      code: string;
      title: string;
    } | null> | null;
    selected_payment_method?: {
      __typename?: 'SelectedPaymentMethod';
      code: string;
    } | null;
    shipping_addresses: Array<{
      __typename?: 'ShippingCartAddress';
      selected_shipping_method?: {
        __typename?: 'SelectedShippingMethod';
        amount: {
          __typename?: 'Money';
          value?: number | null;
          currency?: CurrencyEnum | null;
        };
      } | null;
    } | null>;
    items?: Array<
      | {
          __typename?: 'BundleCartItem';
          quantity: number;
          product:
            | {
                __typename?: 'BundleProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                items?: Array<{
                  __typename?: 'BundleItem';
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'SimpleProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'VirtualProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              };
          prices?: {
            __typename?: 'CartItemPrices';
            price: { __typename?: 'Money'; value?: number | null };
            price_including_tax: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            };
            hp_upcoming_price_including_tax?: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ConfigurableCartItem';
          quantity: number;
          product:
            | {
                __typename?: 'BundleProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                items?: Array<{
                  __typename?: 'BundleItem';
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'SimpleProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'VirtualProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              };
          prices?: {
            __typename?: 'CartItemPrices';
            price: { __typename?: 'Money'; value?: number | null };
            price_including_tax: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            };
            hp_upcoming_price_including_tax?: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'SimpleCartItem';
          quantity: number;
          product:
            | {
                __typename?: 'BundleProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                items?: Array<{
                  __typename?: 'BundleItem';
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'SimpleProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'VirtualProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              };
          prices?: {
            __typename?: 'CartItemPrices';
            price: { __typename?: 'Money'; value?: number | null };
            price_including_tax: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            };
            hp_upcoming_price_including_tax?: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'VirtualCartItem';
          quantity: number;
          product:
            | {
                __typename?: 'BundleProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                items?: Array<{
                  __typename?: 'BundleItem';
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          hp_product_type_label?: string | null;
                          sku?: string | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'SimpleProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              }
            | {
                __typename?: 'VirtualProduct';
                hp_allowed_payment_type_label?: string | null;
                hp_short_config_name?: string | null;
                name?: string | null;
                sku?: string | null;
                hp_product_type?: number | null;
                hp_product_type_label?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                } | null;
              };
          prices?: {
            __typename?: 'CartItemPrices';
            price: { __typename?: 'Money'; value?: number | null };
            price_including_tax: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            };
            hp_upcoming_price_including_tax?: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            } | null;
          } | null;
        }
      | null
    > | null;
  } | null;
};

export type GetCartByIdWithAddressQueryVariables = Exact<{
  cart_id: Scalars['String'];
}>;

export type GetCartByIdWithAddressQuery = {
  __typename?: 'Query';
  customerCart?: {
    __typename?: 'Cart';
    id: string;
    shipping_addresses: Array<{
      __typename?: 'ShippingCartAddress';
      city: string;
      hp_address_id?: string | null;
      country: {
        __typename?: 'CartAddressCountry';
        code: string;
        label: string;
      };
    } | null>;
    items?: Array<
      | {
          __typename?: 'BundleCartItem';
          uid: string;
          product:
            | {
                __typename?: 'BundleProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    uid: string;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'SimpleProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'VirtualProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
              };
        }
      | {
          __typename?: 'ConfigurableCartItem';
          uid: string;
          product:
            | {
                __typename?: 'BundleProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    uid: string;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'SimpleProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'VirtualProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
              };
        }
      | {
          __typename?: 'SimpleCartItem';
          uid: string;
          product:
            | {
                __typename?: 'BundleProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    uid: string;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'SimpleProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'VirtualProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
              };
        }
      | {
          __typename?: 'VirtualCartItem';
          uid: string;
          product:
            | {
                __typename?: 'BundleProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    uid: string;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'SimpleProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'VirtualProduct';
                hp_allowed_payment_type_label?: string | null;
                uid: string;
                stock_status?: ProductStockStatus | null;
              };
        }
      | null
    > | null;
  } | null;
};

export type GetCmsPageQueryVariables = Exact<{
  identifier: Scalars['String'];
}>;

export type GetCmsPageQuery = {
  __typename?: 'Query';
  cmsPage?: {
    __typename?: 'CmsPage';
    url_key?: string | null;
    content?: string | null;
    content_heading?: string | null;
    title?: string | null;
    page_layout?: string | null;
    meta_title?: string | null;
  } | null;
};

export type GetCustomerCartQueryVariables = Exact<{ [key: string]: never }>;

export type GetCustomerCartQuery = {
  __typename?: 'Query';
  customerCart: {
    __typename?: 'Cart';
    id: string;
    email?: string | null;
    items?: Array<
      | {
          __typename?: 'BundleCartItem';
          hp_cancellation_json?: string | null;
          uid: string;
          id: string;
          quantity: number;
          bundle_options: Array<{
            __typename?: 'SelectedBundleOption';
            uid: string;
            label: string;
            values: Array<{
              __typename?: 'SelectedBundleOptionValue';
              uid: string;
              sku?: string | null;
              label: string;
              price: number;
              quantity: number;
            } | null>;
          } | null>;
          product:
            | {
                __typename: 'BundleProduct';
                hp_cancellation_json?: string | null;
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                price_range: {
                  __typename?: 'PriceRange';
                  maximum_price?: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  } | null;
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  };
                };
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  hidden?: number | null;
                  json_option?: string | null;
                  options?: Array<{
                    __typename: 'BundleItemOption';
                    uid: string;
                    label?: string | null;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              }
            | {
                __typename: 'ConfigurableProduct';
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              }
            | {
                __typename: 'SimpleProduct';
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              }
            | {
                __typename: 'VirtualProduct';
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              };
          prices?: {
            __typename?: 'CartItemPrices';
            price: { __typename?: 'Money'; value?: number | null };
            price_including_tax: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            };
            hp_upcoming_price_including_tax?: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'ConfigurableCartItem';
          uid: string;
          id: string;
          quantity: number;
          product:
            | {
                __typename: 'BundleProduct';
                hp_cancellation_json?: string | null;
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                price_range: {
                  __typename?: 'PriceRange';
                  maximum_price?: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  } | null;
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  };
                };
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  hidden?: number | null;
                  json_option?: string | null;
                  options?: Array<{
                    __typename: 'BundleItemOption';
                    uid: string;
                    label?: string | null;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              }
            | {
                __typename: 'ConfigurableProduct';
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              }
            | {
                __typename: 'SimpleProduct';
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              }
            | {
                __typename: 'VirtualProduct';
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              };
          prices?: {
            __typename?: 'CartItemPrices';
            price: { __typename?: 'Money'; value?: number | null };
            price_including_tax: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            };
            hp_upcoming_price_including_tax?: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'SimpleCartItem';
          uid: string;
          id: string;
          quantity: number;
          product:
            | {
                __typename: 'BundleProduct';
                hp_cancellation_json?: string | null;
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                price_range: {
                  __typename?: 'PriceRange';
                  maximum_price?: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  } | null;
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  };
                };
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  hidden?: number | null;
                  json_option?: string | null;
                  options?: Array<{
                    __typename: 'BundleItemOption';
                    uid: string;
                    label?: string | null;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              }
            | {
                __typename: 'ConfigurableProduct';
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              }
            | {
                __typename: 'SimpleProduct';
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              }
            | {
                __typename: 'VirtualProduct';
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              };
          prices?: {
            __typename?: 'CartItemPrices';
            price: { __typename?: 'Money'; value?: number | null };
            price_including_tax: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            };
            hp_upcoming_price_including_tax?: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            } | null;
          } | null;
        }
      | {
          __typename?: 'VirtualCartItem';
          uid: string;
          id: string;
          quantity: number;
          product:
            | {
                __typename: 'BundleProduct';
                hp_cancellation_json?: string | null;
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                price_range: {
                  __typename?: 'PriceRange';
                  maximum_price?: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  } | null;
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                    };
                  };
                };
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  hidden?: number | null;
                  json_option?: string | null;
                  options?: Array<{
                    __typename: 'BundleItemOption';
                    uid: string;
                    label?: string | null;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          uid: string;
                          sku?: string | null;
                          name?: string | null;
                          hp_pages_per_month?: number | null;
                          hp_short_config_name?: string | null;
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                          hp_contract_duration?: number | null;
                          hp_support_coverage_included_with_hw_label?:
                            | string
                            | null;
                          price_range: {
                            __typename?: 'PriceRange';
                            minimum_price: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            };
                            maximum_price?: {
                              __typename?: 'ProductPrice';
                              regular_price: {
                                __typename?: 'Money';
                                value?: number | null;
                              };
                            } | null;
                          };
                          thumbnail?: {
                            __typename?: 'ProductImage';
                            label?: string | null;
                            url?: string | null;
                          } | null;
                          media_gallery?: Array<
                            | {
                                __typename?: 'ProductImage';
                                url?: string | null;
                                label?: string | null;
                              }
                            | {
                                __typename?: 'ProductVideo';
                                url?: string | null;
                                label?: string | null;
                              }
                            | null
                          > | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              }
            | {
                __typename: 'ConfigurableProduct';
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              }
            | {
                __typename: 'SimpleProduct';
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              }
            | {
                __typename: 'VirtualProduct';
                name?: string | null;
                uid: string;
                sku?: string | null;
                hp_product_type_label?: string | null;
                hp_bundle_lease_type?: string | null;
                hp_product_type?: number | null;
                thumbnail?: {
                  __typename?: 'ProductImage';
                  label?: string | null;
                  url?: string | null;
                } | null;
              };
          prices?: {
            __typename?: 'CartItemPrices';
            price: { __typename?: 'Money'; value?: number | null };
            price_including_tax: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            };
            hp_upcoming_price_including_tax?: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            } | null;
          } | null;
        }
      | null
    > | null;
    available_payment_methods?: Array<{
      __typename?: 'AvailablePaymentMethod';
      code: string;
      title: string;
    } | null> | null;
    billing_address?: {
      __typename?: 'BillingCartAddress';
      hp_address_id?: string | null;
      city: string;
      firstname: string;
      lastname: string;
      telephone?: string | null;
      postcode?: string | null;
      company?: string | null;
      street: Array<string | null>;
      country: {
        __typename?: 'CartAddressCountry';
        code: string;
        label: string;
      };
      region?: {
        __typename?: 'CartAddressRegion';
        code?: string | null;
        label?: string | null;
        region_id?: number | null;
      } | null;
    } | null;
    shipping_addresses: Array<{
      __typename?: 'ShippingCartAddress';
      hp_address_id?: string | null;
      city: string;
      firstname: string;
      lastname: string;
      postcode?: string | null;
      telephone?: string | null;
      company?: string | null;
      street: Array<string | null>;
      country: {
        __typename?: 'CartAddressCountry';
        code: string;
        label: string;
      };
      region?: {
        __typename?: 'CartAddressRegion';
        code?: string | null;
        label?: string | null;
        region_id?: number | null;
      } | null;
      selected_shipping_method?: {
        __typename?: 'SelectedShippingMethod';
        amount: { __typename?: 'Money'; value?: number | null };
      } | null;
    } | null>;
    prices?: {
      __typename?: 'CartPrices';
      monthly_total: {
        __typename?: 'MonthlyTotal';
        device_monthly_total_with_tax: {
          __typename?: 'Money';
          value?: number | null;
        };
        device_monthly_total_without_tax: {
          __typename?: 'Money';
          value?: number | null;
        };
        subscription_monthly_total_with_tax: {
          __typename?: 'Money';
          value?: number | null;
        };
        subscription_monthly_total_without_tax: {
          __typename?: 'Money';
          value?: number | null;
        };
      };
      grand_total?: {
        __typename?: 'Money';
        currency?: CurrencyEnum | null;
        value?: number | null;
      } | null;
      discounts?: Array<{
        __typename?: 'Discount';
        applied_to: CartDiscountType;
        label: string;
        amount: {
          __typename?: 'Money';
          currency?: CurrencyEnum | null;
          value?: number | null;
        };
      } | null> | null;
    } | null;
    applied_coupons?: Array<{
      __typename?: 'AppliedCoupon';
      code: string;
    } | null> | null;
  };
};

export type GetCustomerCartWithAddressQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCustomerCartWithAddressQuery = {
  __typename?: 'Query';
  customerCart: {
    __typename?: 'Cart';
    id: string;
    shipping_addresses: Array<{
      __typename?: 'ShippingCartAddress';
      city: string;
      hp_address_id?: string | null;
      country: {
        __typename?: 'CartAddressCountry';
        code: string;
        label: string;
      };
    } | null>;
    billing_address?: {
      __typename?: 'BillingCartAddress';
      city: string;
      firstname: string;
      lastname: string;
      postcode?: string | null;
      street: Array<string | null>;
      region?: {
        __typename?: 'CartAddressRegion';
        code?: string | null;
        label?: string | null;
        region_id?: number | null;
      } | null;
    } | null;
    items?: Array<
      | {
          __typename?: 'BundleCartItem';
          uid: string;
          product:
            | {
                __typename?: 'BundleProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    uid: string;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'SimpleProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'VirtualProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
              };
        }
      | {
          __typename?: 'ConfigurableCartItem';
          uid: string;
          product:
            | {
                __typename?: 'BundleProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    uid: string;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'SimpleProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'VirtualProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
              };
        }
      | {
          __typename?: 'SimpleCartItem';
          uid: string;
          product:
            | {
                __typename?: 'BundleProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    uid: string;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'SimpleProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'VirtualProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
              };
        }
      | {
          __typename?: 'VirtualCartItem';
          uid: string;
          product:
            | {
                __typename?: 'BundleProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
                items?: Array<{
                  __typename?: 'BundleItem';
                  uid?: string | null;
                  options?: Array<{
                    __typename?: 'BundleItemOption';
                    uid: string;
                    product?:
                      | {
                          __typename?: 'BundleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'ConfigurableProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'SimpleProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | {
                          __typename?: 'VirtualProduct';
                          hp_product_type?: number | null;
                          hp_product_type_label?: string | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
              }
            | {
                __typename?: 'ConfigurableProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'SimpleProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
              }
            | {
                __typename?: 'VirtualProduct';
                uid: string;
                stock_status?: ProductStockStatus | null;
              };
        }
      | null
    > | null;
  };
};

export type GetCustomerCartIdQueryVariables = Exact<{ [key: string]: never }>;

export type GetCustomerCartIdQuery = {
  __typename?: 'Query';
  customerCart: { __typename?: 'Cart'; id: string };
};

export type GetOrdersQueryVariables = Exact<{
  order_number: Scalars['String'];
}>;

export type GetOrdersQuery = {
  __typename?: 'Query';
  customer?: {
    __typename?: 'Customer';
    orders?: {
      __typename?: 'CustomerOrders';
      total_count?: number | null;
      items: Array<{
        __typename?: 'CustomerOrder';
        id: string;
        number: string;
        order_date: string;
        status: string;
        hp_partner_compensation?: {
          __typename?: 'PartnerCompensation';
          hp_partner_name?: string | null;
          hp_off_ramp_redirect_url?: string | null;
          hp_partner_logo_url?: string | null;
        } | null;
        total?: {
          __typename?: 'OrderTotal';
          base_grand_total: {
            __typename?: 'Money';
            value?: number | null;
            currency?: CurrencyEnum | null;
          };
          grand_total: {
            __typename?: 'Money';
            value?: number | null;
            currency?: CurrencyEnum | null;
          };
          total_tax: {
            __typename?: 'Money';
            value?: number | null;
            currency?: CurrencyEnum | null;
          };
          subtotal: {
            __typename?: 'Money';
            value?: number | null;
            currency?: CurrencyEnum | null;
          };
          device_total_with_tax: {
            __typename?: 'Money';
            value?: number | null;
            currency?: CurrencyEnum | null;
          };
          services_total_with_tax: {
            __typename?: 'Money';
            value?: number | null;
            currency?: CurrencyEnum | null;
          };
          taxes?: Array<{
            __typename?: 'TaxItem';
            title: string;
            rate: number;
            amount: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            };
          } | null> | null;
          total_shipping: { __typename?: 'Money'; value?: number | null };
          shipping_handling?: {
            __typename?: 'ShippingHandling';
            amount_including_tax?: {
              __typename?: 'Money';
              value?: number | null;
            } | null;
            amount_excluding_tax?: {
              __typename?: 'Money';
              value?: number | null;
            } | null;
            total_amount: {
              __typename?: 'Money';
              currency?: CurrencyEnum | null;
              value?: number | null;
            };
            taxes?: Array<{
              __typename?: 'TaxItem';
              title: string;
              rate: number;
              amount: {
                __typename?: 'Money';
                currency?: CurrencyEnum | null;
                value?: number | null;
              };
            } | null> | null;
          } | null;
          discounts?: Array<{
            __typename?: 'Discount';
            label: string;
            amount: {
              __typename?: 'Money';
              value?: number | null;
              currency?: CurrencyEnum | null;
            };
          } | null> | null;
        } | null;
        payment_methods?: Array<{
          __typename?: 'OrderPaymentMethod';
          name: string;
          type: string;
          additional_data?: Array<{
            __typename?: 'KeyValue';
            name?: string | null;
            value?: string | null;
          } | null> | null;
        } | null> | null;
        items?: Array<
          | {
              __typename?: 'BundleOrderItem';
              product_sku: string;
              product_name?: string | null;
              product_url_key?: string | null;
              bundle_options?: Array<{
                __typename?: 'ItemSelectedBundleOption';
                uid: string;
                label: string;
                id: string;
                values?: Array<{
                  __typename?: 'ItemSelectedBundleOptionValue';
                  product_name: string;
                  product_sku: string;
                  hp_product_type_label?: string | null;
                  quantity: number;
                  price: { __typename?: 'Money'; value?: number | null };
                } | null> | null;
              } | null> | null;
            }
          | {
              __typename?: 'OrderItem';
              product_name?: string | null;
              product_sku: string;
              product_url_key?: string | null;
            }
          | null
        > | null;
      } | null>;
    } | null;
  } | null;
};

export type GetPaperEligibleQueryVariables = Exact<{ [key: string]: never }>;

export type GetPaperEligibleQuery = {
  __typename?: 'Query';
  customerCart: {
    __typename?: 'Cart';
    id: string;
    hp_paper_eligible?: boolean | null;
  };
};

export type GetPartnerCompensationQueryVariables = Exact<{
  hpChannelCode: Scalars['String'];
}>;

export type GetPartnerCompensationQuery = {
  __typename?: 'Query';
  getPartnerCompensation?: {
    __typename: 'PartnerCompensation';
    hp_attribution_id?: string | null;
    hp_off_ramp_redirect_url?: string | null;
    hp_partner_name?: string | null;
    hp_partner_logo_url?: string | null;
  } | null;
};

export type GetTotalOrdersQueryVariables = Exact<{ [key: string]: never }>;

export type GetTotalOrdersQuery = {
  __typename?: 'Query';
  customer?: {
    __typename?: 'Customer';
    orders?: {
      __typename?: 'CustomerOrders';
      total_count?: number | null;
    } | null;
  } | null;
};

export type GetSkuProductsQueryVariables = Exact<{
  skuList: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;

export type GetSkuProductsQuery = {
  __typename?: 'Query';
  products?: {
    __typename: 'Products';
    items?: Array<
      | {
          __typename: 'BundleProduct';
          uid: string;
          lowest_price?: number | null;
          hp_cancellation_json?: string | null;
          hp_early_accessibility?: number | null;
          hp_allowed_payment_type_label?: string | null;
          hp_is_popular?: number | null;
          name?: string | null;
          sku?: string | null;
          stock_status?: ProductStockStatus | null;
          hp_model_purpose?: string | null;
          items?: Array<{
            __typename: 'BundleItem';
            json_option?: string | null;
            hidden?: number | null;
            title?: string | null;
            type?: string | null;
            uid?: string | null;
            required?: boolean | null;
            required_sku?: string | null;
            options?: Array<{
              __typename: 'BundleItemOption';
              lowest_price?: number | null;
              hp_plan_option?: string | null;
              is_default?: boolean | null;
              label?: string | null;
              position?: number | null;
              price?: number | null;
              hp_is_popular?: string | null;
              quantity?: number | null;
              uid: string;
              required_sku?: string | null;
              product?:
                | {
                    __typename?: 'BundleProduct';
                    hp_early_accessibility?: number | null;
                    hp_supply_type?: number | null;
                    hp_supply_type_label?: string | null;
                    hp_product_full_specification?: string | null;
                    hp_overage_block_price?: number | null;
                    hp_overage_block_size?: number | null;
                    hp_specifications_json?: string | null;
                    hp_short_config_name?: string | null;
                    hp_pages_per_month?: number | null;
                    hp_price_type?: number | null;
                    hp_product_type?: number | null;
                    hp_product_type_label?: string | null;
                    hp_contract_duration?: number | null;
                    hp_contract_duration_uom?: number | null;
                    hp_contract_duration_uom_label?: string | null;
                    hp_as_low_as_price?: number | null;
                    name?: string | null;
                    sku?: string | null;
                    stock_status?: ProductStockStatus | null;
                    uid: string;
                    description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    price_range: {
                      __typename?: 'PriceRange';
                      maximum_price?: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      } | null;
                      minimum_price: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      };
                    };
                    image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    media_gallery?: Array<
                      | {
                          __typename?: 'ProductImage';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | {
                          __typename?: 'ProductVideo';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | null
                    > | null;
                    short_description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    small_image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    thumbnail?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    thumbnail_accessories?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                  }
                | {
                    __typename?: 'ConfigurableProduct';
                    hp_early_accessibility?: number | null;
                    hp_supply_type?: number | null;
                    hp_supply_type_label?: string | null;
                    hp_product_full_specification?: string | null;
                    hp_overage_block_price?: number | null;
                    hp_overage_block_size?: number | null;
                    hp_specifications_json?: string | null;
                    hp_short_config_name?: string | null;
                    hp_pages_per_month?: number | null;
                    hp_price_type?: number | null;
                    hp_product_type?: number | null;
                    hp_product_type_label?: string | null;
                    hp_contract_duration?: number | null;
                    hp_contract_duration_uom?: number | null;
                    hp_contract_duration_uom_label?: string | null;
                    hp_as_low_as_price?: number | null;
                    name?: string | null;
                    sku?: string | null;
                    stock_status?: ProductStockStatus | null;
                    uid: string;
                    description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    price_range: {
                      __typename?: 'PriceRange';
                      maximum_price?: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      } | null;
                      minimum_price: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      };
                    };
                    image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    media_gallery?: Array<
                      | {
                          __typename?: 'ProductImage';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | {
                          __typename?: 'ProductVideo';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | null
                    > | null;
                    short_description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    small_image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    thumbnail?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    thumbnail_accessories?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                  }
                | {
                    __typename?: 'SimpleProduct';
                    hp_early_accessibility?: number | null;
                    hp_supply_type?: number | null;
                    hp_supply_type_label?: string | null;
                    hp_product_full_specification?: string | null;
                    hp_overage_block_price?: number | null;
                    hp_overage_block_size?: number | null;
                    hp_specifications_json?: string | null;
                    hp_short_config_name?: string | null;
                    hp_pages_per_month?: number | null;
                    hp_price_type?: number | null;
                    hp_product_type?: number | null;
                    hp_product_type_label?: string | null;
                    hp_contract_duration?: number | null;
                    hp_contract_duration_uom?: number | null;
                    hp_contract_duration_uom_label?: string | null;
                    hp_as_low_as_price?: number | null;
                    name?: string | null;
                    sku?: string | null;
                    stock_status?: ProductStockStatus | null;
                    uid: string;
                    description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    price_range: {
                      __typename?: 'PriceRange';
                      maximum_price?: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      } | null;
                      minimum_price: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      };
                    };
                    image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    media_gallery?: Array<
                      | {
                          __typename?: 'ProductImage';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | {
                          __typename?: 'ProductVideo';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | null
                    > | null;
                    short_description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    small_image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    thumbnail?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    thumbnail_accessories?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                  }
                | {
                    __typename?: 'VirtualProduct';
                    hp_early_accessibility?: number | null;
                    hp_supply_type?: number | null;
                    hp_supply_type_label?: string | null;
                    hp_product_full_specification?: string | null;
                    hp_overage_block_price?: number | null;
                    hp_overage_block_size?: number | null;
                    hp_specifications_json?: string | null;
                    hp_short_config_name?: string | null;
                    hp_pages_per_month?: number | null;
                    hp_price_type?: number | null;
                    hp_product_type?: number | null;
                    hp_product_type_label?: string | null;
                    hp_contract_duration?: number | null;
                    hp_contract_duration_uom?: number | null;
                    hp_contract_duration_uom_label?: string | null;
                    hp_as_low_as_price?: number | null;
                    name?: string | null;
                    sku?: string | null;
                    stock_status?: ProductStockStatus | null;
                    uid: string;
                    description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    price_range: {
                      __typename?: 'PriceRange';
                      maximum_price?: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      } | null;
                      minimum_price: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      };
                    };
                    image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    media_gallery?: Array<
                      | {
                          __typename?: 'ProductImage';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | {
                          __typename?: 'ProductVideo';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | null
                    > | null;
                    short_description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    small_image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    thumbnail?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    thumbnail_accessories?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                  }
                | null;
            } | null> | null;
          } | null> | null;
          description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          short_description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          image?: { __typename?: 'ProductImage'; url?: string | null } | null;
          price_range: {
            __typename?: 'PriceRange';
            minimum_price: {
              __typename?: 'ProductPrice';
              regular_price: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
            };
          };
          small_image?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          base_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          small_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
        }
      | {
          __typename: 'ConfigurableProduct';
          hp_allowed_payment_type_label?: string | null;
          hp_is_popular?: number | null;
          name?: string | null;
          sku?: string | null;
          stock_status?: ProductStockStatus | null;
          hp_model_purpose?: string | null;
          description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          short_description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          image?: { __typename?: 'ProductImage'; url?: string | null } | null;
          price_range: {
            __typename?: 'PriceRange';
            minimum_price: {
              __typename?: 'ProductPrice';
              regular_price: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
            };
          };
          small_image?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          base_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          small_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
        }
      | {
          __typename: 'SimpleProduct';
          hp_allowed_payment_type_label?: string | null;
          hp_is_popular?: number | null;
          name?: string | null;
          sku?: string | null;
          stock_status?: ProductStockStatus | null;
          hp_model_purpose?: string | null;
          description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          short_description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          image?: { __typename?: 'ProductImage'; url?: string | null } | null;
          price_range: {
            __typename?: 'PriceRange';
            minimum_price: {
              __typename?: 'ProductPrice';
              regular_price: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
            };
          };
          small_image?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          base_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          small_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
        }
      | {
          __typename: 'VirtualProduct';
          hp_allowed_payment_type_label?: string | null;
          hp_is_popular?: number | null;
          name?: string | null;
          sku?: string | null;
          stock_status?: ProductStockStatus | null;
          hp_model_purpose?: string | null;
          description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          short_description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          image?: { __typename?: 'ProductImage'; url?: string | null } | null;
          price_range: {
            __typename?: 'PriceRange';
            minimum_price: {
              __typename?: 'ProductPrice';
              regular_price: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
            };
          };
          small_image?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          base_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          small_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
        }
      | null
    > | null;
  } | null;
};

export type GetSkuProductsWithRelationsQueryVariables = Exact<{
  skuList: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;

export type GetSkuProductsWithRelationsQuery = {
  __typename?: 'Query';
  products?: {
    __typename: 'Products';
    items?: Array<
      | {
          __typename: 'BundleProduct';
          uid: string;
          lowest_price?: number | null;
          hp_cancellation_json?: string | null;
          hp_early_accessibility?: number | null;
          hp_allowed_payment_type_label?: string | null;
          hp_is_popular?: number | null;
          name?: string | null;
          sku?: string | null;
          stock_status?: ProductStockStatus | null;
          hp_model_purpose?: string | null;
          items?: Array<{
            __typename: 'BundleItem';
            json_option?: string | null;
            hidden?: number | null;
            title?: string | null;
            type?: string | null;
            uid?: string | null;
            required?: boolean | null;
            required_sku?: string | null;
            options?: Array<{
              __typename: 'BundleItemOption';
              lowest_price?: number | null;
              hp_plan_option?: string | null;
              is_default?: boolean | null;
              label?: string | null;
              position?: number | null;
              price?: number | null;
              hp_is_popular?: string | null;
              quantity?: number | null;
              uid: string;
              required_sku?: string | null;
              product?:
                | {
                    __typename?: 'BundleProduct';
                    hp_early_accessibility?: number | null;
                    hp_supply_type?: number | null;
                    hp_supply_type_label?: string | null;
                    hp_product_full_specification?: string | null;
                    hp_overage_block_price?: number | null;
                    hp_overage_block_size?: number | null;
                    hp_specifications_json?: string | null;
                    hp_short_config_name?: string | null;
                    hp_pages_per_month?: number | null;
                    hp_price_type?: number | null;
                    hp_product_type?: number | null;
                    hp_product_type_label?: string | null;
                    hp_contract_duration?: number | null;
                    hp_contract_duration_uom?: number | null;
                    hp_contract_duration_uom_label?: string | null;
                    hp_as_low_as_price?: number | null;
                    name?: string | null;
                    sku?: string | null;
                    stock_status?: ProductStockStatus | null;
                    uid: string;
                    description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    price_range: {
                      __typename?: 'PriceRange';
                      maximum_price?: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      } | null;
                      minimum_price: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      };
                    };
                    image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    media_gallery?: Array<
                      | {
                          __typename?: 'ProductImage';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | {
                          __typename?: 'ProductVideo';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | null
                    > | null;
                    short_description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    small_image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    thumbnail?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                  }
                | {
                    __typename?: 'ConfigurableProduct';
                    hp_early_accessibility?: number | null;
                    hp_supply_type?: number | null;
                    hp_supply_type_label?: string | null;
                    hp_product_full_specification?: string | null;
                    hp_overage_block_price?: number | null;
                    hp_overage_block_size?: number | null;
                    hp_specifications_json?: string | null;
                    hp_short_config_name?: string | null;
                    hp_pages_per_month?: number | null;
                    hp_price_type?: number | null;
                    hp_product_type?: number | null;
                    hp_product_type_label?: string | null;
                    hp_contract_duration?: number | null;
                    hp_contract_duration_uom?: number | null;
                    hp_contract_duration_uom_label?: string | null;
                    hp_as_low_as_price?: number | null;
                    name?: string | null;
                    sku?: string | null;
                    stock_status?: ProductStockStatus | null;
                    uid: string;
                    description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    price_range: {
                      __typename?: 'PriceRange';
                      maximum_price?: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      } | null;
                      minimum_price: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      };
                    };
                    image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    media_gallery?: Array<
                      | {
                          __typename?: 'ProductImage';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | {
                          __typename?: 'ProductVideo';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | null
                    > | null;
                    short_description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    small_image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    thumbnail?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                  }
                | {
                    __typename?: 'SimpleProduct';
                    hp_early_accessibility?: number | null;
                    hp_supply_type?: number | null;
                    hp_supply_type_label?: string | null;
                    hp_product_full_specification?: string | null;
                    hp_overage_block_price?: number | null;
                    hp_overage_block_size?: number | null;
                    hp_specifications_json?: string | null;
                    hp_short_config_name?: string | null;
                    hp_pages_per_month?: number | null;
                    hp_price_type?: number | null;
                    hp_product_type?: number | null;
                    hp_product_type_label?: string | null;
                    hp_contract_duration?: number | null;
                    hp_contract_duration_uom?: number | null;
                    hp_contract_duration_uom_label?: string | null;
                    hp_as_low_as_price?: number | null;
                    name?: string | null;
                    sku?: string | null;
                    stock_status?: ProductStockStatus | null;
                    uid: string;
                    description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    price_range: {
                      __typename?: 'PriceRange';
                      maximum_price?: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      } | null;
                      minimum_price: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      };
                    };
                    image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    media_gallery?: Array<
                      | {
                          __typename?: 'ProductImage';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | {
                          __typename?: 'ProductVideo';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | null
                    > | null;
                    short_description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    small_image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    thumbnail?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                  }
                | {
                    __typename?: 'VirtualProduct';
                    hp_early_accessibility?: number | null;
                    hp_supply_type?: number | null;
                    hp_supply_type_label?: string | null;
                    hp_product_full_specification?: string | null;
                    hp_overage_block_price?: number | null;
                    hp_overage_block_size?: number | null;
                    hp_specifications_json?: string | null;
                    hp_short_config_name?: string | null;
                    hp_pages_per_month?: number | null;
                    hp_price_type?: number | null;
                    hp_product_type?: number | null;
                    hp_product_type_label?: string | null;
                    hp_contract_duration?: number | null;
                    hp_contract_duration_uom?: number | null;
                    hp_contract_duration_uom_label?: string | null;
                    hp_as_low_as_price?: number | null;
                    name?: string | null;
                    sku?: string | null;
                    stock_status?: ProductStockStatus | null;
                    uid: string;
                    description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    price_range: {
                      __typename?: 'PriceRange';
                      maximum_price?: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      } | null;
                      minimum_price: {
                        __typename?: 'ProductPrice';
                        regular_price: {
                          __typename?: 'Money';
                          currency?: CurrencyEnum | null;
                          value?: number | null;
                        };
                      };
                    };
                    image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    media_gallery?: Array<
                      | {
                          __typename?: 'ProductImage';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | {
                          __typename?: 'ProductVideo';
                          disabled?: boolean | null;
                          label?: string | null;
                          position?: number | null;
                          url?: string | null;
                        }
                      | null
                    > | null;
                    short_description?: {
                      __typename?: 'ComplexTextValue';
                      html: string;
                    } | null;
                    small_image?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                    thumbnail?: {
                      __typename?: 'ProductImage';
                      disabled?: boolean | null;
                      label?: string | null;
                      position?: number | null;
                      url?: string | null;
                    } | null;
                  }
                | null;
            } | null> | null;
          } | null> | null;
          description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          short_description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          image?: { __typename?: 'ProductImage'; url?: string | null } | null;
          price_range: {
            __typename?: 'PriceRange';
            minimum_price: {
              __typename?: 'ProductPrice';
              regular_price: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
            };
          };
          small_image?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          base_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          small_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          crosssell_products?: Array<
            | {
                __typename: 'BundleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'ConfigurableProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'SimpleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'VirtualProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | null
          > | null;
          related_products?: Array<
            | {
                __typename: 'BundleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'ConfigurableProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'SimpleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'VirtualProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | null
          > | null;
          upsell_products?: Array<
            | {
                __typename: 'BundleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'ConfigurableProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'SimpleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'VirtualProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | null
          > | null;
        }
      | {
          __typename: 'ConfigurableProduct';
          hp_allowed_payment_type_label?: string | null;
          hp_is_popular?: number | null;
          name?: string | null;
          sku?: string | null;
          stock_status?: ProductStockStatus | null;
          hp_model_purpose?: string | null;
          description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          short_description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          image?: { __typename?: 'ProductImage'; url?: string | null } | null;
          price_range: {
            __typename?: 'PriceRange';
            minimum_price: {
              __typename?: 'ProductPrice';
              regular_price: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
            };
          };
          small_image?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          base_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          small_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          crosssell_products?: Array<
            | {
                __typename: 'BundleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'ConfigurableProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'SimpleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'VirtualProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | null
          > | null;
          related_products?: Array<
            | {
                __typename: 'BundleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'ConfigurableProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'SimpleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'VirtualProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | null
          > | null;
          upsell_products?: Array<
            | {
                __typename: 'BundleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'ConfigurableProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'SimpleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'VirtualProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | null
          > | null;
        }
      | {
          __typename: 'SimpleProduct';
          hp_allowed_payment_type_label?: string | null;
          hp_is_popular?: number | null;
          name?: string | null;
          sku?: string | null;
          stock_status?: ProductStockStatus | null;
          hp_model_purpose?: string | null;
          description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          short_description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          image?: { __typename?: 'ProductImage'; url?: string | null } | null;
          price_range: {
            __typename?: 'PriceRange';
            minimum_price: {
              __typename?: 'ProductPrice';
              regular_price: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
            };
          };
          small_image?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          base_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          small_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          crosssell_products?: Array<
            | {
                __typename: 'BundleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'ConfigurableProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'SimpleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'VirtualProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | null
          > | null;
          related_products?: Array<
            | {
                __typename: 'BundleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'ConfigurableProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'SimpleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'VirtualProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | null
          > | null;
          upsell_products?: Array<
            | {
                __typename: 'BundleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'ConfigurableProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'SimpleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'VirtualProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | null
          > | null;
        }
      | {
          __typename: 'VirtualProduct';
          hp_allowed_payment_type_label?: string | null;
          hp_is_popular?: number | null;
          name?: string | null;
          sku?: string | null;
          stock_status?: ProductStockStatus | null;
          hp_model_purpose?: string | null;
          description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          short_description?: {
            __typename?: 'ComplexTextValue';
            html: string;
          } | null;
          image?: { __typename?: 'ProductImage'; url?: string | null } | null;
          price_range: {
            __typename?: 'PriceRange';
            minimum_price: {
              __typename?: 'ProductPrice';
              regular_price: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
            };
          };
          small_image?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          base_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          small_accessories?: {
            __typename?: 'ProductImage';
            label?: string | null;
            url?: string | null;
          } | null;
          crosssell_products?: Array<
            | {
                __typename: 'BundleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'ConfigurableProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'SimpleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'VirtualProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | null
          > | null;
          related_products?: Array<
            | {
                __typename: 'BundleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'ConfigurableProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'SimpleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'VirtualProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | null
          > | null;
          upsell_products?: Array<
            | {
                __typename: 'BundleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'ConfigurableProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'SimpleProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | {
                __typename: 'VirtualProduct';
                sku?: string | null;
                name?: string | null;
                stock_status?: ProductStockStatus | null;
                canonical_url?: string | null;
                image?: {
                  __typename?: 'ProductImage';
                  url?: string | null;
                  label?: string | null;
                } | null;
                price_range: {
                  __typename?: 'PriceRange';
                  minimum_price: {
                    __typename?: 'ProductPrice';
                    regular_price: {
                      __typename?: 'Money';
                      value?: number | null;
                      currency?: CurrencyEnum | null;
                    };
                  };
                };
              }
            | null
          > | null;
        }
      | null
    > | null;
  } | null;
};

export type GetPdpStateQueryVariables = Exact<{
  skuList: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;

export type GetPdpStateQuery = {
  __typename?: 'Query';
  pdpConfig: {
    __typename?: 'PdpConfigState';
    selected_options: Array<string>;
    prices: {
      __typename?: 'Prices';
      totalPrice: number;
      totalPricePerMonth: number;
      totalSubscriptionPricePerMonth: number;
      totalDevicePricePerMonth: number;
      totalDevice: number;
    };
  };
};

export type PlaceOrderMutationVariables = Exact<{
  cart_id: Scalars['String'];
  visitUUID?: InputMaybe<Scalars['String']>;
  tm_profiling_id?: InputMaybe<Scalars['String']>;
  user_consents?: InputMaybe<Scalars['String']>;
}>;

export type PlaceOrderMutation = {
  __typename?: 'Mutation';
  placeOrder?: {
    __typename?: 'PlaceOrderOutput';
    order: {
      __typename?: 'Order';
      order_number: string;
      instantinkUpgrades?: Array<{
        __typename?: 'InstantinkUpgrade';
        created_at?: string | null;
        friendly_name?: string | null;
        id?: number | null;
        printer_image_url?: string | null;
        printer_model_name?: string | null;
        printer_serial_number?: string | null;
        subscription_id?: string | null;
        cancel?: boolean | null;
      } | null> | null;
    };
  } | null;
};

export type RemoveCouponFromCartMutationVariables = Exact<{
  cart_id: Scalars['String'];
}>;

export type RemoveCouponFromCartMutation = {
  __typename?: 'Mutation';
  removeCouponFromCart?: {
    __typename?: 'RemoveCouponFromCartOutput';
    cart?: {
      __typename?: 'Cart';
      items?: Array<
        | {
            __typename?: 'BundleCartItem';
            quantity: number;
            product:
              | {
                  __typename?: 'BundleProduct';
                  sku?: string | null;
                  name?: string | null;
                }
              | {
                  __typename?: 'ConfigurableProduct';
                  sku?: string | null;
                  name?: string | null;
                }
              | {
                  __typename?: 'SimpleProduct';
                  sku?: string | null;
                  name?: string | null;
                }
              | {
                  __typename?: 'VirtualProduct';
                  sku?: string | null;
                  name?: string | null;
                };
          }
        | {
            __typename?: 'ConfigurableCartItem';
            quantity: number;
            product:
              | {
                  __typename?: 'BundleProduct';
                  sku?: string | null;
                  name?: string | null;
                }
              | {
                  __typename?: 'ConfigurableProduct';
                  sku?: string | null;
                  name?: string | null;
                }
              | {
                  __typename?: 'SimpleProduct';
                  sku?: string | null;
                  name?: string | null;
                }
              | {
                  __typename?: 'VirtualProduct';
                  sku?: string | null;
                  name?: string | null;
                };
          }
        | {
            __typename?: 'SimpleCartItem';
            quantity: number;
            product:
              | {
                  __typename?: 'BundleProduct';
                  sku?: string | null;
                  name?: string | null;
                }
              | {
                  __typename?: 'ConfigurableProduct';
                  sku?: string | null;
                  name?: string | null;
                }
              | {
                  __typename?: 'SimpleProduct';
                  sku?: string | null;
                  name?: string | null;
                }
              | {
                  __typename?: 'VirtualProduct';
                  sku?: string | null;
                  name?: string | null;
                };
          }
        | {
            __typename?: 'VirtualCartItem';
            quantity: number;
            product:
              | {
                  __typename?: 'BundleProduct';
                  sku?: string | null;
                  name?: string | null;
                }
              | {
                  __typename?: 'ConfigurableProduct';
                  sku?: string | null;
                  name?: string | null;
                }
              | {
                  __typename?: 'SimpleProduct';
                  sku?: string | null;
                  name?: string | null;
                }
              | {
                  __typename?: 'VirtualProduct';
                  sku?: string | null;
                  name?: string | null;
                };
          }
        | null
      > | null;
      applied_coupons?: Array<{
        __typename?: 'AppliedCoupon';
        code: string;
      } | null> | null;
      prices?: {
        __typename?: 'CartPrices';
        monthly_total: {
          __typename?: 'MonthlyTotal';
          device_monthly_total_with_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
          device_monthly_total_without_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
          subscription_monthly_total_with_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
          subscription_monthly_total_without_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
        };
        grand_total?: {
          __typename?: 'Money';
          currency?: CurrencyEnum | null;
          value?: number | null;
        } | null;
        discounts?: Array<{
          __typename?: 'Discount';
          applied_to: CartDiscountType;
          label: string;
          amount: {
            __typename?: 'Money';
            currency?: CurrencyEnum | null;
            value?: number | null;
          };
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type RemovePaperFromCartMutationVariables = Exact<{
  cart_id: Scalars['String'];
}>;

export type RemovePaperFromCartMutation = {
  __typename?: 'Mutation';
  removePaperFromCart?: {
    __typename?: 'RemovePaperFromCartOutput';
    message?: string | null;
    success: boolean;
  } | null;
};

export type SetPaymentMethodMutationVariables = Exact<{
  cart_id: Scalars['String'];
  payment_method: Scalars['String'];
}>;

export type SetPaymentMethodMutation = {
  __typename?: 'Mutation';
  setPaymentMethodOnCart?: {
    __typename?: 'SetPaymentMethodOnCartOutput';
    cart: {
      __typename?: 'Cart';
      id: string;
      selected_payment_method?: {
        __typename?: 'SelectedPaymentMethod';
        code: string;
        title: string;
        pgs_details?: {
          __typename?: 'PgsDetails';
          iframe_url?: string | null;
          merchant_name?: string | null;
          quote_id?: number | null;
          request_time?: string | null;
        } | null;
      } | null;
    };
  } | null;
};

export type SetShippingAddressAndMethodOnCartMutationVariables = Exact<{
  cart_id: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  street: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  region?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  country_code: Scalars['String'];
  hp_address_id: Scalars['String'];
  telephone?: InputMaybe<Scalars['String']>;
  save_in_address_book?: InputMaybe<Scalars['Boolean']>;
}>;

export type SetShippingAddressAndMethodOnCartMutation = {
  __typename?: 'Mutation';
  setShippingAddressesOnCart?: {
    __typename?: 'SetShippingAddressesOnCartOutput';
    cart: { __typename?: 'Cart'; id: string };
  } | null;
  setShippingMethodsOnCart?: {
    __typename?: 'SetShippingMethodsOnCartOutput';
    cart: {
      __typename?: 'Cart';
      id: string;
      items?: Array<
        | {
            __typename?: 'BundleCartItem';
            uid: string;
            prices?: {
              __typename?: 'CartItemPrices';
              price: { __typename?: 'Money'; value?: number | null };
              price_including_tax: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
              hp_upcoming_price_including_tax?: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              } | null;
            } | null;
          }
        | {
            __typename?: 'ConfigurableCartItem';
            uid: string;
            prices?: {
              __typename?: 'CartItemPrices';
              price: { __typename?: 'Money'; value?: number | null };
              price_including_tax: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
              hp_upcoming_price_including_tax?: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              } | null;
            } | null;
          }
        | {
            __typename?: 'SimpleCartItem';
            uid: string;
            prices?: {
              __typename?: 'CartItemPrices';
              price: { __typename?: 'Money'; value?: number | null };
              price_including_tax: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
              hp_upcoming_price_including_tax?: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              } | null;
            } | null;
          }
        | {
            __typename?: 'VirtualCartItem';
            uid: string;
            prices?: {
              __typename?: 'CartItemPrices';
              price: { __typename?: 'Money'; value?: number | null };
              price_including_tax: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
              hp_upcoming_price_including_tax?: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              } | null;
            } | null;
          }
        | null
      > | null;
      prices?: {
        __typename?: 'CartPrices';
        monthly_total: {
          __typename?: 'MonthlyTotal';
          device_monthly_total_with_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
          device_monthly_total_without_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
          subscription_monthly_total_with_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
          subscription_monthly_total_without_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
        };
        grand_total?: {
          __typename?: 'Money';
          currency?: CurrencyEnum | null;
          value?: number | null;
        } | null;
        discounts?: Array<{
          __typename?: 'Discount';
          applied_to: CartDiscountType;
          label: string;
          amount: {
            __typename?: 'Money';
            currency?: CurrencyEnum | null;
            value?: number | null;
          };
        } | null> | null;
      } | null;
      shipping_addresses: Array<{
        __typename?: 'ShippingCartAddress';
        hp_address_id?: string | null;
        city: string;
        firstname: string;
        lastname: string;
        postcode?: string | null;
        telephone?: string | null;
        company?: string | null;
        street: Array<string | null>;
        country: {
          __typename?: 'CartAddressCountry';
          code: string;
          label: string;
        };
        region?: {
          __typename?: 'CartAddressRegion';
          code?: string | null;
          label?: string | null;
          region_id?: number | null;
        } | null;
        selected_shipping_method?: {
          __typename?: 'SelectedShippingMethod';
          amount: { __typename?: 'Money'; value?: number | null };
        } | null;
      } | null>;
    };
  } | null;
};

export type SetSubscriptionUpgradesMutationVariables = Exact<{
  subscriptionId?: InputMaybe<Scalars['String']>;
  orderIncrementId: Scalars['String'];
}>;

export type SetSubscriptionUpgradesMutation = {
  __typename?: 'Mutation';
  setSubscriptionUpgrades?: {
    __typename?: 'SetSubscriptionUpgradesOutput';
    message?: string | null;
    success: boolean;
  } | null;
};

export type SetBillingAddressOnCartMutationVariables = Exact<{
  cart_id: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  street: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  region?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  country_code: Scalars['String'];
  hp_address_id: Scalars['String'];
  telephone?: InputMaybe<Scalars['String']>;
  save_in_address_book?: InputMaybe<Scalars['Boolean']>;
  same_as_shipping?: InputMaybe<Scalars['Boolean']>;
  use_for_shipping?: InputMaybe<Scalars['Boolean']>;
}>;

export type SetBillingAddressOnCartMutation = {
  __typename?: 'Mutation';
  setBillingAddressOnCart?: {
    __typename?: 'SetBillingAddressOnCartOutput';
    cart: {
      __typename?: 'Cart';
      id: string;
      available_payment_methods?: Array<{
        __typename?: 'AvailablePaymentMethod';
        code: string;
        title: string;
      } | null> | null;
      items?: Array<
        | {
            __typename?: 'BundleCartItem';
            uid: string;
            prices?: {
              __typename?: 'CartItemPrices';
              price: { __typename?: 'Money'; value?: number | null };
              price_including_tax: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
              hp_upcoming_price_including_tax?: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              } | null;
            } | null;
          }
        | {
            __typename?: 'ConfigurableCartItem';
            uid: string;
            prices?: {
              __typename?: 'CartItemPrices';
              price: { __typename?: 'Money'; value?: number | null };
              price_including_tax: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
              hp_upcoming_price_including_tax?: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              } | null;
            } | null;
          }
        | {
            __typename?: 'SimpleCartItem';
            uid: string;
            prices?: {
              __typename?: 'CartItemPrices';
              price: { __typename?: 'Money'; value?: number | null };
              price_including_tax: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
              hp_upcoming_price_including_tax?: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              } | null;
            } | null;
          }
        | {
            __typename?: 'VirtualCartItem';
            uid: string;
            prices?: {
              __typename?: 'CartItemPrices';
              price: { __typename?: 'Money'; value?: number | null };
              price_including_tax: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              };
              hp_upcoming_price_including_tax?: {
                __typename?: 'Money';
                value?: number | null;
                currency?: CurrencyEnum | null;
              } | null;
            } | null;
          }
        | null
      > | null;
      prices?: {
        __typename?: 'CartPrices';
        monthly_total: {
          __typename?: 'MonthlyTotal';
          device_monthly_total_with_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
          device_monthly_total_without_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
          subscription_monthly_total_with_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
          subscription_monthly_total_without_tax: {
            __typename?: 'Money';
            value?: number | null;
          };
        };
        grand_total?: {
          __typename?: 'Money';
          currency?: CurrencyEnum | null;
          value?: number | null;
        } | null;
        discounts?: Array<{
          __typename?: 'Discount';
          applied_to: CartDiscountType;
          label: string;
          amount: {
            __typename?: 'Money';
            currency?: CurrencyEnum | null;
            value?: number | null;
          };
        } | null> | null;
      } | null;
      billing_address?: {
        __typename?: 'BillingCartAddress';
        hp_address_id?: string | null;
        city: string;
        firstname: string;
        lastname: string;
        telephone?: string | null;
        postcode?: string | null;
        company?: string | null;
        street: Array<string | null>;
        country: {
          __typename?: 'CartAddressCountry';
          code: string;
          label: string;
        };
        region?: {
          __typename?: 'CartAddressRegion';
          code?: string | null;
          label?: string | null;
          region_id?: number | null;
        } | null;
      } | null;
    };
  } | null;
};

export type UpdatePaymentMethodCvvOnCartFromCodeMutationVariables = Exact<{
  pickup_code: Scalars['String'];
}>;

export type UpdatePaymentMethodCvvOnCartFromCodeMutation = {
  __typename?: 'Mutation';
  updatePaymentMethodCvvOnCartFromCode?: {
    __typename?: 'UpdatePaymentMethodCvvOutput';
    payment_method_id?: string | null;
  } | null;
};

export type AddBundleProductsToCartOutputKeySpecifier = (
  | 'cart'
  | AddBundleProductsToCartOutputKeySpecifier
)[];
export type AddBundleProductsToCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddConfigurableProductsToCartOutputKeySpecifier = (
  | 'cart'
  | AddConfigurableProductsToCartOutputKeySpecifier
)[];
export type AddConfigurableProductsToCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddPaperToCartOutputKeySpecifier = (
  | 'message'
  | 'success'
  | AddPaperToCartOutputKeySpecifier
)[];
export type AddPaperToCartOutputFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddProductsToCartOutputKeySpecifier = (
  | 'cart'
  | 'user_errors'
  | AddProductsToCartOutputKeySpecifier
)[];
export type AddProductsToCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
  user_errors?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddProductsToWishlistOutputKeySpecifier = (
  | 'user_errors'
  | 'wishlist'
  | AddProductsToWishlistOutputKeySpecifier
)[];
export type AddProductsToWishlistOutputFieldPolicy = {
  user_errors?: FieldPolicy<any> | FieldReadFunction<any>;
  wishlist?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddSimpleProductsToCartOutputKeySpecifier = (
  | 'cart'
  | AddSimpleProductsToCartOutputKeySpecifier
)[];
export type AddSimpleProductsToCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddVirtualProductsToCartOutputKeySpecifier = (
  | 'cart'
  | AddVirtualProductsToCartOutputKeySpecifier
)[];
export type AddVirtualProductsToCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AddWishlistItemsToCartOutputKeySpecifier = (
  | 'add_wishlist_items_to_cart_user_errors'
  | 'status'
  | 'wishlist'
  | AddWishlistItemsToCartOutputKeySpecifier
)[];
export type AddWishlistItemsToCartOutputFieldPolicy = {
  add_wishlist_items_to_cart_user_errors?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  wishlist?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AggregationKeySpecifier = (
  | 'attribute_code'
  | 'count'
  | 'label'
  | 'options'
  | 'position'
  | AggregationKeySpecifier
)[];
export type AggregationFieldPolicy = {
  attribute_code?: FieldPolicy<any> | FieldReadFunction<any>;
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  options?: FieldPolicy<any> | FieldReadFunction<any>;
  position?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AggregationOptionKeySpecifier = (
  | 'count'
  | 'label'
  | 'value'
  | AggregationOptionKeySpecifier
)[];
export type AggregationOptionFieldPolicy = {
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AggregationOptionInterfaceKeySpecifier = (
  | 'count'
  | 'label'
  | 'value'
  | AggregationOptionInterfaceKeySpecifier
)[];
export type AggregationOptionInterfaceFieldPolicy = {
  count?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AmountKeySpecifier = ('value' | AmountKeySpecifier)[];
export type AmountFieldPolicy = {
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppliedCouponKeySpecifier = ('code' | AppliedCouponKeySpecifier)[];
export type AppliedCouponFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ApplyCouponToCartOutputKeySpecifier = (
  | 'cart'
  | ApplyCouponToCartOutputKeySpecifier
)[];
export type ApplyCouponToCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AttributeKeySpecifier = (
  | 'attribute_code'
  | 'attribute_options'
  | 'attribute_type'
  | 'entity_type'
  | 'input_type'
  | 'storefront_properties'
  | AttributeKeySpecifier
)[];
export type AttributeFieldPolicy = {
  attribute_code?: FieldPolicy<any> | FieldReadFunction<any>;
  attribute_options?: FieldPolicy<any> | FieldReadFunction<any>;
  attribute_type?: FieldPolicy<any> | FieldReadFunction<any>;
  entity_type?: FieldPolicy<any> | FieldReadFunction<any>;
  input_type?: FieldPolicy<any> | FieldReadFunction<any>;
  storefront_properties?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AttributeMetadataKeySpecifier = (
  | 'code'
  | 'default_value'
  | 'entity_type'
  | 'frontend_class'
  | 'frontend_input'
  | 'is_required'
  | 'is_unique'
  | 'label'
  | 'options'
  | AttributeMetadataKeySpecifier
)[];
export type AttributeMetadataFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  default_value?: FieldPolicy<any> | FieldReadFunction<any>;
  entity_type?: FieldPolicy<any> | FieldReadFunction<any>;
  frontend_class?: FieldPolicy<any> | FieldReadFunction<any>;
  frontend_input?: FieldPolicy<any> | FieldReadFunction<any>;
  is_required?: FieldPolicy<any> | FieldReadFunction<any>;
  is_unique?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  options?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AttributeMetadataErrorKeySpecifier = (
  | 'message'
  | 'type'
  | AttributeMetadataErrorKeySpecifier
)[];
export type AttributeMetadataErrorFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AttributeOptionKeySpecifier = (
  | 'label'
  | 'value'
  | AttributeOptionKeySpecifier
)[];
export type AttributeOptionFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AttributeOptionMetadataKeySpecifier = (
  | 'is_default'
  | 'label'
  | 'value'
  | AttributeOptionMetadataKeySpecifier
)[];
export type AttributeOptionMetadataFieldPolicy = {
  is_default?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AttributeSelectedOptionKeySpecifier = (
  | 'label'
  | 'value'
  | AttributeSelectedOptionKeySpecifier
)[];
export type AttributeSelectedOptionFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AttributeSelectedOptionInterfaceKeySpecifier = (
  | 'label'
  | 'value'
  | AttributeSelectedOptionInterfaceKeySpecifier
)[];
export type AttributeSelectedOptionInterfaceFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AttributeSelectedOptionsKeySpecifier = (
  | 'code'
  | 'selected_options'
  | AttributeSelectedOptionsKeySpecifier
)[];
export type AttributeSelectedOptionsFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  selected_options?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AttributeValueKeySpecifier = (
  | 'code'
  | 'value'
  | AttributeValueKeySpecifier
)[];
export type AttributeValueFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AttributeValueInterfaceKeySpecifier = (
  | 'code'
  | AttributeValueInterfaceKeySpecifier
)[];
export type AttributeValueInterfaceFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AttributesFormOutputKeySpecifier = (
  | 'errors'
  | 'items'
  | AttributesFormOutputKeySpecifier
)[];
export type AttributesFormOutputFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AttributesMetadataOutputKeySpecifier = (
  | 'errors'
  | 'items'
  | AttributesMetadataOutputKeySpecifier
)[];
export type AttributesMetadataOutputFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AvailablePaymentMethodKeySpecifier = (
  | 'code'
  | 'is_deferred'
  | 'title'
  | AvailablePaymentMethodKeySpecifier
)[];
export type AvailablePaymentMethodFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  is_deferred?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AvailableShippingMethodKeySpecifier = (
  | 'amount'
  | 'available'
  | 'base_amount'
  | 'carrier_code'
  | 'carrier_title'
  | 'error_message'
  | 'method_code'
  | 'method_title'
  | 'price_excl_tax'
  | 'price_incl_tax'
  | AvailableShippingMethodKeySpecifier
)[];
export type AvailableShippingMethodFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  available?: FieldPolicy<any> | FieldReadFunction<any>;
  base_amount?: FieldPolicy<any> | FieldReadFunction<any>;
  carrier_code?: FieldPolicy<any> | FieldReadFunction<any>;
  carrier_title?: FieldPolicy<any> | FieldReadFunction<any>;
  error_message?: FieldPolicy<any> | FieldReadFunction<any>;
  method_code?: FieldPolicy<any> | FieldReadFunction<any>;
  method_title?: FieldPolicy<any> | FieldReadFunction<any>;
  price_excl_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  price_incl_tax?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BillingCartAddressKeySpecifier = (
  | 'city'
  | 'company'
  | 'country'
  | 'custom_attributes'
  | 'customer_notes'
  | 'fax'
  | 'firstname'
  | 'hp_address_id'
  | 'lastname'
  | 'middlename'
  | 'postcode'
  | 'prefix'
  | 'region'
  | 'street'
  | 'suffix'
  | 'telephone'
  | 'uid'
  | 'vat_id'
  | BillingCartAddressKeySpecifier
)[];
export type BillingCartAddressFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  custom_attributes?: FieldPolicy<any> | FieldReadFunction<any>;
  customer_notes?: FieldPolicy<any> | FieldReadFunction<any>;
  fax?: FieldPolicy<any> | FieldReadFunction<any>;
  firstname?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_address_id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastname?: FieldPolicy<any> | FieldReadFunction<any>;
  middlename?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  prefix?: FieldPolicy<any> | FieldReadFunction<any>;
  region?: FieldPolicy<any> | FieldReadFunction<any>;
  street?: FieldPolicy<any> | FieldReadFunction<any>;
  suffix?: FieldPolicy<any> | FieldReadFunction<any>;
  telephone?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  vat_id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BreadcrumbKeySpecifier = (
  | 'category_id'
  | 'category_level'
  | 'category_name'
  | 'category_uid'
  | 'category_url_key'
  | 'category_url_path'
  | BreadcrumbKeySpecifier
)[];
export type BreadcrumbFieldPolicy = {
  category_id?: FieldPolicy<any> | FieldReadFunction<any>;
  category_level?: FieldPolicy<any> | FieldReadFunction<any>;
  category_name?: FieldPolicy<any> | FieldReadFunction<any>;
  category_uid?: FieldPolicy<any> | FieldReadFunction<any>;
  category_url_key?: FieldPolicy<any> | FieldReadFunction<any>;
  category_url_path?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BundleCartItemKeySpecifier = (
  | 'bundle_options'
  | 'customizable_options'
  | 'errors'
  | 'hp_cancellation_json'
  | 'id'
  | 'is_available'
  | 'lineItems'
  | 'prices'
  | 'product'
  | 'quantity'
  | 'uid'
  | BundleCartItemKeySpecifier
)[];
export type BundleCartItemFieldPolicy = {
  bundle_options?: FieldPolicy<any> | FieldReadFunction<any>;
  customizable_options?: FieldPolicy<any> | FieldReadFunction<any>;
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_cancellation_json?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  is_available?: FieldPolicy<any> | FieldReadFunction<any>;
  lineItems?: FieldPolicy<any> | FieldReadFunction<any>;
  prices?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BundleCreditMemoItemKeySpecifier = (
  | 'bundle_options'
  | 'discounts'
  | 'id'
  | 'order_item'
  | 'product_name'
  | 'product_sale_price'
  | 'product_sku'
  | 'quantity_refunded'
  | BundleCreditMemoItemKeySpecifier
)[];
export type BundleCreditMemoItemFieldPolicy = {
  bundle_options?: FieldPolicy<any> | FieldReadFunction<any>;
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  order_item?: FieldPolicy<any> | FieldReadFunction<any>;
  product_name?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sale_price?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_refunded?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BundleInvoiceItemKeySpecifier = (
  | 'bundle_options'
  | 'discounts'
  | 'id'
  | 'order_item'
  | 'product_name'
  | 'product_sale_price'
  | 'product_sku'
  | 'quantity_invoiced'
  | BundleInvoiceItemKeySpecifier
)[];
export type BundleInvoiceItemFieldPolicy = {
  bundle_options?: FieldPolicy<any> | FieldReadFunction<any>;
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  order_item?: FieldPolicy<any> | FieldReadFunction<any>;
  product_name?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sale_price?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_invoiced?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BundleItemKeySpecifier = (
  | 'hidden'
  | 'json_option'
  | 'option_id'
  | 'options'
  | 'position'
  | 'price_range'
  | 'required'
  | 'required_sku'
  | 'sku'
  | 'title'
  | 'type'
  | 'uid'
  | BundleItemKeySpecifier
)[];
export type BundleItemFieldPolicy = {
  hidden?: FieldPolicy<any> | FieldReadFunction<any>;
  json_option?: FieldPolicy<any> | FieldReadFunction<any>;
  option_id?: FieldPolicy<any> | FieldReadFunction<any>;
  options?: FieldPolicy<any> | FieldReadFunction<any>;
  position?: FieldPolicy<any> | FieldReadFunction<any>;
  price_range?: FieldPolicy<any> | FieldReadFunction<any>;
  required?: FieldPolicy<any> | FieldReadFunction<any>;
  required_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BundleItemOptionKeySpecifier = (
  | 'can_change_quantity'
  | 'hp_is_popular'
  | 'hp_plan_option'
  | 'id'
  | 'is_default'
  | 'label'
  | 'lowest_price'
  | 'position'
  | 'price'
  | 'price_type'
  | 'product'
  | 'qty'
  | 'quantity'
  | 'required_sku'
  | 'uid'
  | BundleItemOptionKeySpecifier
)[];
export type BundleItemOptionFieldPolicy = {
  can_change_quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_is_popular?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_option?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  is_default?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  lowest_price?: FieldPolicy<any> | FieldReadFunction<any>;
  position?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  qty?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  required_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BundleOrderItemKeySpecifier = (
  | 'bundle_options'
  | 'discounts'
  | 'entered_options'
  | 'hp_product_number'
  | 'hp_product_type_label'
  | 'hp_short_config_name'
  | 'hp_storage_amount'
  | 'hp_storage_uom_label'
  | 'id'
  | 'product'
  | 'product_name'
  | 'product_sale_price'
  | 'product_sku'
  | 'product_type'
  | 'product_url_key'
  | 'quantity_canceled'
  | 'quantity_invoiced'
  | 'quantity_ordered'
  | 'quantity_refunded'
  | 'quantity_returned'
  | 'quantity_shipped'
  | 'selected_options'
  | 'status'
  | BundleOrderItemKeySpecifier
)[];
export type BundleOrderItemFieldPolicy = {
  bundle_options?: FieldPolicy<any> | FieldReadFunction<any>;
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  entered_options?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_number?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_short_config_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_amount?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  product_name?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sale_price?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  product_type?: FieldPolicy<any> | FieldReadFunction<any>;
  product_url_key?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_canceled?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_invoiced?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_ordered?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_refunded?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_returned?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_shipped?: FieldPolicy<any> | FieldReadFunction<any>;
  selected_options?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BundleProductKeySpecifier = (
  | 'a12345'
  | 'attribute_set_id'
  | 'base_accessories'
  | 'canonical_url'
  | 'categories'
  | 'color'
  | 'country_of_manufacture'
  | 'created_at'
  | 'crosssell_products'
  | 'custom_attributesV2'
  | 'description'
  | 'dynamic_price'
  | 'dynamic_sku'
  | 'dynamic_weight'
  | 'gift_message_available'
  | 'hp_allowed_payment_type'
  | 'hp_allowed_payment_type_label'
  | 'hp_as_low_as_price'
  | 'hp_auto_renewal'
  | 'hp_billing_cycle'
  | 'hp_billing_cycle_uom'
  | 'hp_billing_cycle_uom_label'
  | 'hp_billing_period'
  | 'hp_billing_period_label'
  | 'hp_bundle_lease_type'
  | 'hp_bundle_type'
  | 'hp_bundle_type_label'
  | 'hp_can_be_ordered_individually'
  | 'hp_cancellation_json'
  | 'hp_charge_type'
  | 'hp_charge_type_label'
  | 'hp_contract_duration'
  | 'hp_contract_duration_uom'
  | 'hp_contract_duration_uom_label'
  | 'hp_delivery_method'
  | 'hp_delivery_method_label'
  | 'hp_disclaimer'
  | 'hp_downgrade_cost_change'
  | 'hp_early_accessibility'
  | 'hp_eligibility_ruleset_id'
  | 'hp_external_product_id'
  | 'hp_fair_market_value'
  | 'hp_initial_hpone_subscription_cost'
  | 'hp_is_popular'
  | 'hp_lease_fmv'
  | 'hp_lease_type'
  | 'hp_limit_per_org'
  | 'hp_marketing_name'
  | 'hp_max_days_to_return'
  | 'hp_max_rollover_pages'
  | 'hp_model_name'
  | 'hp_model_purpose'
  | 'hp_offer_type'
  | 'hp_offer_type_label'
  | 'hp_order_type'
  | 'hp_overage_block_price'
  | 'hp_overage_block_size'
  | 'hp_overage_block_uom'
  | 'hp_pages_per_month'
  | 'hp_partner_fmvs'
  | 'hp_plan_change_freeze_period'
  | 'hp_plan_change_freeze_period_uom'
  | 'hp_plan_change_freeze_period_uom_label'
  | 'hp_price_type'
  | 'hp_price_type_label'
  | 'hp_product_full_specification'
  | 'hp_product_number'
  | 'hp_product_type'
  | 'hp_product_type_label'
  | 'hp_return_json'
  | 'hp_return_shipping_fee_sku'
  | 'hp_rollover_pages'
  | 'hp_short_config_name'
  | 'hp_solution_id'
  | 'hp_source_system'
  | 'hp_specifications_json'
  | 'hp_storage_amount'
  | 'hp_storage_uom'
  | 'hp_storage_uom_label'
  | 'hp_storefront_group'
  | 'hp_storefront_group_label'
  | 'hp_supply_type'
  | 'hp_supply_type_label'
  | 'hp_support_coverage_included_with_hw'
  | 'hp_support_coverage_included_with_hw_label'
  | 'hp_tokens_count'
  | 'hp_trial_duration'
  | 'hp_trial_duration_unit'
  | 'hp_trial_duration_unit_label'
  | 'hp_trial_pages_per_month'
  | 'hp_trial_price'
  | 'hp_unit_of_measure'
  | 'hp_unit_of_measure_label'
  | 'hp_updated_hpone_subscription_cost'
  | 'hp_upgrade_cost_change'
  | 'id'
  | 'image'
  | 'items'
  | 'lowest_price'
  | 'manufacturer'
  | 'media_gallery'
  | 'media_gallery_entries'
  | 'meta_description'
  | 'meta_keyword'
  | 'meta_title'
  | 'name'
  | 'new_from_date'
  | 'new_to_date'
  | 'only_x_left_in_stock'
  | 'operational_system'
  | 'options'
  | 'options_container'
  | 'price'
  | 'price_details'
  | 'price_range'
  | 'price_tiers'
  | 'price_view'
  | 'product_links'
  | 'redirect_code'
  | 'related_products'
  | 'relative_url'
  | 'ship_bundle_items'
  | 'short_description'
  | 'sku'
  | 'small_accessories'
  | 'small_image'
  | 'special_from_date'
  | 'special_price'
  | 'special_to_date'
  | 'staged'
  | 'stock_status'
  | 'storage'
  | 'swatch_image'
  | 'thumbnail'
  | 'thumbnail_accessories'
  | 'tier_price'
  | 'tier_prices'
  | 'type'
  | 'type_id'
  | 'uid'
  | 'updated_at'
  | 'upsell_products'
  | 'url_key'
  | 'url_path'
  | 'url_rewrites'
  | 'url_suffix'
  | 'usage'
  | 'websites'
  | 'weight'
  | BundleProductKeySpecifier
)[];
export type BundleProductFieldPolicy = {
  a12345?: FieldPolicy<any> | FieldReadFunction<any>;
  attribute_set_id?: FieldPolicy<any> | FieldReadFunction<any>;
  base_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  canonical_url?: FieldPolicy<any> | FieldReadFunction<any>;
  categories?: FieldPolicy<any> | FieldReadFunction<any>;
  color?: FieldPolicy<any> | FieldReadFunction<any>;
  country_of_manufacture?: FieldPolicy<any> | FieldReadFunction<any>;
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  crosssell_products?: FieldPolicy<any> | FieldReadFunction<any>;
  custom_attributesV2?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  dynamic_price?: FieldPolicy<any> | FieldReadFunction<any>;
  dynamic_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  dynamic_weight?: FieldPolicy<any> | FieldReadFunction<any>;
  gift_message_available?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_allowed_payment_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_allowed_payment_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_as_low_as_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_auto_renewal?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_period?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_period_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_lease_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_can_be_ordered_individually?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_cancellation_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_charge_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_charge_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_delivery_method?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_delivery_method_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_disclaimer?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_downgrade_cost_change?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_early_accessibility?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_eligibility_ruleset_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_external_product_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_fair_market_value?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_initial_hpone_subscription_cost?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_is_popular?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_lease_fmv?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_lease_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_limit_per_org?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_marketing_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_max_days_to_return?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_max_rollover_pages?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_model_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_model_purpose?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_offer_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_offer_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_order_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_size?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_pages_per_month?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_partner_fmvs?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period_uom_label?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_price_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_full_specification?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_number?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_return_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_return_shipping_fee_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_rollover_pages?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_short_config_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_solution_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_source_system?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_specifications_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_amount?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storefront_group?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storefront_group_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_supply_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_supply_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_support_coverage_included_with_hw?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_support_coverage_included_with_hw_label?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_tokens_count?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration_unit?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration_unit_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_pages_per_month?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_unit_of_measure?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_unit_of_measure_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_updated_hpone_subscription_cost?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_upgrade_cost_change?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  image?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  lowest_price?: FieldPolicy<any> | FieldReadFunction<any>;
  manufacturer?: FieldPolicy<any> | FieldReadFunction<any>;
  media_gallery?: FieldPolicy<any> | FieldReadFunction<any>;
  media_gallery_entries?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_description?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_keyword?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_title?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  new_from_date?: FieldPolicy<any> | FieldReadFunction<any>;
  new_to_date?: FieldPolicy<any> | FieldReadFunction<any>;
  only_x_left_in_stock?: FieldPolicy<any> | FieldReadFunction<any>;
  operational_system?: FieldPolicy<any> | FieldReadFunction<any>;
  options?: FieldPolicy<any> | FieldReadFunction<any>;
  options_container?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_details?: FieldPolicy<any> | FieldReadFunction<any>;
  price_range?: FieldPolicy<any> | FieldReadFunction<any>;
  price_tiers?: FieldPolicy<any> | FieldReadFunction<any>;
  price_view?: FieldPolicy<any> | FieldReadFunction<any>;
  product_links?: FieldPolicy<any> | FieldReadFunction<any>;
  redirect_code?: FieldPolicy<any> | FieldReadFunction<any>;
  related_products?: FieldPolicy<any> | FieldReadFunction<any>;
  relative_url?: FieldPolicy<any> | FieldReadFunction<any>;
  ship_bundle_items?: FieldPolicy<any> | FieldReadFunction<any>;
  short_description?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  small_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  small_image?: FieldPolicy<any> | FieldReadFunction<any>;
  special_from_date?: FieldPolicy<any> | FieldReadFunction<any>;
  special_price?: FieldPolicy<any> | FieldReadFunction<any>;
  special_to_date?: FieldPolicy<any> | FieldReadFunction<any>;
  staged?: FieldPolicy<any> | FieldReadFunction<any>;
  stock_status?: FieldPolicy<any> | FieldReadFunction<any>;
  storage?: FieldPolicy<any> | FieldReadFunction<any>;
  swatch_image?: FieldPolicy<any> | FieldReadFunction<any>;
  thumbnail?: FieldPolicy<any> | FieldReadFunction<any>;
  thumbnail_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  tier_price?: FieldPolicy<any> | FieldReadFunction<any>;
  tier_prices?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  type_id?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  updated_at?: FieldPolicy<any> | FieldReadFunction<any>;
  upsell_products?: FieldPolicy<any> | FieldReadFunction<any>;
  url_key?: FieldPolicy<any> | FieldReadFunction<any>;
  url_path?: FieldPolicy<any> | FieldReadFunction<any>;
  url_rewrites?: FieldPolicy<any> | FieldReadFunction<any>;
  url_suffix?: FieldPolicy<any> | FieldReadFunction<any>;
  usage?: FieldPolicy<any> | FieldReadFunction<any>;
  websites?: FieldPolicy<any> | FieldReadFunction<any>;
  weight?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BundleShipmentItemKeySpecifier = (
  | 'bundle_options'
  | 'id'
  | 'order_item'
  | 'product_name'
  | 'product_sale_price'
  | 'product_sku'
  | 'quantity_shipped'
  | BundleShipmentItemKeySpecifier
)[];
export type BundleShipmentItemFieldPolicy = {
  bundle_options?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  order_item?: FieldPolicy<any> | FieldReadFunction<any>;
  product_name?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sale_price?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_shipped?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type BundleWishlistItemKeySpecifier = (
  | 'added_at'
  | 'bundle_options'
  | 'customizable_options'
  | 'description'
  | 'id'
  | 'product'
  | 'quantity'
  | BundleWishlistItemKeySpecifier
)[];
export type BundleWishlistItemFieldPolicy = {
  added_at?: FieldPolicy<any> | FieldReadFunction<any>;
  bundle_options?: FieldPolicy<any> | FieldReadFunction<any>;
  customizable_options?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CancelOrderOutputKeySpecifier = (
  | 'error'
  | 'order'
  | CancelOrderOutputKeySpecifier
)[];
export type CancelOrderOutputFieldPolicy = {
  error?: FieldPolicy<any> | FieldReadFunction<any>;
  order?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CancellationReasonKeySpecifier = (
  | 'description'
  | CancellationReasonKeySpecifier
)[];
export type CancellationReasonFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CartKeySpecifier = (
  | 'applied_coupon'
  | 'applied_coupons'
  | 'available_payment_methods'
  | 'billing_address'
  | 'device_total_with_tax'
  | 'email'
  | 'hp_paper_eligible'
  | 'hp_total_subscription_price'
  | 'id'
  | 'is_virtual'
  | 'items'
  | 'itemsV2'
  | 'prices'
  | 'selected_payment_method'
  | 'services_total_with_tax'
  | 'shipping_addresses'
  | 'total_quantity'
  | CartKeySpecifier
)[];
export type CartFieldPolicy = {
  applied_coupon?: FieldPolicy<any> | FieldReadFunction<any>;
  applied_coupons?: FieldPolicy<any> | FieldReadFunction<any>;
  available_payment_methods?: FieldPolicy<any> | FieldReadFunction<any>;
  billing_address?: FieldPolicy<any> | FieldReadFunction<any>;
  device_total_with_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_paper_eligible?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_total_subscription_price?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  is_virtual?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  itemsV2?: FieldPolicy<any> | FieldReadFunction<any>;
  prices?: FieldPolicy<any> | FieldReadFunction<any>;
  selected_payment_method?: FieldPolicy<any> | FieldReadFunction<any>;
  services_total_with_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  shipping_addresses?: FieldPolicy<any> | FieldReadFunction<any>;
  total_quantity?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CartAddressCountryKeySpecifier = (
  | 'code'
  | 'label'
  | CartAddressCountryKeySpecifier
)[];
export type CartAddressCountryFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CartAddressInterfaceKeySpecifier = (
  | 'city'
  | 'company'
  | 'country'
  | 'custom_attributes'
  | 'fax'
  | 'firstname'
  | 'hp_address_id'
  | 'lastname'
  | 'middlename'
  | 'postcode'
  | 'prefix'
  | 'region'
  | 'street'
  | 'suffix'
  | 'telephone'
  | 'uid'
  | 'vat_id'
  | CartAddressInterfaceKeySpecifier
)[];
export type CartAddressInterfaceFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  custom_attributes?: FieldPolicy<any> | FieldReadFunction<any>;
  fax?: FieldPolicy<any> | FieldReadFunction<any>;
  firstname?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_address_id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastname?: FieldPolicy<any> | FieldReadFunction<any>;
  middlename?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  prefix?: FieldPolicy<any> | FieldReadFunction<any>;
  region?: FieldPolicy<any> | FieldReadFunction<any>;
  street?: FieldPolicy<any> | FieldReadFunction<any>;
  suffix?: FieldPolicy<any> | FieldReadFunction<any>;
  telephone?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  vat_id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CartAddressRegionKeySpecifier = (
  | 'code'
  | 'label'
  | 'region_id'
  | CartAddressRegionKeySpecifier
)[];
export type CartAddressRegionFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  region_id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CartDiscountKeySpecifier = (
  | 'amount'
  | 'label'
  | CartDiscountKeySpecifier
)[];
export type CartDiscountFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CartItemErrorKeySpecifier = (
  | 'code'
  | 'message'
  | CartItemErrorKeySpecifier
)[];
export type CartItemErrorFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CartItemInterfaceKeySpecifier = (
  | 'errors'
  | 'id'
  | 'is_available'
  | 'prices'
  | 'product'
  | 'quantity'
  | 'uid'
  | CartItemInterfaceKeySpecifier
)[];
export type CartItemInterfaceFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  is_available?: FieldPolicy<any> | FieldReadFunction<any>;
  prices?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CartItemPricesKeySpecifier = (
  | 'discounts'
  | 'fixed_product_taxes'
  | 'hp_upcoming_price_including_tax'
  | 'price'
  | 'price_including_tax'
  | 'row_total'
  | 'row_total_including_tax'
  | 'total_item_discount'
  | CartItemPricesKeySpecifier
)[];
export type CartItemPricesFieldPolicy = {
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  fixed_product_taxes?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_upcoming_price_including_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_including_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  row_total?: FieldPolicy<any> | FieldReadFunction<any>;
  row_total_including_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  total_item_discount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CartItemQuantityKeySpecifier = (
  | 'cart_item_id'
  | 'quantity'
  | CartItemQuantityKeySpecifier
)[];
export type CartItemQuantityFieldPolicy = {
  cart_item_id?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CartItemSelectedOptionValuePriceKeySpecifier = (
  | 'type'
  | 'units'
  | 'value'
  | CartItemSelectedOptionValuePriceKeySpecifier
)[];
export type CartItemSelectedOptionValuePriceFieldPolicy = {
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  units?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CartItemsKeySpecifier = (
  | 'items'
  | 'page_info'
  | 'total_count'
  | CartItemsKeySpecifier
)[];
export type CartItemsFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  page_info?: FieldPolicy<any> | FieldReadFunction<any>;
  total_count?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CartPricesKeySpecifier = (
  | 'applied_taxes'
  | 'device_total'
  | 'discount'
  | 'discounts'
  | 'grand_total'
  | 'monthly_total'
  | 'subtotal_excluding_tax'
  | 'subtotal_including_tax'
  | 'subtotal_with_discount_excluding_tax'
  | 'total_wsreg_fee'
  | 'wsreg_fees'
  | CartPricesKeySpecifier
)[];
export type CartPricesFieldPolicy = {
  applied_taxes?: FieldPolicy<any> | FieldReadFunction<any>;
  device_total?: FieldPolicy<any> | FieldReadFunction<any>;
  discount?: FieldPolicy<any> | FieldReadFunction<any>;
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  grand_total?: FieldPolicy<any> | FieldReadFunction<any>;
  monthly_total?: FieldPolicy<any> | FieldReadFunction<any>;
  subtotal_excluding_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  subtotal_including_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  subtotal_with_discount_excluding_tax?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  total_wsreg_fee?: FieldPolicy<any> | FieldReadFunction<any>;
  wsreg_fees?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CartTaxItemKeySpecifier = (
  | 'amount'
  | 'label'
  | CartTaxItemKeySpecifier
)[];
export type CartTaxItemFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CartUserInputErrorKeySpecifier = (
  | 'code'
  | 'message'
  | CartUserInputErrorKeySpecifier
)[];
export type CartUserInputErrorFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CatalogAttributeMetadataKeySpecifier = (
  | 'apply_to'
  | 'code'
  | 'default_value'
  | 'entity_type'
  | 'frontend_class'
  | 'frontend_input'
  | 'is_comparable'
  | 'is_filterable'
  | 'is_filterable_in_search'
  | 'is_html_allowed_on_front'
  | 'is_required'
  | 'is_searchable'
  | 'is_unique'
  | 'is_used_for_price_rules'
  | 'is_used_for_promo_rules'
  | 'is_visible_in_advanced_search'
  | 'is_visible_on_front'
  | 'is_wysiwyg_enabled'
  | 'label'
  | 'options'
  | 'swatch_input_type'
  | 'update_product_preview_image'
  | 'use_product_image_for_swatch'
  | 'used_in_product_listing'
  | CatalogAttributeMetadataKeySpecifier
)[];
export type CatalogAttributeMetadataFieldPolicy = {
  apply_to?: FieldPolicy<any> | FieldReadFunction<any>;
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  default_value?: FieldPolicy<any> | FieldReadFunction<any>;
  entity_type?: FieldPolicy<any> | FieldReadFunction<any>;
  frontend_class?: FieldPolicy<any> | FieldReadFunction<any>;
  frontend_input?: FieldPolicy<any> | FieldReadFunction<any>;
  is_comparable?: FieldPolicy<any> | FieldReadFunction<any>;
  is_filterable?: FieldPolicy<any> | FieldReadFunction<any>;
  is_filterable_in_search?: FieldPolicy<any> | FieldReadFunction<any>;
  is_html_allowed_on_front?: FieldPolicy<any> | FieldReadFunction<any>;
  is_required?: FieldPolicy<any> | FieldReadFunction<any>;
  is_searchable?: FieldPolicy<any> | FieldReadFunction<any>;
  is_unique?: FieldPolicy<any> | FieldReadFunction<any>;
  is_used_for_price_rules?: FieldPolicy<any> | FieldReadFunction<any>;
  is_used_for_promo_rules?: FieldPolicy<any> | FieldReadFunction<any>;
  is_visible_in_advanced_search?: FieldPolicy<any> | FieldReadFunction<any>;
  is_visible_on_front?: FieldPolicy<any> | FieldReadFunction<any>;
  is_wysiwyg_enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  options?: FieldPolicy<any> | FieldReadFunction<any>;
  swatch_input_type?: FieldPolicy<any> | FieldReadFunction<any>;
  update_product_preview_image?: FieldPolicy<any> | FieldReadFunction<any>;
  use_product_image_for_swatch?: FieldPolicy<any> | FieldReadFunction<any>;
  used_in_product_listing?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CategoryInterfaceKeySpecifier = (
  | 'automatic_sorting'
  | 'available_sort_by'
  | 'breadcrumbs'
  | 'canonical_url'
  | 'children_count'
  | 'cms_block'
  | 'created_at'
  | 'custom_layout_update_file'
  | 'default_sort_by'
  | 'description'
  | 'display_mode'
  | 'filter_price_range'
  | 'id'
  | 'image'
  | 'include_in_menu'
  | 'is_anchor'
  | 'landing_page'
  | 'level'
  | 'meta_description'
  | 'meta_keywords'
  | 'meta_title'
  | 'name'
  | 'path'
  | 'path_in_store'
  | 'position'
  | 'product_count'
  | 'products'
  | 'staged'
  | 'uid'
  | 'updated_at'
  | 'url_key'
  | 'url_path'
  | 'url_suffix'
  | CategoryInterfaceKeySpecifier
)[];
export type CategoryInterfaceFieldPolicy = {
  automatic_sorting?: FieldPolicy<any> | FieldReadFunction<any>;
  available_sort_by?: FieldPolicy<any> | FieldReadFunction<any>;
  breadcrumbs?: FieldPolicy<any> | FieldReadFunction<any>;
  canonical_url?: FieldPolicy<any> | FieldReadFunction<any>;
  children_count?: FieldPolicy<any> | FieldReadFunction<any>;
  cms_block?: FieldPolicy<any> | FieldReadFunction<any>;
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  custom_layout_update_file?: FieldPolicy<any> | FieldReadFunction<any>;
  default_sort_by?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  display_mode?: FieldPolicy<any> | FieldReadFunction<any>;
  filter_price_range?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  image?: FieldPolicy<any> | FieldReadFunction<any>;
  include_in_menu?: FieldPolicy<any> | FieldReadFunction<any>;
  is_anchor?: FieldPolicy<any> | FieldReadFunction<any>;
  landing_page?: FieldPolicy<any> | FieldReadFunction<any>;
  level?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_description?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_keywords?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_title?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  path?: FieldPolicy<any> | FieldReadFunction<any>;
  path_in_store?: FieldPolicy<any> | FieldReadFunction<any>;
  position?: FieldPolicy<any> | FieldReadFunction<any>;
  product_count?: FieldPolicy<any> | FieldReadFunction<any>;
  products?: FieldPolicy<any> | FieldReadFunction<any>;
  staged?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  updated_at?: FieldPolicy<any> | FieldReadFunction<any>;
  url_key?: FieldPolicy<any> | FieldReadFunction<any>;
  url_path?: FieldPolicy<any> | FieldReadFunction<any>;
  url_suffix?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CategoryProductsKeySpecifier = (
  | 'items'
  | 'page_info'
  | 'total_count'
  | CategoryProductsKeySpecifier
)[];
export type CategoryProductsFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  page_info?: FieldPolicy<any> | FieldReadFunction<any>;
  total_count?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CategoryResultKeySpecifier = (
  | 'items'
  | 'page_info'
  | 'total_count'
  | CategoryResultKeySpecifier
)[];
export type CategoryResultFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  page_info?: FieldPolicy<any> | FieldReadFunction<any>;
  total_count?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CategoryTreeKeySpecifier = (
  | 'automatic_sorting'
  | 'available_sort_by'
  | 'breadcrumbs'
  | 'canonical_url'
  | 'children'
  | 'children_count'
  | 'cms_block'
  | 'created_at'
  | 'custom_layout_update_file'
  | 'default_sort_by'
  | 'description'
  | 'display_mode'
  | 'filter_price_range'
  | 'id'
  | 'image'
  | 'include_in_menu'
  | 'is_anchor'
  | 'landing_page'
  | 'level'
  | 'meta_description'
  | 'meta_keywords'
  | 'meta_title'
  | 'name'
  | 'path'
  | 'path_in_store'
  | 'position'
  | 'product_count'
  | 'products'
  | 'redirect_code'
  | 'relative_url'
  | 'staged'
  | 'type'
  | 'uid'
  | 'updated_at'
  | 'url_key'
  | 'url_path'
  | 'url_suffix'
  | CategoryTreeKeySpecifier
)[];
export type CategoryTreeFieldPolicy = {
  automatic_sorting?: FieldPolicy<any> | FieldReadFunction<any>;
  available_sort_by?: FieldPolicy<any> | FieldReadFunction<any>;
  breadcrumbs?: FieldPolicy<any> | FieldReadFunction<any>;
  canonical_url?: FieldPolicy<any> | FieldReadFunction<any>;
  children?: FieldPolicy<any> | FieldReadFunction<any>;
  children_count?: FieldPolicy<any> | FieldReadFunction<any>;
  cms_block?: FieldPolicy<any> | FieldReadFunction<any>;
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  custom_layout_update_file?: FieldPolicy<any> | FieldReadFunction<any>;
  default_sort_by?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  display_mode?: FieldPolicy<any> | FieldReadFunction<any>;
  filter_price_range?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  image?: FieldPolicy<any> | FieldReadFunction<any>;
  include_in_menu?: FieldPolicy<any> | FieldReadFunction<any>;
  is_anchor?: FieldPolicy<any> | FieldReadFunction<any>;
  landing_page?: FieldPolicy<any> | FieldReadFunction<any>;
  level?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_description?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_keywords?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_title?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  path?: FieldPolicy<any> | FieldReadFunction<any>;
  path_in_store?: FieldPolicy<any> | FieldReadFunction<any>;
  position?: FieldPolicy<any> | FieldReadFunction<any>;
  product_count?: FieldPolicy<any> | FieldReadFunction<any>;
  products?: FieldPolicy<any> | FieldReadFunction<any>;
  redirect_code?: FieldPolicy<any> | FieldReadFunction<any>;
  relative_url?: FieldPolicy<any> | FieldReadFunction<any>;
  staged?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  updated_at?: FieldPolicy<any> | FieldReadFunction<any>;
  url_key?: FieldPolicy<any> | FieldReadFunction<any>;
  url_path?: FieldPolicy<any> | FieldReadFunction<any>;
  url_suffix?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CheckoutAgreementKeySpecifier = (
  | 'agreement_id'
  | 'checkbox_text'
  | 'content'
  | 'content_height'
  | 'is_html'
  | 'mode'
  | 'name'
  | 'type'
  | CheckoutAgreementKeySpecifier
)[];
export type CheckoutAgreementFieldPolicy = {
  agreement_id?: FieldPolicy<any> | FieldReadFunction<any>;
  checkbox_text?: FieldPolicy<any> | FieldReadFunction<any>;
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  content_height?: FieldPolicy<any> | FieldReadFunction<any>;
  is_html?: FieldPolicy<any> | FieldReadFunction<any>;
  mode?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CheckoutUserInputErrorKeySpecifier = (
  | 'code'
  | 'message'
  | 'path'
  | CheckoutUserInputErrorKeySpecifier
)[];
export type CheckoutUserInputErrorFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  path?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ClearCartErrorKeySpecifier = (
  | 'message'
  | 'type'
  | ClearCartErrorKeySpecifier
)[];
export type ClearCartErrorFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ClearCartOutputKeySpecifier = (
  | 'cart'
  | 'errors'
  | ClearCartOutputKeySpecifier
)[];
export type ClearCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ClearCustomerCartOutputKeySpecifier = (
  | 'cart'
  | 'status'
  | ClearCustomerCartOutputKeySpecifier
)[];
export type ClearCustomerCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CmsBlockKeySpecifier = (
  | 'content'
  | 'data'
  | 'identifier'
  | 'title'
  | CmsBlockKeySpecifier
)[];
export type CmsBlockFieldPolicy = {
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  data?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CmsBlocksKeySpecifier = ('items' | CmsBlocksKeySpecifier)[];
export type CmsBlocksFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CmsPageKeySpecifier = (
  | 'content'
  | 'content_heading'
  | 'identifier'
  | 'meta_description'
  | 'meta_keywords'
  | 'meta_title'
  | 'page_layout'
  | 'redirect_code'
  | 'relative_url'
  | 'title'
  | 'type'
  | 'url_key'
  | CmsPageKeySpecifier
)[];
export type CmsPageFieldPolicy = {
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  content_heading?: FieldPolicy<any> | FieldReadFunction<any>;
  identifier?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_description?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_keywords?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_title?: FieldPolicy<any> | FieldReadFunction<any>;
  page_layout?: FieldPolicy<any> | FieldReadFunction<any>;
  redirect_code?: FieldPolicy<any> | FieldReadFunction<any>;
  relative_url?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  url_key?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ColorSwatchDataKeySpecifier = (
  | 'value'
  | ColorSwatchDataKeySpecifier
)[];
export type ColorSwatchDataFieldPolicy = {
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ComplexTextValueKeySpecifier = (
  | 'html'
  | ComplexTextValueKeySpecifier
)[];
export type ComplexTextValueFieldPolicy = {
  html?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConfigurableAttributeOptionKeySpecifier = (
  | 'code'
  | 'label'
  | 'uid'
  | 'value_index'
  | ConfigurableAttributeOptionKeySpecifier
)[];
export type ConfigurableAttributeOptionFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  value_index?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConfigurableCartItemKeySpecifier = (
  | 'configurable_options'
  | 'configured_variant'
  | 'customizable_options'
  | 'errors'
  | 'id'
  | 'is_available'
  | 'prices'
  | 'product'
  | 'quantity'
  | 'uid'
  | ConfigurableCartItemKeySpecifier
)[];
export type ConfigurableCartItemFieldPolicy = {
  configurable_options?: FieldPolicy<any> | FieldReadFunction<any>;
  configured_variant?: FieldPolicy<any> | FieldReadFunction<any>;
  customizable_options?: FieldPolicy<any> | FieldReadFunction<any>;
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  is_available?: FieldPolicy<any> | FieldReadFunction<any>;
  prices?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConfigurableOptionAvailableForSelectionKeySpecifier = (
  | 'attribute_code'
  | 'option_value_uids'
  | ConfigurableOptionAvailableForSelectionKeySpecifier
)[];
export type ConfigurableOptionAvailableForSelectionFieldPolicy = {
  attribute_code?: FieldPolicy<any> | FieldReadFunction<any>;
  option_value_uids?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConfigurableProductKeySpecifier = (
  | 'a12345'
  | 'attribute_set_id'
  | 'base_accessories'
  | 'canonical_url'
  | 'categories'
  | 'color'
  | 'configurable_options'
  | 'configurable_product_options_selection'
  | 'country_of_manufacture'
  | 'created_at'
  | 'crosssell_products'
  | 'custom_attributesV2'
  | 'description'
  | 'gift_message_available'
  | 'hp_allowed_payment_type'
  | 'hp_allowed_payment_type_label'
  | 'hp_as_low_as_price'
  | 'hp_auto_renewal'
  | 'hp_billing_cycle'
  | 'hp_billing_cycle_uom'
  | 'hp_billing_cycle_uom_label'
  | 'hp_billing_period'
  | 'hp_billing_period_label'
  | 'hp_bundle_lease_type'
  | 'hp_bundle_type'
  | 'hp_bundle_type_label'
  | 'hp_can_be_ordered_individually'
  | 'hp_cancellation_json'
  | 'hp_charge_type'
  | 'hp_charge_type_label'
  | 'hp_contract_duration'
  | 'hp_contract_duration_uom'
  | 'hp_contract_duration_uom_label'
  | 'hp_delivery_method'
  | 'hp_delivery_method_label'
  | 'hp_disclaimer'
  | 'hp_downgrade_cost_change'
  | 'hp_early_accessibility'
  | 'hp_eligibility_ruleset_id'
  | 'hp_external_product_id'
  | 'hp_fair_market_value'
  | 'hp_initial_hpone_subscription_cost'
  | 'hp_is_popular'
  | 'hp_lease_fmv'
  | 'hp_lease_type'
  | 'hp_limit_per_org'
  | 'hp_marketing_name'
  | 'hp_max_days_to_return'
  | 'hp_max_rollover_pages'
  | 'hp_model_name'
  | 'hp_model_purpose'
  | 'hp_offer_type'
  | 'hp_offer_type_label'
  | 'hp_order_type'
  | 'hp_overage_block_price'
  | 'hp_overage_block_size'
  | 'hp_overage_block_uom'
  | 'hp_pages_per_month'
  | 'hp_partner_fmvs'
  | 'hp_plan_change_freeze_period'
  | 'hp_plan_change_freeze_period_uom'
  | 'hp_plan_change_freeze_period_uom_label'
  | 'hp_price_type'
  | 'hp_price_type_label'
  | 'hp_product_full_specification'
  | 'hp_product_number'
  | 'hp_product_type'
  | 'hp_product_type_label'
  | 'hp_return_json'
  | 'hp_return_shipping_fee_sku'
  | 'hp_rollover_pages'
  | 'hp_short_config_name'
  | 'hp_solution_id'
  | 'hp_source_system'
  | 'hp_specifications_json'
  | 'hp_storage_amount'
  | 'hp_storage_uom'
  | 'hp_storage_uom_label'
  | 'hp_storefront_group'
  | 'hp_storefront_group_label'
  | 'hp_supply_type'
  | 'hp_supply_type_label'
  | 'hp_support_coverage_included_with_hw'
  | 'hp_support_coverage_included_with_hw_label'
  | 'hp_tokens_count'
  | 'hp_trial_duration'
  | 'hp_trial_duration_unit'
  | 'hp_trial_duration_unit_label'
  | 'hp_trial_pages_per_month'
  | 'hp_trial_price'
  | 'hp_unit_of_measure'
  | 'hp_unit_of_measure_label'
  | 'hp_updated_hpone_subscription_cost'
  | 'hp_upgrade_cost_change'
  | 'id'
  | 'image'
  | 'manufacturer'
  | 'media_gallery'
  | 'media_gallery_entries'
  | 'meta_description'
  | 'meta_keyword'
  | 'meta_title'
  | 'name'
  | 'new_from_date'
  | 'new_to_date'
  | 'only_x_left_in_stock'
  | 'operational_system'
  | 'options'
  | 'options_container'
  | 'price'
  | 'price_range'
  | 'price_tiers'
  | 'product_links'
  | 'redirect_code'
  | 'related_products'
  | 'relative_url'
  | 'short_description'
  | 'sku'
  | 'small_accessories'
  | 'small_image'
  | 'special_from_date'
  | 'special_price'
  | 'special_to_date'
  | 'staged'
  | 'stock_status'
  | 'storage'
  | 'swatch_image'
  | 'thumbnail'
  | 'thumbnail_accessories'
  | 'tier_price'
  | 'tier_prices'
  | 'type'
  | 'type_id'
  | 'uid'
  | 'updated_at'
  | 'upsell_products'
  | 'url_key'
  | 'url_path'
  | 'url_rewrites'
  | 'url_suffix'
  | 'usage'
  | 'variants'
  | 'websites'
  | 'weight'
  | ConfigurableProductKeySpecifier
)[];
export type ConfigurableProductFieldPolicy = {
  a12345?: FieldPolicy<any> | FieldReadFunction<any>;
  attribute_set_id?: FieldPolicy<any> | FieldReadFunction<any>;
  base_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  canonical_url?: FieldPolicy<any> | FieldReadFunction<any>;
  categories?: FieldPolicy<any> | FieldReadFunction<any>;
  color?: FieldPolicy<any> | FieldReadFunction<any>;
  configurable_options?: FieldPolicy<any> | FieldReadFunction<any>;
  configurable_product_options_selection?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  country_of_manufacture?: FieldPolicy<any> | FieldReadFunction<any>;
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  crosssell_products?: FieldPolicy<any> | FieldReadFunction<any>;
  custom_attributesV2?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  gift_message_available?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_allowed_payment_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_allowed_payment_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_as_low_as_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_auto_renewal?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_period?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_period_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_lease_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_can_be_ordered_individually?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_cancellation_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_charge_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_charge_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_delivery_method?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_delivery_method_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_disclaimer?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_downgrade_cost_change?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_early_accessibility?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_eligibility_ruleset_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_external_product_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_fair_market_value?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_initial_hpone_subscription_cost?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_is_popular?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_lease_fmv?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_lease_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_limit_per_org?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_marketing_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_max_days_to_return?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_max_rollover_pages?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_model_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_model_purpose?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_offer_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_offer_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_order_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_size?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_pages_per_month?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_partner_fmvs?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period_uom_label?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_price_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_full_specification?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_number?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_return_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_return_shipping_fee_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_rollover_pages?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_short_config_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_solution_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_source_system?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_specifications_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_amount?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storefront_group?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storefront_group_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_supply_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_supply_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_support_coverage_included_with_hw?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_support_coverage_included_with_hw_label?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_tokens_count?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration_unit?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration_unit_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_pages_per_month?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_unit_of_measure?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_unit_of_measure_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_updated_hpone_subscription_cost?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_upgrade_cost_change?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  image?: FieldPolicy<any> | FieldReadFunction<any>;
  manufacturer?: FieldPolicy<any> | FieldReadFunction<any>;
  media_gallery?: FieldPolicy<any> | FieldReadFunction<any>;
  media_gallery_entries?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_description?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_keyword?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_title?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  new_from_date?: FieldPolicy<any> | FieldReadFunction<any>;
  new_to_date?: FieldPolicy<any> | FieldReadFunction<any>;
  only_x_left_in_stock?: FieldPolicy<any> | FieldReadFunction<any>;
  operational_system?: FieldPolicy<any> | FieldReadFunction<any>;
  options?: FieldPolicy<any> | FieldReadFunction<any>;
  options_container?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_range?: FieldPolicy<any> | FieldReadFunction<any>;
  price_tiers?: FieldPolicy<any> | FieldReadFunction<any>;
  product_links?: FieldPolicy<any> | FieldReadFunction<any>;
  redirect_code?: FieldPolicy<any> | FieldReadFunction<any>;
  related_products?: FieldPolicy<any> | FieldReadFunction<any>;
  relative_url?: FieldPolicy<any> | FieldReadFunction<any>;
  short_description?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  small_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  small_image?: FieldPolicy<any> | FieldReadFunction<any>;
  special_from_date?: FieldPolicy<any> | FieldReadFunction<any>;
  special_price?: FieldPolicy<any> | FieldReadFunction<any>;
  special_to_date?: FieldPolicy<any> | FieldReadFunction<any>;
  staged?: FieldPolicy<any> | FieldReadFunction<any>;
  stock_status?: FieldPolicy<any> | FieldReadFunction<any>;
  storage?: FieldPolicy<any> | FieldReadFunction<any>;
  swatch_image?: FieldPolicy<any> | FieldReadFunction<any>;
  thumbnail?: FieldPolicy<any> | FieldReadFunction<any>;
  thumbnail_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  tier_price?: FieldPolicy<any> | FieldReadFunction<any>;
  tier_prices?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  type_id?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  updated_at?: FieldPolicy<any> | FieldReadFunction<any>;
  upsell_products?: FieldPolicy<any> | FieldReadFunction<any>;
  url_key?: FieldPolicy<any> | FieldReadFunction<any>;
  url_path?: FieldPolicy<any> | FieldReadFunction<any>;
  url_rewrites?: FieldPolicy<any> | FieldReadFunction<any>;
  url_suffix?: FieldPolicy<any> | FieldReadFunction<any>;
  usage?: FieldPolicy<any> | FieldReadFunction<any>;
  variants?: FieldPolicy<any> | FieldReadFunction<any>;
  websites?: FieldPolicy<any> | FieldReadFunction<any>;
  weight?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConfigurableProductOptionKeySpecifier = (
  | 'attribute_code'
  | 'label'
  | 'uid'
  | 'values'
  | ConfigurableProductOptionKeySpecifier
)[];
export type ConfigurableProductOptionFieldPolicy = {
  attribute_code?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  values?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConfigurableProductOptionValueKeySpecifier = (
  | 'is_available'
  | 'is_use_default'
  | 'label'
  | 'swatch'
  | 'uid'
  | ConfigurableProductOptionValueKeySpecifier
)[];
export type ConfigurableProductOptionValueFieldPolicy = {
  is_available?: FieldPolicy<any> | FieldReadFunction<any>;
  is_use_default?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  swatch?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConfigurableProductOptionsKeySpecifier = (
  | 'attribute_code'
  | 'attribute_id'
  | 'attribute_id_v2'
  | 'attribute_uid'
  | 'id'
  | 'label'
  | 'position'
  | 'product_id'
  | 'uid'
  | 'use_default'
  | 'values'
  | ConfigurableProductOptionsKeySpecifier
)[];
export type ConfigurableProductOptionsFieldPolicy = {
  attribute_code?: FieldPolicy<any> | FieldReadFunction<any>;
  attribute_id?: FieldPolicy<any> | FieldReadFunction<any>;
  attribute_id_v2?: FieldPolicy<any> | FieldReadFunction<any>;
  attribute_uid?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  position?: FieldPolicy<any> | FieldReadFunction<any>;
  product_id?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  use_default?: FieldPolicy<any> | FieldReadFunction<any>;
  values?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConfigurableProductOptionsSelectionKeySpecifier = (
  | 'configurable_options'
  | 'media_gallery'
  | 'options_available_for_selection'
  | 'variant'
  | ConfigurableProductOptionsSelectionKeySpecifier
)[];
export type ConfigurableProductOptionsSelectionFieldPolicy = {
  configurable_options?: FieldPolicy<any> | FieldReadFunction<any>;
  media_gallery?: FieldPolicy<any> | FieldReadFunction<any>;
  options_available_for_selection?: FieldPolicy<any> | FieldReadFunction<any>;
  variant?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConfigurableProductOptionsValuesKeySpecifier = (
  | 'default_label'
  | 'label'
  | 'store_label'
  | 'swatch_data'
  | 'uid'
  | 'use_default_value'
  | 'value_index'
  | ConfigurableProductOptionsValuesKeySpecifier
)[];
export type ConfigurableProductOptionsValuesFieldPolicy = {
  default_label?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  store_label?: FieldPolicy<any> | FieldReadFunction<any>;
  swatch_data?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  use_default_value?: FieldPolicy<any> | FieldReadFunction<any>;
  value_index?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConfigurableVariantKeySpecifier = (
  | 'attributes'
  | 'product'
  | ConfigurableVariantKeySpecifier
)[];
export type ConfigurableVariantFieldPolicy = {
  attributes?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ConfigurableWishlistItemKeySpecifier = (
  | 'added_at'
  | 'child_sku'
  | 'configurable_options'
  | 'configured_variant'
  | 'customizable_options'
  | 'description'
  | 'id'
  | 'product'
  | 'quantity'
  | ConfigurableWishlistItemKeySpecifier
)[];
export type ConfigurableWishlistItemFieldPolicy = {
  added_at?: FieldPolicy<any> | FieldReadFunction<any>;
  child_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  configurable_options?: FieldPolicy<any> | FieldReadFunction<any>;
  configured_variant?: FieldPolicy<any> | FieldReadFunction<any>;
  customizable_options?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ContactUsOutputKeySpecifier = (
  | 'status'
  | ContactUsOutputKeySpecifier
)[];
export type ContactUsOutputFieldPolicy = {
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CountryKeySpecifier = (
  | 'available_regions'
  | 'full_name_english'
  | 'full_name_locale'
  | 'id'
  | 'three_letter_abbreviation'
  | 'two_letter_abbreviation'
  | CountryKeySpecifier
)[];
export type CountryFieldPolicy = {
  available_regions?: FieldPolicy<any> | FieldReadFunction<any>;
  full_name_english?: FieldPolicy<any> | FieldReadFunction<any>;
  full_name_locale?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  three_letter_abbreviation?: FieldPolicy<any> | FieldReadFunction<any>;
  two_letter_abbreviation?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreateGuestCartOutputKeySpecifier = (
  | 'cart'
  | CreateGuestCartOutputKeySpecifier
)[];
export type CreateGuestCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreatePaymentMethodOnCartOutputKeySpecifier = (
  | 'payment_method_id'
  | CreatePaymentMethodOnCartOutputKeySpecifier
)[];
export type CreatePaymentMethodOnCartOutputFieldPolicy = {
  payment_method_id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreditMemoKeySpecifier = (
  | 'comments'
  | 'id'
  | 'items'
  | 'number'
  | 'total'
  | CreditMemoKeySpecifier
)[];
export type CreditMemoFieldPolicy = {
  comments?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  number?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreditMemoItemKeySpecifier = (
  | 'discounts'
  | 'id'
  | 'order_item'
  | 'product_name'
  | 'product_sale_price'
  | 'product_sku'
  | 'quantity_refunded'
  | CreditMemoItemKeySpecifier
)[];
export type CreditMemoItemFieldPolicy = {
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  order_item?: FieldPolicy<any> | FieldReadFunction<any>;
  product_name?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sale_price?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_refunded?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreditMemoItemInterfaceKeySpecifier = (
  | 'discounts'
  | 'id'
  | 'order_item'
  | 'product_name'
  | 'product_sale_price'
  | 'product_sku'
  | 'quantity_refunded'
  | CreditMemoItemInterfaceKeySpecifier
)[];
export type CreditMemoItemInterfaceFieldPolicy = {
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  order_item?: FieldPolicy<any> | FieldReadFunction<any>;
  product_name?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sale_price?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_refunded?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CreditMemoTotalKeySpecifier = (
  | 'adjustment'
  | 'base_grand_total'
  | 'discounts'
  | 'grand_total'
  | 'shipping_handling'
  | 'subtotal'
  | 'taxes'
  | 'total_shipping'
  | 'total_tax'
  | CreditMemoTotalKeySpecifier
)[];
export type CreditMemoTotalFieldPolicy = {
  adjustment?: FieldPolicy<any> | FieldReadFunction<any>;
  base_grand_total?: FieldPolicy<any> | FieldReadFunction<any>;
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  grand_total?: FieldPolicy<any> | FieldReadFunction<any>;
  shipping_handling?: FieldPolicy<any> | FieldReadFunction<any>;
  subtotal?: FieldPolicy<any> | FieldReadFunction<any>;
  taxes?: FieldPolicy<any> | FieldReadFunction<any>;
  total_shipping?: FieldPolicy<any> | FieldReadFunction<any>;
  total_tax?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CurrencyKeySpecifier = (
  | 'available_currency_codes'
  | 'base_currency_code'
  | 'base_currency_symbol'
  | 'default_display_currecy_code'
  | 'default_display_currecy_symbol'
  | 'default_display_currency_code'
  | 'default_display_currency_symbol'
  | 'exchange_rates'
  | CurrencyKeySpecifier
)[];
export type CurrencyFieldPolicy = {
  available_currency_codes?: FieldPolicy<any> | FieldReadFunction<any>;
  base_currency_code?: FieldPolicy<any> | FieldReadFunction<any>;
  base_currency_symbol?: FieldPolicy<any> | FieldReadFunction<any>;
  default_display_currecy_code?: FieldPolicy<any> | FieldReadFunction<any>;
  default_display_currecy_symbol?: FieldPolicy<any> | FieldReadFunction<any>;
  default_display_currency_code?: FieldPolicy<any> | FieldReadFunction<any>;
  default_display_currency_symbol?: FieldPolicy<any> | FieldReadFunction<any>;
  exchange_rates?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomAttributeMetadataKeySpecifier = (
  | 'items'
  | CustomAttributeMetadataKeySpecifier
)[];
export type CustomAttributeMetadataFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomAttributeMetadataInterfaceKeySpecifier = (
  | 'code'
  | 'default_value'
  | 'entity_type'
  | 'frontend_class'
  | 'frontend_input'
  | 'is_required'
  | 'is_unique'
  | 'label'
  | 'options'
  | CustomAttributeMetadataInterfaceKeySpecifier
)[];
export type CustomAttributeMetadataInterfaceFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  default_value?: FieldPolicy<any> | FieldReadFunction<any>;
  entity_type?: FieldPolicy<any> | FieldReadFunction<any>;
  frontend_class?: FieldPolicy<any> | FieldReadFunction<any>;
  frontend_input?: FieldPolicy<any> | FieldReadFunction<any>;
  is_required?: FieldPolicy<any> | FieldReadFunction<any>;
  is_unique?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  options?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomAttributeOptionInterfaceKeySpecifier = (
  | 'is_default'
  | 'label'
  | 'value'
  | CustomAttributeOptionInterfaceKeySpecifier
)[];
export type CustomAttributeOptionInterfaceFieldPolicy = {
  is_default?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomerKeySpecifier = (
  | 'addresses'
  | 'confirmation_status'
  | 'created_at'
  | 'custom_attributes'
  | 'date_of_birth'
  | 'default_billing'
  | 'default_shipping'
  | 'dob'
  | 'email'
  | 'firstname'
  | 'gender'
  | 'group_id'
  | 'id'
  | 'is_subscribed'
  | 'lastname'
  | 'middlename'
  | 'orders'
  | 'prefix'
  | 'suffix'
  | 'taxvat'
  | 'wishlist'
  | 'wishlist_v2'
  | 'wishlists'
  | CustomerKeySpecifier
)[];
export type CustomerFieldPolicy = {
  addresses?: FieldPolicy<any> | FieldReadFunction<any>;
  confirmation_status?: FieldPolicy<any> | FieldReadFunction<any>;
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  custom_attributes?: FieldPolicy<any> | FieldReadFunction<any>;
  date_of_birth?: FieldPolicy<any> | FieldReadFunction<any>;
  default_billing?: FieldPolicy<any> | FieldReadFunction<any>;
  default_shipping?: FieldPolicy<any> | FieldReadFunction<any>;
  dob?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  firstname?: FieldPolicy<any> | FieldReadFunction<any>;
  gender?: FieldPolicy<any> | FieldReadFunction<any>;
  group_id?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  is_subscribed?: FieldPolicy<any> | FieldReadFunction<any>;
  lastname?: FieldPolicy<any> | FieldReadFunction<any>;
  middlename?: FieldPolicy<any> | FieldReadFunction<any>;
  orders?: FieldPolicy<any> | FieldReadFunction<any>;
  prefix?: FieldPolicy<any> | FieldReadFunction<any>;
  suffix?: FieldPolicy<any> | FieldReadFunction<any>;
  taxvat?: FieldPolicy<any> | FieldReadFunction<any>;
  wishlist?: FieldPolicy<any> | FieldReadFunction<any>;
  wishlist_v2?: FieldPolicy<any> | FieldReadFunction<any>;
  wishlists?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomerAddressKeySpecifier = (
  | 'city'
  | 'company'
  | 'country_code'
  | 'country_id'
  | 'custom_attributes'
  | 'custom_attributesV2'
  | 'customer_id'
  | 'default_billing'
  | 'default_shipping'
  | 'extension_attributes'
  | 'fax'
  | 'firstname'
  | 'id'
  | 'lastname'
  | 'middlename'
  | 'postcode'
  | 'prefix'
  | 'region'
  | 'region_id'
  | 'street'
  | 'suffix'
  | 'telephone'
  | 'vat_id'
  | CustomerAddressKeySpecifier
)[];
export type CustomerAddressFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  country_code?: FieldPolicy<any> | FieldReadFunction<any>;
  country_id?: FieldPolicy<any> | FieldReadFunction<any>;
  custom_attributes?: FieldPolicy<any> | FieldReadFunction<any>;
  custom_attributesV2?: FieldPolicy<any> | FieldReadFunction<any>;
  customer_id?: FieldPolicy<any> | FieldReadFunction<any>;
  default_billing?: FieldPolicy<any> | FieldReadFunction<any>;
  default_shipping?: FieldPolicy<any> | FieldReadFunction<any>;
  extension_attributes?: FieldPolicy<any> | FieldReadFunction<any>;
  fax?: FieldPolicy<any> | FieldReadFunction<any>;
  firstname?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastname?: FieldPolicy<any> | FieldReadFunction<any>;
  middlename?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  prefix?: FieldPolicy<any> | FieldReadFunction<any>;
  region?: FieldPolicy<any> | FieldReadFunction<any>;
  region_id?: FieldPolicy<any> | FieldReadFunction<any>;
  street?: FieldPolicy<any> | FieldReadFunction<any>;
  suffix?: FieldPolicy<any> | FieldReadFunction<any>;
  telephone?: FieldPolicy<any> | FieldReadFunction<any>;
  vat_id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomerAddressAttributeKeySpecifier = (
  | 'attribute_code'
  | 'value'
  | CustomerAddressAttributeKeySpecifier
)[];
export type CustomerAddressAttributeFieldPolicy = {
  attribute_code?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomerAddressRegionKeySpecifier = (
  | 'region'
  | 'region_code'
  | 'region_id'
  | CustomerAddressRegionKeySpecifier
)[];
export type CustomerAddressRegionFieldPolicy = {
  region?: FieldPolicy<any> | FieldReadFunction<any>;
  region_code?: FieldPolicy<any> | FieldReadFunction<any>;
  region_id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomerAttributeMetadataKeySpecifier = (
  | 'code'
  | 'default_value'
  | 'entity_type'
  | 'frontend_class'
  | 'frontend_input'
  | 'input_filter'
  | 'is_required'
  | 'is_unique'
  | 'label'
  | 'multiline_count'
  | 'options'
  | 'sort_order'
  | 'validate_rules'
  | CustomerAttributeMetadataKeySpecifier
)[];
export type CustomerAttributeMetadataFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  default_value?: FieldPolicy<any> | FieldReadFunction<any>;
  entity_type?: FieldPolicy<any> | FieldReadFunction<any>;
  frontend_class?: FieldPolicy<any> | FieldReadFunction<any>;
  frontend_input?: FieldPolicy<any> | FieldReadFunction<any>;
  input_filter?: FieldPolicy<any> | FieldReadFunction<any>;
  is_required?: FieldPolicy<any> | FieldReadFunction<any>;
  is_unique?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  multiline_count?: FieldPolicy<any> | FieldReadFunction<any>;
  options?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  validate_rules?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomerOrderKeySpecifier = (
  | 'applied_coupons'
  | 'billing_address'
  | 'carrier'
  | 'comments'
  | 'created_at'
  | 'credit_memos'
  | 'email'
  | 'grand_total'
  | 'hp_partner_compensation'
  | 'id'
  | 'increment_id'
  | 'invoices'
  | 'items'
  | 'number'
  | 'order_date'
  | 'order_number'
  | 'payment_methods'
  | 'shipments'
  | 'shipping_address'
  | 'shipping_method'
  | 'status'
  | 'token'
  | 'total'
  | CustomerOrderKeySpecifier
)[];
export type CustomerOrderFieldPolicy = {
  applied_coupons?: FieldPolicy<any> | FieldReadFunction<any>;
  billing_address?: FieldPolicy<any> | FieldReadFunction<any>;
  carrier?: FieldPolicy<any> | FieldReadFunction<any>;
  comments?: FieldPolicy<any> | FieldReadFunction<any>;
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  credit_memos?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  grand_total?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_partner_compensation?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  increment_id?: FieldPolicy<any> | FieldReadFunction<any>;
  invoices?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  number?: FieldPolicy<any> | FieldReadFunction<any>;
  order_date?: FieldPolicy<any> | FieldReadFunction<any>;
  order_number?: FieldPolicy<any> | FieldReadFunction<any>;
  payment_methods?: FieldPolicy<any> | FieldReadFunction<any>;
  shipments?: FieldPolicy<any> | FieldReadFunction<any>;
  shipping_address?: FieldPolicy<any> | FieldReadFunction<any>;
  shipping_method?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  token?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomerOrdersKeySpecifier = (
  | 'items'
  | 'page_info'
  | 'total_count'
  | CustomerOrdersKeySpecifier
)[];
export type CustomerOrdersFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  page_info?: FieldPolicy<any> | FieldReadFunction<any>;
  total_count?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomerOutputKeySpecifier = (
  | 'customer'
  | CustomerOutputKeySpecifier
)[];
export type CustomerOutputFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomerPaymentTokensKeySpecifier = (
  | 'items'
  | CustomerPaymentTokensKeySpecifier
)[];
export type CustomerPaymentTokensFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomerTokenKeySpecifier = ('token' | CustomerTokenKeySpecifier)[];
export type CustomerTokenFieldPolicy = {
  token?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableAreaOptionKeySpecifier = (
  | 'option_id'
  | 'product_sku'
  | 'required'
  | 'sort_order'
  | 'title'
  | 'uid'
  | 'value'
  | CustomizableAreaOptionKeySpecifier
)[];
export type CustomizableAreaOptionFieldPolicy = {
  option_id?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  required?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableAreaValueKeySpecifier = (
  | 'max_characters'
  | 'price'
  | 'price_type'
  | 'sku'
  | 'uid'
  | CustomizableAreaValueKeySpecifier
)[];
export type CustomizableAreaValueFieldPolicy = {
  max_characters?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableCheckboxOptionKeySpecifier = (
  | 'option_id'
  | 'required'
  | 'sort_order'
  | 'title'
  | 'uid'
  | 'value'
  | CustomizableCheckboxOptionKeySpecifier
)[];
export type CustomizableCheckboxOptionFieldPolicy = {
  option_id?: FieldPolicy<any> | FieldReadFunction<any>;
  required?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableCheckboxValueKeySpecifier = (
  | 'option_type_id'
  | 'price'
  | 'price_type'
  | 'sku'
  | 'sort_order'
  | 'title'
  | 'uid'
  | CustomizableCheckboxValueKeySpecifier
)[];
export type CustomizableCheckboxValueFieldPolicy = {
  option_type_id?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableDateOptionKeySpecifier = (
  | 'option_id'
  | 'product_sku'
  | 'required'
  | 'sort_order'
  | 'title'
  | 'uid'
  | 'value'
  | CustomizableDateOptionKeySpecifier
)[];
export type CustomizableDateOptionFieldPolicy = {
  option_id?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  required?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableDateValueKeySpecifier = (
  | 'price'
  | 'price_type'
  | 'sku'
  | 'type'
  | 'uid'
  | CustomizableDateValueKeySpecifier
)[];
export type CustomizableDateValueFieldPolicy = {
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableDropDownOptionKeySpecifier = (
  | 'option_id'
  | 'required'
  | 'sort_order'
  | 'title'
  | 'uid'
  | 'value'
  | CustomizableDropDownOptionKeySpecifier
)[];
export type CustomizableDropDownOptionFieldPolicy = {
  option_id?: FieldPolicy<any> | FieldReadFunction<any>;
  required?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableDropDownValueKeySpecifier = (
  | 'option_type_id'
  | 'price'
  | 'price_type'
  | 'sku'
  | 'sort_order'
  | 'title'
  | 'uid'
  | CustomizableDropDownValueKeySpecifier
)[];
export type CustomizableDropDownValueFieldPolicy = {
  option_type_id?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableFieldOptionKeySpecifier = (
  | 'option_id'
  | 'product_sku'
  | 'required'
  | 'sort_order'
  | 'title'
  | 'uid'
  | 'value'
  | CustomizableFieldOptionKeySpecifier
)[];
export type CustomizableFieldOptionFieldPolicy = {
  option_id?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  required?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableFieldValueKeySpecifier = (
  | 'max_characters'
  | 'price'
  | 'price_type'
  | 'sku'
  | 'uid'
  | CustomizableFieldValueKeySpecifier
)[];
export type CustomizableFieldValueFieldPolicy = {
  max_characters?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableFileOptionKeySpecifier = (
  | 'option_id'
  | 'product_sku'
  | 'required'
  | 'sort_order'
  | 'title'
  | 'uid'
  | 'value'
  | CustomizableFileOptionKeySpecifier
)[];
export type CustomizableFileOptionFieldPolicy = {
  option_id?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  required?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableFileValueKeySpecifier = (
  | 'file_extension'
  | 'image_size_x'
  | 'image_size_y'
  | 'price'
  | 'price_type'
  | 'sku'
  | 'uid'
  | CustomizableFileValueKeySpecifier
)[];
export type CustomizableFileValueFieldPolicy = {
  file_extension?: FieldPolicy<any> | FieldReadFunction<any>;
  image_size_x?: FieldPolicy<any> | FieldReadFunction<any>;
  image_size_y?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableMultipleOptionKeySpecifier = (
  | 'option_id'
  | 'required'
  | 'sort_order'
  | 'title'
  | 'uid'
  | 'value'
  | CustomizableMultipleOptionKeySpecifier
)[];
export type CustomizableMultipleOptionFieldPolicy = {
  option_id?: FieldPolicy<any> | FieldReadFunction<any>;
  required?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableMultipleValueKeySpecifier = (
  | 'option_type_id'
  | 'price'
  | 'price_type'
  | 'sku'
  | 'sort_order'
  | 'title'
  | 'uid'
  | CustomizableMultipleValueKeySpecifier
)[];
export type CustomizableMultipleValueFieldPolicy = {
  option_type_id?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableOptionInterfaceKeySpecifier = (
  | 'option_id'
  | 'required'
  | 'sort_order'
  | 'title'
  | 'uid'
  | CustomizableOptionInterfaceKeySpecifier
)[];
export type CustomizableOptionInterfaceFieldPolicy = {
  option_id?: FieldPolicy<any> | FieldReadFunction<any>;
  required?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableProductInterfaceKeySpecifier = (
  | 'options'
  | CustomizableProductInterfaceKeySpecifier
)[];
export type CustomizableProductInterfaceFieldPolicy = {
  options?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableRadioOptionKeySpecifier = (
  | 'option_id'
  | 'required'
  | 'sort_order'
  | 'title'
  | 'uid'
  | 'value'
  | CustomizableRadioOptionKeySpecifier
)[];
export type CustomizableRadioOptionFieldPolicy = {
  option_id?: FieldPolicy<any> | FieldReadFunction<any>;
  required?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CustomizableRadioValueKeySpecifier = (
  | 'option_type_id'
  | 'price'
  | 'price_type'
  | 'sku'
  | 'sort_order'
  | 'title'
  | 'uid'
  | CustomizableRadioValueKeySpecifier
)[];
export type CustomizableRadioValueFieldPolicy = {
  option_type_id?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DeletePaymentTokenOutputKeySpecifier = (
  | 'customerPaymentTokens'
  | 'result'
  | DeletePaymentTokenOutputKeySpecifier
)[];
export type DeletePaymentTokenOutputFieldPolicy = {
  customerPaymentTokens?: FieldPolicy<any> | FieldReadFunction<any>;
  result?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DiscountKeySpecifier = (
  | 'amount'
  | 'applied_to'
  | 'coupon'
  | 'label'
  | DiscountKeySpecifier
)[];
export type DiscountFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  applied_to?: FieldPolicy<any> | FieldReadFunction<any>;
  coupon?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DynamicBlockKeySpecifier = (
  | 'content'
  | 'uid'
  | DynamicBlockKeySpecifier
)[];
export type DynamicBlockFieldPolicy = {
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DynamicBlocksKeySpecifier = (
  | 'items'
  | 'page_info'
  | 'total_count'
  | DynamicBlocksKeySpecifier
)[];
export type DynamicBlocksFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  page_info?: FieldPolicy<any> | FieldReadFunction<any>;
  total_count?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EntityUrlKeySpecifier = (
  | 'canonical_url'
  | 'entity_uid'
  | 'id'
  | 'redirectCode'
  | 'relative_url'
  | 'type'
  | EntityUrlKeySpecifier
)[];
export type EntityUrlFieldPolicy = {
  canonical_url?: FieldPolicy<any> | FieldReadFunction<any>;
  entity_uid?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  redirectCode?: FieldPolicy<any> | FieldReadFunction<any>;
  relative_url?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ErrorInterfaceKeySpecifier = (
  | 'message'
  | ErrorInterfaceKeySpecifier
)[];
export type ErrorInterfaceFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type EstimateTotalsOutputKeySpecifier = (
  | 'cart'
  | EstimateTotalsOutputKeySpecifier
)[];
export type EstimateTotalsOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ExchangeRateKeySpecifier = (
  | 'currency_to'
  | 'rate'
  | ExchangeRateKeySpecifier
)[];
export type ExchangeRateFieldPolicy = {
  currency_to?: FieldPolicy<any> | FieldReadFunction<any>;
  rate?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FixedProductTaxKeySpecifier = (
  | 'amount'
  | 'label'
  | FixedProductTaxKeySpecifier
)[];
export type FixedProductTaxFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FormKeySpecifier = ('fields' | 'id' | FormKeySpecifier)[];
export type FormFieldPolicy = {
  fields?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type FormFieldKeySpecifier = ('id' | 'rules' | FormFieldKeySpecifier)[];
export type FormFieldFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  rules?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type HttpQueryParameterKeySpecifier = (
  | 'name'
  | 'value'
  | HttpQueryParameterKeySpecifier
)[];
export type HttpQueryParameterFieldPolicy = {
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ImageSwatchDataKeySpecifier = (
  | 'thumbnail'
  | 'value'
  | ImageSwatchDataKeySpecifier
)[];
export type ImageSwatchDataFieldPolicy = {
  thumbnail?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InitializeCustomerCartOutputKeySpecifier = (
  | 'cart'
  | 'user_errors'
  | InitializeCustomerCartOutputKeySpecifier
)[];
export type InitializeCustomerCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
  user_errors?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InstantinkUpgradeKeySpecifier = (
  | 'cancel'
  | 'created_at'
  | 'friendly_name'
  | 'id'
  | 'printer_image_url'
  | 'printer_model_name'
  | 'printer_serial_number'
  | 'subscription_id'
  | InstantinkUpgradeKeySpecifier
)[];
export type InstantinkUpgradeFieldPolicy = {
  cancel?: FieldPolicy<any> | FieldReadFunction<any>;
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  friendly_name?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  printer_image_url?: FieldPolicy<any> | FieldReadFunction<any>;
  printer_model_name?: FieldPolicy<any> | FieldReadFunction<any>;
  printer_serial_number?: FieldPolicy<any> | FieldReadFunction<any>;
  subscription_id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InternalErrorKeySpecifier = (
  | 'message'
  | InternalErrorKeySpecifier
)[];
export type InternalErrorFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvoiceKeySpecifier = (
  | 'comments'
  | 'id'
  | 'items'
  | 'number'
  | 'total'
  | InvoiceKeySpecifier
)[];
export type InvoiceFieldPolicy = {
  comments?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  number?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvoiceItemKeySpecifier = (
  | 'discounts'
  | 'id'
  | 'order_item'
  | 'product_name'
  | 'product_sale_price'
  | 'product_sku'
  | 'quantity_invoiced'
  | InvoiceItemKeySpecifier
)[];
export type InvoiceItemFieldPolicy = {
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  order_item?: FieldPolicy<any> | FieldReadFunction<any>;
  product_name?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sale_price?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_invoiced?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvoiceItemInterfaceKeySpecifier = (
  | 'discounts'
  | 'id'
  | 'order_item'
  | 'product_name'
  | 'product_sale_price'
  | 'product_sku'
  | 'quantity_invoiced'
  | InvoiceItemInterfaceKeySpecifier
)[];
export type InvoiceItemInterfaceFieldPolicy = {
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  order_item?: FieldPolicy<any> | FieldReadFunction<any>;
  product_name?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sale_price?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_invoiced?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvoiceTotalKeySpecifier = (
  | 'base_grand_total'
  | 'discounts'
  | 'grand_total'
  | 'shipping_handling'
  | 'subtotal'
  | 'taxes'
  | 'total_shipping'
  | 'total_tax'
  | InvoiceTotalKeySpecifier
)[];
export type InvoiceTotalFieldPolicy = {
  base_grand_total?: FieldPolicy<any> | FieldReadFunction<any>;
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  grand_total?: FieldPolicy<any> | FieldReadFunction<any>;
  shipping_handling?: FieldPolicy<any> | FieldReadFunction<any>;
  subtotal?: FieldPolicy<any> | FieldReadFunction<any>;
  taxes?: FieldPolicy<any> | FieldReadFunction<any>;
  total_shipping?: FieldPolicy<any> | FieldReadFunction<any>;
  total_tax?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type IsEmailAvailableOutputKeySpecifier = (
  | 'is_email_available'
  | IsEmailAvailableOutputKeySpecifier
)[];
export type IsEmailAvailableOutputFieldPolicy = {
  is_email_available?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ItemKeySpecifier = (
  | 'option_id'
  | 'options'
  | 'title'
  | ItemKeySpecifier
)[];
export type ItemFieldPolicy = {
  option_id?: FieldPolicy<any> | FieldReadFunction<any>;
  options?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ItemSelectedBundleOptionKeySpecifier = (
  | 'id'
  | 'label'
  | 'uid'
  | 'values'
  | ItemSelectedBundleOptionKeySpecifier
)[];
export type ItemSelectedBundleOptionFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  values?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ItemSelectedBundleOptionValueKeySpecifier = (
  | 'hp_product_type_label'
  | 'hp_storage_amount'
  | 'hp_storage_uom_label'
  | 'id'
  | 'price'
  | 'product_name'
  | 'product_sku'
  | 'quantity'
  | 'uid'
  | ItemSelectedBundleOptionValueKeySpecifier
)[];
export type ItemSelectedBundleOptionValueFieldPolicy = {
  hp_product_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_amount?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  product_name?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type KeyValueKeySpecifier = ('name' | 'value' | KeyValueKeySpecifier)[];
export type KeyValueFieldPolicy = {
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LayerFilterKeySpecifier = (
  | 'filter_items'
  | 'filter_items_count'
  | 'name'
  | 'request_var'
  | LayerFilterKeySpecifier
)[];
export type LayerFilterFieldPolicy = {
  filter_items?: FieldPolicy<any> | FieldReadFunction<any>;
  filter_items_count?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  request_var?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LayerFilterItemKeySpecifier = (
  | 'items_count'
  | 'label'
  | 'value_string'
  | LayerFilterItemKeySpecifier
)[];
export type LayerFilterItemFieldPolicy = {
  items_count?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value_string?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LayerFilterItemInterfaceKeySpecifier = (
  | 'items_count'
  | 'label'
  | 'value_string'
  | LayerFilterItemInterfaceKeySpecifier
)[];
export type LayerFilterItemInterfaceFieldPolicy = {
  items_count?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value_string?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LineItemKeySpecifier = (
  | 'features'
  | 'label'
  | 'name'
  | 'price'
  | 'quantity'
  | 'sku'
  | 'thumbnail'
  | 'title'
  | LineItemKeySpecifier
)[];
export type LineItemFieldPolicy = {
  features?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  thumbnail?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type LineItemThumbnailKeySpecifier = (
  | 'src'
  | LineItemThumbnailKeySpecifier
)[];
export type LineItemThumbnailFieldPolicy = {
  src?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MediaGalleryEntryKeySpecifier = (
  | 'content'
  | 'disabled'
  | 'file'
  | 'id'
  | 'label'
  | 'media_type'
  | 'position'
  | 'types'
  | 'uid'
  | 'video_content'
  | MediaGalleryEntryKeySpecifier
)[];
export type MediaGalleryEntryFieldPolicy = {
  content?: FieldPolicy<any> | FieldReadFunction<any>;
  disabled?: FieldPolicy<any> | FieldReadFunction<any>;
  file?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  media_type?: FieldPolicy<any> | FieldReadFunction<any>;
  position?: FieldPolicy<any> | FieldReadFunction<any>;
  types?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  video_content?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MediaGalleryInterfaceKeySpecifier = (
  | 'disabled'
  | 'label'
  | 'position'
  | 'url'
  | MediaGalleryInterfaceKeySpecifier
)[];
export type MediaGalleryInterfaceFieldPolicy = {
  disabled?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  position?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MoneyKeySpecifier = ('currency' | 'value' | MoneyKeySpecifier)[];
export type MoneyFieldPolicy = {
  currency?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MonthlyTotalKeySpecifier = (
  | 'device_monthly_total_with_tax'
  | 'device_monthly_total_without_tax'
  | 'subscription_monthly_total_with_tax'
  | 'subscription_monthly_total_without_tax'
  | MonthlyTotalKeySpecifier
)[];
export type MonthlyTotalFieldPolicy = {
  device_monthly_total_with_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  device_monthly_total_without_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  subscription_monthly_total_with_tax?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  subscription_monthly_total_without_tax?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
};
export type MutationKeySpecifier = (
  | 'addBundleProductsToCart'
  | 'addConfigurableProductsToCart'
  | 'addPaperToCart'
  | 'addProductsToCart'
  | 'addProductsToUpgradeCart'
  | 'addProductsToWishlist'
  | 'addSimpleProductsToCart'
  | 'addVirtualProductsToCart'
  | 'addWishlistItemsToCart'
  | 'applyCouponToCart'
  | 'applyCouponsToCart'
  | 'assignCustomerToGuestCart'
  | 'cancelOrder'
  | 'changeCustomerPassword'
  | 'clearCart'
  | 'clearCustomerCart'
  | 'confirmEmail'
  | 'contactUs'
  | 'createCustomer'
  | 'createCustomerAddress'
  | 'createCustomerV2'
  | 'createEmptyCart'
  | 'createGuestCart'
  | 'createPaymentMethodOnCartFromCode'
  | 'deleteCustomer'
  | 'deleteCustomerAddress'
  | 'deletePaymentToken'
  | 'estimateShippingMethods'
  | 'estimateTotals'
  | 'generateCustomerToken'
  | 'initializeCustomerCart'
  | 'mergeCarts'
  | 'placeOrder'
  | 'removeCouponFromCart'
  | 'removeCouponsFromCart'
  | 'removeItemFromCart'
  | 'removePaperFromCart'
  | 'removeProductsFromWishlist'
  | 'reorderItems'
  | 'requestPasswordResetEmail'
  | 'resetPassword'
  | 'revokeCustomerToken'
  | 'setBillingAddressOnCart'
  | 'setGuestEmailOnCart'
  | 'setPaymentMethodAndPlaceOrder'
  | 'setPaymentMethodIdOnCart'
  | 'setPaymentMethodOnCart'
  | 'setShippingAddressesOnCart'
  | 'setShippingMethodsOnCart'
  | 'setSubscriptionUpgrades'
  | 'subscribeEmailToNewsletter'
  | 'updateCartItems'
  | 'updateCustomer'
  | 'updateCustomerAddress'
  | 'updateCustomerEmail'
  | 'updateCustomerV2'
  | 'updatePaymentMethodCvvOnCartFromCode'
  | 'updateProductsInWishlist'
  | MutationKeySpecifier
)[];
export type MutationFieldPolicy = {
  addBundleProductsToCart?: FieldPolicy<any> | FieldReadFunction<any>;
  addConfigurableProductsToCart?: FieldPolicy<any> | FieldReadFunction<any>;
  addPaperToCart?: FieldPolicy<any> | FieldReadFunction<any>;
  addProductsToCart?: FieldPolicy<any> | FieldReadFunction<any>;
  addProductsToUpgradeCart?: FieldPolicy<any> | FieldReadFunction<any>;
  addProductsToWishlist?: FieldPolicy<any> | FieldReadFunction<any>;
  addSimpleProductsToCart?: FieldPolicy<any> | FieldReadFunction<any>;
  addVirtualProductsToCart?: FieldPolicy<any> | FieldReadFunction<any>;
  addWishlistItemsToCart?: FieldPolicy<any> | FieldReadFunction<any>;
  applyCouponToCart?: FieldPolicy<any> | FieldReadFunction<any>;
  applyCouponsToCart?: FieldPolicy<any> | FieldReadFunction<any>;
  assignCustomerToGuestCart?: FieldPolicy<any> | FieldReadFunction<any>;
  cancelOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  changeCustomerPassword?: FieldPolicy<any> | FieldReadFunction<any>;
  clearCart?: FieldPolicy<any> | FieldReadFunction<any>;
  clearCustomerCart?: FieldPolicy<any> | FieldReadFunction<any>;
  confirmEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  contactUs?: FieldPolicy<any> | FieldReadFunction<any>;
  createCustomer?: FieldPolicy<any> | FieldReadFunction<any>;
  createCustomerAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  createCustomerV2?: FieldPolicy<any> | FieldReadFunction<any>;
  createEmptyCart?: FieldPolicy<any> | FieldReadFunction<any>;
  createGuestCart?: FieldPolicy<any> | FieldReadFunction<any>;
  createPaymentMethodOnCartFromCode?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteCustomer?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteCustomerAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  deletePaymentToken?: FieldPolicy<any> | FieldReadFunction<any>;
  estimateShippingMethods?: FieldPolicy<any> | FieldReadFunction<any>;
  estimateTotals?: FieldPolicy<any> | FieldReadFunction<any>;
  generateCustomerToken?: FieldPolicy<any> | FieldReadFunction<any>;
  initializeCustomerCart?: FieldPolicy<any> | FieldReadFunction<any>;
  mergeCarts?: FieldPolicy<any> | FieldReadFunction<any>;
  placeOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  removeCouponFromCart?: FieldPolicy<any> | FieldReadFunction<any>;
  removeCouponsFromCart?: FieldPolicy<any> | FieldReadFunction<any>;
  removeItemFromCart?: FieldPolicy<any> | FieldReadFunction<any>;
  removePaperFromCart?: FieldPolicy<any> | FieldReadFunction<any>;
  removeProductsFromWishlist?: FieldPolicy<any> | FieldReadFunction<any>;
  reorderItems?: FieldPolicy<any> | FieldReadFunction<any>;
  requestPasswordResetEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  resetPassword?: FieldPolicy<any> | FieldReadFunction<any>;
  revokeCustomerToken?: FieldPolicy<any> | FieldReadFunction<any>;
  setBillingAddressOnCart?: FieldPolicy<any> | FieldReadFunction<any>;
  setGuestEmailOnCart?: FieldPolicy<any> | FieldReadFunction<any>;
  setPaymentMethodAndPlaceOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  setPaymentMethodIdOnCart?: FieldPolicy<any> | FieldReadFunction<any>;
  setPaymentMethodOnCart?: FieldPolicy<any> | FieldReadFunction<any>;
  setShippingAddressesOnCart?: FieldPolicy<any> | FieldReadFunction<any>;
  setShippingMethodsOnCart?: FieldPolicy<any> | FieldReadFunction<any>;
  setSubscriptionUpgrades?: FieldPolicy<any> | FieldReadFunction<any>;
  subscribeEmailToNewsletter?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCartItems?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCustomer?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCustomerAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCustomerEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  updateCustomerV2?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePaymentMethodCvvOnCartFromCode?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  updateProductsInWishlist?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NoSuchEntityUidErrorKeySpecifier = (
  | 'message'
  | 'uid'
  | NoSuchEntityUidErrorKeySpecifier
)[];
export type NoSuchEntityUidErrorFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OptionKeySpecifier = (
  | 'label'
  | 'product'
  | 'required_sku'
  | OptionKeySpecifier
)[];
export type OptionFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  required_sku?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrderKeySpecifier = (
  | 'instantinkUpgrades'
  | 'order_id'
  | 'order_number'
  | OrderKeySpecifier
)[];
export type OrderFieldPolicy = {
  instantinkUpgrades?: FieldPolicy<any> | FieldReadFunction<any>;
  order_id?: FieldPolicy<any> | FieldReadFunction<any>;
  order_number?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrderAddressKeySpecifier = (
  | 'city'
  | 'company'
  | 'country_code'
  | 'fax'
  | 'firstname'
  | 'lastname'
  | 'middlename'
  | 'postcode'
  | 'prefix'
  | 'region'
  | 'region_id'
  | 'street'
  | 'suffix'
  | 'telephone'
  | 'vat_id'
  | OrderAddressKeySpecifier
)[];
export type OrderAddressFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  country_code?: FieldPolicy<any> | FieldReadFunction<any>;
  fax?: FieldPolicy<any> | FieldReadFunction<any>;
  firstname?: FieldPolicy<any> | FieldReadFunction<any>;
  lastname?: FieldPolicy<any> | FieldReadFunction<any>;
  middlename?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  prefix?: FieldPolicy<any> | FieldReadFunction<any>;
  region?: FieldPolicy<any> | FieldReadFunction<any>;
  region_id?: FieldPolicy<any> | FieldReadFunction<any>;
  street?: FieldPolicy<any> | FieldReadFunction<any>;
  suffix?: FieldPolicy<any> | FieldReadFunction<any>;
  telephone?: FieldPolicy<any> | FieldReadFunction<any>;
  vat_id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrderItemKeySpecifier = (
  | 'discounts'
  | 'entered_options'
  | 'hp_product_number'
  | 'hp_product_type_label'
  | 'hp_short_config_name'
  | 'hp_storage_amount'
  | 'hp_storage_uom_label'
  | 'id'
  | 'product'
  | 'product_name'
  | 'product_sale_price'
  | 'product_sku'
  | 'product_type'
  | 'product_url_key'
  | 'quantity_canceled'
  | 'quantity_invoiced'
  | 'quantity_ordered'
  | 'quantity_refunded'
  | 'quantity_returned'
  | 'quantity_shipped'
  | 'selected_options'
  | 'status'
  | OrderItemKeySpecifier
)[];
export type OrderItemFieldPolicy = {
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  entered_options?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_number?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_short_config_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_amount?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  product_name?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sale_price?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  product_type?: FieldPolicy<any> | FieldReadFunction<any>;
  product_url_key?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_canceled?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_invoiced?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_ordered?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_refunded?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_returned?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_shipped?: FieldPolicy<any> | FieldReadFunction<any>;
  selected_options?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrderItemInterfaceKeySpecifier = (
  | 'discounts'
  | 'entered_options'
  | 'hp_product_number'
  | 'hp_product_type_label'
  | 'hp_short_config_name'
  | 'hp_storage_amount'
  | 'hp_storage_uom_label'
  | 'id'
  | 'product'
  | 'product_name'
  | 'product_sale_price'
  | 'product_sku'
  | 'product_type'
  | 'product_url_key'
  | 'quantity_canceled'
  | 'quantity_invoiced'
  | 'quantity_ordered'
  | 'quantity_refunded'
  | 'quantity_returned'
  | 'quantity_shipped'
  | 'selected_options'
  | 'status'
  | OrderItemInterfaceKeySpecifier
)[];
export type OrderItemInterfaceFieldPolicy = {
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  entered_options?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_number?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_short_config_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_amount?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  product_name?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sale_price?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  product_type?: FieldPolicy<any> | FieldReadFunction<any>;
  product_url_key?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_canceled?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_invoiced?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_ordered?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_refunded?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_returned?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_shipped?: FieldPolicy<any> | FieldReadFunction<any>;
  selected_options?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrderItemOptionKeySpecifier = (
  | 'label'
  | 'value'
  | OrderItemOptionKeySpecifier
)[];
export type OrderItemOptionFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrderPaymentMethodKeySpecifier = (
  | 'additional_data'
  | 'name'
  | 'type'
  | OrderPaymentMethodKeySpecifier
)[];
export type OrderPaymentMethodFieldPolicy = {
  additional_data?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrderShipmentKeySpecifier = (
  | 'comments'
  | 'id'
  | 'items'
  | 'number'
  | 'tracking'
  | OrderShipmentKeySpecifier
)[];
export type OrderShipmentFieldPolicy = {
  comments?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  number?: FieldPolicy<any> | FieldReadFunction<any>;
  tracking?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type OrderTotalKeySpecifier = (
  | 'base_grand_total'
  | 'device_total_with_tax'
  | 'discounts'
  | 'grand_total'
  | 'hp_total_subscription_price'
  | 'services_total_with_tax'
  | 'shipping_handling'
  | 'subtotal'
  | 'taxes'
  | 'total_shipping'
  | 'total_tax'
  | OrderTotalKeySpecifier
)[];
export type OrderTotalFieldPolicy = {
  base_grand_total?: FieldPolicy<any> | FieldReadFunction<any>;
  device_total_with_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  grand_total?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_total_subscription_price?: FieldPolicy<any> | FieldReadFunction<any>;
  services_total_with_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  shipping_handling?: FieldPolicy<any> | FieldReadFunction<any>;
  subtotal?: FieldPolicy<any> | FieldReadFunction<any>;
  taxes?: FieldPolicy<any> | FieldReadFunction<any>;
  total_shipping?: FieldPolicy<any> | FieldReadFunction<any>;
  total_tax?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PartnerCompensationKeySpecifier = (
  | 'hp_attribution_id'
  | 'hp_off_ramp_redirect_url'
  | 'hp_partner_logo_url'
  | 'hp_partner_name'
  | PartnerCompensationKeySpecifier
)[];
export type PartnerCompensationFieldPolicy = {
  hp_attribution_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_off_ramp_redirect_url?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_partner_logo_url?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_partner_name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PartnerFmvKeySpecifier = (
  | 'fmv'
  | 'partner_code'
  | PartnerFmvKeySpecifier
)[];
export type PartnerFmvFieldPolicy = {
  fmv?: FieldPolicy<any> | FieldReadFunction<any>;
  partner_code?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaymentTokenKeySpecifier = (
  | 'details'
  | 'payment_method_code'
  | 'public_hash'
  | 'type'
  | PaymentTokenKeySpecifier
)[];
export type PaymentTokenFieldPolicy = {
  details?: FieldPolicy<any> | FieldReadFunction<any>;
  payment_method_code?: FieldPolicy<any> | FieldReadFunction<any>;
  public_hash?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PdpConfigStateKeySpecifier = (
  | 'prices'
  | 'selected_options'
  | PdpConfigStateKeySpecifier
)[];
export type PdpConfigStateFieldPolicy = {
  prices?: FieldPolicy<any> | FieldReadFunction<any>;
  selected_options?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PgsDetailsKeySpecifier = (
  | 'card_type'
  | 'expiration_date'
  | 'iframe_url'
  | 'last_four'
  | 'merchant_name'
  | 'name_on_card'
  | 'quote_id'
  | 'request_time'
  | 'stratus_customer_id'
  | 'tenant_id'
  | PgsDetailsKeySpecifier
)[];
export type PgsDetailsFieldPolicy = {
  card_type?: FieldPolicy<any> | FieldReadFunction<any>;
  expiration_date?: FieldPolicy<any> | FieldReadFunction<any>;
  iframe_url?: FieldPolicy<any> | FieldReadFunction<any>;
  last_four?: FieldPolicy<any> | FieldReadFunction<any>;
  merchant_name?: FieldPolicy<any> | FieldReadFunction<any>;
  name_on_card?: FieldPolicy<any> | FieldReadFunction<any>;
  quote_id?: FieldPolicy<any> | FieldReadFunction<any>;
  request_time?: FieldPolicy<any> | FieldReadFunction<any>;
  stratus_customer_id?: FieldPolicy<any> | FieldReadFunction<any>;
  tenant_id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PhysicalProductInterfaceKeySpecifier = (
  | 'weight'
  | PhysicalProductInterfaceKeySpecifier
)[];
export type PhysicalProductInterfaceFieldPolicy = {
  weight?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PickupLocationKeySpecifier = (
  | 'city'
  | 'contact_name'
  | 'country_id'
  | 'description'
  | 'email'
  | 'fax'
  | 'latitude'
  | 'longitude'
  | 'name'
  | 'phone'
  | 'pickup_location_code'
  | 'postcode'
  | 'region'
  | 'region_id'
  | 'street'
  | PickupLocationKeySpecifier
)[];
export type PickupLocationFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  contact_name?: FieldPolicy<any> | FieldReadFunction<any>;
  country_id?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  email?: FieldPolicy<any> | FieldReadFunction<any>;
  fax?: FieldPolicy<any> | FieldReadFunction<any>;
  latitude?: FieldPolicy<any> | FieldReadFunction<any>;
  longitude?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  pickup_location_code?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  region?: FieldPolicy<any> | FieldReadFunction<any>;
  region_id?: FieldPolicy<any> | FieldReadFunction<any>;
  street?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PickupLocationsKeySpecifier = (
  | 'items'
  | 'page_info'
  | 'total_count'
  | PickupLocationsKeySpecifier
)[];
export type PickupLocationsFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  page_info?: FieldPolicy<any> | FieldReadFunction<any>;
  total_count?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceOrderErrorKeySpecifier = (
  | 'code'
  | 'message'
  | PlaceOrderErrorKeySpecifier
)[];
export type PlaceOrderErrorFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PlaceOrderOutputKeySpecifier = (
  | 'errors'
  | 'order'
  | 'orderV2'
  | PlaceOrderOutputKeySpecifier
)[];
export type PlaceOrderOutputFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
  order?: FieldPolicy<any> | FieldReadFunction<any>;
  orderV2?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PriceKeySpecifier = (
  | 'adjustments'
  | 'amount'
  | PriceKeySpecifier
)[];
export type PriceFieldPolicy = {
  adjustments?: FieldPolicy<any> | FieldReadFunction<any>;
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PriceAdjustmentKeySpecifier = (
  | 'amount'
  | 'code'
  | 'description'
  | PriceAdjustmentKeySpecifier
)[];
export type PriceAdjustmentFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PriceDetailsKeySpecifier = (
  | 'discount_percentage'
  | 'main_final_price'
  | 'main_price'
  | PriceDetailsKeySpecifier
)[];
export type PriceDetailsFieldPolicy = {
  discount_percentage?: FieldPolicy<any> | FieldReadFunction<any>;
  main_final_price?: FieldPolicy<any> | FieldReadFunction<any>;
  main_price?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PriceRangeKeySpecifier = (
  | 'maximum_price'
  | 'minimum_price'
  | PriceRangeKeySpecifier
)[];
export type PriceRangeFieldPolicy = {
  maximum_price?: FieldPolicy<any> | FieldReadFunction<any>;
  minimum_price?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PricesKeySpecifier = (
  | 'totalDevice'
  | 'totalDevicePricePerMonth'
  | 'totalPrice'
  | 'totalPricePerMonth'
  | 'totalSubscriptionPricePerMonth'
  | PricesKeySpecifier
)[];
export type PricesFieldPolicy = {
  totalDevice?: FieldPolicy<any> | FieldReadFunction<any>;
  totalDevicePricePerMonth?: FieldPolicy<any> | FieldReadFunction<any>;
  totalPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  totalPricePerMonth?: FieldPolicy<any> | FieldReadFunction<any>;
  totalSubscriptionPricePerMonth?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductCustomAttributesKeySpecifier = (
  | 'errors'
  | 'items'
  | ProductCustomAttributesKeySpecifier
)[];
export type ProductCustomAttributesFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductDetailKeySpecifier = (
  | 'fmv'
  | 'hp_allocated_revenue'
  | 'hp_max_rollover_pages'
  | 'hp_overage_block_price'
  | 'hp_overage_block_size'
  | 'hp_pages_per_month'
  | 'hp_product_type_label'
  | 'hp_return_shipping_fee_sku'
  | 'hp_rollover_pages'
  | 'name'
  | 'price'
  | 'sku'
  | ProductDetailKeySpecifier
)[];
export type ProductDetailFieldPolicy = {
  fmv?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_allocated_revenue?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_max_rollover_pages?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_size?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_pages_per_month?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_return_shipping_fee_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_rollover_pages?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductDiscountKeySpecifier = (
  | 'amount_off'
  | 'percent_off'
  | ProductDiscountKeySpecifier
)[];
export type ProductDiscountFieldPolicy = {
  amount_off?: FieldPolicy<any> | FieldReadFunction<any>;
  percent_off?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductImageKeySpecifier = (
  | 'disabled'
  | 'label'
  | 'position'
  | 'url'
  | ProductImageKeySpecifier
)[];
export type ProductImageFieldPolicy = {
  disabled?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  position?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductInterfaceKeySpecifier = (
  | 'a12345'
  | 'attribute_set_id'
  | 'base_accessories'
  | 'canonical_url'
  | 'categories'
  | 'color'
  | 'country_of_manufacture'
  | 'created_at'
  | 'crosssell_products'
  | 'custom_attributesV2'
  | 'description'
  | 'gift_message_available'
  | 'hp_allowed_payment_type'
  | 'hp_allowed_payment_type_label'
  | 'hp_as_low_as_price'
  | 'hp_auto_renewal'
  | 'hp_billing_cycle'
  | 'hp_billing_cycle_uom'
  | 'hp_billing_cycle_uom_label'
  | 'hp_billing_period'
  | 'hp_billing_period_label'
  | 'hp_bundle_lease_type'
  | 'hp_bundle_type'
  | 'hp_bundle_type_label'
  | 'hp_can_be_ordered_individually'
  | 'hp_cancellation_json'
  | 'hp_charge_type'
  | 'hp_charge_type_label'
  | 'hp_contract_duration'
  | 'hp_contract_duration_uom'
  | 'hp_contract_duration_uom_label'
  | 'hp_delivery_method'
  | 'hp_delivery_method_label'
  | 'hp_disclaimer'
  | 'hp_downgrade_cost_change'
  | 'hp_early_accessibility'
  | 'hp_eligibility_ruleset_id'
  | 'hp_external_product_id'
  | 'hp_fair_market_value'
  | 'hp_initial_hpone_subscription_cost'
  | 'hp_is_popular'
  | 'hp_lease_fmv'
  | 'hp_lease_type'
  | 'hp_limit_per_org'
  | 'hp_marketing_name'
  | 'hp_max_days_to_return'
  | 'hp_max_rollover_pages'
  | 'hp_model_name'
  | 'hp_model_purpose'
  | 'hp_offer_type'
  | 'hp_offer_type_label'
  | 'hp_order_type'
  | 'hp_overage_block_price'
  | 'hp_overage_block_size'
  | 'hp_overage_block_uom'
  | 'hp_pages_per_month'
  | 'hp_partner_fmvs'
  | 'hp_plan_change_freeze_period'
  | 'hp_plan_change_freeze_period_uom'
  | 'hp_plan_change_freeze_period_uom_label'
  | 'hp_price_type'
  | 'hp_price_type_label'
  | 'hp_product_full_specification'
  | 'hp_product_number'
  | 'hp_product_type'
  | 'hp_product_type_label'
  | 'hp_return_json'
  | 'hp_return_shipping_fee_sku'
  | 'hp_rollover_pages'
  | 'hp_short_config_name'
  | 'hp_solution_id'
  | 'hp_source_system'
  | 'hp_specifications_json'
  | 'hp_storage_amount'
  | 'hp_storage_uom'
  | 'hp_storage_uom_label'
  | 'hp_storefront_group'
  | 'hp_storefront_group_label'
  | 'hp_supply_type'
  | 'hp_supply_type_label'
  | 'hp_support_coverage_included_with_hw'
  | 'hp_support_coverage_included_with_hw_label'
  | 'hp_tokens_count'
  | 'hp_trial_duration'
  | 'hp_trial_duration_unit'
  | 'hp_trial_duration_unit_label'
  | 'hp_trial_pages_per_month'
  | 'hp_trial_price'
  | 'hp_unit_of_measure'
  | 'hp_unit_of_measure_label'
  | 'hp_updated_hpone_subscription_cost'
  | 'hp_upgrade_cost_change'
  | 'id'
  | 'image'
  | 'manufacturer'
  | 'media_gallery'
  | 'media_gallery_entries'
  | 'meta_description'
  | 'meta_keyword'
  | 'meta_title'
  | 'name'
  | 'new_from_date'
  | 'new_to_date'
  | 'only_x_left_in_stock'
  | 'operational_system'
  | 'options_container'
  | 'price'
  | 'price_range'
  | 'price_tiers'
  | 'product_links'
  | 'related_products'
  | 'short_description'
  | 'sku'
  | 'small_accessories'
  | 'small_image'
  | 'special_from_date'
  | 'special_price'
  | 'special_to_date'
  | 'staged'
  | 'stock_status'
  | 'storage'
  | 'swatch_image'
  | 'thumbnail'
  | 'thumbnail_accessories'
  | 'tier_price'
  | 'tier_prices'
  | 'type_id'
  | 'uid'
  | 'updated_at'
  | 'upsell_products'
  | 'url_key'
  | 'url_path'
  | 'url_rewrites'
  | 'url_suffix'
  | 'usage'
  | 'websites'
  | ProductInterfaceKeySpecifier
)[];
export type ProductInterfaceFieldPolicy = {
  a12345?: FieldPolicy<any> | FieldReadFunction<any>;
  attribute_set_id?: FieldPolicy<any> | FieldReadFunction<any>;
  base_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  canonical_url?: FieldPolicy<any> | FieldReadFunction<any>;
  categories?: FieldPolicy<any> | FieldReadFunction<any>;
  color?: FieldPolicy<any> | FieldReadFunction<any>;
  country_of_manufacture?: FieldPolicy<any> | FieldReadFunction<any>;
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  crosssell_products?: FieldPolicy<any> | FieldReadFunction<any>;
  custom_attributesV2?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  gift_message_available?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_allowed_payment_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_allowed_payment_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_as_low_as_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_auto_renewal?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_period?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_period_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_lease_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_can_be_ordered_individually?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_cancellation_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_charge_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_charge_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_delivery_method?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_delivery_method_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_disclaimer?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_downgrade_cost_change?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_early_accessibility?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_eligibility_ruleset_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_external_product_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_fair_market_value?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_initial_hpone_subscription_cost?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_is_popular?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_lease_fmv?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_lease_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_limit_per_org?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_marketing_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_max_days_to_return?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_max_rollover_pages?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_model_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_model_purpose?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_offer_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_offer_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_order_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_size?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_pages_per_month?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_partner_fmvs?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period_uom_label?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_price_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_full_specification?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_number?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_return_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_return_shipping_fee_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_rollover_pages?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_short_config_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_solution_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_source_system?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_specifications_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_amount?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storefront_group?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storefront_group_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_supply_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_supply_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_support_coverage_included_with_hw?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_support_coverage_included_with_hw_label?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_tokens_count?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration_unit?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration_unit_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_pages_per_month?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_unit_of_measure?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_unit_of_measure_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_updated_hpone_subscription_cost?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_upgrade_cost_change?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  image?: FieldPolicy<any> | FieldReadFunction<any>;
  manufacturer?: FieldPolicy<any> | FieldReadFunction<any>;
  media_gallery?: FieldPolicy<any> | FieldReadFunction<any>;
  media_gallery_entries?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_description?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_keyword?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_title?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  new_from_date?: FieldPolicy<any> | FieldReadFunction<any>;
  new_to_date?: FieldPolicy<any> | FieldReadFunction<any>;
  only_x_left_in_stock?: FieldPolicy<any> | FieldReadFunction<any>;
  operational_system?: FieldPolicy<any> | FieldReadFunction<any>;
  options_container?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_range?: FieldPolicy<any> | FieldReadFunction<any>;
  price_tiers?: FieldPolicy<any> | FieldReadFunction<any>;
  product_links?: FieldPolicy<any> | FieldReadFunction<any>;
  related_products?: FieldPolicy<any> | FieldReadFunction<any>;
  short_description?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  small_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  small_image?: FieldPolicy<any> | FieldReadFunction<any>;
  special_from_date?: FieldPolicy<any> | FieldReadFunction<any>;
  special_price?: FieldPolicy<any> | FieldReadFunction<any>;
  special_to_date?: FieldPolicy<any> | FieldReadFunction<any>;
  staged?: FieldPolicy<any> | FieldReadFunction<any>;
  stock_status?: FieldPolicy<any> | FieldReadFunction<any>;
  storage?: FieldPolicy<any> | FieldReadFunction<any>;
  swatch_image?: FieldPolicy<any> | FieldReadFunction<any>;
  thumbnail?: FieldPolicy<any> | FieldReadFunction<any>;
  thumbnail_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  tier_price?: FieldPolicy<any> | FieldReadFunction<any>;
  tier_prices?: FieldPolicy<any> | FieldReadFunction<any>;
  type_id?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  updated_at?: FieldPolicy<any> | FieldReadFunction<any>;
  upsell_products?: FieldPolicy<any> | FieldReadFunction<any>;
  url_key?: FieldPolicy<any> | FieldReadFunction<any>;
  url_path?: FieldPolicy<any> | FieldReadFunction<any>;
  url_rewrites?: FieldPolicy<any> | FieldReadFunction<any>;
  url_suffix?: FieldPolicy<any> | FieldReadFunction<any>;
  usage?: FieldPolicy<any> | FieldReadFunction<any>;
  websites?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductLinksKeySpecifier = (
  | 'link_type'
  | 'linked_product_sku'
  | 'linked_product_type'
  | 'position'
  | 'sku'
  | ProductLinksKeySpecifier
)[];
export type ProductLinksFieldPolicy = {
  link_type?: FieldPolicy<any> | FieldReadFunction<any>;
  linked_product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  linked_product_type?: FieldPolicy<any> | FieldReadFunction<any>;
  position?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductLinksInterfaceKeySpecifier = (
  | 'link_type'
  | 'linked_product_sku'
  | 'linked_product_type'
  | 'position'
  | 'sku'
  | ProductLinksInterfaceKeySpecifier
)[];
export type ProductLinksInterfaceFieldPolicy = {
  link_type?: FieldPolicy<any> | FieldReadFunction<any>;
  linked_product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  linked_product_type?: FieldPolicy<any> | FieldReadFunction<any>;
  position?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductMediaGalleryEntriesContentKeySpecifier = (
  | 'base64_encoded_data'
  | 'name'
  | 'type'
  | ProductMediaGalleryEntriesContentKeySpecifier
)[];
export type ProductMediaGalleryEntriesContentFieldPolicy = {
  base64_encoded_data?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductMediaGalleryEntriesVideoContentKeySpecifier = (
  | 'media_type'
  | 'video_description'
  | 'video_metadata'
  | 'video_provider'
  | 'video_title'
  | 'video_url'
  | ProductMediaGalleryEntriesVideoContentKeySpecifier
)[];
export type ProductMediaGalleryEntriesVideoContentFieldPolicy = {
  media_type?: FieldPolicy<any> | FieldReadFunction<any>;
  video_description?: FieldPolicy<any> | FieldReadFunction<any>;
  video_metadata?: FieldPolicy<any> | FieldReadFunction<any>;
  video_provider?: FieldPolicy<any> | FieldReadFunction<any>;
  video_title?: FieldPolicy<any> | FieldReadFunction<any>;
  video_url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductPriceKeySpecifier = (
  | 'discount'
  | 'final_price'
  | 'fixed_product_taxes'
  | 'regular_price'
  | ProductPriceKeySpecifier
)[];
export type ProductPriceFieldPolicy = {
  discount?: FieldPolicy<any> | FieldReadFunction<any>;
  final_price?: FieldPolicy<any> | FieldReadFunction<any>;
  fixed_product_taxes?: FieldPolicy<any> | FieldReadFunction<any>;
  regular_price?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductPricesKeySpecifier = (
  | 'maximalPrice'
  | 'minimalPrice'
  | 'regularPrice'
  | ProductPricesKeySpecifier
)[];
export type ProductPricesFieldPolicy = {
  maximalPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  minimalPrice?: FieldPolicy<any> | FieldReadFunction<any>;
  regularPrice?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductTierPricesKeySpecifier = (
  | 'customer_group_id'
  | 'percentage_value'
  | 'qty'
  | 'value'
  | 'website_id'
  | ProductTierPricesKeySpecifier
)[];
export type ProductTierPricesFieldPolicy = {
  customer_group_id?: FieldPolicy<any> | FieldReadFunction<any>;
  percentage_value?: FieldPolicy<any> | FieldReadFunction<any>;
  qty?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
  website_id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductVideoKeySpecifier = (
  | 'disabled'
  | 'label'
  | 'position'
  | 'url'
  | 'video_content'
  | ProductVideoKeySpecifier
)[];
export type ProductVideoFieldPolicy = {
  disabled?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  position?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
  video_content?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ProductsKeySpecifier = (
  | 'aggregations'
  | 'filters'
  | 'items'
  | 'page_info'
  | 'sort_fields'
  | 'suggestions'
  | 'total_count'
  | ProductsKeySpecifier
)[];
export type ProductsFieldPolicy = {
  aggregations?: FieldPolicy<any> | FieldReadFunction<any>;
  filters?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  page_info?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_fields?: FieldPolicy<any> | FieldReadFunction<any>;
  suggestions?: FieldPolicy<any> | FieldReadFunction<any>;
  total_count?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QueryKeySpecifier = (
  | 'attributesForm'
  | 'attributesList'
  | 'availableStores'
  | 'cart'
  | 'categories'
  | 'category'
  | 'categoryList'
  | 'checkoutAgreements'
  | 'cmsBlocks'
  | 'cmsPage'
  | 'countries'
  | 'country'
  | 'currency'
  | 'customAttributeMetadata'
  | 'customAttributeMetadataV2'
  | 'customer'
  | 'customerCart'
  | 'customerOrders'
  | 'customerPaymentTokens'
  | 'dynamicBlocks'
  | 'getPartnerCompensation'
  | 'getValidationSchema'
  | 'guestOrder'
  | 'guestOrderByToken'
  | 'isEmailAvailable'
  | 'pdpConfig'
  | 'pickupLocations'
  | 'products'
  | 'route'
  | 'storeConfig'
  | 'subscriptionRevision'
  | 'urlResolver'
  | 'wishlist'
  | 'wsreg_order'
  | 'wsreg_quote'
  | QueryKeySpecifier
)[];
export type QueryFieldPolicy = {
  attributesForm?: FieldPolicy<any> | FieldReadFunction<any>;
  attributesList?: FieldPolicy<any> | FieldReadFunction<any>;
  availableStores?: FieldPolicy<any> | FieldReadFunction<any>;
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
  categories?: FieldPolicy<any> | FieldReadFunction<any>;
  category?: FieldPolicy<any> | FieldReadFunction<any>;
  categoryList?: FieldPolicy<any> | FieldReadFunction<any>;
  checkoutAgreements?: FieldPolicy<any> | FieldReadFunction<any>;
  cmsBlocks?: FieldPolicy<any> | FieldReadFunction<any>;
  cmsPage?: FieldPolicy<any> | FieldReadFunction<any>;
  countries?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  currency?: FieldPolicy<any> | FieldReadFunction<any>;
  customAttributeMetadata?: FieldPolicy<any> | FieldReadFunction<any>;
  customAttributeMetadataV2?: FieldPolicy<any> | FieldReadFunction<any>;
  customer?: FieldPolicy<any> | FieldReadFunction<any>;
  customerCart?: FieldPolicy<any> | FieldReadFunction<any>;
  customerOrders?: FieldPolicy<any> | FieldReadFunction<any>;
  customerPaymentTokens?: FieldPolicy<any> | FieldReadFunction<any>;
  dynamicBlocks?: FieldPolicy<any> | FieldReadFunction<any>;
  getPartnerCompensation?: FieldPolicy<any> | FieldReadFunction<any>;
  getValidationSchema?: FieldPolicy<any> | FieldReadFunction<any>;
  guestOrder?: FieldPolicy<any> | FieldReadFunction<any>;
  guestOrderByToken?: FieldPolicy<any> | FieldReadFunction<any>;
  isEmailAvailable?: FieldPolicy<any> | FieldReadFunction<any>;
  pdpConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  pickupLocations?: FieldPolicy<any> | FieldReadFunction<any>;
  products?: FieldPolicy<any> | FieldReadFunction<any>;
  route?: FieldPolicy<any> | FieldReadFunction<any>;
  storeConfig?: FieldPolicy<any> | FieldReadFunction<any>;
  subscriptionRevision?: FieldPolicy<any> | FieldReadFunction<any>;
  urlResolver?: FieldPolicy<any> | FieldReadFunction<any>;
  wishlist?: FieldPolicy<any> | FieldReadFunction<any>;
  wsreg_order?: FieldPolicy<any> | FieldReadFunction<any>;
  wsreg_quote?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RegionKeySpecifier = (
  | 'code'
  | 'id'
  | 'name'
  | RegionKeySpecifier
)[];
export type RegionFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RegularPriceKeySpecifier = ('amount' | RegularPriceKeySpecifier)[];
export type RegularPriceFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RemoveCouponFromCartOutputKeySpecifier = (
  | 'cart'
  | RemoveCouponFromCartOutputKeySpecifier
)[];
export type RemoveCouponFromCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RemoveItemFromCartOutputKeySpecifier = (
  | 'cart'
  | RemoveItemFromCartOutputKeySpecifier
)[];
export type RemoveItemFromCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RemovePaperFromCartOutputKeySpecifier = (
  | 'message'
  | 'success'
  | RemovePaperFromCartOutputKeySpecifier
)[];
export type RemovePaperFromCartOutputFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RemoveProductsFromWishlistOutputKeySpecifier = (
  | 'user_errors'
  | 'wishlist'
  | RemoveProductsFromWishlistOutputKeySpecifier
)[];
export type RemoveProductsFromWishlistOutputFieldPolicy = {
  user_errors?: FieldPolicy<any> | FieldReadFunction<any>;
  wishlist?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ReorderItemsOutputKeySpecifier = (
  | 'cart'
  | 'userInputErrors'
  | ReorderItemsOutputKeySpecifier
)[];
export type ReorderItemsOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
  userInputErrors?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RevisionPriceKeySpecifier = (
  | 'regularPrice'
  | RevisionPriceKeySpecifier
)[];
export type RevisionPriceFieldPolicy = {
  regularPrice?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RevokeCustomerTokenOutputKeySpecifier = (
  | 'result'
  | RevokeCustomerTokenOutputKeySpecifier
)[];
export type RevokeCustomerTokenOutputFieldPolicy = {
  result?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RoutableInterfaceKeySpecifier = (
  | 'redirect_code'
  | 'relative_url'
  | 'type'
  | RoutableInterfaceKeySpecifier
)[];
export type RoutableInterfaceFieldPolicy = {
  redirect_code?: FieldPolicy<any> | FieldReadFunction<any>;
  relative_url?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RoutableUrlKeySpecifier = (
  | 'redirect_code'
  | 'relative_url'
  | 'type'
  | RoutableUrlKeySpecifier
)[];
export type RoutableUrlFieldPolicy = {
  redirect_code?: FieldPolicy<any> | FieldReadFunction<any>;
  relative_url?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SalesCommentItemKeySpecifier = (
  | 'message'
  | 'timestamp'
  | SalesCommentItemKeySpecifier
)[];
export type SalesCommentItemFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  timestamp?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SearchResultPageInfoKeySpecifier = (
  | 'current_page'
  | 'page_size'
  | 'total_pages'
  | SearchResultPageInfoKeySpecifier
)[];
export type SearchResultPageInfoFieldPolicy = {
  current_page?: FieldPolicy<any> | FieldReadFunction<any>;
  page_size?: FieldPolicy<any> | FieldReadFunction<any>;
  total_pages?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SearchSuggestionKeySpecifier = (
  | 'search'
  | SearchSuggestionKeySpecifier
)[];
export type SearchSuggestionFieldPolicy = {
  search?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SelectedBundleOptionKeySpecifier = (
  | 'id'
  | 'label'
  | 'type'
  | 'uid'
  | 'values'
  | SelectedBundleOptionKeySpecifier
)[];
export type SelectedBundleOptionFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  values?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SelectedBundleOptionValueKeySpecifier = (
  | 'applied_tax'
  | 'hp_price_type'
  | 'id'
  | 'label'
  | 'monthly_price_with_tax'
  | 'monthly_price_without_tax'
  | 'price'
  | 'quantity'
  | 'sku'
  | 'uid'
  | SelectedBundleOptionValueKeySpecifier
)[];
export type SelectedBundleOptionValueFieldPolicy = {
  applied_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  monthly_price_with_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  monthly_price_without_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SelectedConfigurableOptionKeySpecifier = (
  | 'configurable_product_option_uid'
  | 'configurable_product_option_value_uid'
  | 'id'
  | 'option_label'
  | 'value_id'
  | 'value_label'
  | SelectedConfigurableOptionKeySpecifier
)[];
export type SelectedConfigurableOptionFieldPolicy = {
  configurable_product_option_uid?: FieldPolicy<any> | FieldReadFunction<any>;
  configurable_product_option_value_uid?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  option_label?: FieldPolicy<any> | FieldReadFunction<any>;
  value_id?: FieldPolicy<any> | FieldReadFunction<any>;
  value_label?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SelectedCustomizableOptionKeySpecifier = (
  | 'customizable_option_uid'
  | 'id'
  | 'is_required'
  | 'label'
  | 'sort_order'
  | 'type'
  | 'values'
  | SelectedCustomizableOptionKeySpecifier
)[];
export type SelectedCustomizableOptionFieldPolicy = {
  customizable_option_uid?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  is_required?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  values?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SelectedCustomizableOptionValueKeySpecifier = (
  | 'customizable_option_value_uid'
  | 'id'
  | 'label'
  | 'price'
  | 'value'
  | SelectedCustomizableOptionValueKeySpecifier
)[];
export type SelectedCustomizableOptionValueFieldPolicy = {
  customizable_option_value_uid?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SelectedPaymentMethodKeySpecifier = (
  | 'code'
  | 'pgs_details'
  | 'purchase_order_number'
  | 'title'
  | SelectedPaymentMethodKeySpecifier
)[];
export type SelectedPaymentMethodFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  pgs_details?: FieldPolicy<any> | FieldReadFunction<any>;
  purchase_order_number?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SelectedShippingMethodKeySpecifier = (
  | 'amount'
  | 'base_amount'
  | 'carrier_code'
  | 'carrier_title'
  | 'method_code'
  | 'method_title'
  | 'price_excl_tax'
  | 'price_incl_tax'
  | SelectedShippingMethodKeySpecifier
)[];
export type SelectedShippingMethodFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  base_amount?: FieldPolicy<any> | FieldReadFunction<any>;
  carrier_code?: FieldPolicy<any> | FieldReadFunction<any>;
  carrier_title?: FieldPolicy<any> | FieldReadFunction<any>;
  method_code?: FieldPolicy<any> | FieldReadFunction<any>;
  method_title?: FieldPolicy<any> | FieldReadFunction<any>;
  price_excl_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  price_incl_tax?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SetBillingAddressOnCartOutputKeySpecifier = (
  | 'cart'
  | SetBillingAddressOnCartOutputKeySpecifier
)[];
export type SetBillingAddressOnCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SetGuestEmailOnCartOutputKeySpecifier = (
  | 'cart'
  | SetGuestEmailOnCartOutputKeySpecifier
)[];
export type SetGuestEmailOnCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SetPaymentMethodOnCartOutputKeySpecifier = (
  | 'cart'
  | SetPaymentMethodOnCartOutputKeySpecifier
)[];
export type SetPaymentMethodOnCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SetShippingAddressesOnCartOutputKeySpecifier = (
  | 'cart'
  | SetShippingAddressesOnCartOutputKeySpecifier
)[];
export type SetShippingAddressesOnCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SetShippingMethodsOnCartOutputKeySpecifier = (
  | 'cart'
  | SetShippingMethodsOnCartOutputKeySpecifier
)[];
export type SetShippingMethodsOnCartOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SetSubscriptionUpgradesOutputKeySpecifier = (
  | 'message'
  | 'success'
  | SetSubscriptionUpgradesOutputKeySpecifier
)[];
export type SetSubscriptionUpgradesOutputFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShipmentItemKeySpecifier = (
  | 'id'
  | 'order_item'
  | 'product_name'
  | 'product_sale_price'
  | 'product_sku'
  | 'quantity_shipped'
  | ShipmentItemKeySpecifier
)[];
export type ShipmentItemFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  order_item?: FieldPolicy<any> | FieldReadFunction<any>;
  product_name?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sale_price?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_shipped?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShipmentItemInterfaceKeySpecifier = (
  | 'id'
  | 'order_item'
  | 'product_name'
  | 'product_sale_price'
  | 'product_sku'
  | 'quantity_shipped'
  | ShipmentItemInterfaceKeySpecifier
)[];
export type ShipmentItemInterfaceFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  order_item?: FieldPolicy<any> | FieldReadFunction<any>;
  product_name?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sale_price?: FieldPolicy<any> | FieldReadFunction<any>;
  product_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity_shipped?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShipmentTrackingKeySpecifier = (
  | 'carrier'
  | 'number'
  | 'title'
  | ShipmentTrackingKeySpecifier
)[];
export type ShipmentTrackingFieldPolicy = {
  carrier?: FieldPolicy<any> | FieldReadFunction<any>;
  number?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShippingCartAddressKeySpecifier = (
  | 'available_shipping_methods'
  | 'cart_items'
  | 'cart_items_v2'
  | 'city'
  | 'company'
  | 'country'
  | 'custom_attributes'
  | 'customer_notes'
  | 'fax'
  | 'firstname'
  | 'hp_address_id'
  | 'items_weight'
  | 'lastname'
  | 'middlename'
  | 'pickup_location_code'
  | 'postcode'
  | 'prefix'
  | 'region'
  | 'selected_shipping_method'
  | 'street'
  | 'suffix'
  | 'telephone'
  | 'uid'
  | 'vat_id'
  | ShippingCartAddressKeySpecifier
)[];
export type ShippingCartAddressFieldPolicy = {
  available_shipping_methods?: FieldPolicy<any> | FieldReadFunction<any>;
  cart_items?: FieldPolicy<any> | FieldReadFunction<any>;
  cart_items_v2?: FieldPolicy<any> | FieldReadFunction<any>;
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  company?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  custom_attributes?: FieldPolicy<any> | FieldReadFunction<any>;
  customer_notes?: FieldPolicy<any> | FieldReadFunction<any>;
  fax?: FieldPolicy<any> | FieldReadFunction<any>;
  firstname?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_address_id?: FieldPolicy<any> | FieldReadFunction<any>;
  items_weight?: FieldPolicy<any> | FieldReadFunction<any>;
  lastname?: FieldPolicy<any> | FieldReadFunction<any>;
  middlename?: FieldPolicy<any> | FieldReadFunction<any>;
  pickup_location_code?: FieldPolicy<any> | FieldReadFunction<any>;
  postcode?: FieldPolicy<any> | FieldReadFunction<any>;
  prefix?: FieldPolicy<any> | FieldReadFunction<any>;
  region?: FieldPolicy<any> | FieldReadFunction<any>;
  selected_shipping_method?: FieldPolicy<any> | FieldReadFunction<any>;
  street?: FieldPolicy<any> | FieldReadFunction<any>;
  suffix?: FieldPolicy<any> | FieldReadFunction<any>;
  telephone?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  vat_id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShippingDiscountKeySpecifier = (
  | 'amount'
  | ShippingDiscountKeySpecifier
)[];
export type ShippingDiscountFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShippingHandlingKeySpecifier = (
  | 'amount_excluding_tax'
  | 'amount_including_tax'
  | 'discounts'
  | 'taxes'
  | 'total_amount'
  | ShippingHandlingKeySpecifier
)[];
export type ShippingHandlingFieldPolicy = {
  amount_excluding_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  amount_including_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  discounts?: FieldPolicy<any> | FieldReadFunction<any>;
  taxes?: FieldPolicy<any> | FieldReadFunction<any>;
  total_amount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SimpleCartItemKeySpecifier = (
  | 'customizable_options'
  | 'errors'
  | 'id'
  | 'is_available'
  | 'prices'
  | 'product'
  | 'quantity'
  | 'uid'
  | SimpleCartItemKeySpecifier
)[];
export type SimpleCartItemFieldPolicy = {
  customizable_options?: FieldPolicy<any> | FieldReadFunction<any>;
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  is_available?: FieldPolicy<any> | FieldReadFunction<any>;
  prices?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SimpleProductKeySpecifier = (
  | 'a12345'
  | 'attribute_set_id'
  | 'base_accessories'
  | 'canonical_url'
  | 'categories'
  | 'color'
  | 'country_of_manufacture'
  | 'created_at'
  | 'crosssell_products'
  | 'custom_attributesV2'
  | 'description'
  | 'gift_message_available'
  | 'hp_allowed_payment_type'
  | 'hp_allowed_payment_type_label'
  | 'hp_as_low_as_price'
  | 'hp_auto_renewal'
  | 'hp_billing_cycle'
  | 'hp_billing_cycle_uom'
  | 'hp_billing_cycle_uom_label'
  | 'hp_billing_period'
  | 'hp_billing_period_label'
  | 'hp_bundle_lease_type'
  | 'hp_bundle_type'
  | 'hp_bundle_type_label'
  | 'hp_can_be_ordered_individually'
  | 'hp_cancellation_json'
  | 'hp_charge_type'
  | 'hp_charge_type_label'
  | 'hp_contract_duration'
  | 'hp_contract_duration_uom'
  | 'hp_contract_duration_uom_label'
  | 'hp_delivery_method'
  | 'hp_delivery_method_label'
  | 'hp_disclaimer'
  | 'hp_downgrade_cost_change'
  | 'hp_early_accessibility'
  | 'hp_eligibility_ruleset_id'
  | 'hp_external_product_id'
  | 'hp_fair_market_value'
  | 'hp_initial_hpone_subscription_cost'
  | 'hp_is_popular'
  | 'hp_lease_fmv'
  | 'hp_lease_type'
  | 'hp_limit_per_org'
  | 'hp_marketing_name'
  | 'hp_max_days_to_return'
  | 'hp_max_rollover_pages'
  | 'hp_model_name'
  | 'hp_model_purpose'
  | 'hp_offer_type'
  | 'hp_offer_type_label'
  | 'hp_order_type'
  | 'hp_overage_block_price'
  | 'hp_overage_block_size'
  | 'hp_overage_block_uom'
  | 'hp_pages_per_month'
  | 'hp_partner_fmvs'
  | 'hp_plan_change_freeze_period'
  | 'hp_plan_change_freeze_period_uom'
  | 'hp_plan_change_freeze_period_uom_label'
  | 'hp_price_type'
  | 'hp_price_type_label'
  | 'hp_product_full_specification'
  | 'hp_product_number'
  | 'hp_product_type'
  | 'hp_product_type_label'
  | 'hp_return_json'
  | 'hp_return_shipping_fee_sku'
  | 'hp_rollover_pages'
  | 'hp_short_config_name'
  | 'hp_solution_id'
  | 'hp_source_system'
  | 'hp_specifications_json'
  | 'hp_storage_amount'
  | 'hp_storage_uom'
  | 'hp_storage_uom_label'
  | 'hp_storefront_group'
  | 'hp_storefront_group_label'
  | 'hp_supply_type'
  | 'hp_supply_type_label'
  | 'hp_support_coverage_included_with_hw'
  | 'hp_support_coverage_included_with_hw_label'
  | 'hp_tokens_count'
  | 'hp_trial_duration'
  | 'hp_trial_duration_unit'
  | 'hp_trial_duration_unit_label'
  | 'hp_trial_pages_per_month'
  | 'hp_trial_price'
  | 'hp_unit_of_measure'
  | 'hp_unit_of_measure_label'
  | 'hp_updated_hpone_subscription_cost'
  | 'hp_upgrade_cost_change'
  | 'id'
  | 'image'
  | 'manufacturer'
  | 'media_gallery'
  | 'media_gallery_entries'
  | 'meta_description'
  | 'meta_keyword'
  | 'meta_title'
  | 'name'
  | 'new_from_date'
  | 'new_to_date'
  | 'only_x_left_in_stock'
  | 'operational_system'
  | 'options'
  | 'options_container'
  | 'price'
  | 'price_range'
  | 'price_tiers'
  | 'product_links'
  | 'redirect_code'
  | 'related_products'
  | 'relative_url'
  | 'short_description'
  | 'sku'
  | 'small_accessories'
  | 'small_image'
  | 'special_from_date'
  | 'special_price'
  | 'special_to_date'
  | 'staged'
  | 'stock_status'
  | 'storage'
  | 'swatch_image'
  | 'thumbnail'
  | 'thumbnail_accessories'
  | 'tier_price'
  | 'tier_prices'
  | 'type'
  | 'type_id'
  | 'uid'
  | 'updated_at'
  | 'upsell_products'
  | 'url_key'
  | 'url_path'
  | 'url_rewrites'
  | 'url_suffix'
  | 'usage'
  | 'websites'
  | 'weight'
  | SimpleProductKeySpecifier
)[];
export type SimpleProductFieldPolicy = {
  a12345?: FieldPolicy<any> | FieldReadFunction<any>;
  attribute_set_id?: FieldPolicy<any> | FieldReadFunction<any>;
  base_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  canonical_url?: FieldPolicy<any> | FieldReadFunction<any>;
  categories?: FieldPolicy<any> | FieldReadFunction<any>;
  color?: FieldPolicy<any> | FieldReadFunction<any>;
  country_of_manufacture?: FieldPolicy<any> | FieldReadFunction<any>;
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  crosssell_products?: FieldPolicy<any> | FieldReadFunction<any>;
  custom_attributesV2?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  gift_message_available?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_allowed_payment_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_allowed_payment_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_as_low_as_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_auto_renewal?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_period?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_period_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_lease_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_can_be_ordered_individually?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_cancellation_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_charge_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_charge_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_delivery_method?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_delivery_method_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_disclaimer?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_downgrade_cost_change?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_early_accessibility?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_eligibility_ruleset_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_external_product_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_fair_market_value?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_initial_hpone_subscription_cost?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_is_popular?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_lease_fmv?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_lease_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_limit_per_org?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_marketing_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_max_days_to_return?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_max_rollover_pages?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_model_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_model_purpose?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_offer_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_offer_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_order_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_size?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_pages_per_month?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_partner_fmvs?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period_uom_label?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_price_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_full_specification?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_number?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_return_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_return_shipping_fee_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_rollover_pages?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_short_config_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_solution_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_source_system?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_specifications_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_amount?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storefront_group?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storefront_group_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_supply_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_supply_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_support_coverage_included_with_hw?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_support_coverage_included_with_hw_label?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_tokens_count?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration_unit?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration_unit_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_pages_per_month?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_unit_of_measure?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_unit_of_measure_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_updated_hpone_subscription_cost?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_upgrade_cost_change?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  image?: FieldPolicy<any> | FieldReadFunction<any>;
  manufacturer?: FieldPolicy<any> | FieldReadFunction<any>;
  media_gallery?: FieldPolicy<any> | FieldReadFunction<any>;
  media_gallery_entries?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_description?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_keyword?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_title?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  new_from_date?: FieldPolicy<any> | FieldReadFunction<any>;
  new_to_date?: FieldPolicy<any> | FieldReadFunction<any>;
  only_x_left_in_stock?: FieldPolicy<any> | FieldReadFunction<any>;
  operational_system?: FieldPolicy<any> | FieldReadFunction<any>;
  options?: FieldPolicy<any> | FieldReadFunction<any>;
  options_container?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_range?: FieldPolicy<any> | FieldReadFunction<any>;
  price_tiers?: FieldPolicy<any> | FieldReadFunction<any>;
  product_links?: FieldPolicy<any> | FieldReadFunction<any>;
  redirect_code?: FieldPolicy<any> | FieldReadFunction<any>;
  related_products?: FieldPolicy<any> | FieldReadFunction<any>;
  relative_url?: FieldPolicy<any> | FieldReadFunction<any>;
  short_description?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  small_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  small_image?: FieldPolicy<any> | FieldReadFunction<any>;
  special_from_date?: FieldPolicy<any> | FieldReadFunction<any>;
  special_price?: FieldPolicy<any> | FieldReadFunction<any>;
  special_to_date?: FieldPolicy<any> | FieldReadFunction<any>;
  staged?: FieldPolicy<any> | FieldReadFunction<any>;
  stock_status?: FieldPolicy<any> | FieldReadFunction<any>;
  storage?: FieldPolicy<any> | FieldReadFunction<any>;
  swatch_image?: FieldPolicy<any> | FieldReadFunction<any>;
  thumbnail?: FieldPolicy<any> | FieldReadFunction<any>;
  thumbnail_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  tier_price?: FieldPolicy<any> | FieldReadFunction<any>;
  tier_prices?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  type_id?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  updated_at?: FieldPolicy<any> | FieldReadFunction<any>;
  upsell_products?: FieldPolicy<any> | FieldReadFunction<any>;
  url_key?: FieldPolicy<any> | FieldReadFunction<any>;
  url_path?: FieldPolicy<any> | FieldReadFunction<any>;
  url_rewrites?: FieldPolicy<any> | FieldReadFunction<any>;
  url_suffix?: FieldPolicy<any> | FieldReadFunction<any>;
  usage?: FieldPolicy<any> | FieldReadFunction<any>;
  websites?: FieldPolicy<any> | FieldReadFunction<any>;
  weight?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SimpleWishlistItemKeySpecifier = (
  | 'added_at'
  | 'customizable_options'
  | 'description'
  | 'id'
  | 'product'
  | 'quantity'
  | SimpleWishlistItemKeySpecifier
)[];
export type SimpleWishlistItemFieldPolicy = {
  added_at?: FieldPolicy<any> | FieldReadFunction<any>;
  customizable_options?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SortFieldKeySpecifier = (
  | 'label'
  | 'value'
  | SortFieldKeySpecifier
)[];
export type SortFieldFieldPolicy = {
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SortFieldsKeySpecifier = (
  | 'default'
  | 'options'
  | SortFieldsKeySpecifier
)[];
export type SortFieldsFieldPolicy = {
  default?: FieldPolicy<any> | FieldReadFunction<any>;
  options?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StoreConfigKeySpecifier = (
  | 'absolute_footer'
  | 'autocomplete_on_storefront'
  | 'base_currency_code'
  | 'base_link_url'
  | 'base_media_url'
  | 'base_static_url'
  | 'base_url'
  | 'cart_expires_in_days'
  | 'cart_summary_display_quantity'
  | 'catalog_default_sort_by'
  | 'category_fixed_product_tax_display_setting'
  | 'category_url_suffix'
  | 'check_money_order_enable_for_specific_countries'
  | 'check_money_order_enabled'
  | 'check_money_order_make_check_payable_to'
  | 'check_money_order_max_order_total'
  | 'check_money_order_min_order_total'
  | 'check_money_order_new_order_status'
  | 'check_money_order_payment_from_specific_countries'
  | 'check_money_order_send_check_to'
  | 'check_money_order_sort_order'
  | 'check_money_order_title'
  | 'cms_home_page'
  | 'cms_no_cookies'
  | 'cms_no_route'
  | 'code'
  | 'configurable_thumbnail_source'
  | 'contact_enabled'
  | 'copyright'
  | 'countries_with_required_region'
  | 'create_account_confirmation'
  | 'customer_access_token_lifetime'
  | 'default_country'
  | 'default_description'
  | 'default_display_currency_code'
  | 'default_keywords'
  | 'default_title'
  | 'demonotice'
  | 'display_state_if_optional'
  | 'front'
  | 'grid_per_page'
  | 'grid_per_page_values'
  | 'head_includes'
  | 'head_shortcut_icon'
  | 'header_logo_src'
  | 'id'
  | 'is_default_store'
  | 'is_default_store_group'
  | 'is_guest_checkout_enabled'
  | 'is_one_page_checkout_enabled'
  | 'list_mode'
  | 'list_per_page'
  | 'list_per_page_values'
  | 'locale'
  | 'logo_alt'
  | 'logo_height'
  | 'logo_width'
  | 'magento_wishlist_general_is_enabled'
  | 'max_items_in_order_summary'
  | 'minicart_display'
  | 'minicart_max_items'
  | 'minimum_password_length'
  | 'newsletter_enabled'
  | 'no_route'
  | 'optional_zip_countries'
  | 'order_cancellation_enabled'
  | 'order_cancellation_reasons'
  | 'product_fixed_product_tax_display_setting'
  | 'product_url_suffix'
  | 'required_character_classes_number'
  | 'root_category_id'
  | 'root_category_uid'
  | 'sales_fixed_product_tax_display_setting'
  | 'secure_base_link_url'
  | 'secure_base_media_url'
  | 'secure_base_static_url'
  | 'secure_base_url'
  | 'shopping_cart_display_full_summary'
  | 'shopping_cart_display_grand_total'
  | 'shopping_cart_display_price'
  | 'shopping_cart_display_shipping'
  | 'shopping_cart_display_subtotal'
  | 'shopping_cart_display_tax_gift_wrapping'
  | 'shopping_cart_display_zero_tax'
  | 'show_cms_breadcrumbs'
  | 'store_code'
  | 'store_group_code'
  | 'store_group_name'
  | 'store_name'
  | 'store_sort_order'
  | 'timezone'
  | 'title_prefix'
  | 'title_separator'
  | 'title_suffix'
  | 'use_store_in_url'
  | 'website_code'
  | 'website_id'
  | 'website_name'
  | 'weight_unit'
  | 'welcome'
  | 'zero_subtotal_enable_for_specific_countries'
  | 'zero_subtotal_enabled'
  | 'zero_subtotal_new_order_status'
  | 'zero_subtotal_payment_action'
  | 'zero_subtotal_payment_from_specific_countries'
  | 'zero_subtotal_sort_order'
  | 'zero_subtotal_title'
  | StoreConfigKeySpecifier
)[];
export type StoreConfigFieldPolicy = {
  absolute_footer?: FieldPolicy<any> | FieldReadFunction<any>;
  autocomplete_on_storefront?: FieldPolicy<any> | FieldReadFunction<any>;
  base_currency_code?: FieldPolicy<any> | FieldReadFunction<any>;
  base_link_url?: FieldPolicy<any> | FieldReadFunction<any>;
  base_media_url?: FieldPolicy<any> | FieldReadFunction<any>;
  base_static_url?: FieldPolicy<any> | FieldReadFunction<any>;
  base_url?: FieldPolicy<any> | FieldReadFunction<any>;
  cart_expires_in_days?: FieldPolicy<any> | FieldReadFunction<any>;
  cart_summary_display_quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  catalog_default_sort_by?: FieldPolicy<any> | FieldReadFunction<any>;
  category_fixed_product_tax_display_setting?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  category_url_suffix?: FieldPolicy<any> | FieldReadFunction<any>;
  check_money_order_enable_for_specific_countries?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  check_money_order_enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  check_money_order_make_check_payable_to?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  check_money_order_max_order_total?: FieldPolicy<any> | FieldReadFunction<any>;
  check_money_order_min_order_total?: FieldPolicy<any> | FieldReadFunction<any>;
  check_money_order_new_order_status?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  check_money_order_payment_from_specific_countries?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  check_money_order_send_check_to?: FieldPolicy<any> | FieldReadFunction<any>;
  check_money_order_sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  check_money_order_title?: FieldPolicy<any> | FieldReadFunction<any>;
  cms_home_page?: FieldPolicy<any> | FieldReadFunction<any>;
  cms_no_cookies?: FieldPolicy<any> | FieldReadFunction<any>;
  cms_no_route?: FieldPolicy<any> | FieldReadFunction<any>;
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  configurable_thumbnail_source?: FieldPolicy<any> | FieldReadFunction<any>;
  contact_enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  copyright?: FieldPolicy<any> | FieldReadFunction<any>;
  countries_with_required_region?: FieldPolicy<any> | FieldReadFunction<any>;
  create_account_confirmation?: FieldPolicy<any> | FieldReadFunction<any>;
  customer_access_token_lifetime?: FieldPolicy<any> | FieldReadFunction<any>;
  default_country?: FieldPolicy<any> | FieldReadFunction<any>;
  default_description?: FieldPolicy<any> | FieldReadFunction<any>;
  default_display_currency_code?: FieldPolicy<any> | FieldReadFunction<any>;
  default_keywords?: FieldPolicy<any> | FieldReadFunction<any>;
  default_title?: FieldPolicy<any> | FieldReadFunction<any>;
  demonotice?: FieldPolicy<any> | FieldReadFunction<any>;
  display_state_if_optional?: FieldPolicy<any> | FieldReadFunction<any>;
  front?: FieldPolicy<any> | FieldReadFunction<any>;
  grid_per_page?: FieldPolicy<any> | FieldReadFunction<any>;
  grid_per_page_values?: FieldPolicy<any> | FieldReadFunction<any>;
  head_includes?: FieldPolicy<any> | FieldReadFunction<any>;
  head_shortcut_icon?: FieldPolicy<any> | FieldReadFunction<any>;
  header_logo_src?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  is_default_store?: FieldPolicy<any> | FieldReadFunction<any>;
  is_default_store_group?: FieldPolicy<any> | FieldReadFunction<any>;
  is_guest_checkout_enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  is_one_page_checkout_enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  list_mode?: FieldPolicy<any> | FieldReadFunction<any>;
  list_per_page?: FieldPolicy<any> | FieldReadFunction<any>;
  list_per_page_values?: FieldPolicy<any> | FieldReadFunction<any>;
  locale?: FieldPolicy<any> | FieldReadFunction<any>;
  logo_alt?: FieldPolicy<any> | FieldReadFunction<any>;
  logo_height?: FieldPolicy<any> | FieldReadFunction<any>;
  logo_width?: FieldPolicy<any> | FieldReadFunction<any>;
  magento_wishlist_general_is_enabled?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  max_items_in_order_summary?: FieldPolicy<any> | FieldReadFunction<any>;
  minicart_display?: FieldPolicy<any> | FieldReadFunction<any>;
  minicart_max_items?: FieldPolicy<any> | FieldReadFunction<any>;
  minimum_password_length?: FieldPolicy<any> | FieldReadFunction<any>;
  newsletter_enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  no_route?: FieldPolicy<any> | FieldReadFunction<any>;
  optional_zip_countries?: FieldPolicy<any> | FieldReadFunction<any>;
  order_cancellation_enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  order_cancellation_reasons?: FieldPolicy<any> | FieldReadFunction<any>;
  product_fixed_product_tax_display_setting?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  product_url_suffix?: FieldPolicy<any> | FieldReadFunction<any>;
  required_character_classes_number?: FieldPolicy<any> | FieldReadFunction<any>;
  root_category_id?: FieldPolicy<any> | FieldReadFunction<any>;
  root_category_uid?: FieldPolicy<any> | FieldReadFunction<any>;
  sales_fixed_product_tax_display_setting?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  secure_base_link_url?: FieldPolicy<any> | FieldReadFunction<any>;
  secure_base_media_url?: FieldPolicy<any> | FieldReadFunction<any>;
  secure_base_static_url?: FieldPolicy<any> | FieldReadFunction<any>;
  secure_base_url?: FieldPolicy<any> | FieldReadFunction<any>;
  shopping_cart_display_full_summary?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  shopping_cart_display_grand_total?: FieldPolicy<any> | FieldReadFunction<any>;
  shopping_cart_display_price?: FieldPolicy<any> | FieldReadFunction<any>;
  shopping_cart_display_shipping?: FieldPolicy<any> | FieldReadFunction<any>;
  shopping_cart_display_subtotal?: FieldPolicy<any> | FieldReadFunction<any>;
  shopping_cart_display_tax_gift_wrapping?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  shopping_cart_display_zero_tax?: FieldPolicy<any> | FieldReadFunction<any>;
  show_cms_breadcrumbs?: FieldPolicy<any> | FieldReadFunction<any>;
  store_code?: FieldPolicy<any> | FieldReadFunction<any>;
  store_group_code?: FieldPolicy<any> | FieldReadFunction<any>;
  store_group_name?: FieldPolicy<any> | FieldReadFunction<any>;
  store_name?: FieldPolicy<any> | FieldReadFunction<any>;
  store_sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  timezone?: FieldPolicy<any> | FieldReadFunction<any>;
  title_prefix?: FieldPolicy<any> | FieldReadFunction<any>;
  title_separator?: FieldPolicy<any> | FieldReadFunction<any>;
  title_suffix?: FieldPolicy<any> | FieldReadFunction<any>;
  use_store_in_url?: FieldPolicy<any> | FieldReadFunction<any>;
  website_code?: FieldPolicy<any> | FieldReadFunction<any>;
  website_id?: FieldPolicy<any> | FieldReadFunction<any>;
  website_name?: FieldPolicy<any> | FieldReadFunction<any>;
  weight_unit?: FieldPolicy<any> | FieldReadFunction<any>;
  welcome?: FieldPolicy<any> | FieldReadFunction<any>;
  zero_subtotal_enable_for_specific_countries?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  zero_subtotal_enabled?: FieldPolicy<any> | FieldReadFunction<any>;
  zero_subtotal_new_order_status?: FieldPolicy<any> | FieldReadFunction<any>;
  zero_subtotal_payment_action?: FieldPolicy<any> | FieldReadFunction<any>;
  zero_subtotal_payment_from_specific_countries?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  zero_subtotal_sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
  zero_subtotal_title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StorefrontPropertiesKeySpecifier = (
  | 'position'
  | 'use_in_layered_navigation'
  | 'use_in_product_listing'
  | 'use_in_search_results_layered_navigation'
  | 'visible_on_catalog_pages'
  | StorefrontPropertiesKeySpecifier
)[];
export type StorefrontPropertiesFieldPolicy = {
  position?: FieldPolicy<any> | FieldReadFunction<any>;
  use_in_layered_navigation?: FieldPolicy<any> | FieldReadFunction<any>;
  use_in_product_listing?: FieldPolicy<any> | FieldReadFunction<any>;
  use_in_search_results_layered_navigation?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  visible_on_catalog_pages?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SubscribeEmailToNewsletterOutputKeySpecifier = (
  | 'status'
  | SubscribeEmailToNewsletterOutputKeySpecifier
)[];
export type SubscribeEmailToNewsletterOutputFieldPolicy = {
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SubscriptionRevisionKeySpecifier = (
  | 'hp_return_shipping_fee_sku'
  | 'hp_upgrade_cutoff_time'
  | 'hp_upgrade_cutoff_time_uom'
  | 'items'
  | 'name'
  | 'sku'
  | SubscriptionRevisionKeySpecifier
)[];
export type SubscriptionRevisionFieldPolicy = {
  hp_return_shipping_fee_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_upgrade_cutoff_time?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_upgrade_cutoff_time_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SwatchDataKeySpecifier = (
  | 'type'
  | 'value'
  | SwatchDataKeySpecifier
)[];
export type SwatchDataFieldPolicy = {
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SwatchDataInterfaceKeySpecifier = (
  | 'value'
  | SwatchDataInterfaceKeySpecifier
)[];
export type SwatchDataInterfaceFieldPolicy = {
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SwatchLayerFilterItemKeySpecifier = (
  | 'items_count'
  | 'label'
  | 'swatch_data'
  | 'value_string'
  | SwatchLayerFilterItemKeySpecifier
)[];
export type SwatchLayerFilterItemFieldPolicy = {
  items_count?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  swatch_data?: FieldPolicy<any> | FieldReadFunction<any>;
  value_string?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SwatchLayerFilterItemInterfaceKeySpecifier = (
  | 'swatch_data'
  | SwatchLayerFilterItemInterfaceKeySpecifier
)[];
export type SwatchLayerFilterItemInterfaceFieldPolicy = {
  swatch_data?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TaxItemKeySpecifier = (
  | 'amount'
  | 'rate'
  | 'title'
  | TaxItemKeySpecifier
)[];
export type TaxItemFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  rate?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TextSwatchDataKeySpecifier = (
  | 'value'
  | TextSwatchDataKeySpecifier
)[];
export type TextSwatchDataFieldPolicy = {
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TierPriceKeySpecifier = (
  | 'discount'
  | 'final_price'
  | 'quantity'
  | TierPriceKeySpecifier
)[];
export type TierPriceFieldPolicy = {
  discount?: FieldPolicy<any> | FieldReadFunction<any>;
  final_price?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateCartItemsOutputKeySpecifier = (
  | 'cart'
  | UpdateCartItemsOutputKeySpecifier
)[];
export type UpdateCartItemsOutputFieldPolicy = {
  cart?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdatePaymentMethodCvvOutputKeySpecifier = (
  | 'payment_method_id'
  | UpdatePaymentMethodCvvOutputKeySpecifier
)[];
export type UpdatePaymentMethodCvvOutputFieldPolicy = {
  payment_method_id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UpdateProductsInWishlistOutputKeySpecifier = (
  | 'user_errors'
  | 'wishlist'
  | UpdateProductsInWishlistOutputKeySpecifier
)[];
export type UpdateProductsInWishlistOutputFieldPolicy = {
  user_errors?: FieldPolicy<any> | FieldReadFunction<any>;
  wishlist?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UrlRewriteKeySpecifier = (
  | 'parameters'
  | 'url'
  | UrlRewriteKeySpecifier
)[];
export type UrlRewriteFieldPolicy = {
  parameters?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserErrorKeySpecifier = (
  | 'code'
  | 'message'
  | UserErrorKeySpecifier
)[];
export type UserErrorFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ValidationRuleKeySpecifier = (
  | 'message'
  | 'name'
  | 'type'
  | 'value'
  | ValidationRuleKeySpecifier
)[];
export type ValidationRuleFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ValidationSchemaKeySpecifier = (
  | 'forms'
  | ValidationSchemaKeySpecifier
)[];
export type ValidationSchemaFieldPolicy = {
  forms?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VirtualCartItemKeySpecifier = (
  | 'customizable_options'
  | 'errors'
  | 'id'
  | 'is_available'
  | 'prices'
  | 'product'
  | 'quantity'
  | 'uid'
  | VirtualCartItemKeySpecifier
)[];
export type VirtualCartItemFieldPolicy = {
  customizable_options?: FieldPolicy<any> | FieldReadFunction<any>;
  errors?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  is_available?: FieldPolicy<any> | FieldReadFunction<any>;
  prices?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VirtualProductKeySpecifier = (
  | 'a12345'
  | 'attribute_set_id'
  | 'base_accessories'
  | 'canonical_url'
  | 'categories'
  | 'color'
  | 'country_of_manufacture'
  | 'created_at'
  | 'crosssell_products'
  | 'custom_attributesV2'
  | 'description'
  | 'gift_message_available'
  | 'hp_allowed_payment_type'
  | 'hp_allowed_payment_type_label'
  | 'hp_as_low_as_price'
  | 'hp_auto_renewal'
  | 'hp_billing_cycle'
  | 'hp_billing_cycle_uom'
  | 'hp_billing_cycle_uom_label'
  | 'hp_billing_period'
  | 'hp_billing_period_label'
  | 'hp_bundle_lease_type'
  | 'hp_bundle_type'
  | 'hp_bundle_type_label'
  | 'hp_can_be_ordered_individually'
  | 'hp_cancellation_json'
  | 'hp_charge_type'
  | 'hp_charge_type_label'
  | 'hp_contract_duration'
  | 'hp_contract_duration_uom'
  | 'hp_contract_duration_uom_label'
  | 'hp_delivery_method'
  | 'hp_delivery_method_label'
  | 'hp_disclaimer'
  | 'hp_downgrade_cost_change'
  | 'hp_early_accessibility'
  | 'hp_eligibility_ruleset_id'
  | 'hp_external_product_id'
  | 'hp_fair_market_value'
  | 'hp_initial_hpone_subscription_cost'
  | 'hp_is_popular'
  | 'hp_lease_fmv'
  | 'hp_lease_type'
  | 'hp_limit_per_org'
  | 'hp_marketing_name'
  | 'hp_max_days_to_return'
  | 'hp_max_rollover_pages'
  | 'hp_model_name'
  | 'hp_model_purpose'
  | 'hp_offer_type'
  | 'hp_offer_type_label'
  | 'hp_order_type'
  | 'hp_overage_block_price'
  | 'hp_overage_block_size'
  | 'hp_overage_block_uom'
  | 'hp_pages_per_month'
  | 'hp_partner_fmvs'
  | 'hp_plan_change_freeze_period'
  | 'hp_plan_change_freeze_period_uom'
  | 'hp_plan_change_freeze_period_uom_label'
  | 'hp_price_type'
  | 'hp_price_type_label'
  | 'hp_product_full_specification'
  | 'hp_product_number'
  | 'hp_product_type'
  | 'hp_product_type_label'
  | 'hp_return_json'
  | 'hp_return_shipping_fee_sku'
  | 'hp_rollover_pages'
  | 'hp_short_config_name'
  | 'hp_solution_id'
  | 'hp_source_system'
  | 'hp_specifications_json'
  | 'hp_storage_amount'
  | 'hp_storage_uom'
  | 'hp_storage_uom_label'
  | 'hp_storefront_group'
  | 'hp_storefront_group_label'
  | 'hp_supply_type'
  | 'hp_supply_type_label'
  | 'hp_support_coverage_included_with_hw'
  | 'hp_support_coverage_included_with_hw_label'
  | 'hp_tokens_count'
  | 'hp_trial_duration'
  | 'hp_trial_duration_unit'
  | 'hp_trial_duration_unit_label'
  | 'hp_trial_pages_per_month'
  | 'hp_trial_price'
  | 'hp_unit_of_measure'
  | 'hp_unit_of_measure_label'
  | 'hp_updated_hpone_subscription_cost'
  | 'hp_upgrade_cost_change'
  | 'id'
  | 'image'
  | 'manufacturer'
  | 'media_gallery'
  | 'media_gallery_entries'
  | 'meta_description'
  | 'meta_keyword'
  | 'meta_title'
  | 'name'
  | 'new_from_date'
  | 'new_to_date'
  | 'only_x_left_in_stock'
  | 'operational_system'
  | 'options'
  | 'options_container'
  | 'price'
  | 'price_range'
  | 'price_tiers'
  | 'product_links'
  | 'redirect_code'
  | 'related_products'
  | 'relative_url'
  | 'short_description'
  | 'sku'
  | 'small_accessories'
  | 'small_image'
  | 'special_from_date'
  | 'special_price'
  | 'special_to_date'
  | 'staged'
  | 'stock_status'
  | 'storage'
  | 'swatch_image'
  | 'thumbnail'
  | 'thumbnail_accessories'
  | 'tier_price'
  | 'tier_prices'
  | 'type'
  | 'type_id'
  | 'uid'
  | 'updated_at'
  | 'upsell_products'
  | 'url_key'
  | 'url_path'
  | 'url_rewrites'
  | 'url_suffix'
  | 'usage'
  | 'websites'
  | VirtualProductKeySpecifier
)[];
export type VirtualProductFieldPolicy = {
  a12345?: FieldPolicy<any> | FieldReadFunction<any>;
  attribute_set_id?: FieldPolicy<any> | FieldReadFunction<any>;
  base_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  canonical_url?: FieldPolicy<any> | FieldReadFunction<any>;
  categories?: FieldPolicy<any> | FieldReadFunction<any>;
  color?: FieldPolicy<any> | FieldReadFunction<any>;
  country_of_manufacture?: FieldPolicy<any> | FieldReadFunction<any>;
  created_at?: FieldPolicy<any> | FieldReadFunction<any>;
  crosssell_products?: FieldPolicy<any> | FieldReadFunction<any>;
  custom_attributesV2?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  gift_message_available?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_allowed_payment_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_allowed_payment_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_as_low_as_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_auto_renewal?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_cycle_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_period?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_billing_period_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_lease_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_bundle_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_can_be_ordered_individually?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_cancellation_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_charge_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_charge_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_contract_duration_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_delivery_method?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_delivery_method_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_disclaimer?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_downgrade_cost_change?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_early_accessibility?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_eligibility_ruleset_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_external_product_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_fair_market_value?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_initial_hpone_subscription_cost?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_is_popular?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_lease_fmv?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_lease_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_limit_per_org?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_marketing_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_max_days_to_return?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_max_rollover_pages?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_model_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_model_purpose?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_offer_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_offer_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_order_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_size?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_overage_block_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_pages_per_month?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_partner_fmvs?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_plan_change_freeze_period_uom_label?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_price_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_price_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_full_specification?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_number?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_product_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_return_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_return_shipping_fee_sku?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_rollover_pages?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_short_config_name?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_solution_id?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_source_system?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_specifications_json?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_amount?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_uom?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storage_uom_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storefront_group?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_storefront_group_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_supply_type?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_supply_type_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_support_coverage_included_with_hw?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_support_coverage_included_with_hw_label?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_tokens_count?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration_unit?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_duration_unit_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_pages_per_month?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_trial_price?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_unit_of_measure?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_unit_of_measure_label?: FieldPolicy<any> | FieldReadFunction<any>;
  hp_updated_hpone_subscription_cost?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  hp_upgrade_cost_change?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  image?: FieldPolicy<any> | FieldReadFunction<any>;
  manufacturer?: FieldPolicy<any> | FieldReadFunction<any>;
  media_gallery?: FieldPolicy<any> | FieldReadFunction<any>;
  media_gallery_entries?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_description?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_keyword?: FieldPolicy<any> | FieldReadFunction<any>;
  meta_title?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  new_from_date?: FieldPolicy<any> | FieldReadFunction<any>;
  new_to_date?: FieldPolicy<any> | FieldReadFunction<any>;
  only_x_left_in_stock?: FieldPolicy<any> | FieldReadFunction<any>;
  operational_system?: FieldPolicy<any> | FieldReadFunction<any>;
  options?: FieldPolicy<any> | FieldReadFunction<any>;
  options_container?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  price_range?: FieldPolicy<any> | FieldReadFunction<any>;
  price_tiers?: FieldPolicy<any> | FieldReadFunction<any>;
  product_links?: FieldPolicy<any> | FieldReadFunction<any>;
  redirect_code?: FieldPolicy<any> | FieldReadFunction<any>;
  related_products?: FieldPolicy<any> | FieldReadFunction<any>;
  relative_url?: FieldPolicy<any> | FieldReadFunction<any>;
  short_description?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  small_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  small_image?: FieldPolicy<any> | FieldReadFunction<any>;
  special_from_date?: FieldPolicy<any> | FieldReadFunction<any>;
  special_price?: FieldPolicy<any> | FieldReadFunction<any>;
  special_to_date?: FieldPolicy<any> | FieldReadFunction<any>;
  staged?: FieldPolicy<any> | FieldReadFunction<any>;
  stock_status?: FieldPolicy<any> | FieldReadFunction<any>;
  storage?: FieldPolicy<any> | FieldReadFunction<any>;
  swatch_image?: FieldPolicy<any> | FieldReadFunction<any>;
  thumbnail?: FieldPolicy<any> | FieldReadFunction<any>;
  thumbnail_accessories?: FieldPolicy<any> | FieldReadFunction<any>;
  tier_price?: FieldPolicy<any> | FieldReadFunction<any>;
  tier_prices?: FieldPolicy<any> | FieldReadFunction<any>;
  type?: FieldPolicy<any> | FieldReadFunction<any>;
  type_id?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  updated_at?: FieldPolicy<any> | FieldReadFunction<any>;
  upsell_products?: FieldPolicy<any> | FieldReadFunction<any>;
  url_key?: FieldPolicy<any> | FieldReadFunction<any>;
  url_path?: FieldPolicy<any> | FieldReadFunction<any>;
  url_rewrites?: FieldPolicy<any> | FieldReadFunction<any>;
  url_suffix?: FieldPolicy<any> | FieldReadFunction<any>;
  usage?: FieldPolicy<any> | FieldReadFunction<any>;
  websites?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type VirtualWishlistItemKeySpecifier = (
  | 'added_at'
  | 'customizable_options'
  | 'description'
  | 'id'
  | 'product'
  | 'quantity'
  | VirtualWishlistItemKeySpecifier
)[];
export type VirtualWishlistItemFieldPolicy = {
  added_at?: FieldPolicy<any> | FieldReadFunction<any>;
  customizable_options?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WebsiteKeySpecifier = (
  | 'code'
  | 'default_group_id'
  | 'id'
  | 'is_default'
  | 'name'
  | 'sort_order'
  | WebsiteKeySpecifier
)[];
export type WebsiteFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  default_group_id?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  is_default?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  sort_order?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WishListUserInputErrorKeySpecifier = (
  | 'code'
  | 'message'
  | WishListUserInputErrorKeySpecifier
)[];
export type WishListUserInputErrorFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WishlistKeySpecifier = (
  | 'id'
  | 'items'
  | 'items_count'
  | 'items_v2'
  | 'sharing_code'
  | 'updated_at'
  | WishlistKeySpecifier
)[];
export type WishlistFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  items_count?: FieldPolicy<any> | FieldReadFunction<any>;
  items_v2?: FieldPolicy<any> | FieldReadFunction<any>;
  sharing_code?: FieldPolicy<any> | FieldReadFunction<any>;
  updated_at?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WishlistCartUserInputErrorKeySpecifier = (
  | 'code'
  | 'message'
  | 'wishlistId'
  | 'wishlistItemId'
  | WishlistCartUserInputErrorKeySpecifier
)[];
export type WishlistCartUserInputErrorFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>;
  message?: FieldPolicy<any> | FieldReadFunction<any>;
  wishlistId?: FieldPolicy<any> | FieldReadFunction<any>;
  wishlistItemId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WishlistItemKeySpecifier = (
  | 'added_at'
  | 'description'
  | 'id'
  | 'product'
  | 'qty'
  | WishlistItemKeySpecifier
)[];
export type WishlistItemFieldPolicy = {
  added_at?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  qty?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WishlistItemInterfaceKeySpecifier = (
  | 'added_at'
  | 'customizable_options'
  | 'description'
  | 'id'
  | 'product'
  | 'quantity'
  | WishlistItemInterfaceKeySpecifier
)[];
export type WishlistItemInterfaceFieldPolicy = {
  added_at?: FieldPolicy<any> | FieldReadFunction<any>;
  customizable_options?: FieldPolicy<any> | FieldReadFunction<any>;
  description?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  product?: FieldPolicy<any> | FieldReadFunction<any>;
  quantity?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WishlistItemsKeySpecifier = (
  | 'items'
  | 'page_info'
  | WishlistItemsKeySpecifier
)[];
export type WishlistItemsFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  page_info?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WishlistOutputKeySpecifier = (
  | 'items'
  | 'items_count'
  | 'name'
  | 'sharing_code'
  | 'updated_at'
  | WishlistOutputKeySpecifier
)[];
export type WishlistOutputFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
  items_count?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  sharing_code?: FieldPolicy<any> | FieldReadFunction<any>;
  updated_at?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WsRegFeesKeySpecifier = (
  | 'total_battery_fee_for_products'
  | 'total_chemical_fee_for_products'
  | 'total_copyright_fee_for_products'
  | 'total_recycle_fee_for_products'
  | WsRegFeesKeySpecifier
)[];
export type WsRegFeesFieldPolicy = {
  total_battery_fee_for_products?: FieldPolicy<any> | FieldReadFunction<any>;
  total_chemical_fee_for_products?: FieldPolicy<any> | FieldReadFunction<any>;
  total_copyright_fee_for_products?: FieldPolicy<any> | FieldReadFunction<any>;
  total_recycle_fee_for_products?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WsregOrderKeySpecifier = (
  | 'total_battery_fee_for_products'
  | 'total_chemical_fee_for_products'
  | 'total_copyright_fee_for_products'
  | 'total_recycle_fee_for_products'
  | 'wsreg_order_item'
  | WsregOrderKeySpecifier
)[];
export type WsregOrderFieldPolicy = {
  total_battery_fee_for_products?: FieldPolicy<any> | FieldReadFunction<any>;
  total_chemical_fee_for_products?: FieldPolicy<any> | FieldReadFunction<any>;
  total_copyright_fee_for_products?: FieldPolicy<any> | FieldReadFunction<any>;
  total_recycle_fee_for_products?: FieldPolicy<any> | FieldReadFunction<any>;
  wsreg_order_item?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WsregOrderItemKeySpecifier = (
  | 'battery_fee_type_code'
  | 'chemical_fee_type_code'
  | 'copyright_fee_type_code'
  | 'label'
  | 'qty'
  | 'recycle_fee_type_code'
  | 'sku'
  | 'total_battery_fee_for_product'
  | 'total_chemical_fee_for_product'
  | 'total_copyright_fee_for_product'
  | 'total_recycle_fee_for_product'
  | WsregOrderItemKeySpecifier
)[];
export type WsregOrderItemFieldPolicy = {
  battery_fee_type_code?: FieldPolicy<any> | FieldReadFunction<any>;
  chemical_fee_type_code?: FieldPolicy<any> | FieldReadFunction<any>;
  copyright_fee_type_code?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  qty?: FieldPolicy<any> | FieldReadFunction<any>;
  recycle_fee_type_code?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  total_battery_fee_for_product?: FieldPolicy<any> | FieldReadFunction<any>;
  total_chemical_fee_for_product?: FieldPolicy<any> | FieldReadFunction<any>;
  total_copyright_fee_for_product?: FieldPolicy<any> | FieldReadFunction<any>;
  total_recycle_fee_for_product?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WsregQuoteKeySpecifier = (
  | 'total_battery_fee_for_products'
  | 'total_chemical_fee_for_products'
  | 'total_copyright_fee_for_products'
  | 'total_recycle_fee_for_products'
  | 'wsreg_quote_item'
  | WsregQuoteKeySpecifier
)[];
export type WsregQuoteFieldPolicy = {
  total_battery_fee_for_products?: FieldPolicy<any> | FieldReadFunction<any>;
  total_chemical_fee_for_products?: FieldPolicy<any> | FieldReadFunction<any>;
  total_copyright_fee_for_products?: FieldPolicy<any> | FieldReadFunction<any>;
  total_recycle_fee_for_products?: FieldPolicy<any> | FieldReadFunction<any>;
  wsreg_quote_item?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type WsregQuoteItemKeySpecifier = (
  | 'battery_fee_type_code'
  | 'chemical_fee_type_code'
  | 'copyright_fee_type_code'
  | 'label'
  | 'qty'
  | 'recycle_fee_type_code'
  | 'sku'
  | 'total_battery_fee_for_product'
  | 'total_chemical_fee_for_product'
  | 'total_copyright_fee_for_product'
  | 'total_recycle_fee_for_product'
  | WsregQuoteItemKeySpecifier
)[];
export type WsregQuoteItemFieldPolicy = {
  battery_fee_type_code?: FieldPolicy<any> | FieldReadFunction<any>;
  chemical_fee_type_code?: FieldPolicy<any> | FieldReadFunction<any>;
  copyright_fee_type_code?: FieldPolicy<any> | FieldReadFunction<any>;
  label?: FieldPolicy<any> | FieldReadFunction<any>;
  qty?: FieldPolicy<any> | FieldReadFunction<any>;
  recycle_fee_type_code?: FieldPolicy<any> | FieldReadFunction<any>;
  sku?: FieldPolicy<any> | FieldReadFunction<any>;
  total_battery_fee_for_product?: FieldPolicy<any> | FieldReadFunction<any>;
  total_chemical_fee_for_product?: FieldPolicy<any> | FieldReadFunction<any>;
  total_copyright_fee_for_product?: FieldPolicy<any> | FieldReadFunction<any>;
  total_recycle_fee_for_product?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StrictTypedTypePolicies = {
  AddBundleProductsToCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddBundleProductsToCartOutputKeySpecifier
      | (() => undefined | AddBundleProductsToCartOutputKeySpecifier);
    fields?: AddBundleProductsToCartOutputFieldPolicy;
  };
  AddConfigurableProductsToCartOutput?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | AddConfigurableProductsToCartOutputKeySpecifier
      | (() => undefined | AddConfigurableProductsToCartOutputKeySpecifier);
    fields?: AddConfigurableProductsToCartOutputFieldPolicy;
  };
  AddPaperToCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddPaperToCartOutputKeySpecifier
      | (() => undefined | AddPaperToCartOutputKeySpecifier);
    fields?: AddPaperToCartOutputFieldPolicy;
  };
  AddProductsToCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddProductsToCartOutputKeySpecifier
      | (() => undefined | AddProductsToCartOutputKeySpecifier);
    fields?: AddProductsToCartOutputFieldPolicy;
  };
  AddProductsToWishlistOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddProductsToWishlistOutputKeySpecifier
      | (() => undefined | AddProductsToWishlistOutputKeySpecifier);
    fields?: AddProductsToWishlistOutputFieldPolicy;
  };
  AddSimpleProductsToCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddSimpleProductsToCartOutputKeySpecifier
      | (() => undefined | AddSimpleProductsToCartOutputKeySpecifier);
    fields?: AddSimpleProductsToCartOutputFieldPolicy;
  };
  AddVirtualProductsToCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddVirtualProductsToCartOutputKeySpecifier
      | (() => undefined | AddVirtualProductsToCartOutputKeySpecifier);
    fields?: AddVirtualProductsToCartOutputFieldPolicy;
  };
  AddWishlistItemsToCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddWishlistItemsToCartOutputKeySpecifier
      | (() => undefined | AddWishlistItemsToCartOutputKeySpecifier);
    fields?: AddWishlistItemsToCartOutputFieldPolicy;
  };
  Aggregation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AggregationKeySpecifier
      | (() => undefined | AggregationKeySpecifier);
    fields?: AggregationFieldPolicy;
  };
  AggregationOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AggregationOptionKeySpecifier
      | (() => undefined | AggregationOptionKeySpecifier);
    fields?: AggregationOptionFieldPolicy;
  };
  AggregationOptionInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AggregationOptionInterfaceKeySpecifier
      | (() => undefined | AggregationOptionInterfaceKeySpecifier);
    fields?: AggregationOptionInterfaceFieldPolicy;
  };
  Amount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AmountKeySpecifier
      | (() => undefined | AmountKeySpecifier);
    fields?: AmountFieldPolicy;
  };
  AppliedCoupon?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppliedCouponKeySpecifier
      | (() => undefined | AppliedCouponKeySpecifier);
    fields?: AppliedCouponFieldPolicy;
  };
  ApplyCouponToCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ApplyCouponToCartOutputKeySpecifier
      | (() => undefined | ApplyCouponToCartOutputKeySpecifier);
    fields?: ApplyCouponToCartOutputFieldPolicy;
  };
  Attribute?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AttributeKeySpecifier
      | (() => undefined | AttributeKeySpecifier);
    fields?: AttributeFieldPolicy;
  };
  AttributeMetadata?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AttributeMetadataKeySpecifier
      | (() => undefined | AttributeMetadataKeySpecifier);
    fields?: AttributeMetadataFieldPolicy;
  };
  AttributeMetadataError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AttributeMetadataErrorKeySpecifier
      | (() => undefined | AttributeMetadataErrorKeySpecifier);
    fields?: AttributeMetadataErrorFieldPolicy;
  };
  AttributeOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AttributeOptionKeySpecifier
      | (() => undefined | AttributeOptionKeySpecifier);
    fields?: AttributeOptionFieldPolicy;
  };
  AttributeOptionMetadata?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AttributeOptionMetadataKeySpecifier
      | (() => undefined | AttributeOptionMetadataKeySpecifier);
    fields?: AttributeOptionMetadataFieldPolicy;
  };
  AttributeSelectedOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AttributeSelectedOptionKeySpecifier
      | (() => undefined | AttributeSelectedOptionKeySpecifier);
    fields?: AttributeSelectedOptionFieldPolicy;
  };
  AttributeSelectedOptionInterface?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | AttributeSelectedOptionInterfaceKeySpecifier
      | (() => undefined | AttributeSelectedOptionInterfaceKeySpecifier);
    fields?: AttributeSelectedOptionInterfaceFieldPolicy;
  };
  AttributeSelectedOptions?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AttributeSelectedOptionsKeySpecifier
      | (() => undefined | AttributeSelectedOptionsKeySpecifier);
    fields?: AttributeSelectedOptionsFieldPolicy;
  };
  AttributeValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AttributeValueKeySpecifier
      | (() => undefined | AttributeValueKeySpecifier);
    fields?: AttributeValueFieldPolicy;
  };
  AttributeValueInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AttributeValueInterfaceKeySpecifier
      | (() => undefined | AttributeValueInterfaceKeySpecifier);
    fields?: AttributeValueInterfaceFieldPolicy;
  };
  AttributesFormOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AttributesFormOutputKeySpecifier
      | (() => undefined | AttributesFormOutputKeySpecifier);
    fields?: AttributesFormOutputFieldPolicy;
  };
  AttributesMetadataOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AttributesMetadataOutputKeySpecifier
      | (() => undefined | AttributesMetadataOutputKeySpecifier);
    fields?: AttributesMetadataOutputFieldPolicy;
  };
  AvailablePaymentMethod?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AvailablePaymentMethodKeySpecifier
      | (() => undefined | AvailablePaymentMethodKeySpecifier);
    fields?: AvailablePaymentMethodFieldPolicy;
  };
  AvailableShippingMethod?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AvailableShippingMethodKeySpecifier
      | (() => undefined | AvailableShippingMethodKeySpecifier);
    fields?: AvailableShippingMethodFieldPolicy;
  };
  BillingCartAddress?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingCartAddressKeySpecifier
      | (() => undefined | BillingCartAddressKeySpecifier);
    fields?: BillingCartAddressFieldPolicy;
  };
  Breadcrumb?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BreadcrumbKeySpecifier
      | (() => undefined | BreadcrumbKeySpecifier);
    fields?: BreadcrumbFieldPolicy;
  };
  BundleCartItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BundleCartItemKeySpecifier
      | (() => undefined | BundleCartItemKeySpecifier);
    fields?: BundleCartItemFieldPolicy;
  };
  BundleCreditMemoItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BundleCreditMemoItemKeySpecifier
      | (() => undefined | BundleCreditMemoItemKeySpecifier);
    fields?: BundleCreditMemoItemFieldPolicy;
  };
  BundleInvoiceItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BundleInvoiceItemKeySpecifier
      | (() => undefined | BundleInvoiceItemKeySpecifier);
    fields?: BundleInvoiceItemFieldPolicy;
  };
  BundleItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BundleItemKeySpecifier
      | (() => undefined | BundleItemKeySpecifier);
    fields?: BundleItemFieldPolicy;
  };
  BundleItemOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BundleItemOptionKeySpecifier
      | (() => undefined | BundleItemOptionKeySpecifier);
    fields?: BundleItemOptionFieldPolicy;
  };
  BundleOrderItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BundleOrderItemKeySpecifier
      | (() => undefined | BundleOrderItemKeySpecifier);
    fields?: BundleOrderItemFieldPolicy;
  };
  BundleProduct?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BundleProductKeySpecifier
      | (() => undefined | BundleProductKeySpecifier);
    fields?: BundleProductFieldPolicy;
  };
  BundleShipmentItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BundleShipmentItemKeySpecifier
      | (() => undefined | BundleShipmentItemKeySpecifier);
    fields?: BundleShipmentItemFieldPolicy;
  };
  BundleWishlistItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BundleWishlistItemKeySpecifier
      | (() => undefined | BundleWishlistItemKeySpecifier);
    fields?: BundleWishlistItemFieldPolicy;
  };
  CancelOrderOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CancelOrderOutputKeySpecifier
      | (() => undefined | CancelOrderOutputKeySpecifier);
    fields?: CancelOrderOutputFieldPolicy;
  };
  CancellationReason?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CancellationReasonKeySpecifier
      | (() => undefined | CancellationReasonKeySpecifier);
    fields?: CancellationReasonFieldPolicy;
  };
  Cart?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | CartKeySpecifier | (() => undefined | CartKeySpecifier);
    fields?: CartFieldPolicy;
  };
  CartAddressCountry?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CartAddressCountryKeySpecifier
      | (() => undefined | CartAddressCountryKeySpecifier);
    fields?: CartAddressCountryFieldPolicy;
  };
  CartAddressInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CartAddressInterfaceKeySpecifier
      | (() => undefined | CartAddressInterfaceKeySpecifier);
    fields?: CartAddressInterfaceFieldPolicy;
  };
  CartAddressRegion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CartAddressRegionKeySpecifier
      | (() => undefined | CartAddressRegionKeySpecifier);
    fields?: CartAddressRegionFieldPolicy;
  };
  CartDiscount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CartDiscountKeySpecifier
      | (() => undefined | CartDiscountKeySpecifier);
    fields?: CartDiscountFieldPolicy;
  };
  CartItemError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CartItemErrorKeySpecifier
      | (() => undefined | CartItemErrorKeySpecifier);
    fields?: CartItemErrorFieldPolicy;
  };
  CartItemInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CartItemInterfaceKeySpecifier
      | (() => undefined | CartItemInterfaceKeySpecifier);
    fields?: CartItemInterfaceFieldPolicy;
  };
  CartItemPrices?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CartItemPricesKeySpecifier
      | (() => undefined | CartItemPricesKeySpecifier);
    fields?: CartItemPricesFieldPolicy;
  };
  CartItemQuantity?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CartItemQuantityKeySpecifier
      | (() => undefined | CartItemQuantityKeySpecifier);
    fields?: CartItemQuantityFieldPolicy;
  };
  CartItemSelectedOptionValuePrice?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | CartItemSelectedOptionValuePriceKeySpecifier
      | (() => undefined | CartItemSelectedOptionValuePriceKeySpecifier);
    fields?: CartItemSelectedOptionValuePriceFieldPolicy;
  };
  CartItems?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CartItemsKeySpecifier
      | (() => undefined | CartItemsKeySpecifier);
    fields?: CartItemsFieldPolicy;
  };
  CartPrices?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CartPricesKeySpecifier
      | (() => undefined | CartPricesKeySpecifier);
    fields?: CartPricesFieldPolicy;
  };
  CartTaxItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CartTaxItemKeySpecifier
      | (() => undefined | CartTaxItemKeySpecifier);
    fields?: CartTaxItemFieldPolicy;
  };
  CartUserInputError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CartUserInputErrorKeySpecifier
      | (() => undefined | CartUserInputErrorKeySpecifier);
    fields?: CartUserInputErrorFieldPolicy;
  };
  CatalogAttributeMetadata?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CatalogAttributeMetadataKeySpecifier
      | (() => undefined | CatalogAttributeMetadataKeySpecifier);
    fields?: CatalogAttributeMetadataFieldPolicy;
  };
  CategoryInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CategoryInterfaceKeySpecifier
      | (() => undefined | CategoryInterfaceKeySpecifier);
    fields?: CategoryInterfaceFieldPolicy;
  };
  CategoryProducts?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CategoryProductsKeySpecifier
      | (() => undefined | CategoryProductsKeySpecifier);
    fields?: CategoryProductsFieldPolicy;
  };
  CategoryResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CategoryResultKeySpecifier
      | (() => undefined | CategoryResultKeySpecifier);
    fields?: CategoryResultFieldPolicy;
  };
  CategoryTree?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CategoryTreeKeySpecifier
      | (() => undefined | CategoryTreeKeySpecifier);
    fields?: CategoryTreeFieldPolicy;
  };
  CheckoutAgreement?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CheckoutAgreementKeySpecifier
      | (() => undefined | CheckoutAgreementKeySpecifier);
    fields?: CheckoutAgreementFieldPolicy;
  };
  CheckoutUserInputError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CheckoutUserInputErrorKeySpecifier
      | (() => undefined | CheckoutUserInputErrorKeySpecifier);
    fields?: CheckoutUserInputErrorFieldPolicy;
  };
  ClearCartError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ClearCartErrorKeySpecifier
      | (() => undefined | ClearCartErrorKeySpecifier);
    fields?: ClearCartErrorFieldPolicy;
  };
  ClearCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ClearCartOutputKeySpecifier
      | (() => undefined | ClearCartOutputKeySpecifier);
    fields?: ClearCartOutputFieldPolicy;
  };
  ClearCustomerCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ClearCustomerCartOutputKeySpecifier
      | (() => undefined | ClearCustomerCartOutputKeySpecifier);
    fields?: ClearCustomerCartOutputFieldPolicy;
  };
  CmsBlock?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CmsBlockKeySpecifier
      | (() => undefined | CmsBlockKeySpecifier);
    fields?: CmsBlockFieldPolicy;
  };
  CmsBlocks?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CmsBlocksKeySpecifier
      | (() => undefined | CmsBlocksKeySpecifier);
    fields?: CmsBlocksFieldPolicy;
  };
  CmsPage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CmsPageKeySpecifier
      | (() => undefined | CmsPageKeySpecifier);
    fields?: CmsPageFieldPolicy;
  };
  ColorSwatchData?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ColorSwatchDataKeySpecifier
      | (() => undefined | ColorSwatchDataKeySpecifier);
    fields?: ColorSwatchDataFieldPolicy;
  };
  ComplexTextValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ComplexTextValueKeySpecifier
      | (() => undefined | ComplexTextValueKeySpecifier);
    fields?: ComplexTextValueFieldPolicy;
  };
  ConfigurableAttributeOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConfigurableAttributeOptionKeySpecifier
      | (() => undefined | ConfigurableAttributeOptionKeySpecifier);
    fields?: ConfigurableAttributeOptionFieldPolicy;
  };
  ConfigurableCartItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConfigurableCartItemKeySpecifier
      | (() => undefined | ConfigurableCartItemKeySpecifier);
    fields?: ConfigurableCartItemFieldPolicy;
  };
  ConfigurableOptionAvailableForSelection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ConfigurableOptionAvailableForSelectionKeySpecifier
      | (() => undefined | ConfigurableOptionAvailableForSelectionKeySpecifier);
    fields?: ConfigurableOptionAvailableForSelectionFieldPolicy;
  };
  ConfigurableProduct?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConfigurableProductKeySpecifier
      | (() => undefined | ConfigurableProductKeySpecifier);
    fields?: ConfigurableProductFieldPolicy;
  };
  ConfigurableProductOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConfigurableProductOptionKeySpecifier
      | (() => undefined | ConfigurableProductOptionKeySpecifier);
    fields?: ConfigurableProductOptionFieldPolicy;
  };
  ConfigurableProductOptionValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConfigurableProductOptionValueKeySpecifier
      | (() => undefined | ConfigurableProductOptionValueKeySpecifier);
    fields?: ConfigurableProductOptionValueFieldPolicy;
  };
  ConfigurableProductOptions?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConfigurableProductOptionsKeySpecifier
      | (() => undefined | ConfigurableProductOptionsKeySpecifier);
    fields?: ConfigurableProductOptionsFieldPolicy;
  };
  ConfigurableProductOptionsSelection?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ConfigurableProductOptionsSelectionKeySpecifier
      | (() => undefined | ConfigurableProductOptionsSelectionKeySpecifier);
    fields?: ConfigurableProductOptionsSelectionFieldPolicy;
  };
  ConfigurableProductOptionsValues?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ConfigurableProductOptionsValuesKeySpecifier
      | (() => undefined | ConfigurableProductOptionsValuesKeySpecifier);
    fields?: ConfigurableProductOptionsValuesFieldPolicy;
  };
  ConfigurableVariant?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConfigurableVariantKeySpecifier
      | (() => undefined | ConfigurableVariantKeySpecifier);
    fields?: ConfigurableVariantFieldPolicy;
  };
  ConfigurableWishlistItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConfigurableWishlistItemKeySpecifier
      | (() => undefined | ConfigurableWishlistItemKeySpecifier);
    fields?: ConfigurableWishlistItemFieldPolicy;
  };
  ContactUsOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ContactUsOutputKeySpecifier
      | (() => undefined | ContactUsOutputKeySpecifier);
    fields?: ContactUsOutputFieldPolicy;
  };
  Country?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CountryKeySpecifier
      | (() => undefined | CountryKeySpecifier);
    fields?: CountryFieldPolicy;
  };
  CreateGuestCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateGuestCartOutputKeySpecifier
      | (() => undefined | CreateGuestCartOutputKeySpecifier);
    fields?: CreateGuestCartOutputFieldPolicy;
  };
  CreatePaymentMethodOnCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreatePaymentMethodOnCartOutputKeySpecifier
      | (() => undefined | CreatePaymentMethodOnCartOutputKeySpecifier);
    fields?: CreatePaymentMethodOnCartOutputFieldPolicy;
  };
  CreditMemo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreditMemoKeySpecifier
      | (() => undefined | CreditMemoKeySpecifier);
    fields?: CreditMemoFieldPolicy;
  };
  CreditMemoItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreditMemoItemKeySpecifier
      | (() => undefined | CreditMemoItemKeySpecifier);
    fields?: CreditMemoItemFieldPolicy;
  };
  CreditMemoItemInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreditMemoItemInterfaceKeySpecifier
      | (() => undefined | CreditMemoItemInterfaceKeySpecifier);
    fields?: CreditMemoItemInterfaceFieldPolicy;
  };
  CreditMemoTotal?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreditMemoTotalKeySpecifier
      | (() => undefined | CreditMemoTotalKeySpecifier);
    fields?: CreditMemoTotalFieldPolicy;
  };
  Currency?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CurrencyKeySpecifier
      | (() => undefined | CurrencyKeySpecifier);
    fields?: CurrencyFieldPolicy;
  };
  CustomAttributeMetadata?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomAttributeMetadataKeySpecifier
      | (() => undefined | CustomAttributeMetadataKeySpecifier);
    fields?: CustomAttributeMetadataFieldPolicy;
  };
  CustomAttributeMetadataInterface?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | CustomAttributeMetadataInterfaceKeySpecifier
      | (() => undefined | CustomAttributeMetadataInterfaceKeySpecifier);
    fields?: CustomAttributeMetadataInterfaceFieldPolicy;
  };
  CustomAttributeOptionInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomAttributeOptionInterfaceKeySpecifier
      | (() => undefined | CustomAttributeOptionInterfaceKeySpecifier);
    fields?: CustomAttributeOptionInterfaceFieldPolicy;
  };
  Customer?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerKeySpecifier
      | (() => undefined | CustomerKeySpecifier);
    fields?: CustomerFieldPolicy;
  };
  CustomerAddress?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerAddressKeySpecifier
      | (() => undefined | CustomerAddressKeySpecifier);
    fields?: CustomerAddressFieldPolicy;
  };
  CustomerAddressAttribute?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerAddressAttributeKeySpecifier
      | (() => undefined | CustomerAddressAttributeKeySpecifier);
    fields?: CustomerAddressAttributeFieldPolicy;
  };
  CustomerAddressRegion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerAddressRegionKeySpecifier
      | (() => undefined | CustomerAddressRegionKeySpecifier);
    fields?: CustomerAddressRegionFieldPolicy;
  };
  CustomerAttributeMetadata?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerAttributeMetadataKeySpecifier
      | (() => undefined | CustomerAttributeMetadataKeySpecifier);
    fields?: CustomerAttributeMetadataFieldPolicy;
  };
  CustomerOrder?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerOrderKeySpecifier
      | (() => undefined | CustomerOrderKeySpecifier);
    fields?: CustomerOrderFieldPolicy;
  };
  CustomerOrders?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerOrdersKeySpecifier
      | (() => undefined | CustomerOrdersKeySpecifier);
    fields?: CustomerOrdersFieldPolicy;
  };
  CustomerOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerOutputKeySpecifier
      | (() => undefined | CustomerOutputKeySpecifier);
    fields?: CustomerOutputFieldPolicy;
  };
  CustomerPaymentTokens?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerPaymentTokensKeySpecifier
      | (() => undefined | CustomerPaymentTokensKeySpecifier);
    fields?: CustomerPaymentTokensFieldPolicy;
  };
  CustomerToken?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerTokenKeySpecifier
      | (() => undefined | CustomerTokenKeySpecifier);
    fields?: CustomerTokenFieldPolicy;
  };
  CustomizableAreaOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableAreaOptionKeySpecifier
      | (() => undefined | CustomizableAreaOptionKeySpecifier);
    fields?: CustomizableAreaOptionFieldPolicy;
  };
  CustomizableAreaValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableAreaValueKeySpecifier
      | (() => undefined | CustomizableAreaValueKeySpecifier);
    fields?: CustomizableAreaValueFieldPolicy;
  };
  CustomizableCheckboxOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableCheckboxOptionKeySpecifier
      | (() => undefined | CustomizableCheckboxOptionKeySpecifier);
    fields?: CustomizableCheckboxOptionFieldPolicy;
  };
  CustomizableCheckboxValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableCheckboxValueKeySpecifier
      | (() => undefined | CustomizableCheckboxValueKeySpecifier);
    fields?: CustomizableCheckboxValueFieldPolicy;
  };
  CustomizableDateOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableDateOptionKeySpecifier
      | (() => undefined | CustomizableDateOptionKeySpecifier);
    fields?: CustomizableDateOptionFieldPolicy;
  };
  CustomizableDateValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableDateValueKeySpecifier
      | (() => undefined | CustomizableDateValueKeySpecifier);
    fields?: CustomizableDateValueFieldPolicy;
  };
  CustomizableDropDownOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableDropDownOptionKeySpecifier
      | (() => undefined | CustomizableDropDownOptionKeySpecifier);
    fields?: CustomizableDropDownOptionFieldPolicy;
  };
  CustomizableDropDownValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableDropDownValueKeySpecifier
      | (() => undefined | CustomizableDropDownValueKeySpecifier);
    fields?: CustomizableDropDownValueFieldPolicy;
  };
  CustomizableFieldOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableFieldOptionKeySpecifier
      | (() => undefined | CustomizableFieldOptionKeySpecifier);
    fields?: CustomizableFieldOptionFieldPolicy;
  };
  CustomizableFieldValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableFieldValueKeySpecifier
      | (() => undefined | CustomizableFieldValueKeySpecifier);
    fields?: CustomizableFieldValueFieldPolicy;
  };
  CustomizableFileOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableFileOptionKeySpecifier
      | (() => undefined | CustomizableFileOptionKeySpecifier);
    fields?: CustomizableFileOptionFieldPolicy;
  };
  CustomizableFileValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableFileValueKeySpecifier
      | (() => undefined | CustomizableFileValueKeySpecifier);
    fields?: CustomizableFileValueFieldPolicy;
  };
  CustomizableMultipleOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableMultipleOptionKeySpecifier
      | (() => undefined | CustomizableMultipleOptionKeySpecifier);
    fields?: CustomizableMultipleOptionFieldPolicy;
  };
  CustomizableMultipleValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableMultipleValueKeySpecifier
      | (() => undefined | CustomizableMultipleValueKeySpecifier);
    fields?: CustomizableMultipleValueFieldPolicy;
  };
  CustomizableOptionInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableOptionInterfaceKeySpecifier
      | (() => undefined | CustomizableOptionInterfaceKeySpecifier);
    fields?: CustomizableOptionInterfaceFieldPolicy;
  };
  CustomizableProductInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableProductInterfaceKeySpecifier
      | (() => undefined | CustomizableProductInterfaceKeySpecifier);
    fields?: CustomizableProductInterfaceFieldPolicy;
  };
  CustomizableRadioOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableRadioOptionKeySpecifier
      | (() => undefined | CustomizableRadioOptionKeySpecifier);
    fields?: CustomizableRadioOptionFieldPolicy;
  };
  CustomizableRadioValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomizableRadioValueKeySpecifier
      | (() => undefined | CustomizableRadioValueKeySpecifier);
    fields?: CustomizableRadioValueFieldPolicy;
  };
  DeletePaymentTokenOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeletePaymentTokenOutputKeySpecifier
      | (() => undefined | DeletePaymentTokenOutputKeySpecifier);
    fields?: DeletePaymentTokenOutputFieldPolicy;
  };
  Discount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DiscountKeySpecifier
      | (() => undefined | DiscountKeySpecifier);
    fields?: DiscountFieldPolicy;
  };
  DynamicBlock?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DynamicBlockKeySpecifier
      | (() => undefined | DynamicBlockKeySpecifier);
    fields?: DynamicBlockFieldPolicy;
  };
  DynamicBlocks?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DynamicBlocksKeySpecifier
      | (() => undefined | DynamicBlocksKeySpecifier);
    fields?: DynamicBlocksFieldPolicy;
  };
  EntityUrl?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EntityUrlKeySpecifier
      | (() => undefined | EntityUrlKeySpecifier);
    fields?: EntityUrlFieldPolicy;
  };
  ErrorInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ErrorInterfaceKeySpecifier
      | (() => undefined | ErrorInterfaceKeySpecifier);
    fields?: ErrorInterfaceFieldPolicy;
  };
  EstimateTotalsOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EstimateTotalsOutputKeySpecifier
      | (() => undefined | EstimateTotalsOutputKeySpecifier);
    fields?: EstimateTotalsOutputFieldPolicy;
  };
  ExchangeRate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ExchangeRateKeySpecifier
      | (() => undefined | ExchangeRateKeySpecifier);
    fields?: ExchangeRateFieldPolicy;
  };
  FixedProductTax?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FixedProductTaxKeySpecifier
      | (() => undefined | FixedProductTaxKeySpecifier);
    fields?: FixedProductTaxFieldPolicy;
  };
  Form?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | FormKeySpecifier | (() => undefined | FormKeySpecifier);
    fields?: FormFieldPolicy;
  };
  FormField?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FormFieldKeySpecifier
      | (() => undefined | FormFieldKeySpecifier);
    fields?: FormFieldFieldPolicy;
  };
  HttpQueryParameter?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | HttpQueryParameterKeySpecifier
      | (() => undefined | HttpQueryParameterKeySpecifier);
    fields?: HttpQueryParameterFieldPolicy;
  };
  ImageSwatchData?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ImageSwatchDataKeySpecifier
      | (() => undefined | ImageSwatchDataKeySpecifier);
    fields?: ImageSwatchDataFieldPolicy;
  };
  InitializeCustomerCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InitializeCustomerCartOutputKeySpecifier
      | (() => undefined | InitializeCustomerCartOutputKeySpecifier);
    fields?: InitializeCustomerCartOutputFieldPolicy;
  };
  InstantinkUpgrade?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InstantinkUpgradeKeySpecifier
      | (() => undefined | InstantinkUpgradeKeySpecifier);
    fields?: InstantinkUpgradeFieldPolicy;
  };
  InternalError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InternalErrorKeySpecifier
      | (() => undefined | InternalErrorKeySpecifier);
    fields?: InternalErrorFieldPolicy;
  };
  Invoice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InvoiceKeySpecifier
      | (() => undefined | InvoiceKeySpecifier);
    fields?: InvoiceFieldPolicy;
  };
  InvoiceItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InvoiceItemKeySpecifier
      | (() => undefined | InvoiceItemKeySpecifier);
    fields?: InvoiceItemFieldPolicy;
  };
  InvoiceItemInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InvoiceItemInterfaceKeySpecifier
      | (() => undefined | InvoiceItemInterfaceKeySpecifier);
    fields?: InvoiceItemInterfaceFieldPolicy;
  };
  InvoiceTotal?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InvoiceTotalKeySpecifier
      | (() => undefined | InvoiceTotalKeySpecifier);
    fields?: InvoiceTotalFieldPolicy;
  };
  IsEmailAvailableOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IsEmailAvailableOutputKeySpecifier
      | (() => undefined | IsEmailAvailableOutputKeySpecifier);
    fields?: IsEmailAvailableOutputFieldPolicy;
  };
  Item?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ItemKeySpecifier | (() => undefined | ItemKeySpecifier);
    fields?: ItemFieldPolicy;
  };
  ItemSelectedBundleOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ItemSelectedBundleOptionKeySpecifier
      | (() => undefined | ItemSelectedBundleOptionKeySpecifier);
    fields?: ItemSelectedBundleOptionFieldPolicy;
  };
  ItemSelectedBundleOptionValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ItemSelectedBundleOptionValueKeySpecifier
      | (() => undefined | ItemSelectedBundleOptionValueKeySpecifier);
    fields?: ItemSelectedBundleOptionValueFieldPolicy;
  };
  KeyValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | KeyValueKeySpecifier
      | (() => undefined | KeyValueKeySpecifier);
    fields?: KeyValueFieldPolicy;
  };
  LayerFilter?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LayerFilterKeySpecifier
      | (() => undefined | LayerFilterKeySpecifier);
    fields?: LayerFilterFieldPolicy;
  };
  LayerFilterItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LayerFilterItemKeySpecifier
      | (() => undefined | LayerFilterItemKeySpecifier);
    fields?: LayerFilterItemFieldPolicy;
  };
  LayerFilterItemInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LayerFilterItemInterfaceKeySpecifier
      | (() => undefined | LayerFilterItemInterfaceKeySpecifier);
    fields?: LayerFilterItemInterfaceFieldPolicy;
  };
  LineItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LineItemKeySpecifier
      | (() => undefined | LineItemKeySpecifier);
    fields?: LineItemFieldPolicy;
  };
  LineItemThumbnail?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LineItemThumbnailKeySpecifier
      | (() => undefined | LineItemThumbnailKeySpecifier);
    fields?: LineItemThumbnailFieldPolicy;
  };
  MediaGalleryEntry?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MediaGalleryEntryKeySpecifier
      | (() => undefined | MediaGalleryEntryKeySpecifier);
    fields?: MediaGalleryEntryFieldPolicy;
  };
  MediaGalleryInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MediaGalleryInterfaceKeySpecifier
      | (() => undefined | MediaGalleryInterfaceKeySpecifier);
    fields?: MediaGalleryInterfaceFieldPolicy;
  };
  Money?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MoneyKeySpecifier
      | (() => undefined | MoneyKeySpecifier);
    fields?: MoneyFieldPolicy;
  };
  MonthlyTotal?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MonthlyTotalKeySpecifier
      | (() => undefined | MonthlyTotalKeySpecifier);
    fields?: MonthlyTotalFieldPolicy;
  };
  Mutation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MutationKeySpecifier
      | (() => undefined | MutationKeySpecifier);
    fields?: MutationFieldPolicy;
  };
  NoSuchEntityUidError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NoSuchEntityUidErrorKeySpecifier
      | (() => undefined | NoSuchEntityUidErrorKeySpecifier);
    fields?: NoSuchEntityUidErrorFieldPolicy;
  };
  Option?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OptionKeySpecifier
      | (() => undefined | OptionKeySpecifier);
    fields?: OptionFieldPolicy;
  };
  Order?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrderKeySpecifier
      | (() => undefined | OrderKeySpecifier);
    fields?: OrderFieldPolicy;
  };
  OrderAddress?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrderAddressKeySpecifier
      | (() => undefined | OrderAddressKeySpecifier);
    fields?: OrderAddressFieldPolicy;
  };
  OrderItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrderItemKeySpecifier
      | (() => undefined | OrderItemKeySpecifier);
    fields?: OrderItemFieldPolicy;
  };
  OrderItemInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrderItemInterfaceKeySpecifier
      | (() => undefined | OrderItemInterfaceKeySpecifier);
    fields?: OrderItemInterfaceFieldPolicy;
  };
  OrderItemOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrderItemOptionKeySpecifier
      | (() => undefined | OrderItemOptionKeySpecifier);
    fields?: OrderItemOptionFieldPolicy;
  };
  OrderPaymentMethod?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrderPaymentMethodKeySpecifier
      | (() => undefined | OrderPaymentMethodKeySpecifier);
    fields?: OrderPaymentMethodFieldPolicy;
  };
  OrderShipment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrderShipmentKeySpecifier
      | (() => undefined | OrderShipmentKeySpecifier);
    fields?: OrderShipmentFieldPolicy;
  };
  OrderTotal?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrderTotalKeySpecifier
      | (() => undefined | OrderTotalKeySpecifier);
    fields?: OrderTotalFieldPolicy;
  };
  PartnerCompensation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PartnerCompensationKeySpecifier
      | (() => undefined | PartnerCompensationKeySpecifier);
    fields?: PartnerCompensationFieldPolicy;
  };
  PartnerFmv?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PartnerFmvKeySpecifier
      | (() => undefined | PartnerFmvKeySpecifier);
    fields?: PartnerFmvFieldPolicy;
  };
  PaymentToken?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaymentTokenKeySpecifier
      | (() => undefined | PaymentTokenKeySpecifier);
    fields?: PaymentTokenFieldPolicy;
  };
  PdpConfigState?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PdpConfigStateKeySpecifier
      | (() => undefined | PdpConfigStateKeySpecifier);
    fields?: PdpConfigStateFieldPolicy;
  };
  PgsDetails?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PgsDetailsKeySpecifier
      | (() => undefined | PgsDetailsKeySpecifier);
    fields?: PgsDetailsFieldPolicy;
  };
  PhysicalProductInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PhysicalProductInterfaceKeySpecifier
      | (() => undefined | PhysicalProductInterfaceKeySpecifier);
    fields?: PhysicalProductInterfaceFieldPolicy;
  };
  PickupLocation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PickupLocationKeySpecifier
      | (() => undefined | PickupLocationKeySpecifier);
    fields?: PickupLocationFieldPolicy;
  };
  PickupLocations?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PickupLocationsKeySpecifier
      | (() => undefined | PickupLocationsKeySpecifier);
    fields?: PickupLocationsFieldPolicy;
  };
  PlaceOrderError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceOrderErrorKeySpecifier
      | (() => undefined | PlaceOrderErrorKeySpecifier);
    fields?: PlaceOrderErrorFieldPolicy;
  };
  PlaceOrderOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlaceOrderOutputKeySpecifier
      | (() => undefined | PlaceOrderOutputKeySpecifier);
    fields?: PlaceOrderOutputFieldPolicy;
  };
  Price?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PriceKeySpecifier
      | (() => undefined | PriceKeySpecifier);
    fields?: PriceFieldPolicy;
  };
  PriceAdjustment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PriceAdjustmentKeySpecifier
      | (() => undefined | PriceAdjustmentKeySpecifier);
    fields?: PriceAdjustmentFieldPolicy;
  };
  PriceDetails?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PriceDetailsKeySpecifier
      | (() => undefined | PriceDetailsKeySpecifier);
    fields?: PriceDetailsFieldPolicy;
  };
  PriceRange?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PriceRangeKeySpecifier
      | (() => undefined | PriceRangeKeySpecifier);
    fields?: PriceRangeFieldPolicy;
  };
  Prices?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PricesKeySpecifier
      | (() => undefined | PricesKeySpecifier);
    fields?: PricesFieldPolicy;
  };
  ProductCustomAttributes?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProductCustomAttributesKeySpecifier
      | (() => undefined | ProductCustomAttributesKeySpecifier);
    fields?: ProductCustomAttributesFieldPolicy;
  };
  ProductDetail?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProductDetailKeySpecifier
      | (() => undefined | ProductDetailKeySpecifier);
    fields?: ProductDetailFieldPolicy;
  };
  ProductDiscount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProductDiscountKeySpecifier
      | (() => undefined | ProductDiscountKeySpecifier);
    fields?: ProductDiscountFieldPolicy;
  };
  ProductImage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProductImageKeySpecifier
      | (() => undefined | ProductImageKeySpecifier);
    fields?: ProductImageFieldPolicy;
  };
  ProductInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProductInterfaceKeySpecifier
      | (() => undefined | ProductInterfaceKeySpecifier);
    fields?: ProductInterfaceFieldPolicy;
  };
  ProductLinks?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProductLinksKeySpecifier
      | (() => undefined | ProductLinksKeySpecifier);
    fields?: ProductLinksFieldPolicy;
  };
  ProductLinksInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProductLinksInterfaceKeySpecifier
      | (() => undefined | ProductLinksInterfaceKeySpecifier);
    fields?: ProductLinksInterfaceFieldPolicy;
  };
  ProductMediaGalleryEntriesContent?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ProductMediaGalleryEntriesContentKeySpecifier
      | (() => undefined | ProductMediaGalleryEntriesContentKeySpecifier);
    fields?: ProductMediaGalleryEntriesContentFieldPolicy;
  };
  ProductMediaGalleryEntriesVideoContent?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ProductMediaGalleryEntriesVideoContentKeySpecifier
      | (() => undefined | ProductMediaGalleryEntriesVideoContentKeySpecifier);
    fields?: ProductMediaGalleryEntriesVideoContentFieldPolicy;
  };
  ProductPrice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProductPriceKeySpecifier
      | (() => undefined | ProductPriceKeySpecifier);
    fields?: ProductPriceFieldPolicy;
  };
  ProductPrices?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProductPricesKeySpecifier
      | (() => undefined | ProductPricesKeySpecifier);
    fields?: ProductPricesFieldPolicy;
  };
  ProductTierPrices?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProductTierPricesKeySpecifier
      | (() => undefined | ProductTierPricesKeySpecifier);
    fields?: ProductTierPricesFieldPolicy;
  };
  ProductVideo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProductVideoKeySpecifier
      | (() => undefined | ProductVideoKeySpecifier);
    fields?: ProductVideoFieldPolicy;
  };
  Products?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProductsKeySpecifier
      | (() => undefined | ProductsKeySpecifier);
    fields?: ProductsFieldPolicy;
  };
  Query?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QueryKeySpecifier
      | (() => undefined | QueryKeySpecifier);
    fields?: QueryFieldPolicy;
  };
  Region?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RegionKeySpecifier
      | (() => undefined | RegionKeySpecifier);
    fields?: RegionFieldPolicy;
  };
  RegularPrice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RegularPriceKeySpecifier
      | (() => undefined | RegularPriceKeySpecifier);
    fields?: RegularPriceFieldPolicy;
  };
  RemoveCouponFromCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoveCouponFromCartOutputKeySpecifier
      | (() => undefined | RemoveCouponFromCartOutputKeySpecifier);
    fields?: RemoveCouponFromCartOutputFieldPolicy;
  };
  RemoveItemFromCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoveItemFromCartOutputKeySpecifier
      | (() => undefined | RemoveItemFromCartOutputKeySpecifier);
    fields?: RemoveItemFromCartOutputFieldPolicy;
  };
  RemovePaperFromCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemovePaperFromCartOutputKeySpecifier
      | (() => undefined | RemovePaperFromCartOutputKeySpecifier);
    fields?: RemovePaperFromCartOutputFieldPolicy;
  };
  RemoveProductsFromWishlistOutput?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | RemoveProductsFromWishlistOutputKeySpecifier
      | (() => undefined | RemoveProductsFromWishlistOutputKeySpecifier);
    fields?: RemoveProductsFromWishlistOutputFieldPolicy;
  };
  ReorderItemsOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReorderItemsOutputKeySpecifier
      | (() => undefined | ReorderItemsOutputKeySpecifier);
    fields?: ReorderItemsOutputFieldPolicy;
  };
  RevisionPrice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RevisionPriceKeySpecifier
      | (() => undefined | RevisionPriceKeySpecifier);
    fields?: RevisionPriceFieldPolicy;
  };
  RevokeCustomerTokenOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RevokeCustomerTokenOutputKeySpecifier
      | (() => undefined | RevokeCustomerTokenOutputKeySpecifier);
    fields?: RevokeCustomerTokenOutputFieldPolicy;
  };
  RoutableInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RoutableInterfaceKeySpecifier
      | (() => undefined | RoutableInterfaceKeySpecifier);
    fields?: RoutableInterfaceFieldPolicy;
  };
  RoutableUrl?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RoutableUrlKeySpecifier
      | (() => undefined | RoutableUrlKeySpecifier);
    fields?: RoutableUrlFieldPolicy;
  };
  SalesCommentItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SalesCommentItemKeySpecifier
      | (() => undefined | SalesCommentItemKeySpecifier);
    fields?: SalesCommentItemFieldPolicy;
  };
  SearchResultPageInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SearchResultPageInfoKeySpecifier
      | (() => undefined | SearchResultPageInfoKeySpecifier);
    fields?: SearchResultPageInfoFieldPolicy;
  };
  SearchSuggestion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SearchSuggestionKeySpecifier
      | (() => undefined | SearchSuggestionKeySpecifier);
    fields?: SearchSuggestionFieldPolicy;
  };
  SelectedBundleOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SelectedBundleOptionKeySpecifier
      | (() => undefined | SelectedBundleOptionKeySpecifier);
    fields?: SelectedBundleOptionFieldPolicy;
  };
  SelectedBundleOptionValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SelectedBundleOptionValueKeySpecifier
      | (() => undefined | SelectedBundleOptionValueKeySpecifier);
    fields?: SelectedBundleOptionValueFieldPolicy;
  };
  SelectedConfigurableOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SelectedConfigurableOptionKeySpecifier
      | (() => undefined | SelectedConfigurableOptionKeySpecifier);
    fields?: SelectedConfigurableOptionFieldPolicy;
  };
  SelectedCustomizableOption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SelectedCustomizableOptionKeySpecifier
      | (() => undefined | SelectedCustomizableOptionKeySpecifier);
    fields?: SelectedCustomizableOptionFieldPolicy;
  };
  SelectedCustomizableOptionValue?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SelectedCustomizableOptionValueKeySpecifier
      | (() => undefined | SelectedCustomizableOptionValueKeySpecifier);
    fields?: SelectedCustomizableOptionValueFieldPolicy;
  };
  SelectedPaymentMethod?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SelectedPaymentMethodKeySpecifier
      | (() => undefined | SelectedPaymentMethodKeySpecifier);
    fields?: SelectedPaymentMethodFieldPolicy;
  };
  SelectedShippingMethod?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SelectedShippingMethodKeySpecifier
      | (() => undefined | SelectedShippingMethodKeySpecifier);
    fields?: SelectedShippingMethodFieldPolicy;
  };
  SetBillingAddressOnCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetBillingAddressOnCartOutputKeySpecifier
      | (() => undefined | SetBillingAddressOnCartOutputKeySpecifier);
    fields?: SetBillingAddressOnCartOutputFieldPolicy;
  };
  SetGuestEmailOnCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetGuestEmailOnCartOutputKeySpecifier
      | (() => undefined | SetGuestEmailOnCartOutputKeySpecifier);
    fields?: SetGuestEmailOnCartOutputFieldPolicy;
  };
  SetPaymentMethodOnCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetPaymentMethodOnCartOutputKeySpecifier
      | (() => undefined | SetPaymentMethodOnCartOutputKeySpecifier);
    fields?: SetPaymentMethodOnCartOutputFieldPolicy;
  };
  SetShippingAddressesOnCartOutput?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | SetShippingAddressesOnCartOutputKeySpecifier
      | (() => undefined | SetShippingAddressesOnCartOutputKeySpecifier);
    fields?: SetShippingAddressesOnCartOutputFieldPolicy;
  };
  SetShippingMethodsOnCartOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetShippingMethodsOnCartOutputKeySpecifier
      | (() => undefined | SetShippingMethodsOnCartOutputKeySpecifier);
    fields?: SetShippingMethodsOnCartOutputFieldPolicy;
  };
  SetSubscriptionUpgradesOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetSubscriptionUpgradesOutputKeySpecifier
      | (() => undefined | SetSubscriptionUpgradesOutputKeySpecifier);
    fields?: SetSubscriptionUpgradesOutputFieldPolicy;
  };
  ShipmentItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShipmentItemKeySpecifier
      | (() => undefined | ShipmentItemKeySpecifier);
    fields?: ShipmentItemFieldPolicy;
  };
  ShipmentItemInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShipmentItemInterfaceKeySpecifier
      | (() => undefined | ShipmentItemInterfaceKeySpecifier);
    fields?: ShipmentItemInterfaceFieldPolicy;
  };
  ShipmentTracking?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShipmentTrackingKeySpecifier
      | (() => undefined | ShipmentTrackingKeySpecifier);
    fields?: ShipmentTrackingFieldPolicy;
  };
  ShippingCartAddress?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShippingCartAddressKeySpecifier
      | (() => undefined | ShippingCartAddressKeySpecifier);
    fields?: ShippingCartAddressFieldPolicy;
  };
  ShippingDiscount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShippingDiscountKeySpecifier
      | (() => undefined | ShippingDiscountKeySpecifier);
    fields?: ShippingDiscountFieldPolicy;
  };
  ShippingHandling?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShippingHandlingKeySpecifier
      | (() => undefined | ShippingHandlingKeySpecifier);
    fields?: ShippingHandlingFieldPolicy;
  };
  SimpleCartItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SimpleCartItemKeySpecifier
      | (() => undefined | SimpleCartItemKeySpecifier);
    fields?: SimpleCartItemFieldPolicy;
  };
  SimpleProduct?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SimpleProductKeySpecifier
      | (() => undefined | SimpleProductKeySpecifier);
    fields?: SimpleProductFieldPolicy;
  };
  SimpleWishlistItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SimpleWishlistItemKeySpecifier
      | (() => undefined | SimpleWishlistItemKeySpecifier);
    fields?: SimpleWishlistItemFieldPolicy;
  };
  SortField?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SortFieldKeySpecifier
      | (() => undefined | SortFieldKeySpecifier);
    fields?: SortFieldFieldPolicy;
  };
  SortFields?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SortFieldsKeySpecifier
      | (() => undefined | SortFieldsKeySpecifier);
    fields?: SortFieldsFieldPolicy;
  };
  StoreConfig?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StoreConfigKeySpecifier
      | (() => undefined | StoreConfigKeySpecifier);
    fields?: StoreConfigFieldPolicy;
  };
  StorefrontProperties?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StorefrontPropertiesKeySpecifier
      | (() => undefined | StorefrontPropertiesKeySpecifier);
    fields?: StorefrontPropertiesFieldPolicy;
  };
  SubscribeEmailToNewsletterOutput?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | SubscribeEmailToNewsletterOutputKeySpecifier
      | (() => undefined | SubscribeEmailToNewsletterOutputKeySpecifier);
    fields?: SubscribeEmailToNewsletterOutputFieldPolicy;
  };
  SubscriptionRevision?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SubscriptionRevisionKeySpecifier
      | (() => undefined | SubscriptionRevisionKeySpecifier);
    fields?: SubscriptionRevisionFieldPolicy;
  };
  SwatchData?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SwatchDataKeySpecifier
      | (() => undefined | SwatchDataKeySpecifier);
    fields?: SwatchDataFieldPolicy;
  };
  SwatchDataInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SwatchDataInterfaceKeySpecifier
      | (() => undefined | SwatchDataInterfaceKeySpecifier);
    fields?: SwatchDataInterfaceFieldPolicy;
  };
  SwatchLayerFilterItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SwatchLayerFilterItemKeySpecifier
      | (() => undefined | SwatchLayerFilterItemKeySpecifier);
    fields?: SwatchLayerFilterItemFieldPolicy;
  };
  SwatchLayerFilterItemInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SwatchLayerFilterItemInterfaceKeySpecifier
      | (() => undefined | SwatchLayerFilterItemInterfaceKeySpecifier);
    fields?: SwatchLayerFilterItemInterfaceFieldPolicy;
  };
  TaxItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TaxItemKeySpecifier
      | (() => undefined | TaxItemKeySpecifier);
    fields?: TaxItemFieldPolicy;
  };
  TextSwatchData?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TextSwatchDataKeySpecifier
      | (() => undefined | TextSwatchDataKeySpecifier);
    fields?: TextSwatchDataFieldPolicy;
  };
  TierPrice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TierPriceKeySpecifier
      | (() => undefined | TierPriceKeySpecifier);
    fields?: TierPriceFieldPolicy;
  };
  UpdateCartItemsOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateCartItemsOutputKeySpecifier
      | (() => undefined | UpdateCartItemsOutputKeySpecifier);
    fields?: UpdateCartItemsOutputFieldPolicy;
  };
  UpdatePaymentMethodCvvOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePaymentMethodCvvOutputKeySpecifier
      | (() => undefined | UpdatePaymentMethodCvvOutputKeySpecifier);
    fields?: UpdatePaymentMethodCvvOutputFieldPolicy;
  };
  UpdateProductsInWishlistOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateProductsInWishlistOutputKeySpecifier
      | (() => undefined | UpdateProductsInWishlistOutputKeySpecifier);
    fields?: UpdateProductsInWishlistOutputFieldPolicy;
  };
  UrlRewrite?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UrlRewriteKeySpecifier
      | (() => undefined | UrlRewriteKeySpecifier);
    fields?: UrlRewriteFieldPolicy;
  };
  UserError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserErrorKeySpecifier
      | (() => undefined | UserErrorKeySpecifier);
    fields?: UserErrorFieldPolicy;
  };
  ValidationRule?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ValidationRuleKeySpecifier
      | (() => undefined | ValidationRuleKeySpecifier);
    fields?: ValidationRuleFieldPolicy;
  };
  ValidationSchema?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ValidationSchemaKeySpecifier
      | (() => undefined | ValidationSchemaKeySpecifier);
    fields?: ValidationSchemaFieldPolicy;
  };
  VirtualCartItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VirtualCartItemKeySpecifier
      | (() => undefined | VirtualCartItemKeySpecifier);
    fields?: VirtualCartItemFieldPolicy;
  };
  VirtualProduct?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VirtualProductKeySpecifier
      | (() => undefined | VirtualProductKeySpecifier);
    fields?: VirtualProductFieldPolicy;
  };
  VirtualWishlistItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VirtualWishlistItemKeySpecifier
      | (() => undefined | VirtualWishlistItemKeySpecifier);
    fields?: VirtualWishlistItemFieldPolicy;
  };
  Website?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WebsiteKeySpecifier
      | (() => undefined | WebsiteKeySpecifier);
    fields?: WebsiteFieldPolicy;
  };
  WishListUserInputError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WishListUserInputErrorKeySpecifier
      | (() => undefined | WishListUserInputErrorKeySpecifier);
    fields?: WishListUserInputErrorFieldPolicy;
  };
  Wishlist?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WishlistKeySpecifier
      | (() => undefined | WishlistKeySpecifier);
    fields?: WishlistFieldPolicy;
  };
  WishlistCartUserInputError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WishlistCartUserInputErrorKeySpecifier
      | (() => undefined | WishlistCartUserInputErrorKeySpecifier);
    fields?: WishlistCartUserInputErrorFieldPolicy;
  };
  WishlistItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WishlistItemKeySpecifier
      | (() => undefined | WishlistItemKeySpecifier);
    fields?: WishlistItemFieldPolicy;
  };
  WishlistItemInterface?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WishlistItemInterfaceKeySpecifier
      | (() => undefined | WishlistItemInterfaceKeySpecifier);
    fields?: WishlistItemInterfaceFieldPolicy;
  };
  WishlistItems?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WishlistItemsKeySpecifier
      | (() => undefined | WishlistItemsKeySpecifier);
    fields?: WishlistItemsFieldPolicy;
  };
  WishlistOutput?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WishlistOutputKeySpecifier
      | (() => undefined | WishlistOutputKeySpecifier);
    fields?: WishlistOutputFieldPolicy;
  };
  WsRegFees?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WsRegFeesKeySpecifier
      | (() => undefined | WsRegFeesKeySpecifier);
    fields?: WsRegFeesFieldPolicy;
  };
  WsregOrder?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WsregOrderKeySpecifier
      | (() => undefined | WsregOrderKeySpecifier);
    fields?: WsregOrderFieldPolicy;
  };
  WsregOrderItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WsregOrderItemKeySpecifier
      | (() => undefined | WsregOrderItemKeySpecifier);
    fields?: WsregOrderItemFieldPolicy;
  };
  WsregQuote?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WsregQuoteKeySpecifier
      | (() => undefined | WsregQuoteKeySpecifier);
    fields?: WsregQuoteFieldPolicy;
  };
  WsregQuoteItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WsregQuoteItemKeySpecifier
      | (() => undefined | WsregQuoteItemKeySpecifier);
    fields?: WsregQuoteItemFieldPolicy;
  };
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
